/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title global.js: Wrapper module to combine global.base.js and utilityGlobal (utility1 + utility2)
	 * This will NOT be included on Home, Browse & Product pages. But will be included on rest of the pages across site.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8), __webpack_require__(77)], __WEBPACK_AMD_DEFINE_RESULT__ = function (util, Global) {
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = {};
	  }
	  $(document).ready(function () {
	    window.COSTCO.Global = Global;
	    window.COSTCO.util = util;
	    Global.init();
	  });
	  return Global;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 8:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title utility.js: Global sub-module - combination of utility1.js and utility2.js
	 * @description A collection of functions used
	 * application wide. This module should contain
	 * generic utility code. No module specifics.
	 * 
	 * 07/27/2022
	 * utility.js was split into two files, utility1.js and utility2.js
	 * utility2.js contains fucntions that are not invoked on Home, Browse 
	 * and Product pages. Rest of the functions are in utility1.js
	 * 
	 * Only utility1.js is imported into new global module called global.hbp.js for Home, Browser & Product (HBP) pages
	 * Rest of the site will continue to load existing global.module.js which will inlcude both utility1.js and utility2.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = function (util1, util2) {
	    var util = Object.assign({}, util1, util2);
	    if (typeof window.COSTCO == 'undefined') {
	        window.COSTCO = new Object();
	    }
	    window.COSTCO.util = util;
	    return util;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 9:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title utility1.js: Global sub-module
	 * @description A collection of functions used
	 * application wide. This module should contain
	 * generic utility code. No module specifics.
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var util = {
	    POSTAL_CODE_REGEX_US: /^(\d{5}(-\d{4})?$)$/,
	    POSTAL_CODE_REGEX_CA: /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1}$/,
	    ATLEAST_ONE_ALPHABET: /^(?=.*[A-Za-z\u00C0-\u017F]).+/,
	    CC_NAME_FIELD_REGEX: /[^0-9A-Z\.\'\-\&\s\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u2030\u20AC]/i,
	    /**
	     * John Resig's micro-templating function
	     * @param  {[string]} str  String ID of template
	     * @param  {[object]} data Object representing dynamic values
	     * @return {[string]}      HTML representation as
	     * a string
	     */
	    tmpl: function tmpl(str, data) {
	      var fn = !/\W/.test(str) ? this.tmpl(document.getElementById(str).innerHTML) : new Function('obj', 'var p=[],print=function(){p.push.apply(p,arguments);};' + 'with(obj){p.push(\'' + str.replace(/[\r\t\n]/g, ' ').split('<&').join('\t').replace(/((^|&>)[^\t]*)'/g, '$1\r').replace(/\t=(.*?)&>/g, '\',$1,\'').split('\t').join('\');').split('&>').join('p.push(\'').split('\r').join('\\\'') + '\');}return p.join(\'\');');
	      return data ? fn(data) : fn;
	    },
	    /**
	     * http://kenwheeler.github.io/slick/
	     * Generalized intialization of carousel.
	     * [carousel description]
	     * @param  {[string]} id        [description]
	     * @param  {[object]} options   [description]
	     * @param  {[object]} settings  [description]
	     * @return {[void]}             [description]
	     */
	    carousel: function carousel(id, options, settings) {
	      options = options || {};
	      $slider = $(id);
	      if (settings && settings.initFn) {
	        $slider.on('init', settings.initFn);
	      }
	      // Initialize the carousel. Waits for the application style sheet
	      // to load before initializing to ensure we have the correct
	      // CSS attributes attached to DOM elements
	      if (window.stylesLoaded) {
	        COSTCO.util.initCarousel($slider, options, settings);
	      } else {
	        document.addEventListener('styles-loaded', function initCarouselEvent() {
	          this.util.initCarousel(this.slider, options, settings);
	        }.bind({
	          util: COSTCO.util,
	          slider: $slider
	        }), false);
	      }
	    },
	
	    /**
	     * Initializes the carousel and does any additional bindings and/or
	     * settings.
	     * @param  {[type]} $slider  [description]
	     * @param  {[type]} options  [description]
	     * @param  {[type]} settings [description]
	     * @return {void}
	     */
	    initCarousel: function initCarousel($slider, options, settings) {
	      $slider.slick(options);
	      if (settings && settings.hasPause) {
	        // append a pause button
	        $slider.find('.slick-dots').append('<li class="pause"><button class="playToggle" role="button" type="button" aria-label="' + messages.PAUSE + '"></button></li>');
	        $slider.find('.pause button').unbind().on('click', function () {
	          // define slider to pause/play as the closest parent of the play/pause button
	          // cannot use $slider as by the time the page is initialized $slider points to a different carousel
	          var mySlider = $(this).closest('.slick-slider');
	          $(this).toggleClass('active');
	          if ($(this).hasClass('active')) {
	            mySlider.slick('slickPause');
	            $(this).attr('aria-label', messages.PLAY);
	          } else {
	            mySlider.slick('slickPlay');
	            $(this).attr('aria-label', messages.PAUSE);
	          }
	        });
	      }
	
	      if (options && options.arrows) {
	        // Update the aria label on the arrows
	        $slider.find('.slick-next').attr('aria-label', settings != undefined && settings.nextLabel != undefined ? settings.nextLabel : messages.NEXT_SLIDE);
	        $slider.find('.slick-prev').attr('aria-label', settings != undefined && settings.prevLabel != undefined ? settings.prevLabel : messages.PREV_SLIDE);
	      }
	
	      // put descriptive text for carousel dot buttons for ADA
	      $slider.each(function () {
	        $(this).find('li button[data-role=none]').each(function (index) {
	          $(this).text('slide set ' + (index + 1));
	        });
	        $(this).find('li').removeAttr('aria-hidden');
	      });
	
	      // Are there any events beforeChange/afterChange we are binding?
	      if (settings && settings.beforeFn) {
	        $slider.on('beforeChange', settings.beforeFn);
	      }
	      if (settings && settings.afterFn) {
	        $slider.on('afterChange', settings.afterFn);
	      }
	      if (settings && settings.destroyFn) {
	        $slider.on('destroy', settings.destroyFn);
	      }
	    },
	    setStyleRule: function setStyleRule(selector, rule) {
	      var stylesheet = document.styleSheets[document.styleSheets.length - 1];
	      COSTCO.util.safe(function () {
	        for (var i in document.styleSheets) {
	          if (document.styleSheets[i].href && document.styleSheets[i].href.indexOf('rwd') >= 0) {
	            stylesheet = document.styleSheets[i];
	            break;
	          }
	        }
	      })();
	      if (stylesheet.addRule) {
	        stylesheet.addRule(selector, rule);
	      } else if (stylesheet.insertRule) {
	        stylesheet.insertRule(selector + ' { ' + rule + ' }', stylesheet.cssRules.length);
	      }
	    },
	    /**
	     * Function decorator that wraps a provided function in a try/catch
	     * to mitigate breaking JS execution. Returns a new function which
	     * must be called.
	     * @param {[function]} fn
	     * @param {[string]} signature
	     * @return {[function]}
	     */
	    safe: function safe(fn, signature) {
	      return function util_safe() {
	        try {
	          fn.apply(this, arguments);
	        } catch (e) {
	          console.error(e, 'at ' + signature);
	        }
	      };
	    },
	    /**
	     * Function used to call bing to obtain location data based on query value
	     *
	     * Param
	     * 	  postalCode -> postalCode that we want to get the city or state for
	     * 	  sucessCallback -> function to be fired after the sucess of the ajax request
	     *
	     */
	    callBing: function callBing(postalCode, successCallback, errorCallback) {
	
	      var globalBingStaticKeyVar = $('#globalBingStaticKey').val();
	      var geocodeRequest = 'https://dev.virtualearth.net/REST/v1/Locations?postalCode=' + postalCode + '&includeNeighborhood=true&include=ciso2&maxResults=5&key=' + globalBingStaticKeyVar;
	
	      $.ajax({
	        url: geocodeRequest,
	        dataType: 'jsonp',
	        jsonp: 'jsonp',
	        error: function error(XMLHttpRequest, textStatus, errorThrown) {
	          console.log('error getting City / State' + postalCode);
	          if (errorCallback) errorCallback(XMLHttpRequest, textStatus, errorThrown);
	        },
	        success: function success(data, textstatus, XMLHttpRequest) {
	          console.log('BING - Success retrieving location');
	          successCallback(data, textstatus, XMLHttpRequest);
	        }
	      });
	    },
	
	    /**
	     * Calls the GeocodeAPI to obtain location data based on the provided postal code.
	     *
	     * @param {string} postalCode - The postal for which to get city/state data.
	     * @param {function} successCallback - The function to be called on successful AJAX request.
	     * @param {function} errorCallback - The function to be called if the AJAX request fails.
	     */
	    callGeocodeAPI: function callGeocodeAPI(postalCode, successCallback, errorCallback) {
	      var country = 'USA';
	      if (COSTCO.util.isCAStore() || COSTCO.util.isCABDStore()) {
	        country = 'CAN';
	        postalCode = postalCode.toUpperCase();
	      }
	
	      var geocodeRequestUrl = $('#geocodeServiceEndpoint').val() + '?q=' + postalCode + '&country=' + country;
	
	      var deriveCityStateFromZipCodeEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === 'true';
	      var allowedCityTypes = deriveCityStateFromZipCodeEnabled ? ['A', 'D'] : ['D'];
	
	      errorCallback = errorCallback || successCallback;
	      var handleError = function handleError() {
	        console.log('Error getting City/State for ' + postalCode);
	        var errData = [{ invalidZip: true }];
	        errorCallback(errData);
	      };
	
	      $.ajax({
	        url: geocodeRequestUrl,
	        dataType: 'json',
	        error: function error(jqXHR, textStatus, errorThrown) {
	          if (textStatus === 'error') {
	            handleError();
	          }
	        },
	        success: function success(data, textStatus, jqXHR) {
	          var filteredElements = data && data.length > 0 ? data.filter(function (element) {
	            return allowedCityTypes.includes(element.cityType);
	          }) : [];
	          if (filteredElements.length) {
	            console.log('GeocodeAPI - Success retrieving location');
	            successCallback(filteredElements, textStatus, jqXHR);
	          } else {
	            handleError();
	          }
	        }
	      });
	    },
	
	    /**
	     * BD only: calls Bing Location service and updates WC_BD_LOC cookie as pipe-separated City|ST|CC value.
	     * @param {string} zipCode
	     * @returns {object} Deferred
	     */
	    callBingAndUpdateBDLocationCookie: function callBingAndUpdateBDLocationCookie(zipCode) {
	      var deferred = $.Deferred();
	      var updateCookie = function updateCookie(data) {
	        if (data && data.resourceSets && data.resourceSets[0] && data.resourceSets[0].estimatedTotal > 0) {
	          var city = '' + data.resourceSets[0].resources[0].address.locality;
	          var state = '' + data.resourceSets[0].resources[0].address.adminDistrict;
	          var countryCode = '' + data.resourceSets[0].resources[0].address.countryRegionIso2;
	          var locationCookie = encodeURI(city.trim() + '|' + state.trim() + '|' + countryCode.trim());
	          var expiration = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
	          document.cookie = 'WC_BD_LOC=' + locationCookie + '; expires=' + expiration + '; path=/';
	          deferred.resolve(data);
	        } else {
	          document.cookie = 'WC_BD_LOC=; expires=' + new Date(0) + '; path=/';
	          console.log('BING - No location for ZIP/postal code: ' + zipCode + ', location cookie deleted.');
	          deferred.resolve(data);
	        }
	      };
	      COSTCO.util.callBing(zipCode, updateCookie);
	      return deferred.promise();
	    },
	    /**
	     * BD only: calls Geocode API service and updates WC_BD_LOC cookie as pipe-separated City|ST|CC value.
	     * @param {string} zipCode
	     * @returns {object} Deferred
	     */
	    callGeocodeApiAndUpdateBDLocationCookie: function callGeocodeApiAndUpdateBDLocationCookie(zipCode) {
	      var deferred = $.Deferred();
	      var updateCookie = function updateCookie(data) {
	        var totalResponses = data.length;
	        if (totalResponses != 0) {
	          var city = '' + data[0].city;
	          var state = '' + data[0].stateProvinceAbbreviation;
	          var countryCode = '' + data[0].country === "USA" ? "US" : "CA";
	          var locationCookie = encodeURI(city.trim() + '|' + state.trim() + '|' + countryCode.trim());
	          var expiration = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
	          document.cookie = 'WC_BD_LOC=' + locationCookie + '; expires=' + expiration + '; path=/';
	          COSTCO.util.setInSession("finalZipcode", data[0].postalCode);
	          deferred.resolve(data);
	        } else {
	          document.cookie = 'WC_BD_LOC=; expires=' + new Date(0) + '; path=/';
	          console.log('Geocode API - No location for ZIP/postal code: ' + zipCode + ', location cookie deleted.');
	          deferred.resolve(data);
	        }
	      };
	      COSTCO.util.callGeocodeAPI(zipCode, updateCookie);
	      return deferred.promise();
	    },
	    /**
	     * Calls bing and updates zip/state/city cookies
	     * @retrns jquery Deferred object
	     */
	    callBingAndUpdateCookies: function callBingAndUpdateCookies(zipcode) {
	
	      var deferred = $.Deferred();
	
	      var updateCookieValues = function updateCookieValues(data) {
	        var totalResponses = data.resourceSets[0].estimatedTotal;
	        if (totalResponses != 0) {
	          var province = null;
	          var country = null;
	          var city = data.resourceSets[0].resources[0].address.locality;
	          try {
	            //Check out if country is Puerto Rico specific
	            country = data.resourceSets[0].resources[0].address.countryRegionIso2;
	            if (country != undefined && country === 'PR') {
	              province = data.resourceSets[0].resources[0].address.countryRegionIso2;
	              country = 'US';
	            } else {
	              province = data.resourceSets[0].resources[0].address.adminDistrict;
	            }
	          } catch (e) {
	            province = "";
	          }
	          $.cookie("invCheckPostalCode", zipcode);
	          $.cookie("invCheckStateCode", province);
	          $.cookie("invCheckCity", city);
	          deferred.resolve(data);
	        } else {
	          deferred.reject();
	        }
	      };
	
	      COSTCO.util.callBing(zipcode, updateCookieValues);
	
	      return deferred.promise();
	    },
	    /**
	     * Calls GeocodeAPI and updates zip/state/city cookies
	     * @retrns jquery Deferred object
	     */
	    callGeocodeAPIAndUpdateCookies: function callGeocodeAPIAndUpdateCookies(zipcode) {
	
	      var deferred = $.Deferred();
	
	      var updateCookieValues = function updateCookieValues(data) {
	        var province = null;
	        var country = null;
	        var city = null;
	        var totalResponses = data.length;
	        if (totalResponses != 0) {
	          try {
	            city = data[0].city;
	            province = data[0].stateProvinceAbbreviation;
	            if (province == null) {
	              province = data[0].stateProvince;
	            }
	            country = data[0].country;
	          } catch (e) {
	            console.error('Error: ' + e.message);
	          }
	
	          //SFSTRY0035043 don't update header zip on multishipping page
	          if (typeof checkoutPage == 'undefined' || checkoutPage !== 'multi-shipping') {
	            $.cookie("invCheckPostalCode", zipcode);
	            $.cookie("invCheckStateCode", province);
	            $.cookie("invCheckCity", city);
	          }
	
	          deferred.resolve(data);
	        } else {
	          deferred.reject();
	        }
	      };
	
	      COSTCO.util.callGeocodeAPI(zipcode, updateCookieValues);
	
	      return deferred.promise();
	    },
	
	    hover_click_popover: function hover_click_popover(selector, _content, trigger, placement) {
	      var hoverClickElement = $(selector);
	      hoverClickElement.attr({
	        'aria-haspopup': 'true',
	        'aria-expanded': 'false'
	      });
	      hoverClickElement.popover({
	        html: true,
	        sanitize: false,
	        animation: false,
	        delay: {
	          show: 400,
	          hide: 400
	        },
	        content: function content() {
	          return $(_content).html();
	        },
	        container: selector,
	        placement: placement || 'bottom',
	        trigger: trigger || 'hover click'
	      }).on('keydown', function (e) {
	        if (e.which == 13) {
	          if ($(this).attr('data-flyout') && $(this).attr('aria-expanded') == 'false') {
	            e.preventDefault();
	            $(this).popover('show');
	          }
	        }
	      }).on('mouseleave focusout', '.popover', {
	        selector: selector,
	        content: _content,
	        placement: placement || 'bottom'
	      }, this.popoverLeave)
	      // Adding listener to toggle the aria tags when popover shown/hidden
	      .on('shown.bs.popover', function () {
	        if (('#warehouse-locations' == selector || '#warehouse-locations-t' == selector) && $.cookie('WC_BD_ZIP') != null) {
	          $('#warehouse-search-field').val($.cookie('WC_BD_ZIP').replace('+', ' '));
	        }
	        $(this).attr('aria-expanded', 'true');
	
	        // used to create ada required attributes on popover
	        var identifierSrting = $(selector)[0].id;
	        $(this).find('.popover-content').attr('id', identifierSrting + '-id');
	        // Add tabindex of -1 to the content to prevent a safari bug where the relatedTarget
	        // is not populated when no tabindex is specified this caused all a and input
	        // to not function on click event
	        $(this).find('.popover-content').attr('tabindex', '-1');
	        // New requirement to focus on the first visible input on popover shown
	        var firstInput = $(this).find('a,input[type!=hidden]')[0];
	        $(this).removeAttr('aria-describedby');
	        $(this).find('.popover-content').removeAttr('aria-label');
	        $(this).find('.popover').removeAttr('role');
	        if (firstInput) $(firstInput).focus();
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      })
	      // stry0123297 - issue with IE with user having to double-click on text boxes in pop-overs
	      // solution to trigger the focus on text boxes on mousedown event
	      .on('mousedown', 'input[type=search], input[type=text]', function () {
	        $(this).trigger('focus');
	      });
	    },
	    click_popover: function click_popover(selector, _content2, trigger, placement) {
	      var ClickElement = $(selector);
	      ClickElement.attr({
	        'aria-expanded': 'false'
	      });
	      ClickElement.popover({
	        html: true,
	        sanitize: false,
	        animation: false,
	        delay: {
	          show: 400,
	          hide: 400
	        },
	        content: function content() {
	          return $(_content2).html();
	        },
	        container: selector,
	        placement: placement || 'bottom',
	        trigger: trigger || 'click'
	      }).on('keydown', function (e) {
	        if (e.which == 13) {
	          if ($(this).attr('data-flyout') && $(this).attr('aria-expanded') == 'false') {
	            e.preventDefault();
	            $(this).popover('show');
	          }
	        }
	      }).on('click focusout', '.popover', {
	        selector: selector,
	        content: _content2,
	        placement: placement || 'bottom'
	      }, this.clickpopoverLeave)
	      // Adding listener to toggle the aria tags when popover shown/hidden
	      .on('shown.bs.popover', function () {
	        if (('#warehouse-locations' == selector || '#warehouse-locations-t' == selector) && $.cookie('WC_BD_ZIP') != null) {
	          $('#warehouse-search-field').val($.cookie('WC_BD_ZIP').replace('+', ' '));
	        }
	        $(this).attr('aria-expanded', 'true');
	
	        if (_content2 === '#ca-grocery-delivery-postal-code-popover') {
	          $(this).find('#postal-code-input').val($('.user-entered-zip:first').text());
	        }
	
	        $('#delivery-postal-change,  #set-delivery-zipcode').removeAttr('aria-describedby');
	        $('#delivery-postal-change,  #set-delivery-zipcode').find('.popover').removeAttr('role');
	
	        // used to create ada required attributes on popover
	        var identifierSrting = $(selector)[0].id;
	        $(this).find('.popover-content').attr('id', identifierSrting + '-id');
	        // Add tabindex of -1 to the content to prevent a safari bug where the relatedTarget
	        // is not populated when no tabindex is specified this caused all a and input
	        // to not function on click event
	        $(this).find('.popover-content').attr('tabindex', '-1');
	        $(this).find('.popover-content').removeAttr('aria-label');
	        // New requirement to focus on the first visible input on popover shown
	        var firstInput = $(this).find('a,input[type!=hidden]')[0];
	        if (firstInput) $(firstInput).focus();
	        var firstBDInput = $(this).find('div > input[type!=hidden]')[0];
	        setTimeout(function () {
	          if (firstBDInput) {
	            $(firstBDInput).focus();
	          }
	        }, 100);
	        $('#postal-code-input-grocery').on('focusout', function () {
	          var content = $('#postal-code-input-grocery').val();
	          if (content !== undefined && content != '') {
	            $('#postal-code-input-grocery-label').addClass('active');
	          }
	        });
	        var nameOfCategoryInput = $('#delivery-postal-code-popover-container').parent().parent().parent().attr('id');
	        $('#delivery-postal-form').append('<input type="hidden" name="category-grocery-delivery" value="' + nameOfCategoryInput + '">');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      })
	      // stry0123297 - issue with IE with user having to double-click on text boxes in pop-overs
	      // solution to trigger the focus on text boxes on mousedown event
	      .on('mousedown', 'input[type=search], input[type=text]', function () {
	        $(this).trigger('focus');
	      });
	    },
	    hover_click_popover_nav: function hover_click_popover_nav(selector, _content3, trigger) {
	      var hoverClickElement = $(selector);
	      hoverClickElement.attr({
	        'aria-haspopup': 'true',
	        'aria-expanded': 'false'
	      });
	      hoverClickElement.popover({
	        html: true,
	        animation: false,
	        delay: {
	          show: 400,
	          hide: 400
	        },
	        content: function content() {
	          return $(_content3).html();
	        },
	        container: selector,
	        placement: 'bottom',
	        trigger: trigger || 'hover click'
	      }).on('keydown', function (e) {
	        if (e.which == 13) {
	          if ($(this).attr('data-flyout') && $(this).attr('aria-expanded') == 'false') {
	            e.preventDefault();
	            $(this).popover('show');
	          }
	        }
	      }).on('mouseleave focusout', '.popover', {
	        selector: selector,
	        content: _content3
	      }, this.popoverLeave)
	      // Adding listener to toggle the aria tags when popover shown/hidden
	      .on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	        $(this).find('.popover').addClass('top50pixels');
	        $(this).find('.popover-content').attr('role', 'region');
	        // used to create ada attributes on popover
	        var identifierSrting = $(selector)[0].id;
	        $(this).find('.popover-content').attr('id', identifierSrting + '_id');
	        $(this).find('.popover-content').attr('aria-label', identifierSrting + '_label');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	    },
	    /*
	     * Function used to handle closing the pop-over based on which element is receiving focus
	     * If it is not a child element of the pop-over the pop-over will close
	     */
	    popoverLeave: function popoverLeave(event) {
	      var eventType = event.type;
	      var isInput = $(event.target).is('input');
	      // relatedTarget of a focusout event is the element which is receiving focus.
	      var relatedTargetIsContained = $(event.data.selector).get(0) == event.relatedTarget || $.contains($(event.data.selector).get(0), event.relatedTarget);
	      // the first condition is to stop popover from closing if the user tries to select from the browser autocomplete box
	      // the second condition is to keep popover open if focus stays within the popover.
	      if (eventType == 'mouseleave' && !isInput || eventType == 'focusout' && event.target && !relatedTargetIsContained) {
	        if (eventType == 'mouseleave' && COSTCO.Header.checkIsZipSetByAkamai() && COSTCO.zipCodeModal) {
	          // If ZIP code is set by Akamai, force-submit on popover leave
	          COSTCO.zipCodeModal.forceSubmitZipCode();
	        } else {
	          $(event.data.selector).popover('destroy');
	          COSTCO.util.hover_click_popover(event.data.selector, event.data.content, undefined, event.data.placement);
	        }
	      }
	    },
	    clickpopoverLeave: function clickpopoverLeave(event) {
	      event.stopPropagation();
	      var eventType = event.type;
	      var isInput = $(event.target).is('input');
	      // relatedTarget of a focusout event is the element which is receiving focus.
	      var relatedTargetIsContained = $(event.data.selector).get(0) == event.relatedTarget || $.contains($(event.data.selector).get(0), event.relatedTarget);
	      // the first condition is to stop popover from closing if the user tries to select from the browser autocomplete box
	      // the second condition is to keep popover open if focus stays within the popover.
	      if (eventType == 'click' && !isInput && isInput.length === 0 || eventType == 'focusout' && event.target && !relatedTargetIsContained) {
	        if (eventType == 'mouseleave' && COSTCO.Header.checkIsZipSetByAkamai() && COSTCO.zipCodeModal) {
	          // If ZIP code is set by Akamai, force-submit on popover leave
	          COSTCO.zipCodeModal.forceSubmitZipCode();
	        } else {
	          setTimeout(function () {
	            $(event.data.selector).popover('destroy');
	            COSTCO.util.click_popover(event.data.selector, event.data.content, undefined, event.data.placement);
	          }, 100);
	        }
	      }
	    },
	    /*
	     * Function used to get whether or not the element is within the last or first
	     * link within the target level container
	     *
	     * If the need arise we can actually return the decimal position of the element
	     * by looping through the array not exactly needed here
	     *
	     * If the element is the first function will return 0
	     * If the element is the last function will return 1
	     * If other -1
	     */
	    get_element_position: function get_element_position(element, searchCriteria) {
	      var containerDivLinkArr = $(searchCriteria);
	      if (containerDivLinkArr.first()[0] == element) return 0;
	      if (containerDivLinkArr.last()[0] == element) return 1;
	      return -1;
	    },
	    /**
	     * This function makes icons in social networks popover content tabbable for ADA purposes
	     * @param {string} selector - the element which contains a social networks popover
	     * @return {void}
	     */
	    socialNetworksPopover: function socialNetworksPopover(selector) {
	      var popoverElement = $('.' + selector);
	      var popoverContent = $(".social-popover-container").html();
	      popoverElement.attr({
	        'data-content': popoverContent,
	        'aria-haspopup': 'true',
	        'aria-expanded': 'false',
	        'tabindex': 0,
	        'role': 'tooltip'
	      });
	      popoverElement.popover({ sanitize: false }).on('keydown', function (event) {
	        //Enter event keycode
	        if (event.which === 13) {
	          $(this).popover('toggle');
	          //Esc event keycode
	        } else if (event.which === 27) {
	          $(this).popover('hide');
	          //Shift+Tab event keycode
	        } else if (event.shiftKey && event.keyCode === 9) {
	          $(this).popover('hide');
	        }
	      }).on('focus', function () {
	        $(this).popover('toggle');
	        var tooltipElement = $(this);
	        var lastIconArr = document.getElementsByClassName('last-icon');
	        var popoverContentId = $(this).attr('aria-describedby');
	        $.each(lastIconArr, function (index, value) {
	          if (popoverContentId !== undefined && $(lastIconArr[index]).length !== 0) {
	            $(lastIconArr[index]).on('blur', function () {
	              tooltipElement.popover('hide');
	            });
	          }
	        });
	        var contentElements = $('body').find('.social-popover');
	        contentElements.find('img').each(function () {
	          $(this).on('keypress', function () {
	            this.onclick();
	          });
	        });
	      }).on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	      $(':not(.' + selector + ')').on('click', function () {
	        $('.co-help').each(function () {
	          if ($(this).attr('aria-expanded') === 'true') {
	            $(this).popover('hide');
	          }
	        });
	      });
	    },
	
	    /**
	     * Function used to simply show/hide popover capability to add accesibility features
	     * function popover parameters are expected to be defined in the element as normal bootsrap popover
	     *  hover and focus been triggered using data-trigger functionality. 
	     */
	    swatch_accesible_popover: function swatch_accesible_popover(selector) {
	      var popoverElement = $(selector);
	      popoverElement.attr({
	        'aria-haspopup': 'true',
	        'aria-expanded': 'false',
	        'tabindex': 0,
	        'role': 'tooltip'
	      });
	      popoverElement.popover().on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	    },
	    signupFormValidation: function signupFormValidation(element) {
	      $(element).validate({
	        rules: {
	          emailSignUp: {
	            required: true,
	            email: true
	          }
	        },
	        messages: {
	          emailSignUp: messages.ERR_INVALID_EMAIL
	        },
	        errorPlacement: function errorPlacement(error, element) {
	          var p = element.parent('div');
	          error.addClass('emailSignUp');
	          p.after(error);
	        }
	      });
	
	      if ($(element).valid()) {
	        if ($('input[name="emailSignUpFeatureV2"]').val() === 'true') {
	          COSTCO.util.emailSignUpV2Submit('footer');
	        } else {
	          util.emailSubmit(element);
	        }
	      }
	
	      return false;
	    },
	    getMemberCookie: function getMemberCookie() {
	      var isSignedIn = void 0,
	          isMember = false,
	          isValidated = false,
	          isVerified = false,
	          isActive = false,
	          usage = '',
	          membershipNumber = '';
	      var m = $.cookie('wcMember'),
	          h = $.cookie('hashedUserId'),
	          p = $.cookie('rrDisabledPref'),
	          r = $.cookie('rrStoreFlag');
	      if (h != null && h == '""' || h == null && p == null && r == null || h == null && (p != null && p == '""' || r != null && r == '""')) {
	        isSignedIn = false;
	      } else if (h != null && h == '' || h == null && p == null && r == null || h == null && (p != null && p == '' || r != null && r == '')) {
	        isSignedIn = false;
	      } else if (h != null & h != '""' || h == null && p != null && p != '""' && r != null && r != '""') {
	        isSignedIn = true;
	      } else {
	        isSignedIn = 'undefined';
	      }
	      if (m != null && m != 'undefined') {
	        var cArray = m.split(',');
	        if (cArray.length > 1) {
	          if (cArray[1] == '1') {
	            isMember = true;
	          }
	          if (typeof cArray[3] !== 'undefined') {
	            usage = cArray[3];
	          }
	          if (cArray[4] == '1') {
	            isValidated = true;
	          }
	          if (cArray[5] == '1') {
	            isVerified = true;
	          }
	          if (cArray[6] == 'E0002') {
	            isActive = true;
	          }
	          if (typeof cArray[8] !== 'undefined') {
	            membershipNumber = cArray[8];
	          }
	        }
	      } else {
	        isMember = 'undefined';
	      }
	      return {
	        signedIn: isSignedIn,
	        costcoMember: isMember,
	        validated: isValidated,
	        verified: isVerified,
	        active: isActive,
	        usage: usage,
	        membershipNumber: membershipNumber
	      };
	    },
	    /**
	     * This function checks if the user has signed in
	     */
	    isUserSignedIn: function isUserSignedIn() {
	      return this.getMemberCookie().signedIn === "true";
	    },
	    checkSsoLogin: function checkSsoLogin(aTag) {
	      aTag.href += aTag.href.indexOf("?") < 0 ? "?redirectLogin=" + COSTCO.util.isUserLoggedIn() : "&redirectLogin=" + COSTCO.util.isUserLoggedIn();
	    },
	    disbleElementById: function disbleElementById(id) {
	      $("#" + id).hide();
	    },
	    checkAndDisableSignInButton: function checkAndDisableSignInButton() {
	      if (this.isUserLoggedIn()) this.disbleElementById("bd-specific-sign-in-button");
	    },
	
	    /**
	     * This function checks if the user has valid membership
	     */
	    isCostcoMember: function isCostcoMember() {
	      return this.getMemberCookie().costcoMember != 'undefined' ? userInfo.costcoMember : false;
	    },
	    /**
	     * sets a cookie with given name, value, expiration and domain
	     *
	     * @param  {[string]} cookieName - The name of the cookie to set
	     * @param  {[string]} cookieValue - The value for the cookie to set
	     * @param  {[int]} cookieExpires - The number of days until the cookie expires
	     * @parm   {[string]} cookieDomain - The domain of the cookie to set
	     * @return {void}
	     */
	    setCookie: function setCookie(cookieName, cookieVal, cookieExpires, cookieDomain) {
	      cookieExpires = parseInt(cookieExpires);
	      if (typeof cookieDomain !== 'undefined') {
	        $.cookie(cookieName, cookieVal, {
	          expires: cookieExpires,
	          path: '/',
	          domain: cookieDomain
	        });
	      } else {
	        $.cookie(cookieName, cookieVal, {
	          expires: cookieExpires,
	          path: '/'
	        });
	      }
	    },
	
	    /**
	     * Gets the language id of the users's session. default is -1(English)
	     * for US and -24(English) for CA
	     * @return {[int]} the langId
	     */
	    getLangId: function getLangId() {
	      var selectedLang = $.cookie(cookies.SELECTED_LANG_COOKIE);
	      var host = window.location.host;
	      var cookieDomain = wcs.domain;
	      if (host.indexOf('bd-cmc.vqa') > -1 || host.indexOf('bd-cmc.vuat') > -1 || host.indexOf('bd-cmc.ecom') > -1) {
	        cookieDomain = '.costco.com';
	      }
	      if (typeof selectedLang == 'undefined' || !selectedLang) {
	        if (wcs.hasOwnProperty('langId')) {
	          COSTCO.util.setCookie(cookies.SELECTED_LANG_COOKIE, wcs.langId, cookies.SELECTED_LANG_EXPIRES, cookieDomain);
	          return parseInt(wcs.langId);
	        } else {
	          // check for stgbrowse costco domains
	          if (host.indexOf('stgbrowseca') > -1 || host.indexOf('stgbrowse-ca') > -1 || host.indexOf('ca-cmc') > -1 || host.indexOf('ca-stage') > -1) {
	            return -24;
	          }
	          if (host.indexOf('.com') > -1) {
	            return -1; // Default .com lang
	          } else {
	            COSTCO.util.setCookie(cookies.SELECTED_LANG_COOKIE, "-24", cookies.SELECTED_LANG_EXPIRES, cookieDomain);
	            return -24; // Default .ca lang
	          }
	        }
	      } else {
	        // The selectedLanguage cookie exists and the selectedLanguageOld cookie does not exist. 
	        this.registerLanguageListener();
	      }
	      return selectedLang;
	    },
	    /**
	     * Get the warehouse number for the user's session - used mainly for image templates
	     */
	    getWarehouseNumber: function getWarehouseNumber() {
	      var langId = this.getLangId();
	      if (langId < -1) {
	        return 894;
	      } else {
	        return 847;
	      }
	    },
	    /**
	     * Gets the string value of the user's region. Default is null.
	     * @return {[string]} the string value of SELECTED_REGION_COOKIE
	     */
	    getRegion: function getRegion() {
	      var selectedRegion = $.cookie(cookies.SELECTED_REGION_COOKIE);
	      if (typeof selectedRegion == 'undefined' || !selectedRegion) {
	        selectedRegion = null;
	      }
	      return selectedRegion;
	    },
	    getScreenType: function getScreenType() {
	      var width = $(window).width();
	      if (width >= 1025) return 'DESKTOP';
	      if (width >= 769) return 'TABLET-LANDSCAPE';
	      if (width >= 668) return 'TABLET-PORTRAIT';
	      if (width >= 376) return 'PHONE-LANDSCAPE';
	      return 'PHONE-PORTRAIT';
	    },
	    is_touch_device: function is_touch_device() {
	      return 'ontouchstart' in window // works on most browsers
	      || navigator.maxTouchPoints; // works on IE10/11 and Surface
	    },
	    buildEmailSignUpV2Req: function buildEmailSignUpV2Req(sel) {
	      var userEmail = '';
	      var userMemberNum = '';
	      var userWhNum = '';
	      var userLangPref = '';
	      var userSite = '';
	      var dataSource = '';
	
	      var zipCookieKey = 'invCheckPostalCode';
	      if (COSTCO.util.isBDStore()) {
	        zipCookieKey = 'WC_BD_ZIP';
	      }
	      var rawZip = COSTCO.util.getCookieByName(zipCookieKey) || '';
	      var userZip = decodeURIComponent(rawZip);
	
	      if (COSTCO.util.isBDStore()) {
	        userWhNum = COSTCO.util.getCookieByName('WC_BD_WHS') || '';
	      } else {
	        var prefWhDetails = localStorage.getItem('preferredWarehouse');
	        var pWhDetailsJSON = prefWhDetails ? JSON.parse(prefWhDetails) : {};
	        userWhNum = pWhDetailsJSON.warehouseId || '';
	      }
	
	      var signUpForm = $('form[id="signup_form"]');
	      var emailOffersForm = $('form[id="EmailOffersForm"]');
	
	      if (sel === 'page' && signUpForm.length > 0) {
	        dataSource = 'Signup page';
	        userEmail = signUpForm.find('input[name="email"]').val().trim() || '';
	        userMemberNum = signUpForm.find('input[name="custom_membernumber"]').val().trim() || '';
	
	        if (COSTCO.util.isUSStore()) {
	          userWhNum = signUpForm.find('select[name="custom_local_whse_number"]').val() || '';
	        } else if (COSTCO.util.isCAStore()) {
	          userWhNum = signUpForm.find('select[name="custom_warehouse_number"]').val() || '';
	        }
	
	        if (COSTCO.util.isUSBDStore()) {
	          userZip = signUpForm.find('input[name="zip"]').val().trim() || '';
	        } else if (COSTCO.util.isCABDStore()) {
	          userZip = signUpForm.find('input[name="custom_postalcode"]').val().trim() || '';
	        }
	      } else if (sel === 'footer' && emailOffersForm.length > 0) {
	        dataSource = 'Footer Signup';
	        userEmail = emailOffersForm.find('input[name="emailSignUp"]').val().trim() || '';
	
	        var wcMember = COSTCO.util.getCookieByName('wcMember');
	        if (wcMember !== null && typeof wcMember !== 'undefined') {
	          var cArray = wcMember.split(',');
	          if (cArray.length > 1) {
	            if (typeof cArray[8] !== 'undefined') {
	              membershipNumber = cArray[8];
	            }
	          }
	        }
	      }
	
	      var enCheck = signUpForm.find('input[name="slid_1"][id="en"]:not([type="hidden"])');
	      var frCheck = signUpForm.find('input[name="slid_1"][id="fr"]:not([type="hidden"])');
	      if (enCheck.length > 0 && enCheck.prop('checked')) {
	        userLangPref = 'EN';
	      } else if (frCheck.length > 0 && frCheck.prop('checked')) {
	        userLangPref = 'FR';
	      } else {
	        userLangPref = COSTCO.util.getLocale().slice(0, 2).toUpperCase();
	      }
	
	      if (COSTCO.util.isUSStore()) {
	        userSite = 'USBC';
	      } else if (COSTCO.util.isCAStore()) {
	        userSite = 'CABC';
	      } else if (COSTCO.util.isUSBDStore()) {
	        userSite = 'USBD';
	      } else if (COSTCO.util.isCABDStore()) {
	        userSite = 'CABD';
	      } else {
	        userSite = 'USBC';
	      }
	
	      var reqBody = {
	        'emailAddress': userEmail,
	        'memberNumber': userMemberNum,
	        'warehouse': userWhNum,
	        'languagePref': userLangPref,
	        'zip': userZip,
	        'site': userSite,
	        'dataSource': dataSource
	      };
	
	      return reqBody;
	    },
	    emailSignUpV2Submit: function emailSignUpV2Submit(sel) {
	      var emailSignUpV2URL = $('input[name="emailSignUpV2URL"]').val();
	      var emailSignUpV2ClientId = $('input[name="emailSignUpV2ClientId"]').val();
	
	      var requestBody = COSTCO.util.buildEmailSignUpV2Req(sel);
	
	      if (!requestBody.emailAddress || !requestBody.emailAddress.trim()) {
	        return;
	      }
	
	      var requestOptions = {
	        method: 'POST',
	        headers: {
	          'Content-Type': 'application/json',
	          'client-identifier': emailSignUpV2ClientId
	        },
	        body: JSON.stringify(requestBody)
	      };
	
	      fetch(emailSignUpV2URL, requestOptions).then(function (response) {
	        if (!response.ok) throw new Error(response.status);
	        return response.json();
	      }).then(function (data) {
	        if (sel === 'footer') {
	          var successP = '<p class=\'success emailSignUp\'><i class=\'co-checkmark\'></i>' + messages.RWD_VALID_EMAIL_THANKYOU + '.</p>';
	          $('form[id="EmailOffersForm"]').after(successP);
	          $('form[id="EmailOffersForm"]').addClass('hide');
	        }
	      }).catch(function (error) {
	        return console.error(error);
	      });
	    },
	    emailSubmit: function emailSubmit(form) {
	      var locale = COSTCO.util.getLocale();
	      var isWhatCountsEnabled = $("input[name='whatCountsEventsFeatureFlagFooter']").val();
	      var isAdobeEnabled = $("input[name='adobePreferencesFeatureFlagFooter']").val();
	      if (isAdobeEnabled == 'true') {
	        if (locale != 'en-US') {
	          var url = form.action;
	          document.location.href = url;
	        } else {
	          var data = {
	            memberNumber: '',
	            emailAddress: $('#footer-email-offers').val().trim(),
	            listSource: 'Footer SignUp'
	          };
	          COSTCO.AdobeEvents.sendEmailSubscriptionEvent($("input[name='adobeSubscribeEndpointFooter']").val(), contextVariables, data);
	        }
	      }
	      if (isWhatCountsEnabled == 'true' || isWhatCountsEnabled === '1') {
	        if (locale != 'en-US') {
	          var _url = form.action;
	          document.location.href = _url;
	        } else {
	          $.ajax({
	            type: 'POST',
	            url: form.action,
	            data: 'emailSignUp=' + form['emailSignUp'].value,
	            success: function success() {
	              $(form).find('input[type=text]').each(function () {
	                $(this).val('');
	              });
	            }
	          });
	        }
	      }
	      var successP = '<p class=\'success emailSignUp\'><i class=\'co-checkmark\'></i>' + messages.RWD_VALID_EMAIL_THANKYOU + '.</p>';
	      $(form).after(successP);
	      $(form).addClass('hide');
	      return false;
	    },
	
	    emailSubscribeForm: function emailSubscribeForm(element) {
	      $.validator.addMethod('countryspecificpostalcodePassCountrySelectorModal', function (value, element) {
	        return !(COSTCO.util.getLangId() == -1) ? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value)) : this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value));
	      }, messages.ERR_ENTER_ZIPCODE);
	      $.validator.addMethod('email', function (value, element) {
	        return (/^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/.test(value.toLowerCase())
	        );
	      }, messages.JS_VALID_EMAIL);
	      $(element).validate({
	        rules: {
	          emailAddress: {
	            required: true,
	            email: true
	          },
	          deliveryZipCode: {
	            required: true,
	            countryspecificpostalcodePassCountrySelectorModal: true
	          }
	        },
	        messages: {
	          emailAddress: messages.ERR_INVALID_EMAIL,
	          deliveryZipCode: messages.ERR_ENTER_ZIPCODE
	        },
	        errorPlacement: function errorPlacement(error, element) {
	          if (element.attr('name') == 'emailAddress') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=emailAddress]'));
	          } else if (element.attr('name') == 'deliveryZipCode') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=deliveryZipCode]'));
	          } else {
	            error.insertAfter(element);
	          }
	        }
	      });
	      if ($(element).valid()) {
	        util.emailSubscribeSubmit(element);
	      }
	      return false;
	    },
	
	    emailSubscribeSubmit: function emailSubscribeSubmit(form) {
	      $.ajax({
	        type: 'POST',
	        url: form.action,
	        data: 'emailAddress=' + form['emailAddress'].value + '&deliveryZipCode=' + form['deliveryZipCode'].value + '&newLocation=' + form['newLocation'].value,
	        success: function success() {
	          $(form).find('input[type=text]').each(function () {
	            $(this).val('');
	          });
	        }
	      });
	      var successP = '<p class=\'success emailAddress\'><i class=\'co-checkmark\'></i>' + messages.RWD_VALID_EMAIL_THANKYOU + '.</p>';
	      $(form).after(successP);
	      $(form).addClass('hide');
	      return false;
	    },
	
	    emailTruckloadSubscribeForm: function emailTruckloadSubscribeForm(element) {
	      var errorElement = null; // Variable to store the first error element
	      $.validator.addMethod('email', function (value, element) {
	        return this.optional(element) || /^.+@(([^.])+\.)+([^.])+$/i.test(value);
	      }, messages.ERR_INVALID_EMAIL);
	      $.validator.addMethod('costcoMembership', function (value, element) {
	        return this.optional(element) || /^\d{12,16}$/.test(value);
	      }, messages.ERR_INVALID_MEMBERSHIP_NO_BD);
	      $(element).validate({
	        rules: {
	          userName: { required: true },
	          membershipNo: { required: true, costcoMembership: true },
	          emailAddress: { required: true, email: true }
	        },
	        messages: {
	          userName: messages.ERR_USERNAME_REQUIRED,
	          membershipNo: { required: messages.ERR_MEMBERSHIP_NUMBER_REQUIRED, costcoMembership: messages.ERR_INVALID_MEMBERSHIP },
	          emailAddress: { required: messages.ERR_REQUIRED_EMAIL_MY, email: messages.ERR_INVALID_EMAIL }
	        },
	        errorPlacement: function errorPlacement(error, element) {
	          if (!errorElement) {
	            // Store the first error element
	            errorElement = element;
	          } else if (element.attr('name') == 'userName') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=userName]'));
	          } else if (element.attr('name') == 'membershipNo') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=membershipNo]'));
	          } else if (element.attr('name') == 'emailAddress') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=emailAddress]'));
	          } else {
	            error.insertAfter(element);
	          }
	        }
	      });
	      if ($(element).valid()) {
	        util.emailTruckloadSubscribeSubmit(element);
	      } else {
	        errorElement.focus();
	      }
	      return false;
	    },
	
	    emailTruckloadSubscribeSubmit: function emailTruckloadSubscribeSubmit(form) {
	      event.preventDefault();
	      $.ajax({
	        type: 'POST',
	        url: form.action,
	        data: 'emailAddress=' + form['emailAddress'].value + '&userName=' + form['userName'].value + '&membershipNo=' + form['membershipNo'].value + '&BusinessName=' + form['BusinessName'].value + '&Address1=' + form['Address1'].value + '&Address2=' + form['Address2'].value + '&City=' + form['City'].value + '&State=' + form['State'].value + '&zipcode=' + form['zipcode'].value + '&phonenumber=' + form['phonenumber'].value + '&items=' + form['items'].value,
	        success: function success() {
	          $(form).find('input[type=text]').each(function () {
	            $(this).val('');
	          });
	          $(form).find('input[type=email]').each(function () {
	            $(this).val('');
	          });
	        }
	      });
	      var successP = '<p id="successP" tabindex="0" class=\'success emailAddress\'><i class=\'co-checkmark\'></i>' + " " + messages.MSG_EMAIL_RECEIVED + '.</p>';
	      $(form).before(successP);
	      $(form).addClass('hide');
	      document.getElementById('successP').focus();
	      return false;
	    },
	
	    /**
	     * This function appends an additional panel to an existing accordion using
	     * the accordion_id. The header and body represent the HTML that will display
	     * for this add on.
	     * @param  {[string]} accordion_id - The accordion data structure's id
	     * @param  {[string]} header - String (html) to display as the panel header
	     * @param  {[string]} body - String (html) to display as the panel body
	     * @return {[void]}
	     */
	    accordion_addon: function accordion_addon(accordion_id, header, body, handlers, parent) {
	      var position = $('#' + accordion_id).children().length + 1;
	      var handlerTemplate = void 0;
	      if (typeof handlers == 'undefined') {
	        handlerTemplate = '';
	      } else {
	        handlerTemplate = handlers;
	      }
	      $('#' + accordion_id).append(this.tmpl('tmpl_accordion_addon', {
	        accordion_id: accordion_id,
	        pos: position,
	        header: header,
	        body: body,
	        handlers: handlerTemplate,
	        parent: parent !== 'undefined' ? parent : true
	      }));
	    },
	    /**
	     * Retrieve the value of the 'rememberedShowMemberItem' cookie
	     * used to display member-only pricing without the need to sign in
	     */
	    getRememberedShowMemberItem: function getRememberedShowMemberItem() {
	      var rememberMeCookie = $.cookie('rememberedShowMemberItem');
	      var cookieExists = rememberMeCookie === undefined || rememberMeCookie === null ? false : true;
	      return cookieExists;
	    },
	    /**
	     * If the user is signed in and has a Costco membership number stored,
	     * show the member-only prices else don't.
	     * @return {[void]}
	     */
	    display_member_prices: function display_member_prices() {
	      var member_cookie = this.getMemberCookie(),
	          signed_in = member_cookie.signedIn || false,
	          is_member = member_cookie.costcoMember || false,
	          is_validated = member_cookie.validated || false,
	          is_active = member_cookie.active || false,
	          is_bd = util.isBusinessDelivery();
	      var rememberMe = this.getRememberedShowMemberItem();
	      // This check is added to keep BD flow unaffected by the change in BC flow
	      var display_moi_price = COSTCO.util.isBusinessDelivery() ? signed_in && is_member : signed_in && is_member && is_validated && is_active;
	      if (display_moi_price) {
	        $('.moi,.mapi').show();
	      } else if (signed_in) {
	        $('.mapi').show();
	        $('.moi').hide();
	      } else if (rememberMe) {
	        $('.mapi').hide();
	        $('.moi').show();
	      } else {
	        $('.moi,.mapi').hide();
	        $('.mapi').parent().find('.map-item').removeClass('hide');
	      }
	    },
	
	    /**
	     * If the user is signed in and has a Costco membership number stored,
	     * show the Select Options or Sign in for Price Button
	     * @return {[void]}
	     */
	    display_SelectOrSignInButton: function display_SelectOrSignInButton() {
	      var member_cookie = this.getMemberCookie();
	      $('.product-tile-set').each(function (element, index) {
	        if ($(this).find('.member-only').length > 0) {
	          if (member_cookie.signedIn) {
	            $(this).find('.select-option-button, .see-details-button').removeClass('hide');
	          } else {
	            $(this).find('.sign-in-button').removeClass('hide');
	          }
	        } else if ($(this).find('#mapItem').length > 0 && !member_cookie.signedIn) {
	          $(this).find('.sign-in-button').removeClass('hide');
	        } else {
	          $(this).find('.select-option-button, .see-details-button').removeClass('hide');
	        }
	      });
	    },
	    /**
	     * This is used by inline links to pop the email offers modal. It is
	     * attached to the TopRow_ESpot_4 "Sign Up" link but can be used anywhere
	     * a "get email offers" modal is necessary.
	     * @return {[void]}
	     */
	    get_email_offers: function get_email_offers() {
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.RWD_GET_EMAIL_OFFERS,
	        body: this.tmpl('tmpl_email_offers', {}),
	        primary: messages.EMAIL_BUTTON_TITLE,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          !$('#costcoModal p.success').length > 0 ? $('#costcoModal form').submit() : $('#costcoModalBtn2').hide();
	        }
	      });
	    },
	    /**
	     * This function is the entry point for the front-end citi credit card
	     * application process.  The business includes this javascript in an <a onclick/>,
	     * which will initiate the ajax call.  From here, the path can go 2 different ways
	     * 1.  	If the user has authorized users, they are provided with a dialog, allowing
	     * 		them to choose from a list of authorized users, or none at all.
	     * 2.	If the baseUrl is not included an the whitelist, it will show the
	     * 		external link dialog to user, otherwise it will open a new tab to the url.
	     */
	    getBrandFolderVideo: function getBrandFolderVideo(assetKey, folderkey) {
	      var baseUriForBrandfolder = $('#baseUriForBrandfolder' + folderkey).val();
	      var bearerTokenForBrandfolder = $('#bearerTokenForBrandfolder').val();
	      var bfHeaders = {};
	      bfHeaders["Authorization"] = bearerTokenForBrandfolder;
	      fetch(baseUriForBrandfolder + assetKey, {
	        method: "GET",
	        headers: bfHeaders
	      }).then(function (response) {
	        if (response.status >= 200 && response.status <= 299) {
	          return response.json();
	        } else {
	          throw Error(response.statusText);
	        }
	      }).then(function (jsonResponse) {
	        var title = "";
	        try {
	          title = jsonResponse.data[0].attributes.name;
	        } catch (e) {
	          console.log('Title could not be retrieved from BrandFolder');
	        }
	        window.eventBus.publish('popupShow', { asset_key: assetKey, title: title, bfFolderType: folderkey });
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    applyForCostcoCredit: function applyForCostcoCredit(baseUrl, authorizedMemNum) {
	      COSTCO.util.ajaxSend();
	      if (typeof PageAnalyticsInfo !== 'undefined') {
	        var pageType = PageAnalyticsInfo.pageType;
	      }
	      $.ajax({
	        type: 'POST',
	        url: 'https://' + location.hostname + '/ApplyForCostcoCredit',
	        dataType: 'jsonp',
	        data: {
	          'authorizedMemNum': authorizedMemNum,
	          'pageType': pageType
	        },
	        success: function success(parsedDataJson) {
	          // Show dropdown of member numbers to choose
	          if (parsedDataJson.errorCode) {
	            if (parsedDataJson.errorCode == 2510) // session timeout
	              {
	                document.location.href = 'Logoff?URL=ReLogonFormView&storeId=' + wcs.storeId;
	                return;
	              }
	          }
	
	          var data = parsedDataJson.applicationPrepopData;
	          var token = '';
	          var citiRedirectUrl = '';
	          var authorizedMembersJsonArray = [];
	
	          if (data) {
	            token = data.CITI_MEMBERDATA_SIGNED_ENCRYPTED;
	          }
	
	          if (baseUrl && token) {
	            citiRedirectUrl = '' + baseUrl + token;
	          }
	
	          var payloadJson = {
	            'applicationPrepopData': data
	          };
	
	          if (parsedDataJson.authorizedMembers) {
	            authorizedMembersJsonArray = $.parseJSON(parsedDataJson.authorizedMembers);
	          }
	          //TO-DO: hiding authorizedMember selection modal until funitonality is implemented on backend. 
	          // if (authorizedMembersJsonArray != undefined && authorizedMembersJsonArray.length > 0) {
	          //   util.createMemberNumberSelectDialog(baseUrl, payloadJson, authorizedMembersJsonArray);
	          // } else 
	          if (citiRedirectUrl) {
	            util.createCostcoCreditApplyExtPrefillDialog(citiRedirectUrl);
	          } else {
	            util.createCostcoCreditApplyExtPrefillDialog(baseUrl);
	          }
	        },
	        error: function error(x, t, m) {
	          COSTCO.util.LoginTimeout.updateActivity();
	          if (t === 'timeout') {
	            console.log('timout with server');
	          } else {
	            console.log('unexpected error TODO');
	          }
	          console.log('set return codes for caller of this service TODO');
	        },
	        complete: function complete() {
	          COSTCO.util.ajaxComplete();
	        }
	      });
	      return false;
	    },
	    /**
	     * This is the dialog, allowing users to select authorized users for their citi
	     * application.  This function is referenced solely in applyForCostcoCredit().
	     */
	    createMemberNumberSelectDialog: function createMemberNumberSelectDialog(baseUrl, payloadJson, authorizedMembersJsonArray) {
	      var dialogDiv = $(this.tmpl('tmpl_costco_cc_additional_member', {}));
	      dialogDiv.find(':selected').val(payloadJson);
	      var memberSelect = dialogDiv.find('select');
	      for (var i = 0; i < authorizedMembersJsonArray.length; i++) {
	        memberSelect.append($('<option>', {
	          value: {
	            'applicationPrepopData': authorizedMembersJsonArray[i].memberPayload
	          }
	        }).text(authorizedMembersJsonArray[i].name));
	      }
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.JS_DIALOG_AUTHORIZED_USER_TITLE,
	        body: dialogDiv,
	        primary: messages.JS_DIALOG_AUTHORIZED_USER_OK,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          var authorizedMemNum = $('#authorized-member-select').val();
	          COSTCO.util.dynamicExternalFormPost(baseUrl, payloadJson);
	          $('.costcoModalBtn1').first().click();
	        }
	      });
	      return false;
	    },
	    createCostcoCreditApplyExtDialog: function createCostcoCreditApplyExtDialog(baseUrl, payloadJson) {
	      var dialogDiv = $(this.tmpl('tmpl_costco_cc_apply_confirm', {}));
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.JS_DIALOG_LEAVING_SITE_TITLE,
	        body: dialogDiv,
	        primary: messages.JS_DIALOG_AUTHORIZED_USER_OK,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          COSTCO.util.dynamicExternalFormPost(baseUrl, payloadJson);
	          $('.costcoModalBtn1').first().click();
	        }
	      });
	      return false;
	    },
	    /**
	    * External link dialog for Citi application prefill.
	    */
	    createCostcoCreditApplyExtPrefillDialog: function createCostcoCreditApplyExtPrefillDialog(url) {
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.JS_DIALOG_EXTERNAL_LINK,
	        body: messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary: messages.JS_DIALOG_EXTERNAL_LINK,
	        primary_event: function primary_event() {
	          document.location.href = url;
	          COSTCO.dialog.close();
	        }
	      });
	    },
	    /**
	     * This shows or hides all citi application links based on certain criteria.
	     */
	    showAllCappLinks: function showAllCappLinks(isShow) {
	      if (isShow == undefined || isShow) {
	        $('.citi_credit_app_link').show();
	      } else {
	        $('.citi_credit_app_link').hide();
	      }
	    },
	    /**
	     * This processes the business cases for when users should not be allowed to apply
	     * for citi credit cards.  Links will be hidden, and other text will be shown instead.
	     * For the case where text is shown instead, the business must set this up via CMC.  Please
	     * reference the run documentation provided.
	     */
	    processCappLogic: function processCappLogic() {
	      var capp_json = util.getCappJson();
	      if (capp_json != null) {
	        if (capp_json.coBrandedCreditMax) {
	          // hide all application links
	          util.showAllCappLinks(false);
	        } else if (capp_json.displayErrorForRenew) {
	          // show message and hide all application link
	          $('#displayErrorForRenew').show();
	          util.showAllCappLinks(false);
	        } else if (capp_json.displayErrorForCancel) {
	          // show message and hide all application links
	          $('#displayErrorForCancel').show();
	          util.showAllCappLinks(false);
	        } else if (capp_json.displayErrorForRenewGSHousehold) {
	          // show message and hide all application links
	          $('#displayErrorForRenewGSHousehold').show();
	          util.showAllCappLinks(false);
	        } else {
	          // show credit app links
	          util.showAllCappLinks(true);
	        }
	      } else {
	        // show credit app links
	        util.showAllCappLinks(true);
	      }
	    },
	    /**
	     * Updates the cookie json with the business logic encapsulated in these
	     * attributes.
	     */
	    updateCappJson: function updateCappJson(data) {
	      var capp_json = {};
	      capp_json.coBrandedCreditMax = typeof data !== 'undefined' ? data.coBrandedCreditMax : MembershipMetaData.payload.caller.coBrandedCreditMax;
	      capp_json.displayErrorForRenew = typeof data !== 'undefined' ? data.displayErrorForRenew : MembershipMetaData.payload.caller.displayErrorForRenew;
	      capp_json.displayErrorForCancel = typeof data !== 'undefined' ? data.displayErrorForCancel : MembershipMetaData.payload.caller.displayErrorForCancel;
	      capp_json.displayErrorForRenewGSHousehold = typeof data !== 'undefined' ? data.displayErrorForRenewGSHousehold : MembershipMetaData.payload.caller.displayErrorForRenewGSHousehold;
	      $.cookie('capp_json', JSON.stringify(capp_json), {
	        expires: 30,
	        path: '/'
	      });
	    },
	    /**
	     * Retrieves citi cookie and converts to json.
	     */
	    getCappJson: function getCappJson() {
	      var capp_json = $.cookie('capp_json');
	      if (capp_json != null) {
	        capp_json = JSON.parse(capp_json);
	      }
	      return capp_json;
	    },
	    /**
	     * Create external post form, to be used in a dialog (if on whitelist)
	     * or incorporated into the external link dialog.  dataJson is converted
	     * into hidden inputs to pass in the form. Form opens to new tab.
	     */
	    dynamicExternalFormPost: function dynamicExternalFormPost(url, dataJson) {
	      var dynamicPostForm = $('<form method=\'POST\' action=\'' + url + '\' target=\'_blank\' enctype=\'multipart/form-data\'></form>');
	      for (var key in dataJson) {
	        if (dataJson.hasOwnProperty(key)) {
	          dynamicPostForm.append($('<input type=\'hidden\' name=\'' + key + '\' value=\'' + dataJson[key] + '\'/>'));
	        }
	      }
	      // Pushing the form into the DOM and then submitting, IE complains if not done.
	      $('body').append($('<div id=\'external_link\' style=\'display:hidden\'/>').append(dynamicPostForm.clone()));
	      $('#external_link form').submit();
	      $('#external_link form').remove();
	    },
	    /**
	     * Ajax spinner for send.
	     */
	    ajaxSend: function ajaxSend() {
	      if ($('#dataGlobalSpinner').length == 0) {
	        var spinner = '<div class="ui-widget-overlay ui-front r1_spinner" id="dataGlobalSpinner"></div>';
	        $('body').append(spinner);
	      } else {
	        $('#dataGlobalSpinner').append('<div/>');
	      }
	    },
	    /**
	     * Ajax spinner for completion.  Multiple ajax spinners could be going, so this
	     * will only take one out with each call.
	     */
	    ajaxComplete: function ajaxComplete() {
	      var spinner = $('#dataGlobalSpinner');
	      if (spinner.length > 0 && spinner.children().length == 0) {
	        spinner.remove();
	      } else {
	        $(spinner.children()[0]).remove();
	      }
	    },
	    /**
	     * Login timeout logic incorporated from legacy js that is referenced.
	     */
	    LoginTimeout: {
	      redirectView: '/LogonForm',
	      lastActivity: '',
	      checkTimeout: function checkTimeout() {
	        if (COSTCO.util.LoginTimeout.lastActivity == '') {
	          return;
	        }
	        var now = new Date().getTime();
	        var diff = now - COSTCO.util.LoginTimeout.lastActivity;
	        if (diff > wcs.loginTimeOut) {
	          window.location.href = COSTCO.util.LoginTimeout.redirectView;
	          throw new Error('Stale browser - redirecting');
	        }
	      },
	      updateActivity: function updateActivity() {
	        COSTCO.util.LoginTimeout.lastActivity = new Date().getTime();
	      }
	    },
	    /**
	     * Get a parsed object from localStorage (if localStorage is available).
	     * @param  {[item]} item - the key to pull from localStorage
	     * @return {[object]} storage_item - the object representing the string
	     *  in local storage (or empty object in the case of the item not existing)
	     */
	    getFromStorage: function getFromStorage(item) {
	      var storage_item = {};
	      if (localStorage) {
	        storage_item = localStorage.getItem(item) ? JSON.parse(localStorage.getItem(item)) : {};
	      }
	      return storage_item;
	    },
	    /**
	     * Set a string/object in localStorage for later use (if localStorage is available)
	     * @param {[string]} name - key to reference the value
	     * @param {[string|object]} item - value to store in localStorage
	     */
	    setInStorage: function setInStorage(name, item) {
	      var item = typeof item === 'string' ? item : JSON.stringify(item);
	      if (localStorage) {
	        localStorage.setItem(name, item);
	      }
	    },
	    /**
	     * Get a parsed object from sessionStorage (if sessionStorage is available).
	     * @param  {[item]} item - the key to pull from sessionStorage
	     * @return {[object]} storage_item - the object representing the string
	     *  in session storage (or empty object in the case of the item not existing)
	     */
	    getFromSession: function getFromSession(item) {
	      var storage_item = {};
	      if (sessionStorage) {
	        storage_item = sessionStorage.getItem(item) ? JSON.parse(sessionStorage.getItem(item)) : {};
	      }
	      return storage_item;
	    },
	    /**
	     * Set a string/object in sessionStorage for later use (if sessionStorage
	     * is available)
	     * @param {[string]} name - key to reference the value
	     * @param {[string|object]} item - value to store in sessionStorage
	     */
	    setInSession: function setInSession(name, item) {
	      var item = typeof item === 'string' ? item : JSON.stringify(item);
	      if (sessionStorage) {
	        sessionStorage.setItem(name, item);
	      }
	    },
	    /**
	     * Remove object from sessionStorage (if sessionStorage is available).
	     * @param  {[name]} name - key for item to be removed from sessionStorage
	     * @return none
	     *
	     */
	    removeFromSession: function removeFromSession(name) {
	      if (sessionStorage) {
	        sessionStorage.removeItem(name);
	      }
	    },
	    /**
	     * Shamelessly stolen from stackoverflow. Get the query string by name
	     * @param  {[type]}
	     * @param  {[type]}
	     * @return {[type]}
	     */
	    getParameterByName: function getParameterByName(name, url) {
	      if (!url) url = window.location.href;
	      name = name.replace(/[\[\]]/g, '\\$&');
	      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
	          results = regex.exec(url);
	      if (!results) return null;
	      if (!results[2]) return '';
	      return decodeURIComponent(results[2].replace(/\+/g, ' '));
	    },
	    /**
	     * Shamelessly stolen from stackoverflow. Adds a single parameter to the URL 
	     * @param  {[type]}
	     * @param  {[type]}
	     * @return {[type]}
	     */
	    insertParamInUrl: function insertParamInUrl(key, value) {
	      key = encodeURIComponent(key);
	      value = encodeURIComponent(value);
	      var kvp = document.location.search.substr(1).split('&');
	      var i = 0;
	      for (; i < kvp.length; i++) {
	        if (kvp[i].startsWith(key + '=')) {
	          var pair = kvp[i].split('=');
	          pair[1] = value;
	          kvp[i] = pair.join('=');
	          break;
	        }
	      }
	      if (i >= kvp.length) {
	        kvp[kvp.length] = [key, value].join('=');
	      }
	      var params = kvp.join('&');
	      return params;
	    },
	    /**
	     * Returns an object representing query string parameters.
	     * @return {[object]} The object represeting query strings
	     *                        &isAwesome=true becomes
	     *                        {"isAwesome":"true"}
	     */
	    get_parameters_as_object: function get_parameters_as_object() {
	      return document.location.search.replace(/(^\?)/, '').split('&').map(function (n) {
	        return n = n.split('='), this[n[0]] = n[1], this;
	      }.bind({}))[0];
	    },
	    all: function all(arr, p) {
	      // from haskell's data.list
	      var test = true;
	      arr.forEach(function (x) {
	        if (!p(x)) {
	          test = false;
	          return;
	        }
	      });
	      return test;
	    },
	    /**
	     * Returns True if at least one item in the array fulfills the condition
	     * @param  {[array]}    arr - the array to test
	     * @param  {[function]} p - the predicate function to test against the array
	     * @return {Boolean}
	     */
	    any: function any(arr, p) {
	      var answer = false;
	      for (var i = 0, len = arr.length; i < len; i++) {
	        if (answer) break;
	        if (p(arr[i])) {
	          answer = true;
	          break;
	        }
	      }
	      return answer;
	    },
	    hasElem: function hasElem(elem, array) {
	      var hasit = false;
	      array.forEach(function (e, i) {
	        if (elem === e) hasit = true;
	        return;
	      });
	      return hasit;
	    },
	    localeSpecificCurrency: function localeSpecificCurrency(v, loc, c) {
	      var n = parseFloat(v);
	      if (isNaN(v)) return v;
	      c = typeof c != 'undefined' ? c : 2;
	      switch (loc) {
	        case 'fr':
	          return this.formatCurrency(n, c, ',', ' ') + ' $';
	        default:
	          return '$' + this.formatCurrency(n, c, '.', ',');
	      }
	    },
	    formatCurrency: function formatCurrency(n, c, d, t) {
	      var c = isNaN(c = Math.abs(c)) ? 2 : c,
	          d = d == undefined ? ',' : d,
	          t = t == undefined ? '.' : t,
	          s = n < 0 ? '-' : '',
	          i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + '',
	          j = (j = i.length) > 3 ? j % 3 : 0;
	      return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
	    },
	    formatMoney: function formatMoney(number, has_symbol) {
	      var number = (Math.round(number * 100) / 100).toString(),
	          dollars = number.split('.')[0],
	          cents = (number.split('.')[1] || '') + '00';
	      dollars = dollars.split('').reverse().join('').replace(/(\d{3}(?!$))/g, '$1,').split('').reverse().join(''), symbol = has_symbol ? '$' : '';
	      var locale = COSTCO.util.getLocale();
	      if (locale == 'fr-CA') {
	        return dollars.split(',').join(' ') + ',' + cents.slice(0, 2) + ' ' + symbol;
	      }
	      return symbol + dollars + '.' + cents.slice(0, 2);
	    },
	    formatPhone: function formatPhone(number) {
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
	        return number.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
	      } else {
	        return number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
	      }
	    },
	    // public method for encoding
	    encode: function encode(input) {
	      var output = '';
	      var chr1 = void 0,
	          chr2 = void 0,
	          chr3 = void 0,
	          enc1 = void 0,
	          enc2 = void 0,
	          enc3 = void 0,
	          enc4 = void 0;
	      var i = 0;
	      input = COSTCO.util._utf8_encode(input);
	      while (i < input.length) {
	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);
	        enc1 = chr1 >> 2;
	        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
	        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
	        enc4 = chr3 & 63;
	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }
	        output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
	      }
	      return output;
	    },
	    // public method for decoding
	    decode: function decode(input) {
	      var output = '';
	      var chr1 = void 0,
	          chr2 = void 0,
	          chr3 = void 0;
	      var enc1 = void 0,
	          enc2 = void 0,
	          enc3 = void 0,
	          enc4 = void 0;
	      var i = 0;
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
	      while (i < input.length) {
	        enc1 = this._keyStr.indexOf(input.charAt(i++));
	        enc2 = this._keyStr.indexOf(input.charAt(i++));
	        enc3 = this._keyStr.indexOf(input.charAt(i++));
	        enc4 = this._keyStr.indexOf(input.charAt(i++));
	        chr1 = enc1 << 2 | enc2 >> 4;
	        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
	        chr3 = (enc3 & 3) << 6 | enc4;
	        output = output + String.fromCharCode(chr1);
	        if (enc3 != 64) {
	          output = output + String.fromCharCode(chr2);
	        }
	        if (enc4 != 64) {
	          output = output + String.fromCharCode(chr3);
	        }
	      }
	      output = COSTCO.util._utf8_decode(output);
	      return output;
	    },
	    // private method for UTF-8 decoding
	    _utf8_decode: function _utf8_decode(utftext) {
	      var string = '';
	      var i = 0;
	      var c = c1 = c2 = 0;
	      while (i < utftext.length) {
	        c = utftext.charCodeAt(i);
	        if (c < 128) {
	          string += String.fromCharCode(c);
	          i++;
	        } else if (c > 191 && c < 224) {
	          c2 = utftext.charCodeAt(i + 1);
	          string += String.fromCharCode((c & 31) << 6 | c2 & 63);
	          i += 2;
	        } else {
	          c2 = utftext.charCodeAt(i + 1);
	          c3 = utftext.charCodeAt(i + 2);
	          string += String.fromCharCode((c & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
	          i += 3;
	        }
	      }
	      return string;
	    },
	    // private method for UTF-8 encoding
	    _utf8_encode: function _utf8_encode(string) {
	      string = string.replace(/\r\n/g, '\n');
	      var utftext = '';
	      for (var n = 0; n < string.length; n++) {
	        var c = string.charCodeAt(n);
	        if (c < 128) {
	          utftext += String.fromCharCode(c);
	        } else if (c > 127 && c < 2048) {
	          utftext += String.fromCharCode(c >> 6 | 192);
	          utftext += String.fromCharCode(c & 63 | 128);
	        } else {
	          utftext += String.fromCharCode(c >> 12 | 224);
	          utftext += String.fromCharCode(c >> 6 & 63 | 128);
	          utftext += String.fromCharCode(c & 63 | 128);
	        }
	      }
	      return utftext;
	    },
	    /**
	     * Hard coded the locales as our current implementation only supports 3
	     * locales. Also application logic can override the default browser
	     * locale
	     */
	    getLocale: function getLocale() {
	      var langId = this.getLangId();
	      if (langId == -1) return 'en-US';
	      if (langId == -24) return 'en-CA';
	      if (langId == -25) return 'fr-CA';
	      return 'en-US';
	    },
	    isSafari: function isSafari() {
	      var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
	      var is_safari = navigator.userAgent.indexOf('Safari') > -1;
	      if (is_chrome && is_safari) {
	        is_safari = false;
	      }
	      return is_safari;
	    },
	    /**
	     * Function once ran will copy the dom to nodes as needed - helps to avoid a server "DOM Bomb", but places that load on the client
	     *
	     * Required to define placement and content params
	     *
	     * Options can be overriden as needed to use different classes depending how the responsive content is setup.
	     */
	    responsivePlacement: function responsivePlacement(options) {
	      var opt = {
	        placement: '',
	        content: '',
	        useInnerContent: true,
	        display: 'block',
	        DESKTOP: '.visible-xl-',
	        TABLETLANDSCAPE: '.visible-lg-',
	        TABLETPORTRAIT: '.visible-md-',
	        PHONELANDSCAPE: '.visible-sm-',
	        PHONEPORTRAIT: '.visible-xs-'
	      };
	      $.extend(opt, options);
	      var node = $(opt.placement + opt.content);
	      if (node.length < 1) {
	        console.log('Missing Content for RespnsivePlacement');
	        return;
	      }
	      var content = '';
	      if (opt.useInnerContent) content = node.html();else {
	        content = node;
	      }
	      if ($(opt.placement).find('[itemprop=name]')) {
	        $(opt.placement).find('[itemprop=name]').removeAttr('itemprop');
	      }
	
	      COSTCO.util.responsiveContent(opt.placement, opt.DESKTOP + opt.display, content);
	      COSTCO.util.responsiveContent(opt.placement, opt.TABLETLANDSCAPE + opt.display, content);
	      COSTCO.util.responsiveContent(opt.placement, opt.TABLETPORTRAIT + opt.display, content);
	      COSTCO.util.responsiveContent(opt.placement, opt.PHONELANDSCAPE + opt.display, content);
	      COSTCO.util.responsiveContent(opt.placement, opt.PHONEPORTRAIT + opt.display, content);
	      return;
	    },
	    responsiveContent: function responsiveContent(selector, nodeClass, content) {
	      var node = $(selector + nodeClass);
	      if (node.length <= 0) {
	        return;
	      }
	      if (node.html().trim().length <= 0) {
	        node.append(content);
	      }
	      return;
	    },
	    getQueryStringArray: function getQueryStringArray() {
	      var queryString = [];
	      var a = window.location.search.substr(1).split('&'),
	          b = void 0;
	      for (var i = 0; i < a.length; i++) {
	        b = a[i].split('=');
	        queryString[decodeURIComponent(b[0])] = decodeURIComponent(b[1]);
	      }
	      return queryString;
	    },
	    /**
	     * Taken from Underscore.js (http://underscorejs.org/)
	     * Returns a function, that, as long as it continues to be invoked, will not
	     * be triggered. The function will be called after it stops being called for
	     * N milliseconds. If `immediate` is passed, trigger the function on the
	     * leading edge, instead of the trailing.
	     */
	    debounce: function debounce(func, wait, immediate) {
	      var timeout = void 0;
	      return function () {
	        var context = this,
	            args = arguments;
	        clearTimeout(timeout);
	        timeout = setTimeout(function () {
	          timeout = null;
	          if (!immediate) func.apply(context, args);
	        }, wait);
	        if (immediate && !timeout) func.apply(context, args);
	      };
	    },
	    isElementInViewport: function isElementInViewport(el) {
	      if (el.length <= 0) {
	        return false;
	      }
	      var rect = el[0].getBoundingClientRect();
	      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + 600 && /* or $(window).height() */rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */;
	    },
	    onVisibilityChange: function onVisibilityChange(el, callback) {
	      return function () {
	        var visible = COSTCO.util.isElementInViewport(el);
	        if (visible == true) {
	          if (typeof callback == 'function') {
	            callback();
	          }
	        }
	      };
	    },
	    /**
	     * Decode an HTML encoded string. Turns stuff like this
	     * '&lt;p&gt;name&lt;/p&gt;&lt;' and converts it to '<p>name</p>'
	     * @param  {String} encodedHtmlString The html string to decode
	     * @return {String}                   The decoded html string.
	     */
	    get_decoded_html: function get_decoded_html(encodedHtmlString) {
	      var textArea = document.createElement('textarea');
	      textArea.innerHTML = encodedHtmlString;
	      return textArea.value;
	    },
	    /**
	     * Inject an arbitrary number of hidden inputs into a given form. Meant
	     * to be a utility to prevent statically adding key/values to $.ajax.
	     * Just use this function and then serialize the form with $.fn.serialize.
	     * Note that this function will only inject an input into a form if the
	     * named input doesn't already exist.
	     * @param  {String} form   The form selector
	     * @param  {Object} inputs The object representing the key/values to
	     *                         be inserted into the form as inputs
	     *                         {key:'value'}
	     * @return {void}
	     */
	    input_injector: function input_injector(form, inputs) {
	      var html = '';
	      Object.keys(inputs).forEach(function (key) {
	        if ($(form + ' input[name=' + key + ']').length == 0) {
	          html += '<input type=\'hidden\' name=\'' + key + '\' value=\'' + inputs[key] + '\'/>';
	        } else if (key === 'prescriptionId' || key === 'isPharmacy') {
	          $(form + ' input[name=' + key + ']').val(inputs[key]);
	        }
	      });
	      $(form).append(html);
	    },
	    iosModalWhiteSpace: function iosModalWhiteSpace(selectorArray) {
	      // hide the native soft keyboards
	      if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
	        selectorArray.forEach(function (selector) {
	          var formElements = $(selector + ' input,' + selector + ' select,' + selector + ' textarea');
	          $(formElements).unbind('focus.iosModalWhiteSpace').on('focus.iosModalWhiteSpace', function () {
	            $(selector).css({
	              position: 'absolute'
	            });
	          });
	          $(formElements).unbind('blur.iosModalWhiteSpace').on('blur.iosModalWhiteSpace', function () {
	            $(selector).css({
	              position: 'fixed'
	            });
	            window.scrollTo(0, 0);
	          });
	        });
	      }
	    },
	    /**
	     * This fixes the case where the cursor sits outside of the focused input
	     * on iOS devices. It has the unfortunate side effect of scrolling
	     * to the top of the page when the modal is overlayed.
	     * @return {void}
	     */
	    iosPositionFix: function iosPositionFix() {
	      if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
	        var style = $('<style>body.modal-open { position: fixed; }</style>');
	        $('html > head').append(style);
	      }
	    },
	    /**
	     * Check if the application is running on the costco mobile app
	     */
	    isRunningOnMobileApp: function isRunningOnMobileApp() {
	      return typeof Android != 'undefined' || typeof webkit != 'undefined';
	      //return true;
	    },
	    /**
	     * This function compares UserAgent header with mobile pattern regex. If mobile browser is not detected with this way,
	     * it checks if screen width is 1024 or less, which is also being treated as a mobile browser.
	     * 
	     * @returns True if mobile browser is detected
	     */
	    isMobile: function isMobile() {
	      var detectedMobileWithRegex = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune|Nokia|UCWEB/i.test(navigator.userAgent.toLowerCase());
	      var detectedMobileByScreenSize = $(window).width() <= 1024;
	      return detectedMobileWithRegex || detectedMobileByScreenSize;
	    },
	    /**
	     * Generates random UUID number
	     */
	    createUUID: function createUUID() {
	      var dt = new Date().getTime();
	      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        var r = (dt + Math.random() * 16) % 16 | 0;
	        dt = Math.floor(dt / 16);
	        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
	      });
	      return uuid;
	    },
	    /**
	     * Generic ajax wrapper. Set promise handlers inside the options
	     * object. ie options.done: function(){} will be called when the
	     * request is finished. Options object also gets passed back the
	     * the promise functions. Look at the signures below.
	     * @param  {Object} options The object used to pass options.
	     *                          {done: function(){}, hi: 'robert'}
	     * @return {jQuery.Deferred} The deferred object generated by calling
	     *                           $.ajax which can be chained.
	     */
	    ajax: function ajax(options) {
	      var done = void 0;
	      var fail = void 0;
	      var always = void 0;
	      var beforeSend = options.beforeSend || undefined;
	      var complete = options.complete || undefined;
	      options.done ? done = options.done : undefined;
	      options.fail ? fail = options.fail : undefined;
	      options.always ? always = options.always : undefined;
	      // Defaulting adding/removing the "busy" class as a decorator
	      // for beforeSend and complete
	      beforeSend ? options.beforeSend = function (jqXHR, settings) {
	        $('.order-ajax').addClass('ajax-busy');
	        beforeSend(jqXHR, settings);
	      } : options.beforeSend = function (jqXHR, settings) {
	        $('.order-ajax').addClass('ajax-busy');
	      };
	      complete ? options.complete = function (jqXHR, textStatus) {
	        $('.order-ajax, .permanent-ajax-busy').removeClass('ajax-busy');
	        complete(jqXHR, textStatus);
	      } : options.complete = function (jqXHR, textStatus) {
	        if (!options.keepBusy) {
	          $('.order-ajax, .permanent-ajax-busy').removeClass('ajax-busy');
	        }
	      };
	      return $.ajax(options).done(function (data, textStatus, jqXHR) {
	        if (done) done(data, textStatus, jqXHR, options);
	      }).fail(function (jqXHR, textStatus, errorThrown) {
	        if (fail) fail(jqXHR, textStatus, errorThrown, options);
	      }).always(function (data, textStatus, jqXHR) {
	        if (always) always(data, textStatus, jqXHR, options);
	      });
	    },
	    /**
	     * Used by jquery.validate on "validate" function options to scroll to the
	     * first error in the list.
	     * @param  {object} event     The event on the form
	     * @param  {object} validator The validator object associated with the form
	     * @return {void}
	     */
	    invalid_handler: function invalid_handler(event, validator) {
	      if (!validator.numberOfInvalids()) return;
	      var base = $('#costcoModal').hasClass('in') ? '#costcoModal' : 'html, body';
	      base == '#costcoModal' ? $(base).scrollTo(validator.errorList[0].element, 100) : $(base).scrollToElem(validator.errorList[0].element, 100);
	      validator.errorList[0].element.focus();
	    },
	    /**
	     * Check to see if a particular path is part of the checkout flow.
	     * @param  {String}  pathname The path (document.location.pathname)
	     * @return {Boolean}          Is this path part of the checkout flow?
	     */
	    isCheckout: function isCheckout(pathname) {
	      var isCheckout = false;
	      if (pathname == '/CheckoutCartView' || pathname == '/CheckoutCartDisplayView' || pathname == '/CheckoutPaymentView' || pathname == '/CheckoutShippingView' || pathname == '/CheckoutReviewView') {
	        isCheckout = true;
	      }
	      return isCheckout;
	    },
	    triggerClickOnEnterKeyPress: function triggerClickOnEnterKeyPress(inputSelector, clickSelector) {
	      $(inputSelector).unbind('keypress').on('keypress', function (event) {
	        if (event.which == 13) {
	          $(clickSelector).click();
	          return false;
	        }
	      });
	    },
	    /**
	     * Takes a base url and appends query strings to it. Joining the
	     * base and querystring with the appropriate separator '&' or '?'
	     * @param  {string} base           The string to append query strings to
	     *                                 '/order-item-update' or 'www.costco.com'
	     * @param  {object} querystringObj The object representing the querystrings
	     *                                 to append ie '{checkoutPage: 'review'}'
	     * @return {string}                The made url with querystrings attached.
	     */
	    makeUrl: function makeUrl(base, querystringObj) {
	      var sep = base.indexOf('?') > -1 ? '&' : '?';
	      return base + sep + $.param(querystringObj);
	    },
	    /**
	     * Did the ajax response object return any application or system errors?
	     * @param  {object}  response_obj The parsed response object from calling
	     *                                any backend class that resolves to
	     *                                JSONLayout.jsp
	     * @return {Boolean}              Does it have application or system errors?
	     */
	    has_errors: function has_errors(response_obj) {
	      var application = response_obj.error.application;
	      var exception = response_obj.error.exception;
	      return application.length > 0 || exception.length > 0;
	    },
	    messageFormat: function messageFormat(format) {
	      var args = Array.prototype.slice.call(arguments, 1);
	      return format.replace(/{(\d+)}/g, function (match, number) {
	        return typeof args[number] != 'undefined' ? args[number] : match;
	      });
	    },
	    /**
	     * This function restricts membership number inputs to numeric user input.
	     * The input must be of type=text for it to work.
	     * @return {void}
	     */
	    maskMembershipInput: function maskMembershipInput() {
	      $('[name=userField2], [name=membershipNumber], [name=membershipId], [name=membershipNumberToVerify]').mask('#');
	    },
	    addToWishList: function addToWishList(catentryId, fromPage) {
	      window.location.href = COSTCO.util.makeUrl('/AddToWishListView', {
	        catentryId: catentryId,
	        fromPage: fromPage || ''
	      });
	    },
	    isBusinessDelivery: function isBusinessDelivery() {
	      if ($('#isBDAppVar') && $('#isBDAppVar').length > 0) {
	        currentSite = $('#isBDAppVar').val();
	        if (currentSite == 'BD') {
	          return true;
	        }
	      }
	      return false;
	    },
	
	    /**
	     * To initialize global grocery flag. Determine whether grocery product is displayed in the page or not.
	     * @return {Boolean} hasGroceryProducts
	     */
	    hasGroceryProducts: function hasGroceryProducts() {
	      var hasGroceryProducts = false;
	      if ($('#hasGroceryPdts').length > 0) {
	        var globalFlag = $('#hasGroceryPdts').val();
	        if (null != globalFlag && globalFlag == 'true') {
	          hasGroceryProducts = true;
	        }
	      }
	      return hasGroceryProducts;
	    },
	    /**
	     * Determine the default grocery home page url
	     * @return {String} groceryHomepageURL
	     */
	    groceryDefaultHomepage: function groceryDefaultHomepage() {
	      var groceryHomepageURL = '';
	      if ($('#groceryDefaultHomepage').length > 0) {
	        groceryHomepageURL = $('#groceryDefaultHomepage').val();
	      }
	      return groceryHomepageURL;
	    },
	    isCAStore: function isCAStore() {
	      var isCAStore = false;
	      if (null != wcs.storeId && wcs.storeId == '10302') {
	        isCAStore = true;
	      }
	      return isCAStore;
	    },
	    isCABDStore: function isCABDStore() {
	      var isCAStore = false;
	      if (null != wcs.storeId && wcs.storeId == '11303') {
	        isCAStore = true;
	      }
	      return isCAStore;
	    },
	    isUSBDStore: function isUSBDStore() {
	      var isBDStore = false;
	      if (null != wcs.storeId && wcs.storeId == '11301') {
	        isBDStore = true;
	      }
	      return isBDStore;
	    },
	    isBDStore: function isBDStore() {
	      var isBDStore = false;
	      if (null != wcs.storeId && wcs.storeId != '10301' && wcs.storeId != '10302') {
	        isBDStore = true;
	      }
	      return isBDStore;
	    },
	    isUSStore: function isUSStore() {
	      var isUSStore = false;
	      if (null != wcs.storeId && wcs.storeId == '10301') {
	        isUSStore = true;
	      }
	      return isUSStore;
	    },
	    is2DayEligbleRegn: function is2DayEligbleRegn() {
	      var isRegionValid = 'false';
	      if ($.cookie('C_2LOC') != null) {
	        isRegionValid = $.cookie('C_2LOC');
	      }
	      if (isRegionValid != null && COSTCO.util.isCAStore() && isRegionValid == 'false') {
	        return false;
	      }
	      return true;
	    },
	    logToClickTale: function logToClickTale(message, url, lineNumber) {
	      if (typeof window.onerror !== 'function') {
	        console.log('onerror is not a function');
	      }
	      try {
	        if ((typeof message === 'undefined' ? 'undefined' : _typeof(message)) === 'object') {
	          message = JSON.stringify(message);
	        }
	        window.onerror(message, url, lineNumber);
	      } catch (e) {
	        console.log('Unknown error logging to Clicktale');
	      }
	    },
	    getSource: function getSource() {
	      var locale = util.getLocale().slice(3, 5).toUpperCase();
	      var store = util.isBDStore() ? 'BD' : 'BC';
	      return locale + store;
	    },
	    // Begin Business Delivery Client Cookies
	    getBDZipCookie: function getBDZipCookie() {
	      var z = $.cookie('WC_BD_ZIP'),
	          w = $.cookie('WC_BD_WHS'),
	          ec = '',
	          originalZipCode = $.cookie('WC_BD_ZIP_ORIGINAL');
	      if (z == null || z == '""') {
	        z = '';
	      }
	      if (originalZipCode == null || originalZipCode == '""') {
	        originalZipCode = '';
	      }
	      if (w == null || w == '""') {
	        w = '';
	      } else {
	        if (w.indexOf('-') != -1) {
	          //STRY0140687 BD-National Delivery-Check the presence of EC to identify the residential flow.
	          if (w.indexOf('ND') != -1) {
	            var whsArray = w.split('-');
	            if (whsArray.includes('ND')) {
	              ec = 'ND';
	            }
	          }
	          w = w.substring(0, w.indexOf('-'));
	        }
	      }
	      z = z.replace(/\+/g, ' ');
	      originalZipCode = originalZipCode.replace(/\+/g, ' ');
	      return {
	        zipCode: z,
	        warehouseNumber: w,
	        externalCarrier: ec,
	        originalZipCode: originalZipCode
	      };
	    },
	    getMaxOutherHeight: function getMaxOutherHeight(elems) {
	      return Math.max.apply(null, elems.map(function () {
	        return $(this).outerHeight(true);
	      }).get());
	    },
	    isDepotCatalogEnabled: function isDepotCatalogEnabled() {
	      var depotCatalogEnableFlag = $('#depotCatalogEnableFlag').length > 0 && $('#depotCatalogEnableFlag').val() == 'true' ? true : false;
	      return depotCatalogEnableFlag;
	    },
	    isNdEnabled: function isNdEnabled() {
	      if ($('#isNdEnabled').val() == 'true') {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    isEDDEnabled: function isEDDEnabled() {
	      var eddEnabled = true;
	      if (COSTCO.util.checkElementById('#vendorName', 'EDD:CHUBSmallPack') && !COSTCO.util.checkElementById('#eddSmallPackEnabled', 'true')) {
	        eddEnabled = false;
	      }
	      return eddEnabled;
	    },
	
	    isExternalCarrierShipmode: function isExternalCarrierShipmode() {
	      var shipmodeId = '';
	      if (COSTCO.util.isNdEnabled() && ($('input[name="deliveryMethod"]').length > 0 || $('#shipmodeId').length > 0)) {
	        shipmodeId = $('input[name="deliveryMethod"]').length > 0 ? $('input[name="deliveryMethod"]:checked').val() : $('#shipmodeId').val();
	      }
	      if (shipmodeId == '10102' || shipmodeId == '10104') {
	        return true;
	      } else {
	        return false;
	      }
	    },
	
	    isExternalCarrierShipmodeValue: function isExternalCarrierShipmodeValue(shipmodeId) {
	      if (COSTCO.util.isNdEnabled() && shipmodeId.length > 0 && (shipmodeId == '10102' || shipmodeId == '10104')) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	
	    /**
	     * Check if first search suggestion exists and set it to
	     * screen reader announcement div
	     */
	    setFirstSuggestionAnnouncement: function setFirstSuggestionAnnouncement() {
	      if ($('.tt-suggestion').length > 0 && $('#announce-first-suggestion').length > 0 && $('.tt-menu').find('.tt-cursor').length === 0) {
	        var firstSuggestion = $('.tt-suggestion:first').text();
	        $('#announce-first-suggestion').text(firstSuggestion);
	      }
	    },
	
	    /**
	       * Announce first suggestion (if any) after user's inactivity 
	       */
	    announceFirstSuggestion: function announceFirstSuggestion() {
	      if ($('#announce-first-suggestion').length > 0) {
	        $('#announce-first-suggestion').text('');
	      }
	      window.clearTimeout(this.timeout);
	      timeout = window.setTimeout(this.setFirstSuggestionAnnouncement, 2000);
	    },
	    /**
	     * This is to define the constants for the product availablity check
	     */
	    productConstants: {
	      inv_backorderd: 'BACK_ORDER',
	      inv_outOfStock: 'OUT_STOCK',
	      inv_invalidSku: 'INVALID_ITEM',
	      zipcodeAvailCheck_StatusFail: 'FAIL',
	      check_StatusSuccess: 'success',
	      edd_shiprestricted: 'SHIPRESTRICTED',
	      edd_backordered: 'BACKORDERED',
	      edd_presell: 'PRESELL'
	    },
	    /**
	     * Notification object for notification message display.
	     */
	    notification: {
	      /**
	       * Constants for notification display.
	       */
	      type: {
	        SUCCESS: 'SUCCESS',
	        WARNING: 'WARNING',
	        ERROR: 'ERROR'
	      },
	      /**
	       * Displays notification on screen.
	       * @param {string}  notificationType     Type of notification message to display (SUCCESS | WARNING | ERROR)
	       * @param {Array}   notifications        Array of notification messages to be displayed in the notification box
	       * @param {boolean} scrollToNotification Scroll window to notification message
	       * @param {Jquery element}  element           Jquery element for notification display
	       */
	      displayNotification: function displayNotification(notificationType, notifications, scrollToNotification, $element, wrapper) {
	        $element = $element && $($element).length > 0 ? $($element) : $('#notification-message');
	        scrollToNotification = scrollToNotification ? scrollToNotification : false;
	
	        this.clearNotification($element);
	
	        var topNotificationClass = '';
	        var topNotificationInnerHtml = '';
	
	        switch (notificationType) {
	          case this.type.SUCCESS:
	            topNotificationClass = 'success-notification';
	            break;
	          case this.type.WARNING:
	            topNotificationClass = 'warning';
	            break;
	          case this.type.ERROR:
	            topNotificationClass = 'critical-notification';
	            break;
	          default:
	            break;
	        }
	        var elementWrapper = wrapper ? wrapper : 'p';
	        notifications.forEach(function (notification) {
	          if ((typeof notification === 'undefined' ? 'undefined' : _typeof(notification)) === 'object') {
	            for (var errorKey in notification) {
	              topNotificationInnerHtml += '<' + elementWrapper + ' role=\"alert\">' + notification[errorKey] + '</' + elementWrapper + '>';
	            }
	          } else {
	            topNotificationInnerHtml += '<' + elementWrapper + ' role=\"alert\">' + notification + '</' + elementWrapper + '>';
	          }
	        });
	
	        $element.addClass(topNotificationClass);
	
	        topNotificationInnerHtml = COSTCO.util.get_decoded_html(topNotificationInnerHtml);
	        $element.html(topNotificationInnerHtml);
	
	        if (scrollToNotification) {
	          $('body, html').animate({
	            scrollTop: $element.offset().top - 30
	          }, 800);
	        }
	
	        $element.attr('tabindex', -1);
	        $element.focus();
	      },
	      /**
	       * Clears displayed notifications on screen.
	       * @param {Jquery element} Jquery element for notification display.
	       */
	      clearNotification: function clearNotification($element) {
	        $element = $element ? $($element) : $('#notification-message');
	
	        $element.removeClass();
	        $element.html('');
	      }
	    },
	
	    /**
	     * Redirects the pages to generic error/cart on inactive conditions
	     * @param page 
	     * @param orderStatus 
	     */
	    redirectCartOnInactive: function redirectCartOnInactive(page, status) {
	      if ($('#orderStatus').val() !== '' && $('#orderStatus').val() !== undefined) {
	        if ((page === 'SHIPPING' || page === 'payment' || page === 'review') && status === 'INACTIVE') {
	          window.location.href = "/CheckoutCartView";
	        } else if ((page === 'quick-membership' || page === 'quick-membership-renew') && status === 'INACTIVE') {
	          window.location.href = "/GenericError";
	        }
	      }
	    },
	
	    /**
	     * Gets element with back to top link
	     * and (if exists) binds keydown and click event
	     * that moves focus to top of the page
	     * @param backToTopLink
	     */
	    setEventOnBackToTopLink: function setEventOnBackToTopLink(backToTopLinkClass) {
	      var $backToTopLink = $(backToTopLinkClass).find("a").length > 0 ? $(backToTopLinkClass).find("a") : $(backToTopLinkClass);
	      /* ADA STRY0169325 - Back to top functionality */
	      $backToTopLink.attr("href", "#headerskip");
	      $backToTopLink.click(function () {
	        COSTCO.util.scrollToTop();
	      });
	      $backToTopLink.keydown(function (e) {
	        if (e.keyCode === 13) COSTCO.util.scrollToTop();
	      });
	    },
	
	    /**
	     * Function used to add a label with error message accessible only to screen reader
	     * @param element that error label should be attached to
	     */
	    addErrorLabelForAda: function addErrorLabelForAda(element) {
	      if (typeof element !== 'undefined' && element !== null) {
	        var $element = $(element);
	        if ($element.hasClass("error") && !$element.siblings('.sr-only').length) {
	          $element.before("<span for=\"" + $element[0].id + "\" class=\"sr-only\">" + messages.ERROR + "</span>");
	        }
	      }
	    },
	
	    /**
	     * Function used for fetching first global error message on page
	     * @param containerElement - specifies the element in which the global error is searched for
	     * @return first element with global error class
	     */
	    getFirstGlobalErrorOnPage: function getFirstGlobalErrorOnPage(containerElement) {
	      var errorClasses = COSTCO.util.globalErrorElementClasses;
	      //create jquery selector from an array of classes
	      var selector = errorClasses.join(", .");
	      var firstElementWithClass = containerElement.find('.' + selector).html() !== undefined ? containerElement.find('.' + selector).first() : null;
	      var iterationValue = firstElementWithClass;
	      while (iterationValue !== undefined && iterationValue !== null) {
	        firstElementWithClass = iterationValue;
	        iterationValue = COSTCO.util.getFirstGlobalErrorOnPage(firstElementWithClass);
	      }
	      return firstElementWithClass;
	    },
	
	    /**
	     * Function that creates an error label accessible only to screen reader
	     * @param errorMessage that should be appended with screen reader label
	     * @return string containing both the error message and the screen reader only error label
	     */
	    createErrorAdaLabel: function createErrorAdaLabel(errorMessage) {
	      return "<span class='sr-only'>" + messages.ERROR + "</span>" + errorMessage;
	    },
	
	    /**
	     * Function used to remove a label with error message accessible only to screen reader
	     * @param element whose label should be removed
	     */
	    removeErrorLabelForAda: function removeErrorLabelForAda(element) {
	      if (typeof element !== 'undefined' && element !== null) {
	        var $element = $(element);
	        $element.siblings('label').remove(".sr-only");
	        $element.siblings().children('label').remove(".sr-only");
	        $element.parent().siblings('label').remove(".sr-only");
	      }
	    },
	
	    /**
	     * jquery validator 'highlight' method,
	     * with ADA error label added
	     */
	    highlightWithErrorLabel: function highlightWithErrorLabel(element, errorClass, validClass) {
	
	      if (element.type === 'radio') {
	        this.findByName(element.name).addClass(errorClass).removeClass(validClass);
	      } else {
	        $(element).addClass(errorClass).removeClass(validClass);
	        $(element).attr("aria-describedby", this.idOrName(element) + this.settings.idSuffix);
	      }
	      COSTCO.util.addErrorLabelForAda(element);
	    },
	
	    /**
	        * jquery validator 'unhighlight' method,
	        * with ADA error label added
	        */
	    unhighlightWithErrorLabel: function unhighlightWithErrorLabel(element, errorClass, validClass) {
	      if (element.type === 'radio') {
	        this.findByName(element.name).removeClass(errorClass).addClass(validClass);
	      } else {
	        $(element).removeClass(errorClass).addClass(validClass);
	        $(element).removeAttr("aria-describedby");
	      }
	      COSTCO.util.removeErrorLabelForAda(element);
	    },
	
	    /**
	     * Function used to inject message in screen reader placeholder announcement div
	     * @param message to be injected
	     */
	    announceSRMessage: function announceSRMessage(message) {
	      var adaMessageDiv = $('#screen-reader-announcement');
	      if (message !== undefined && message.length !== 0 && message !== "") {
	        adaMessageDiv.empty();
	        adaMessageDiv.html(message);
	
	        //after a 2sec delay, remove the message so SR users don't unneccessarily revisit it when navigating DOM
	        setTimeout(function () {
	          adaMessageDiv.empty();
	        }, 2000);
	      }
	    },
	
	    /**
	     * Calling function onclick by pressing enter key (keyCode = 13)
	     * @param id
	     */
	    clickElementOnEnter: function clickElementOnEnter(elementId) {
	      if (event.keyCode === 13 && $('#' + elementId).length > 0) {
	        $('#' + elementId).click();
	      }
	    },
	
	    /**
	     * Calling function onclick by pressing enter key (keyCode = 13)
	     * or pressing space key (keyCode = 32)
	     * @param id
	     */
	    clickElementOnEnterOrSpace: function clickElementOnEnterOrSpace(elementId) {
	      if ((event.keyCode === 13 || event.keyCode === 32) && $('#' + elementId).length > 0) {
	        //Prevents from window scrolling
	        if (event.keyCode === 32) {
	          event.preventDefault();
	        }
	        //If element is tooltip, do not perfrom action
	        if ($(".span-inline-block").is(":focus")) {
	          return false;
	        }
	        $('#' + elementId).click();
	      }
	    },
	
	    //Workarround for FireFox locked tabbing on radio buttons ALM #22811
	    /**
	     * Calling function onfocus event 
	     * and changing label tabindex attr to -1
	     */
	    changeTabIndex: function changeTabIndex() {
	      var element = $("label[role=radio]");
	      element.each(function () {
	        $(this).attr('tabindex', '-1');
	      });
	    },
	
	    /**
	     * Calling function onblur event making element unfocusable
	     * and changing label tabindex attr back to 0
	     * @param el (date input name)
	     */
	    changeTabIndexOut: function changeTabIndexOut(el) {
	      if (el) {
	        $(el).attr('tabindex', '0');
	      }
	      var element = $("label[role=radio]");
	      element.each(function () {
	        $(this).attr('tabindex', '0');
	      });
	    },
	
	    /**
	     * Calling function onfocus event making date input focusable
	     * @param element (date input name)
	     */
	    setTabIndex: function setTabIndex(el) {
	      var element = $("input[name=" + el + "]");
	      element.attr('tabindex', '0');
	    },
	
	    /**
	     * Calling function onclick by pressing Space key (keyCode = 32) 
	     * referencing element by element's ID
	     * @param elementId
	     */
	    clickElementOnSpaceBtn: function clickElementOnSpaceBtn(elementId) {
	      if (event.keyCode === 32 && $('#' + elementId).length > 0) {
	        //Prevents from window scrolling
	        event.preventDefault();
	        //If element is tooltip, do not perfrom action
	        if ($(".span-inline-block").is(":focus")) {
	          return false;
	        }
	        $('#' + elementId).click();
	      }
	    },
	    /**
	     * Returns all focusable elements inside parent element
	     * @parentElement
	     */
	    returnAllFocusableElements: function returnAllFocusableElements(parentElement) {
	      var focusableElements = parentElement.querySelectorAll('a[href]:not([disabled]), button:not([disabled]),' + 'textarea:not([disabled]),input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]),' + 'input[type="checkbox"]:not([disabled]), select:not([disabled]), *[tabindex="0"], area');
	      return focusableElements;
	    },
	    /**
	     * Returns all visible focusable elements from list of elements
	     * @focusableElements
	     */
	    returnAllFocusableVisibleElements: function returnAllFocusableVisibleElements(focusableElements) {
	      var visibleFocusable = [];
	
	      function findVisibleElements(item, index) {
	        $(item).unbind('keydown');
	        //Does element or its parent has display none
	        if (item.style.display !== "none" && item.offsetParent !== null) {
	          if ($(item).is(':visible')) {
	            visibleFocusable.push(item);
	          }
	        }
	      }
	
	      for (var i = 0; i < focusableElements.length; i++) {
	        findVisibleElements(focusableElements[i]);
	      }
	      return visibleFocusable;
	    },
	    /**
	     * Returns focus to first/last focusable element in modal
	     */
	    setElementFocus: function setElementFocus(firstElement, lastElement, e) {
	      var KEYCODE_TAB = 9;
	      if (e.key === 'Tab' || e.keyCode === KEYCODE_TAB) {
	        if (e.shiftKey && document.activeElement === firstElement) /* shift + tab */{
	            lastElement.focus();
	            e.preventDefault();
	          } else if (!e.shiftKey && document.activeElement === lastElement) {
	          firstElement.focus();
	          e.preventDefault();
	        }
	      }
	    },
	
	    /**
	     * Scrolls page to top
	     */
	    scrollToTop: function scrollToTop() {
	      $('#headerskip').get(0).scrollIntoView(true);
	      $('#headerskip').focus();
	    },
	
	    /**
	     * Focuses on an element without scrolling to it
	     */
	    focusWithoutScroll: function focusWithoutScroll(elem) {
	      var x = window.scrollX;
	      var y = window.scrollY;
	      elem.focus();
	      window.scrollTo(x, y);
	    },
	
	    /**
	     * Sets lisener on first and last
	     * element on modal, and traps focus inside them
	     */
	    bindModalFocusEvents: function bindModalFocusEvents(firstElement, lastElement) {
	      $(firstElement).unbind('keydown').bind('keydown', function (e) {
	        COSTCO.util.setElementFocus(firstElement, lastElement, e);
	      });
	      $(lastElement).unbind('keydown').bind('keydown', function (e) {
	        COSTCO.util.setElementFocus(firstElement, lastElement, e);
	      });
	    },
	    trapFocusInsideModal: function trapFocusInsideModal() {
	      var modalBody = $(".modal-dialog").get(0);
	      if (modalBody != undefined) {
	        var focusableElements = COSTCO.util.returnAllFocusableElements(modalBody);
	        var focusableVisible = COSTCO.util.returnAllFocusableVisibleElements(focusableElements);
	        if (focusableVisible.length > 0) {
	          var firstElement = focusableVisible[0];
	          var lastElement = focusableVisible[focusableVisible.length - 1];
	          COSTCO.util.bindModalFocusEvents(firstElement, lastElement);
	        }
	      }
	    },
	    /**
	     * Showes and hides elemenet based on flag parameter
	     * @param element
	     * @param flag
	     */
	    showHtmlElementByFlag: function showHtmlElementByFlag(element, flag) {
	      if (element == undefined || flag == undefined) {
	        return false;
	      }
	      if (flag === true) {
	        element.removeClass('hide');
	      } else {
	        element.addClass('hide');
	      }
	    },
	    /**
	     * Test if this page is part of new design.
	     * @return true if page is part of new design, false otherwise
	     */
	    isPDPCartCheckoutEnabled: function isPDPCartCheckoutEnabled() {
	      return costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE;
	    },
	
	    /**
	     * Method to convert the date input string to Timestamp format
	     */
	    convertDateToTimestamp: function convertDateToTimestamp(dateSring) {
	      var dateTimeParts = dateSring,
	          dateParts = dateTimeParts.split('-'),
	          date;
	      date = new Date(dateParts[0], parseInt(dateParts[1], 10) - 1, dateParts[2], '00', '00');
	      return date.getTime();
	    },
	    globalErrorElementClasses: ['critical-notification', 'error', 'lists-error', 'form-error-text'],
	    base64test: /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/,
	    _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
	    _keyStrExcl: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
	    getUrlToLangMap: function getUrlToLangMap() {
	      var urlToLanguageMap = sessionStorage.getItem("urlToLanguageMap");
	      if (urlToLanguageMap == null) {
	        return JSON.parse("{}");
	      } else {
	        return JSON.parse(urlToLanguageMap);
	      }
	    },
	    addUrlToLangMap: function addUrlToLangMap(url, selectedLang) {
	      var urlToLanguageMap = COSTCO.util.getUrlToLangMap();
	      // Checked with business and we will accommodate 50 items in history to 
	      // check for language to reasonably meet most of customers' activities.
	      if (Object.keys(urlToLanguageMap).length >= 50) {
	        var keyToDelete = Object.keys(urlToLanguageMap)[0];
	        delete urlToLanguageMap[keyToDelete];
	      }
	      urlToLanguageMap[url] = selectedLang;
	      sessionStorage.setItem("urlToLanguageMap", JSON.stringify(urlToLanguageMap));
	    },
	    removeUrlFromLangMap: function removeUrlFromLangMap(url) {
	      var urlToLanguageMap = COSTCO.util.getUrlToLangMap();
	      delete urlToLanguageMap[url];
	      sessionStorage.setItem("urlToLanguageMap", JSON.stringify(urlToLanguageMap));
	    },
	    /**
	     * 1. Create a map of url pathname and the language at the time the url was accessed 
	     * 2. During browser history back and forward, if the selectedLanguage and value of the language from the map
	     * 		do not match, then do a hard load of the page
	     */
	    registerLanguageListener: function registerLanguageListener() {
	      // Register event if event function is not already defined
	      if (typeof window.onpageshow !== "function") {
	        window.onpageshow = function (event) {
	          var currentLang = $.cookie(cookies.SELECTED_LANG_COOKIE);
	          var currentUrl = window.location.pathname;
	          // event.persisted is faulty, so use window.performance.navigation.type also
	          if (event.persisted || window.performance && window.performance.navigation.type == 2) {
	            // window.performance.navigation.type = 2 means back or forward
	            var langSettingForCurrentUrl = COSTCO.util.getUrlToLangMap()[currentUrl];
	            if (langSettingForCurrentUrl !== undefined && langSettingForCurrentUrl !== currentLang) {
	              console.log("Doing hard reload since language has changed");
	              COSTCO.util.removeUrlFromLangMap(currentUrl);
	              if (isMobileApp == 'true') {
	                COSTCO.myLocation.reloadWithNewLanguage(currentLang);
	              }
	            }
	          } else {
	            COSTCO.util.addUrlToLangMap(currentUrl, currentLang);
	          }
	        };
	      }
	    },
	    /*
	     * A11Y STRY0166460
	     */
	    closeDropdownWhenOutOfFocus: function closeDropdownWhenOutOfFocus() {
	      $('.list-group-item').find('a').focusin(function () {
	        if (!$(this).parents('.dropdown-container').hasClass('open')) {
	          $('.dropdown-container.open').removeClass('open');
	        }
	      });
	      $('#search-field').focusin(function () {
	        $('.dropdown-container.open').removeClass('open');
	      });
	    },
	
	    /* A screen reader user should only be able to access one search field 
	     * ADA STRY0166458
	     */
	
	    addAriaHiddenToHiddenInput: function addAriaHiddenToHiddenInput() {
	      $("input[type=text].tt-hint").attr("aria-hidden", "true");
	    },
	
	    /** DSR Membership Enquiry - used to open Membership inquiry modal
	     * 
	    */
	    membershipDetailedEnquiry: function membershipDetailedEnquiry() {
	      var modalOptions = {
	        title: messages.RWD_MEMBERSHIP_NUMBER,
	        body: COSTCO.util.tmpl('tmpl_membership_modal'),
	        primary: messages.CLOSE,
	        primary_button_fullspan: false,
	        primary_event: function primary_event() {
	          COSTCO.dialog.close();
	        }
	      };
	      COSTCO.dialog.showAndHideModal(modalOptions);
	    },
	    /**
	        * Method return timeout function for fetch method to call API services
	        */
	    getTimeoutController: function getTimeoutController() {
	      /**
	        * Timeout function
	        * @param {Integer} time (miliseconds)
	        * @param {Promise} promise
	        */
	      var timeout = function timeout(time, promise) {
	        return new Promise(function (resolve, reject) {
	          setTimeout(function () {
	            reject(new Error('API_TIMEOUT'));
	          }, time);
	          promise.then(resolve, reject);
	        });
	      };
	      return timeout;
	    },
	    /**
	        * Method to check if a DOM element is present using its ID and verify the value of the element
	        * return true if the value matches, else false.
	        */
	    checkElementById: function checkElementById(elementId, value) {
	      var elementValueMatch = false;
	      if ($(elementId).length > 0 && $(elementId).val() === value) {
	        elementValueMatch = true;
	      }
	      return elementValueMatch;
	    },
	
	    parseURL: function parseURL(url) {
	      var a = document.createElement('a');
	      a.href = url;
	      return {
	        source: url,
	        protocol: a.protocol.replace(':', ''),
	        host: a.hostname,
	        port: a.port,
	        query: a.search,
	        params: function () {
	          var ret = {},
	              seg = a.search.replace(/^\?/, '').split('&'),
	              len = seg.length,
	              i = 0,
	              s;
	          for (; i < len; i++) {
	            if (!seg[i]) {
	              continue;
	            }
	            s = seg[i].split('=');
	            ret[s[0]] = s[1];
	          }
	          return ret;
	        }(),
	        file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ''])[1],
	        hash: a.hash.replace('#', ''),
	        path: a.pathname.replace(/^([^\/])/, '/$1'),
	        relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ''])[1],
	        segments: a.pathname.replace(/^\//, '').split('/')
	      };
	    },
	
	    getParamVal: function getParamVal(url, key) {
	      var urlMap = COSTCO.util.parseURL(url);
	      return urlMap.params[key];
	    },
	
	    /**
	     * Utility function detect is browser IE11 or older version
	     * return boolean
	     */
	    isIE11OrOlder: function isIE11OrOlder() {
	      var ua = window.navigator.userAgent;
	      var msie = ua.indexOf('MSIE ');
	      if (msie > 0) {
	        // IE 10 or older 
	        return true;
	      }
	      var trident = ua.indexOf('Trident/');
	      if (trident > 0) {
	        // IE 11 
	        return true;
	      }
	      return false;
	    },
	
	    /**
	     * Utility function to check if user is logged in
	     * return boolean
	     */
	    isUserLoggedIn: function isUserLoggedIn() {
	
	      try {
	        $.cookie("hashedUserId").length;
	        return true;
	      } catch (e) {
	        return false;
	      }
	    },
	
	    objectExistsAndNonEmpty: function objectExistsAndNonEmpty(obj) {
	      if (typeof obj == 'undefined') {
	        return false;
	      } else if (obj == null) {
	        return false;
	      } else if (obj == '') {
	        return false;
	      } else {
	        return true;
	      }
	    },
	    filterItems: function filterItems(arr, query) {
	      return arr.filter(function (el) {
	        return el.toLowerCase() != query.toLowerCase();
	      });
	    },
	
	    signoutNextAuth: function signoutNextAuth() {
	      // Fetch CSRF token
	      fetch("/api/auth/csrf", {
	        method: "GET",
	        headers: {
	          "Accept": "*/*",
	          "Cache-Control": "no-cache",
	          "Content-Type": "application/json",
	          "Pragma": "no-cache",
	          "Sec-Fetch-Mode": "cors",
	          "Sec-Fetch-Site": "same-origin",
	          "Credentials": "include"
	        }
	      }).then(function (response) {
	        if (!response.ok) {
	          throw new Error('Failed to fetch CSRF token');
	        }
	        return response.json();
	      }).then(function (data) {
	        var csrfToken = data.csrfToken;
	
	        // Sign out using CSRF token
	        return fetch("/api/auth/signout", {
	          method: "POST",
	          headers: {
	            "Accept": "*/*",
	            "Cache-Control": "no-cache",
	            "Content-Type": "application/x-www-form-urlencoded",
	            "Pragma": "no-cache",
	            "Sec-Fetch-Mode": "cors",
	            "Sec-Fetch-Site": "same-origin",
	            "Credentials": "include"
	          },
	          body: new URLSearchParams({
	            csrfToken: csrfToken,
	            callbackUrl: new URL(window.location.href).origin + "/?ao=yes",
	            json: true
	          })
	        });
	      }).then(function (response) {
	        if (!response.ok) {
	          throw new Error('Failed to sign out');
	        }
	        return response.json();
	      }).then(function (data) {
	        console.log(data.message);
	        // Handle success message as needed
	      }).catch(function (error) {
	        console.error('Error signing out:', error);
	        // Provide user feedback here if needed
	      });
	    },
	    logoutSso: function logoutSso(obj, logOffUrls, isSsoEnabled, isMobileApp) {
	      sessionStorage.removeItem("SelectedPatientIndex");
	      $.cookie('PrescriptionCount', null, { path: '/' });
	      try {
	        console.log("Sign out ");
	        if (typeof Android != 'undefined') {
	          console.log("Android sign out ");
	          Android.onSignOut();
	        } else if (typeof webkit != 'undefined') {
	          console.log("Webkit sign out ");
	          webkit.messageHandlers.onSignOut.postMessage('');
	        }
	        console.log("Sign out finished");
	        if (isSsoEnabled == '0' || isSsoEnabled == null || isSsoEnabled == '' || isSsoEnabled == false || isMobileApp == null || isMobileApp == '' || isMobileApp == 'true') {
	          window.location = window.location.origin + "/Logoff?usrClk=true";
	          return;
	        }
	
	        var logOffAcion = "/security/v1/users/session/ssologoff";
	
	        //New home page support.
	        try {
	          COSTCO.util.signoutNextAuth();
	        } catch (k) {}
	
	        $.cookie('C_GOP', null, { path: '/' });
	        if (logOffUrls == null || logOffUrls == undefined || logOffUrls == "") {
	          window.location = window.location.origin + "/Logoff?usrClk=true";
	          return;
	        }
	
	        logOffUrls = logOffUrls.split(",");
	        logOffUrls = COSTCO.util.filterItems(logOffUrls, window.location.origin);
	
	        if (logOffUrls != null && logOffUrls.length > 0) {
	          var targetUri = '';
	
	          if (costcoStoreFeatures.OCUCO_LOGOUT_ENABLED === true) {
	            targetUri = logOffUrls[0] + logOffAcion + '?' + 'a=' + logOffUrls[1] + logOffAcion + '&b=' + logOffUrls[2] + logOffAcion + '&c=' + logOffUrls[3] + "/Account/Logout";
	          } else {
	            targetUri = logOffUrls[0] + logOffAcion + '?' + 'a=' + logOffUrls[1] + logOffAcion + '&b=' + logOffUrls[2] + logOffAcion;
	          }
	          var logoffWindow = window.open(targetUri, '_blank');
	          setTimeout(function () {
	            logoffWindow.close();
	            window.location = window.location.origin + "/Logoff?usrClk=true";
	          }, 3800); //milliseconds
	        } else {
	          window.location = window.location.origin + "/Logoff?usrClk=true";
	        }
	      } catch (e) {
	        console.log(e);
	        window.location = window.location.origin + "/Logoff?usrClk=true";
	      }
	    },
	
	    /**
	    * This function strips anything that isn't a number
	     * Intended for quantity selector 
	    * @param {[string] inputValue}  
	    * @returns {[number] outputValue}
	    */
	    stripStringOfNonNumberTypes: function stripStringOfNonNumberTypes(inputValue) {
	      var outputValue = inputValue.replace(/[^\d]/g, "");
	      return outputValue;
	    },
	    /**
	     * Checks if the current context is related to a locationControlledInventory product. 
	     */
	    islocationControlledInventoryFlow: function islocationControlledInventoryFlow() {
	      var islocationControlledInventoryFlow = $('#regionalIdentifier').length > 0 && $('#regionalIdentifier').val() == 'true' ? true : false;
	      return islocationControlledInventoryFlow;
	    },
	
	    /**
	     * Checks if the current context is related to a siteControlledInventory product. 
	     */
	    issiteControlledInventoryFlow: function issiteControlledInventoryFlow() {
	      var issiteControlledInventoryFlow = $('#regionalIdentifier').length > 0 && $('#regionalIdentifier').val() == 'false' ? true : false;
	      return issiteControlledInventoryFlow;
	    },
	
	    getFiveDigitPostalCode: function getFiveDigitPostalCode(postalCode) {
	      var zipCode = postalCode;
	      var finalZip = '';
	      var zipCodeWithoutExtraFour = zipCode.split('-');
	      if (zipCodeWithoutExtraFour.length > 1) {
	        finalZip = zipCodeWithoutExtraFour[0];
	      } else {
	        finalZip = zipCode;
	      }
	      return finalZip;
	    },
	
	    formatPhoneNumber: function formatPhoneNumber(number) {
	      var phNumber = number.replace(/\D/g, '');
	      return phNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
	    },
	
	    cancelMemberApplication: function cancelMemberApplication(partNumber) {
	      var appTrackingCookie = $.cookie('APPLICATION_TRACKING_COOKIE');
	      var currentPage = window.location.pathname.substr(1);
	
	      if (document.referrer === "") {
	        window.location.href = '/CheckoutCartView';
	      } else {
	
	        if (appTrackingCookie !== 'null' || 'undefined') {
	          if ($('#isBDAppVar').val() === 'BD' && $.cookie('cartCountCookie') > 1) {
	            path = '/MembershipApplicationView?productPartNumber=' + partNumber + '&fromPage=' + currentPage;
	          } else {
	            path = '/QuickMembershipApplicationView?productPartNumber=' + partNumber + '&fromPage=' + currentPage;
	          }
	          console.log('path: ', path);
	          window.location.href = path;
	          return;
	        }
	        window.location.href = COSTCO.util.scrubSpecialChars(document.referrer);
	      }
	    },
	
	    /** selects the input radio buttons inside the given element
	    * used for all the radio buttons/selection-boxes combined elements */
	    selectRadioBox: function selectRadioBox(element) {
	      $(element).find('input').prop('checked', true);
	    },
	
	    /** used on onblur event of all fields so that the screen reader 
	    * would announce the error when focus moves out of the field */
	    alertScreenReader: function alertScreenReader(element) {
	      if ($(element).attr('aria-invalid') === 'true') {
	        var elementName = $(element).attr('name');
	        var errorElement = $('#' + elementName + 'Error');
	
	        errorElement.removeAttr('role');
	        errorElement.attr('role', 'alert');
	      }
	    },
	
	    ariaSetElementAsValid: function ariaSetElementAsValid(element) {
	      if (element) {
	        element.removeAttr('aria-describedby');
	        element.attr('aria-invalid', 'false');
	      }
	    },
	
	    ariaSetElementAsInvalid: function ariaSetElementAsInvalid(element, describedByElementId) {
	      if (element) {
	        element.attr('aria-describedby', describedByElementId);
	        element.attr('aria-invalid', 'true');
	      }
	    },
	    /**
	     * Gets element with back to top link and (if exists) binds keydown and click event
	     * that moves focus to top of the page. For Gatsby enabled pages # routing is implemented
	     * so we have add event to div rather than adding a new hash to current url
	     *
	     * @param backToTopLink
	     */
	    setEventOnBackToTopLinkGatsby: function setEventOnBackToTopLinkGatsby(backToTopLinkClass) {
	      /* ADA to move focus on skip link click */
	      var $backToTopLink = $(backToTopLinkClass).find("a").length > 0 ? $(backToTopLinkClass).find("a") : $(backToTopLinkClass);
	      //Added for gatsby body focus
	      $backToTopLink.click(function () {
	        $backToTopLink.attr("href", window.location.href);
	        COSTCO.util.scrollToTopGatsby();
	      });
	      $backToTopLink.keydown(function (e) {
	        $backToTopLink.attr("href", window.location.href);
	        if (e.keyCode === 13) COSTCO.util.scrollToTopGatsby();
	      });
	    },
	
	    /**
	    * This function opens and closes accordion that contains drugs list
	    * @param  {String} letter capital letter of drugs
	    * @param  {String} html element that was clicked
	    * @param  {String} hostProtocolURL 
	    * @return {void}
	    */
	    show_drug_list_by_capital_letter: function show_drug_list_by_capital_letter(letter, hostProtocolURL, element) {
	      if ($('#cmpp-drugs-by-letter-accordion-collapse').hasClass('in') && $('#cmpp-drugs-by-letter-accordion-collapse').attr('data-letter') == letter) {
	        $('#cmpp-drugs-by-letter-accordion-collapse').collapse('hide');
	        $(element).children(".cmpp-close").addClass("hidden");
	        $(element).removeClass("cmpp-title-active");
	        $('html, body').animate({ scrollTop: $(element).offset().top }, 800);
	      } else {
	
	        if ($('#cmpp-drugs-by-letter-accordion-collapse').hasClass('in')) {
	
	          $('#cmpp-drugs-by-letter-accordion-collapse').collapse('hide');
	
	          setTimeout(function () {
	            COSTCO.util.drug_list_by_capital(letter, hostProtocolURL, element);
	          }, 700);
	        } else {
	          COSTCO.util.drug_list_by_capital(letter, hostProtocolURL, element);
	        }
	      }
	    },
	    /**
	     * This function handles building the drug list that corresponds
	     * with first letter of drug name.
	     * @param  {String} stateCode used to filter list of all cmpps
	     * @param  {String} html element that was clicked
	     * @param  {String} hostProtocolURL
	     * @return {void}
	     */
	    drug_list_by_capital: function drug_list_by_capital(letter, hostProtocolURL, element) {
	
	      $('#cmpp-drugs-by-letter-accordion-collapse').remove();
	      $('html, body').animate({ scrollTop: $(element).offset().top }, 800);
	
	      $(".panel-group div div div").removeClass("cmpp-title-active");
	      $(".panel-group div div .cmpp-close").addClass("hidden");
	      $(element).addClass("cmpp-title-active");
	      $(element).children(".cmpp-close").removeClass("hidden");
	
	      $(element).parent().after(COSTCO.util.tmpl('tmpl_drugs_by_letter', {
	        letter: letter
	      }));
	      var windowWidth = $(window).width();
	      var colNum = 1;
	      if (windowWidth > 1025) {
	        colNum = 3;
	      } else if (windowWidth > 667) {
	        colNum = 2;
	      };
	      var drugNamesObj = JSON.parse(allDrugNamesMap[0].jsonDrugNameURL);
	      var drugArr = [];
	      for (var el in drugNamesObj) {
	        if (el.substring(0, 1) === letter) {
	          var obj = {
	            drugName: el,
	            drugUrl: drugNamesObj[el]
	          };
	          drugArr.push(obj);
	        }
	      }
	      var numOfItems = drugArr.length;;
	      var numOfRows = Math.ceil(numOfItems / colNum);
	      for (var i = 0; i < numOfRows; i++) {
	        $('#cmpp-drugs-by-letter-accordion-collapse-panel').append(COSTCO.util.tmpl('tmpl_drugs_list_by_capital_letter', {
	          drugLink1: drugArr[i] && hostProtocolURL + drugArr[i].drugUrl,
	          drugLink2: drugArr[i + numOfRows] && hostProtocolURL + drugArr[i + numOfRows].drugUrl,
	          drugLink3: drugArr[i + 2 * numOfRows] && hostProtocolURL + drugArr[i + 2 * numOfRows].drugUrl,
	          drugName1: drugArr[i].drugName && drugArr[i].drugName,
	          drugName2: drugArr[i + numOfRows] && drugArr[i + numOfRows].drugName,
	          drugName3: drugArr[i + 2 * numOfRows] && drugArr[i + 2 * numOfRows].drugName,
	          numOfCol: colNum
	
	        }));
	      }
	      $('#cmpp-drugs-by-letter-accordion-collapse').collapse('show');
	    },
	    /**
	     * Scrolls page to top
	    */
	    scrollToTopGatsby: function scrollToTopGatsby() {
	      document.getElementById("gatsbyIndex").scrollIntoView(true);
	      document.getElementById("gatsbyIndex").focus();
	    },
	
	    /**
	      * Util to give an interactive character count down
	      * @param  {ojbect} label    pass the jquery obj where you want the
	      *                           countdown to reflect
	      * @param  {object} textarea pass a 'text' input
	      *                           (input[type='text'],textarea) to count
	      * @return {void}
	    */
	    character_count: function character_count(label, textarea) {
	      if ($(label).length > 0 && $(textarea).length > 0) {
	        var updateLabelCount = function updateLabelCount(textarea, label) {
	          var count = $(textarea).val().length;
	          $(label).text(max - count);
	        };
	
	        var max = parseInt($(textarea).attr('maxlength'));
	        $(label).text(max - $(textarea).val().length);
	        $(textarea).unbind('keyup').on('keyup', function () {
	          updateLabelCount(this, label);
	        });
	        $(textarea).unbind('change').on('change', function () {
	          updateLabelCount(this, label);
	        });
	      }
	    },
	    getCookieByName: function getCookieByName(name) {
	      var value = '; ' + document.cookie;
	      var parts = value.split('; ' + name + '=');
	      if (parts.length === 2) return parts.pop().split(';').shift();
	    },
	
	    // function for sanitizing data to prevent XSS attacks
	    replaceSpecialChars: function replaceSpecialChars(obj) {
	      var result = new String(obj);
	
	      result = result.replace(/&/g, "&amp;");
	      result = result.replace(/</g, "&lt;");
	      result = result.replace(/>/g, "&gt;");
	      result = result.replace(/'/g, "&#39;");
	      result = result.replace(/"/g, "&quot;");
	      result = result.replace(/\//g, "&#47;");
	      result = result.replace(/\\/g, "&#92;");
	
	      return result;
	    },
	    /**
	     * Async SHA256 encryption
	     * @param {} message text that will be hashed
	     * @param {} callback 
	     */
	    sha256: function sha256(message, callback) {
	      var encoder = new TextEncoder();
	      var data = encoder.encode(message);
	      crypto.subtle.digest('SHA-256', data).then(function (hashBuffer) {
	        var hashArray = Array.from(new Uint8Array(hashBuffer));
	        var hashHex = hashArray.map(function (byte) {
	          return byte.toString(16).padStart(2, '0');
	        }).join('');
	        callback(hashHex);
	      }).catch(function (error) {
	        console.error('Error calculating SHA-256 hash: ', error);
	        callback(null);
	      });
	    },
	    getCookieStartingWith: function getCookieStartingWith(prefix) {
	      var cookies = document.cookie.split(';');
	
	      for (var i = 0; i < cookies.length; i++) {
	        var cookie = cookies[i].trim();
	
	        // Check if the cookie starts with the specified prefix
	        if (cookie.startsWith(prefix)) {
	          // Extract the value of the cookie
	          return cookie.substring(prefix.length + 1);
	        }
	      }
	
	      // Return null if no matching cookie is found
	      return null;
	    },
	
	    /**
	     * Decode JWT and check for validity.  
	     * */
	    checkJWTExpiry: function checkJWTExpiry(JWT) {
	      var expired = true;
	      var JWT_payload = JSON.parse(atob(JWT.split('.')[1]));
	      if (typeof JWT_payload != 'undefined' && JWT_payload != null) {
	        var currentTimeInMiliseconds = Date.now();
	        var validUntil = Number(JWT_payload.created_at) + Number(JWT_payload.expires_in) - 3600000;
	        if (currentTimeInMiliseconds < validUntil) {
	          expired = false;
	        }
	      }
	      return expired;
	    },
	    sentenceToPascalCase: function sentenceToPascalCase(sentence) {
	      return sentence.split(' ').map(function (word) {
	        // Keeps only letters and numbers (including accented/Unicode letters)
	        return (word.match(/[A-Za-zÀ-ÖØ-öø-ÿ0-9]+/g) || []).join('');
	      }).map(function (word) {
	        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
	      }).join(' ');
	    },
	    isElementEmpty: function isElementEmpty(elementValue) {
	      if (typeof elementValue === 'undefined' || elementValue === null || elementValue === '') return true;
	      return false;
	    }
	  };
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = new Object();
	  }
	  window.COSTCO.util = util;
	
	  return util;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 10:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title utility2.js: Global sub-module
	 * @description A collection of functions used application wide, except Home, Browse & Product pages.
	 * Functions that are not needed for Home, Browse & Product pages should live in this file
	 * This module should contain generic utility code. No module specifics.
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var util = {
	    POSTAL_CODE_REGEX_US: /^(\d{5}(-\d{4})?$)$/,
	    POSTAL_CODE_REGEX_CA: /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1}$/,
	    ATLEAST_ONE_ALPHABET: /^(?=.*[A-Za-z\u00C0-\u017F]).+/,
	    CC_NAME_FIELD_REGEX: /[^0-9A-Z\.\'\-\&\s\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u2030\u20AC]/i,
	    LAST_NAME_FIELD_REGEX: /[^0-9A-Z\.\'\-\s\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u2030\u20AC]/i,
	    /*
	     * Function used to escape double ticks (ADA)
	     **/
	    encode_html: function encode_html(input) {
	      input = input.replace('"', '&#34');
	      input = input.replace('\'', '&#39');
	      input = input.replace(';', '&#59');
	      return input;
	    },
	    /**
	     * Function used to "extend" the bootstap popover capability to add accesibility features
	     * function add a couple of the ADA needed attributes and a couple of keyboard navigation listener
	     * popover parameters are expected to be defined in the element as normal bootsrap popover
	     */
	    accesible_popover: function accesible_popover(selector) {
	      var popoverElement = $(selector);
	      popoverElement.popover().on('keydown', function (event) {
	        if (event.which == 13) $(this).popover('toggle');
	        if (event.which == 27) $(this).popover('hide');
	      }).on('blur', function () {
	        $(this).popover('hide');
	      }).on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	    },
	    /**
	     * This function makes images in popover content tabbable for ADA purposes
	     * @param {string} tooltipClass - Tooltip class.
	     * @return {void}
	     */
	    activateKeyboardAccesiblePopover: function activateKeyboardAccesiblePopover(selector) {
	      var popoverElement = $('.' + selector);
	      popoverElement.popover().on('keydown', function (event) {
	        //Enter event keycode
	        if (event.which === 13) {
	          $(this).popover('toggle');
	          //Esc event keycode
	        } else if (event.which === 27) {
	          $(this).popover('hide');
	          //Shift+Tab event keycode
	        } else if (event.shiftKey && event.keyCode === 9) {
	          $(this).popover('hide');
	        }
	      }).on('focus', function () {
	        $(this).popover('toggle');
	        var tooltipElement = $(this);
	        var popoverContentId = $(this).attr('aria-describedby');
	        if (popoverContentId !== undefined && $('#' + popoverContentId).find('img').length !== 0) {
	          $('#' + popoverContentId).find('img').on('blur', function () {
	            tooltipElement.popover('hide');
	          });
	        }
	      }).on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	      $(':not(.' + selector + ')').on('click', function () {
	        $('.co-help').each(function () {
	          if ($(this).attr('aria-expanded') === 'true') {
	            $(this).popover('hide');
	          }
	        });
	      });
	    },
	    isMinimumScreen: function isMinimumScreen(min) {
	      var width = $(window).width();
	      if (min == 'DESKTOP' && width >= 1025) return true;
	      if (min == 'TABLET-LANDSCAPE' && width >= 769) return true;
	      if (min == 'TABLET-PORTRAIT' && width >= 668) return true;
	      if (min == 'PHONE-LANDSCAPE' && width >= 376) return true;
	      if (min == 'PHONE-PORTRAIT' && width >= 0) return true;
	      return false;
	    },
	    isMaxScreen: function isMaxScreen(min) {
	      var width = $(window).width();
	      if (min == 'DESKTOP' && width < 1024) return true;
	      if (min == 'TABLET-LANDSCAPE' && width < 769) return true;
	      if (min == 'TABLET-PORTRAIT' && width < 668) return true;
	      if (min == 'PHONE-LANDSCAPE' && width < 376) return true;
	      if (min == 'PHONE-PORTRAIT' && width >= 0) return true;
	      return false;
	    },
	    /**
	     * External link dialog for FORMS ONLY.
	     */
	    createExternalLinkDialogForForm: function createExternalLinkDialogForForm(link, form, submitButtonTitle) {
	      var dialogDiv = $('<div id="external_link_dialog">' + $('<div>').append(form.clone()).html() + '<span>' + messages.JS_LEAVING_DOMAIN_ALERT.replace('{0}', this.hostname) + '</span></div>');
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.JS_DIALOG_EXTERNAL_LINK,
	        body: dialogDiv,
	        primary: submitButtonTitle,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          $('#external_link_dialog form').submit();
	          $('.costcoModalBtn1').first().click();
	        }
	      });
	      return false;
	    },
	    /**
	     * Return an array with only unique members. unique([1,2,1])
	     * returns [2,1]
	     * @param  {[array]} arr - The array with duplicated members
	     * @return {[array]} out - The array with unique members
	     */
	    unique: function unique(arr) {
	      var seen = {},
	          out = [],
	          len = arr.length,
	          j = 0;
	      for (var i = 0; i < len; i++) {
	        var item = arr[i];
	        if (seen[item] !== 1) {
	          seen[item] = 1;
	          out[j++] = item;
	        }
	      }
	      return out;
	    },
	    /**
	     * Return an array with a string interpolated between
	     * each member i.e. interpolate([1,2],'+') returns [1,"+",2]
	     * @param  {[array]} array - The array to interpolate
	     * @param  {[type]} string - the element to interpolate in the array
	     * @return {[type]} _array - The interpolated array
	     */
	    interpolate: function interpolate(array, _string) {
	      var _array = [];
	      for (var i = 0, len = array.length; i < len; i++) {
	        _array.push(array[i]);
	        if (i != array.length - 1) {
	          _array.push(_string);
	        }
	      }
	      return _array;
	    },
	    // Added for submitting encoded values without special characters
	    encodeExclSpecialChars: function encodeExclSpecialChars(input) {
	      var output = '';
	      var chr1 = void 0,
	          chr2 = void 0,
	          chr3 = void 0,
	          enc1 = void 0,
	          enc2 = void 0,
	          enc3 = void 0,
	          enc4 = void 0;
	      var i = 0;
	      input = COSTCO.util._utf8_encode(input);
	      while (i < input.length) {
	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);
	        enc1 = chr1 >> 2;
	        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
	        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
	        enc4 = chr3 & 63;
	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }
	        output = output + this._keyStrExcl.charAt(enc1) + this._keyStrExcl.charAt(enc2) + this._keyStrExcl.charAt(enc3) + this._keyStrExcl.charAt(enc4);
	      }
	      return output;
	    },
	    // public method for decoding
	    decodeExclSpecialChars: function decodeExclSpecialChars(input) {
	      var output = '';
	      var chr1 = void 0,
	          chr2 = void 0,
	          chr3 = void 0;
	      var enc1 = void 0,
	          enc2 = void 0,
	          enc3 = void 0,
	          enc4 = void 0;
	      var i = 0;
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
	      while (i < input.length) {
	        enc1 = this._keyStrExcl.indexOf(input.charAt(i++));
	        enc2 = this._keyStrExcl.indexOf(input.charAt(i++));
	        enc3 = this._keyStrExcl.indexOf(input.charAt(i++));
	        enc4 = this._keyStrExcl.indexOf(input.charAt(i++));
	        chr1 = enc1 << 2 | enc2 >> 4;
	        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
	        chr3 = (enc3 & 3) << 6 | enc4;
	        output = output + String.fromCharCode(chr1);
	        if (enc3 != 64) {
	          output = output + String.fromCharCode(chr2);
	        }
	        if (enc4 != 64) {
	          output = output + String.fromCharCode(chr3);
	        }
	      }
	      output = COSTCO.util._utf8_decode(output);
	      output = output.replace(/[\u0000-\u0019]+/g, ''); // For removing the non-printable & Invalid JSON characters.
	      return output;
	    },
	    addresses: [],
	    addressLoadState: {
	      shipping: {
	        requested: 0,
	        loaded: 0
	      },
	      billing: {
	        requested: 0,
	        loaded: 0
	      }
	    },
	    resetAddressLoadState: function resetAddressLoadState() {
	      COSTCO.util.addresses = [];
	      COSTCO.util.addressLoadState = {
	        shipping: {
	          requested: 0,
	          loaded: 0
	        },
	        billing: {
	          requested: 0,
	          loaded: 0
	        }
	      };
	    },
	    getAddressBatchPage: function getAddressBatchPage(addressType, filterName, filterOrder, total, processBatch, processPagination) {
	      var start = 1,
	          end = total;;
	      if (addressType == 'S') {
	        addressLoadState = COSTCO.util.addressLoadState.shipping;
	      } else {
	        addressLoadState = COSTCO.util.addressLoadState.billing;
	      }
	      if (addressLoadState.requested == 0) {
	        COSTCO.util.getAddressBatch(addressType, filterName, filterOrder, start, total, processBatch, processPagination);
	      } else {
	        if (total > addressLoadState.requested) {
	          COSTCO.util.getAddressBatch(addressType, filterName, filterOrder, addressLoadState, total + addressLoadState.requested, processBatch, processPagination);
	        } else {
	          if (typeof processBatch === 'function') processBatch(COSTCO.util.addresses);
	          if (typeof processPagination === 'function') processPagination(COSTCO.util.addresses);
	        }
	      }
	    },
	    /* getAddresses
	     * arguments can contain a list of callback functions to be executed on .done.  The last arg is a optional addressType (S || B) that retrieves a filtered list of addresses
	     * */
	    getAddressBatch: function getAddressBatch(addressType, filterName, filterOrder, start, end, processBatch, processPagination) {
	      // request the user's addresses 
	
	      COSTCO.util.ajax({
	        url: '/AjaxCostcoGetAddressCmd?requesttype=ajax',
	        method: 'GET',
	        dataType: 'json',
	        data: {
	          addressType: encodeURIComponent(addressType),
	          filterName: encodeURIComponent(filterName),
	          filterOrder: encodeURIComponent(filterOrder),
	          start: encodeURIComponent(start),
	          end: encodeURIComponent(end)
	        },
	        done: function done(data, textStatus, jqXHR, options) {
	          try {
	            if (addressType == 'S') {
	              COSTCO.util.addressLoadState.shipping.requested += parseInt(end);
	              COSTCO.util.addressLoadState.shipping.loaded += parseInt(data.totalrecords);
	            } else {
	              COSTCO.util.addressLoadState.billing.requested += parseInt(end);
	              COSTCO.util.addressLoadState.billing.loaded += parseInt(data.totalrecords);
	            }
	            if (typeof data.addresses !== 'undefined') {
	              COSTCO.util.mergeAddresses(JSON.parse(data.addresses));
	            }
	          } catch (err) {
	            //
	            console.error(err, 'Parse error');
	          }
	          if (typeof processBatch === 'function') processBatch(data);
	          if (typeof processPagination === 'function') processPagination(data);
	        }
	      });
	    },
	    mergeAddresses: function mergeAddresses(data) {
	      for (var i = 0; i < data.length; i++) {
	        if (data[i].hasOwnProperty('addressId')) {
	          COSTCO.util.renameArray(data[i], COSTCO.util.addressNamingMap);
	        }
	      }
	      COSTCO.util.addresses = COSTCO.util.addresses.concat(data);
	    },
	    /**
	     * Add every unique address from 'addresses' to
	     * COSTCO.util.addresses
	     * @param  {array} addresses [
	     * @return {void}
	     */
	    concatNonDuplicates: function concatNonDuplicates(addresses) {
	      var _this = this;
	
	      addresses.forEach(function (address) {
	        if (!_this.any(_this.addresses, function (x) {
	          return x.id == address.id;
	        })) {
	          _this.addresses.push(address);
	        }
	      });
	    },
	    /*
	     * Address naming is a mess
	     */
	    addressNamingMap: {
	      addressId: 'id',
	      addressTypeId: 'addressType',
	      addressLine1: 'line1',
	      addressLine2: 'line2',
	      firstName: 'first',
	      lastName: 'last',
	      companyName: 'company',
	      primary: 'isPrimary',
	      postalCode: 'zip',
	      middleName: 'mInitial',
	      emailAddress: 'email',
	      fName: 'first',
	      lName: 'last',
	      pNumber: 'phone'
	    },
	    renameArray: function renameArray(data, map) {
	      for (var key in data) {
	        if (data.hasOwnProperty(key) && map.hasOwnProperty(key)) {
	          data[map[key]] = data[key];
	          delete data[key];
	        }
	      }
	    },
	    unbindEvents: function unbindEvents(obj) {
	      Object.keys(obj).forEach(function (key) {
	        $(obj[key]).unbind('click').unbind('blur').unbind('change').unbind('touchstart');
	      });
	    },
	    /**
	     * Function used to notify the native web application that the user has been sucessfully
	     * logged out of the costco website. This is needed as the app relies upon web view
	     */
	    notifyAppLogout: function notifyAppLogout() {
	      console.log('notifying app of logout');
	      try {
	        if (typeof Android != 'undefined') {
	          Android.logoutCostcoApp();
	        } else if (typeof webkit != 'undefined') {
	          webkit.messageHandlers.logoutAction.postMessage('success');
	        }
	      } catch (e) {
	        console.warn(e);
	      }
	    },
	    removeParam: function removeParam(key, sourceURL) {
	      var rtn = sourceURL.split('?')[0],
	          param = void 0,
	          params_arr = [],
	          queryString = sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
	      if (queryString !== '') {
	        params_arr = queryString.split('&');
	        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
	          param = params_arr[i].split('=')[0];
	          if (param === key) {
	            params_arr.splice(i, 1);
	          }
	        }
	        rtn = rtn + '?' + params_arr.join('&');
	      }
	      return rtn;
	    },
	    /**
	     * Politically incorrect method for turning an array of objects in the form
	     * of [{name:'hi',value:'robert'},{}..] into an equivalent object
	     * '{hi: 'robert', hey: 'robert'}'. $(form).serializeArray() will return
	     * the array of objects we're looking to convert
	     * @param  {Array} arr The array of objects.
	     * @return {Object}    The object equivalent of arr
	     */
	    objectifyArray: function objectifyArray(arr) {
	      var obj = {};
	      arr.forEach(function (arrObj) {
	        obj[arrObj.name] = arrObj.value;
	      });
	      return obj;
	    },
	
	    /**
	     * Utility function for adjusting heights of arbitrary numbner of divs, setting it to the 'tallest' value
	     * For this to happen two things must be the case:
	     * #1 All the DIVs that need to be aligned should have same unique css class applied (convention is costco-align-height-some-arbitrary-name)
	     * #2 call the function with string denoting applied class name, e.g. :
	     *		adjustDivHeights('.costco-align-height-some-arbitrary-name');
	     */
	
	    /* Compare heights of all divs with applied css class and increase the 'smaller' ones to the height of the tallest */
	    adjustDivHeights: function adjustDivHeights(alignClass, defaultHeight) {
	      $arrDivs = $(alignClass);
	      if ($arrDivs != null && $arrDivs.length > 0) {
	        max = 0;
	        $arrDivs.each(function () {
	          max = Math.max(max, parseInt($(this).height()));
	        });
	        if (max == 0 && typeof defaultHeight != 'undefined') {
	          max = defaultHeight;
	        }
	        $arrDivs.each(function () {
	          if ($(this).height() != max) {
	            $(this).height(max);
	          }
	        });
	      }
	    },
	    /**
	     * Capitalize a given string. Takes a string of form "Hi there Robert" and
	     * returns "Hi There Robert".
	     * @param  {String} str The string to capitalize
	     * @return {String}     The capitalized string.
	     */
	    capitalize: function capitalize(str) {
	      return str.split(' ').map(function (x) {
	        return x.charAt().toUpperCase().concat(x.substr(1));
	      }).join(' ');
	    },
	    isUsOrCaZipCode: function isUsOrCaZipCode() {
	      if ($('#B_countryId').length > 0 || $('#countryId').length > 0) {
	        return COSTCO.util.isUSOrCaAddressZip();
	      } else {
	        var storeId = wcs.storeId;
	        switch (storeId) {
	          case '10301':
	            return true;
	          case '10302':
	            return false;
	          case '11301':
	            return true;
	          default:
	            return false;
	        }
	      }
	    },
	    isUSOrCaAddressZip: function isUSOrCaAddressZip() {
	      var selCountry = $('#B_countryId').length > 0 ? $('#B_countryId').val() : $('#countryId').val();
	      selCountry = selCountry + wcs.storeId;
	      switch (selCountry) {
	        case 'US10301':
	          return true;
	        case 'CA10301':
	          return false;
	        case 'US10302':
	          return true;
	        case 'CA10302':
	          return false;
	        case 'US11301':
	          return true;
	        case 'CA11301':
	          return false;
	        case 'US11303':
	          return true;
	        case 'CA11303':
	          return false;
	        default:
	          return 'false';
	      }
	    },
	    getMaxHeight: function getMaxHeight(elems) {
	      return Math.max.apply(null, elems.map(function () {
	        return $(this).height();
	      }).get());
	    },
	    /**
	     * Checks if the current context is related to a grocery product. 
	     */
	    is2DayFlow: function is2DayFlow() {
	      var is2DayFlow = $('#groceryIdentifier').length > 0 && $('#groceryIdentifier').val() == 'true' ? true : false;
	      return is2DayFlow;
	    },
	    isLTLDeliveryServicesEnabled: function isLTLDeliveryServicesEnabled() {
	      var ltlDeliveryServicesEnableFlag = $('#deliveryServicesEnabled').length > 0 && $('#deliveryServicesEnabled').val() == 'true' ? true : false;
	      return ltlDeliveryServicesEnableFlag;
	    },
	
	    /**
	     * dob Validation- Month and date range validation and leap year validation.
	     * @param month 
	     * @param day
	     * @param year 
	     */
	    dateValidation: function dateValidation(month, day, year) {
	      var isDateValid = false;
	      var currentYear = new Date().getFullYear();
	      var beginningYear = currentYear - 100;
	      if (typeof year !== 'undefined' && year !== "" && (year < beginningYear || year > currentYear)) {
	        isDateValid = false;
	      } else if ((month === "04" || month === "06" || month === "09" || month === "11") && day <= 30 && day >= 1) {
	        isDateValid = true;
	      }
	      // check for february 29th
	      else if (month === "02") {
	          var isleap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
	          if (day >= 1 && (day < 29 || day === "29" && isleap)) {
	            isDateValid = true;
	          }
	        }
	        // Check for month and day range
	        else if (month >= 1 && month <= 12 && day <= 31 && day >= 1) {
	            isDateValid = true;
	          } else {
	            if ((month === "" || typeof month === 'undefined') && (year === "" || typeof year === 'undefined') && (COSTCO.util.isCAStore() || day === "" || typeof day === 'undefined')) {
	              isDateValid = true;
	            }
	          }
	      return isDateValid;
	    },
	    /**
	     * Function used to check if Global error exists on page.
	     * @return {Boolean}
	     */
	    isGlobalErrorOnPage: function isGlobalErrorOnPage() {
	      var isGlobalError = false;
	      var errorClasses = COSTCO.util.globalErrorElementClasses;
	
	      jQuery.each(errorClasses, function (index, value) {
	        $('.' + value).each(function () {
	          if ($(this) !== 'undefined' && $(this).html() !== 'undefined' && $(this).html().trim().lenght > 0 || $(this).children() !== 'undefined' && $(this).children().html() !== undefined && $(this).children().html().trim().length > 0) {
	            var innerContent = $(this).children().html() !== undefined ? $(this).children().html() : $(this).html();
	            if ($(this).length > 0 && innerContent.length > 1) {
	              isGlobalError = true;
	            }
	          }
	        });
	      });
	
	      return isGlobalError;
	    },
	
	    /**
	     * Populates announcement screen reader div on page load
	     */
	    announceSRGlobalErrorMessage: function announceSRGlobalErrorMessage() {
	      if (COSTCO.util.isGlobalErrorOnPage()) {
	        var errorElement = COSTCO.util.getFirstGlobalErrorOnPage($('body'));
	        if (errorElement !== undefined && errorElement !== null && errorElement.text() !== "") {
	          var eMessage = errorElement.text();
	          COSTCO.util.announceSRErrorMessage(eMessage);
	        }
	      }
	    },
	
	    /**
	     * Function used to monitor screen reader announcement div element for changes
	     */
	    resetScreenReaderAnnouncement: function resetScreenReaderAnnouncement() {
	      var targetObject = document.querySelector("#screen-reader-announcement");
	      var observerObject = new MutationObserver(function (mutationRecordsList) {
	        mutationRecordsList.forEach(function (mutation) {
	          if ("attributes" === mutation.type || "childList" === mutation.type || "subtree" === mutation.type) {
	            setTimeout(function () {
	              $(targetObject).empty();
	            }, 2000);
	          }
	        });
	      });
	      if (targetObject !== undefined && targetObject !== null) {
	        observerObject.observe(targetObject, {
	          attributes: true,
	          attributeOldValue: true,
	          childList: true,
	          subtree: true,
	          characterData: true
	        });
	      }
	    },
	
	    /**
	     * Function used to inject error message in screen reader placeholder announcement div
	     * @param error message to be injected
	     */
	
	    announceSRErrorMessage: function announceSRErrorMessage(errorMessage) {
	      try {
	        errorMessage = errorMessage.trim();
	        var htmlContent = $.parseHTML(errorMessage);
	
	        if (htmlContent != null && !htmlContent.filter(function (e) {
	          return e instanceof HTMLElement;
	        }).length) {
	          errorMessage = '<p>' + errorMessage + '</p>';
	        }
	
	        var errorToAnnounce = $(errorMessage).html() !== undefined ? $(errorMessage).html() : errorMessage;
	        COSTCO.util.announceSRMessage(messages.ERROR + ' ' + errorToAnnounce);
	      } catch (error) {
	        console.log("Error occurred while announcing SR message! Error: " + error);
	      }
	    },
	
	    /**
	     * Moves the specified section to keep it in view when user scrolls.
	     * The section only moves if the screen is Tablet Landscape or wider.
	     * @param {string} elementId	ID of html element which is in view when user scrolls
	     * @param {string} topReferenceElementId	ID of element which is initially top-aligned with "sticky element"
	     * @param {string} bottomReferenceElementId ID of an element which presents a bottom limit to a moving "sticky element"
	     */
	    makeElementSticky: function makeElementSticky(elementId, topReferenceElementId, bottomReferenceElementId) {
	
	      var makeElementStickyFunction = function makeElementStickyFunction() {
	
	        var stickyElement = $('#' + elementId);
	        var topReferenceElement = $('#' + topReferenceElementId);
	        var bottomReferenceElement = $('#' + bottomReferenceElementId);
	
	        var bottomReference = bottomReferenceElement.offset().top;
	
	        if (stickyElement.length > 0 && topReferenceElement.length > 0) {
	          var topReference = topReferenceElement.offset().top + topReferenceElement.height();
	
	          var currentTranslateY = parseFloat(stickyElement.css('transform').split(',')[5]) || 0;
	          var translateY = -stickyElement[0].getBoundingClientRect().top + currentTranslateY;
	          var maxDistance = bottomReference - topReference - stickyElement.height();
	
	          if (translateY > maxDistance) {
	            translateY = maxDistance;
	          } else if (translateY < 0) {
	            translateY = 0;
	          }
	
	          stickyElement.css({
	            '-webkit-transform': 'translateY(' + translateY + 'px)',
	            '-moz-transform': 'translateY(' + translateY + 'px)',
	            '-ms-transform': 'translateY(' + translateY + 'px)',
	            '-o-transform': 'translateY(' + translateY + 'px)',
	            'transform': 'translateY(' + translateY + 'px)'
	          });
	        }
	      };
	      $(window).on('scroll wheel DOMMouseScroll mousewheel resize', function (evt) {
	        // remove all transforms if screen is not at least tablet landscape
	        if (COSTCO.util.isMaxScreen('TABLET-LANDSCAPE')) {
	          $('#' + elementId).css({
	            '-webkit-transform': '',
	            '-moz-transform': '',
	            '-ms-transform': '',
	            '-o-transform': '',
	            'transform': ''
	          });
	        } else {
	          makeElementStickyFunction();
	        }
	      });
	    },
	    preventBackButtonForSso: function preventBackButtonForSso(referer) {
	
	      try {
	        setTimeout(function () {
	          history.pushState(null, null, window.location);
	          window.addEventListener('popstate', function (event) {
	            if (referer != null && referer != undefined && referer != '' && (referer.indexOf('signin-qa.costco.com') > -1 || referer.indexOf('signin.costco.com') > -1)) {
	              alert(1);
	              history.pushState(null, null, window.location);
	            }
	          });
	        }, 5000);
	      } catch (e) {
	        console.error(e);
	      }
	    },
	    /**
	     * Method return date in yyyy-dd-mm-dd format
	     */
	    formatCalendarDate: function formatCalendarDate(date, separator) {
	      var d = new Date(date),
	          month = '' + (d.getMonth() + 1),
	          day = '' + d.getDate(),
	          year = d.getFullYear();
	
	      if (month.length < 2) month = '0' + month;
	      if (day.length < 2) day = '0' + day;
	      if (separator === '-') {
	        return [year, month, day].join('-');
	      } else {
	        return [month, day, year.toString().substr(-2)].join('/');
	      }
	    },
	    getAllCalendarAvailableDates: function getAllCalendarAvailableDates(dates) {
	      var availableDates = [];
	      dates.forEach(function (allowed_obj) {
	        if (allowed_obj.date_str) {
	          var date = new Date(allowed_obj.date_obj);
	          var timeZoneCorrectDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
	          // East of GMT
	          if (date.getTimezoneOffset() < 0) {
	            timeZoneCorrectDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
	          }
	          var formattedDate = timeZoneCorrectDate.toJSON().split("T")[0];
	          var availableFormatedDate = formattedDate.split('-')[1] + '/' + formattedDate.split('-')[2] + '/' + formattedDate.split('-')[0];
	          availableDates.push(availableFormatedDate);
	        }
	      });
	      return availableDates;
	    },
	
	    //Controls continue button on Membership Privileges and Conditions page
	    continueAfterTermsAccepted: function continueAfterTermsAccepted() {
	      if ($("#tnc-checkbox").attr("value") == "true") {
	        if ($('#upgradeOnly').val() == "true") {
	          window.location.href = '/QuickMembershipCheckoutCmd?isTandCAccepted=true&upgradeOnly=true';
	        } else {
	          window.location.href = '/QuickMembershipCheckoutCmd?isTandCAccepted=true';
	        }
	      } else {
	
	        $(".membership-tnc-checkbox-main").css({ 'border': '2px solid #D32029', 'margin': '0px' });
	        $("#terms-conditions-error").removeClass("hidden").css('margin-bottom', '20px');
	        $('#tnc-checkbox').focus();
	        $("#tnc-checkbox").attr("aria-describedby", "terms-conditions-error");
	      }
	    },
	
	    //Functionality for accept check box on Membership Privileges and Conditions page 
	    toggleTermsCheckbox: function toggleTermsCheckbox() {
	      if ($("#tnc-checkbox").attr("value") == "false") {
	        $("#tnc-checkbox").removeAttr("aria-describedby");
	        $("#tnc-checkbox").attr("value", "true");
	        $("#tnc-checkbox").attr("checked", "checked");
	        if (!$("#terms-conditions-error").hasClass("hidden")) {
	          $("#terms-conditions-error").addClass("hidden");
	          $(".membership-tnc-checkbox-main").css({ 'border': '1px solid #cccccc', 'margin': '5px 0px 20px 0px' });
	        }
	      } else {
	        $("#tnc-checkbox").attr("value", "false");
	        $("#tnc-checkbox").removeAttr("checked");
	      }
	    },
	
	    // function for sanitizing data to prevent XSS attacks
	    replaceSpecialChars: function replaceSpecialChars(obj) {
	      var result = new String(obj);
	
	      result = result.replace(/&/g, "&amp;");
	      result = result.replace(/</g, "&lt;");
	      result = result.replace(/>/g, "&gt;");
	      result = result.replace(/'/g, "&#39;");
	      result = result.replace(/"/g, "&quot;");
	      result = result.replace(/\//g, "&#47;");
	      result = result.replace(/\\/g, "&#92;");
	
	      return result;
	    },
	
	    scrubSpecialChars: function scrubSpecialChars(obj) {
	      var result = new String(obj);
	      result = result.replace(/[\%\$\`\\\*\<\>\(\)]*/g, '');
	      return result;
	    },
	
	    scrubSpecialCharsFromCompanyName: function scrubSpecialCharsFromCompanyName(obj) {
	      var result = new String(obj);
	      result = result.replace(/[\%\$\`\~\*\<\>]*/g, '');
	      return result;
	    }
	
	  };
	
	  return util;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 15:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title preauthchargesmodal.js: Sub-module for Global pages
	 * @description This module is used to display the preauthcharges modal
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16)], __WEBPACK_AMD_DEFINE_RESULT__ = function (dialog) {
	
		var preauthchargesmodal = {
	
			init: function init() {
				this.attachExternalClass();
			},
	
			attachExternalClass: function attachExternalClass() {
				$('.preauthcharges-text').unbind().on('click', this.bind_external);
			},
	
			bind_external: function bind_external(event) {
				var callerElement = event.target;
				COSTCO.dialog.returnFocusOnCallerElement(callerElement);
				preauthchargesmodal.createDialogBox(this.href);
				event.preventDefault();
			},
	
			createDialogBox: function createDialogBox(url) {
				dialog.createExtDialogBox({
					title: messages.CHECKOUT_PREAUTH_MSG,
					body: COSTCO.util.tmpl('tmpl_preauthcharges_modal', {}),
					primary: messages.CLOSE
				});
			}
	
		};
	
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.preauthchargesmodal = preauthchargesmodal;
	
		return preauthchargesmodal;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 16:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title costcodialog.js: Sub-module for Global pages
	 * @description This module is used to creating Modal
	 * @dependency
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var dialog = {
	    dialogSettings: null,
	    triggerEvent: null,
	    /**
	     * Create a BS style modal that is customizable
	     * @param  {Object} settings Object with following properties:
	     * - title : string appears in the header portion of the modal
	     * - body : HTML/string that represents the body of the modal
	     * - primary : primary action button name.
	     * - secondary : secondary action button name.z
	     * - primary_event : OPTIONAL custom event to attach to primary button
	     * - url : OPTIONAL url for external link. Used if a primary_event is not provided.
	     * @return {void}
	     */
	    createExtDialogBox: function createExtDialogBox(settings) {
	      // show onetimepopup?
	      if (settings.oneTimePopup && this.isPresentInLocalStorage(settings.url)) {
	        window.open(settings.url);
	        return;
	      }
	      dialog.showAndHideModal(settings);
	    },
	
	    modalObserver: {
	      state: {
	        STARTED: 'STARTED',
	        STOPPED: 'STOPPED'
	      },
	      observer: null,
	      modalObserverState: '',
	      elementCausedModal: undefined,
	      elementCausedSecondModalId: undefined,
	      showingSecondModal: undefined
	    },
	
	    /**
	     * Function used to watch for changes of costco modal
	    */
	    returnFocusOnCallerElement: function returnFocusOnCallerElement(activeElement) {
	      if (dialog.modalObserver.modalObserverState != dialog.modalObserver.state.STARTED) {
	        dialog.modalObserver.modalObserverState = dialog.modalObserver.state.STARTED;
	        if (activeElement !== undefined) {
	          dialog.modalObserver.elementCausedModal = activeElement;
	        }
	        var targetObject = COSTCO.dialog.getModal();
	        if (targetObject.length > 0) {
	          targetObject = targetObject[0];
	          var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	            mutationRecordsList.forEach(function (mutation) {
	              var eventOnClick = false;
	              if (event !== undefined) {
	                eventOnClick = event.target.onclick ? true : false;
	              }
	              //On modal close
	              if (mutation.target.className === "modal fade" && !dialog.modalObserver.elementCausedSecondModalId && !eventOnClick) {
	                $(dialog.modalObserver.elementCausedModal).focus();
	                dialog.modalObserver.elementCausedModal = undefined;
	                COSTCO.dialog.stopModalObserver();
	              } else if (mutation.target.className === "modal fade" && dialog.modalObserver.elementCausedSecondModalId && !eventOnClick) {
	                dialog.modalObserver.showingSecondModal = undefined;
	              } else if (mutation.target.className === "modal fade" && dialog.modalObserver.elementCausedModal && eventOnClick) {
	                COSTCO.dialog.addParentElementForModalObserver(event.target);
	              }
	            });
	          });
	          // Register the target node to observe and specify which DOM changes to watch
	          observerObject.observe(targetObject, {
	            attributes: true,
	            attributeFilter: ["class"]
	          });
	          if (observerObject) {
	            this.modalObserver.observer = observerObject;
	          }
	        }
	      }
	    },
	
	    addParentElementForModalObserver: function addParentElementForModalObserver(activeElement) {
	      dialog.modalObserver.elementCausedSecondModalId = activeElement.id;
	      dialog.modalObserver.showingSecondModal = true;
	    },
	
	    removeParentElementForModalObserver: function removeParentElementForModalObserver(activeElement) {
	      if ($('#' + dialog.modalObserver.elementCausedSecondModalId).get(0)) {
	        $('#' + dialog.modalObserver.elementCausedSecondModalId).get(0).focus();
	        $(document).keyup(function (e) {
	          if (e.key === "Escape") {
	            $(dialog.modalObserver.elementCausedModal).focus();
	            dialog.modalObserver.elementCausedModal = undefined;
	            COSTCO.dialog.stopModalObserver();
	          }
	        });
	      }
	
	      dialog.modalObserver.elementCausedSecondModalId = undefined;
	    },
	
	    stopModalObserver: function stopModalObserver() {
	
	      dialog.modalObserver.modalObserverState = dialog.modalObserver.state.STOPPED;
	
	      this.modalObserver.observer.disconnect();
	    },
	
	    /**
	     * Get the Modal for instances where you need to bind certain events
	     * @return {jQuery.Object} The costcoModal jquery object
	     */
	    getModal: function getModal() {
	      return $('#costcoModal');
	    },
	    /**
	     * [description]
	     * @return {[type]} [description]
	     */
	    isVisible: function isVisible() {
	      if ($('#costcoModal').css('display') == 'none') {
	        return false;
	      } else {
	        return $('#costcoModal').is(':visible');
	      }
	    },
	    /**
	     * [description]
	     * @param  {[type]} settings [description]
	     * @return {void}          [description]
	     */
	    showAndHideModal: function showAndHideModal(settings) {
	      dialog.captureDataBeforeShowingModal(settings);
	      if (COSTCO.dialog.isVisible()) {
	        $('#costcoModal').on('hidden.bs.modal', function () {
	          // Load up a new modal...
	          COSTCO.dialog.showModal(settings);
	        });
	        $('#costcoModal').modal('hide');
	      } else {
	        this.showModal(settings);
	      }
	    },
	    /**
	     * [description]
	     * @param  {[type]} settings [description]
	     * @return {void}          [description]
	     */
	    showModal: function showModal(settings) {
	      dialog.captureDataBeforeShowingModal(settings);
	      //modification for ReturnDialogMOdal.jsp
	      if (settings.url) {
	        $('#select-page').addClass('hidden');
	        $('#add-edit-page').removeClass('hidden');
	      }
	      if (settings.hideCloseButton) {
	        $('.close').addClass('hidden');
	      }
	      //end modification for ReturnDialogMOdal.jsp
	      if (settings.dialogclasses) {
	        $('.modal-dialog').addClass(settings.dialogclasses);
	      }
	      if (settings.hideHeader) {
	        $('.modal-header').hide();
	      } else {
	        $('.modal-header').show();
	        $('#costcoModalTitle').text(settings.title);
	        var modaltitle = settings.title;
	        if (modaltitle == 'Edit Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Edit Shipping Address | X Close");
	          $("#costcoModalBtn2").removeAttr("data-bi-tc");
	          $("#costcoModalBtn2").attr("data-bi-tc", "ui:Edit Shipping Address | Save Address");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").attr("data-bi-tc", "ui:Edit Shipping Address | Cancel");
	        }
	        if (modaltitle == 'Add New Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Add New Address Modal | X Close");
	          $("#costcoModalBtn2").removeAttr("data-bi-tc");
	          $("#costcoModalBtn2").attr("data-bi-tc", "ui:Add New Address Modal | Save Address");
	          $("#costcoModalBtn1").removeAttr("data-bi-tc");
	          $("#costcoModalBtn1").attr("data-bi-tc", "ui:Add New Address | Cancel");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").attr("data-bi-tc", "ui:Add New Address Modal | Cancel");
	        }
	        if (modaltitle == 'Select Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Select Address Modal | X Close");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").attr("data-bi-tc", "ui:Select Address Modal | Cancel");
	        }
	        if (modaltitle == 'Change Pick Up Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	        }
	        if (modaltitle == 'Edit Delivery Address' || modaltitle == 'Edit Billing Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Edit Address | Close Button");
	          $("#costcoModalBtn2").removeAttr("data-bi-tc");
	          $("#costcoModalBtn2").attr("data-bi-tc", "ui:Edit Address | Save Address");
	          $("#costcoModalBtn1").removeAttr("data-bi-tc");
	          $("#costcoModalBtn1").attr("data-bi-tc", "ui:Edit Address | Cancel");
	        }
	        if (settings.close) {
	          $('.close').unbind().on('click', function () {
	            settings.close();
	          });
	        }
	      }
	      // if there is a modal Label specified in the setting used it
	      // otherwise we will use the modal title
	      if (settings.modalLabel) {
	        $('#costcoModal').attr('aria-label', settings.modalLabel);
	        $('#costcoModal').removeAttr('aria-labelledby');
	      } else {
	        if (!settings.hideHeader && settings.title) {
	          $('#costcoModal').attr('aria-labelledby', 'costcoModalTitle');
	          $('#costcoModal').removeAttr('aria-label');
	        }
	      }
	
	      $('#costcoModalText').html(settings.body);
	      if (settings.replaceFooter) {
	        $('#costcoModal .modal-footer').html(settings.replaceFooter);
	      }
	      if (settings.showVerifyMeModal || settings.primary && (settings.primary_event || settings.url)) {
	        $('#costcoModalBtn2').text(settings.primary).show();
	        $('#costcoModalBtn2').removeAttr('automation-id');
	        $('#costcoModalBtn2').attr('automation-id', settings.primary.replace(/[^a-zA-Z0-9]/g, '').toLowerCase() + "_button");
	        if (settings.primary_button_style !== undefined && settings.primary_button_style.includes('rounded')) {
	          $('#costcoModalBtn2').addClass('primary-button-v2');
	        }
	        //since primary button is visible, make the secondary button half the row again
	        if (settings.secondary != undefined || settings.setHalfButtons) {
	          $('.costcoModalBtn1').parent('.col-md-12').removeClass('col-md-12').addClass('col-md-6');
	          $('#costcoModalBtn2').parent('.col-md-12').removeClass('col-md-12').addClass('col-md-6');
	          $('.costcoModalBtn1').parent('.col-lg-12').removeClass('col-lg-12').addClass('col-lg-6');
	          $('#costcoModalBtn2').parent('.col-lg-12').removeClass('col-lg-12').addClass('col-lg-6');
	        } else {
	          $('#costcoModalBtn2').parent('.col-md-6').removeClass('col-md-6').addClass('col-md-12');
	          $('#costcoModalBtn2').parent('.col-lg-6').removeClass('col-lg-6').addClass('col-lg-12');
	        }
	        if (settings.showVerifyMeModal) {
	          $('#costcoModalBtn2').html(settings.showVerifyMeModalText);
	          $('#costcoModalBtn2').addClass('verify-me-button');
	          $('#costcoModalBtn2').removeClass('primary-button-v2');
	          $('#costcoModalBtn2').removeClass('btn-primary');
	          $('#costcoModalBtn2').addClass('no-padding');
	        } else {
	          $('#costcoModalBtn2').removeClass('verify-me-button');
	        }
	      } else {
	        $('#costcoModalBtn2').hide();
	        //since primary event button is hidden, make the secondary button span the whole row
	        $('.costcoModalBtn1').parent('.col-md-6').removeClass('col-md-6').addClass('col-md-12');
	        $('.costcoModalBtn1').parent('.col-lg-6').removeClass('col-lg-6').addClass('col-lg-12');
	      }
	      if (settings.secondary_button_style !== undefined && settings.secondary_button_style.includes('rounded')) {
	        $('.costcoModalBtn1').addClass('secondary-button-v2');
	      } else if (settings.secondary_button_style !== undefined && settings.secondary_button_style.includes('tertiary')) {
	        $('.costcoModalBtn1').addClass('tertiary-alternative-button-v2');
	        $('.costcoModalBtn1').removeClass('btn-tertiary secondary-button-v2');
	      }
	
	      if (settings.hideFooter) {
	        $('.modal-footer').hide();
	      } else {
	        $('.modal-footer').show();
	      }
	      if (settings.primaryDisabled) {
	        $('#costcoModalBtn2').addClass('btn-disabled');
	      } else {
	        $('#costcoModalBtn2').removeClass('btn-disabled');
	      }
	      if (settings.secondary) {
	        $('.costcoModalBtn1').text(settings.secondary).show();
	      } else {
	        $('.costcoModalBtn1').hide();
	      }
	      if (settings.close) {
	        $('.close').unbind().on('click', function () {
	          //modification for ReturnDialogMOdal.jsp
	          if (settings.url == undefined) {
	            $('#select-page').removeClass('hidden');
	            $('#add-edit-page').addClass('hidden');
	          }
	          //end modification for ReturnDialogMOdal.jsp
	
	          settings.close();
	        });
	      }
	
	      if (settings.footerText) {
	        $('#costcoModalFooterText').html(settings.footerText);
	        $('#costcoModalFooterText').removeClass('hide');
	      } else {
	        $('#costcoModalFooterText').addClass('hide');
	      }
	      // Hides the default modal footer and shows the alternate modal footer
	      if (settings.footerText2) {
	        $('#costcoModalFooterText2').html(settings.footerText2);
	        $('#costcoModalFooterText2').removeClass('hide');
	      } else {
	        $('#costcoModalFooterText2').addClass('hide');
	      }
	
	      $('#commercial-indicator, #residental-indicator').unbind().on('keydown keypress', function (event) {
	        if (event.which === 32) {
	          $(this).click();
	        } else if (event.which === 38 || event.which === 40) {
	          //cursors up and down
	          var $controlIndicators = $(this).closest('.control-group').find('.control__indicator');
	          var total = $controlIndicators.length;
	          var index = $controlIndicators.index(this);
	          if (event.which == 38) {
	            //cursor up
	            index = index == 0 ? total - 1 : index - 1;
	          } else if (event.which == 40) {
	            //cursor down
	            index = (index + 1) % total;
	          }
	          $controlIndicators[index].click();
	        }
	      });
	
	      $('#commercial-indicator, #residental-indicator').unbind('click').on('click', function (event) {
	        if ($(event.target).hasClass('control__indicator')) {
	          var passiveElement = $(event.target).attr('id') === "commercial-indicator" ? $('#residental-indicator') : $('#commercial-indicator');
	          COSTCO.dialog.setRadioButtonsAttributes($(event.target), passiveElement);
	        }
	        $(event.target).find('input').click();
	      });
	
	      $('#costcoModalBtn2').unbind().on('click', function () {
	        if (COSTCO.timeoutModal && COSTCO.timeoutModal.state === COSTCO.timeoutModal.TIMEDOUT) {
	          var url = "ReLogonFormView?URL=" + window.location.pathname;
	          document.location.href = url;
	        }
	        if (settings.primary_event) {
	          if (settings.primary == 'View List' || settings.primary == 'Voir la liste') {
	            COSTCO.Global.updateSelectedMenuItem('Lists.label');
	          }
	          settings.primary_event();
	        } else {
	          $('#costcoModal').modal('hide');
	          if (settings.url) {
	            window.open(settings.url);
	
	            // check for onetimepopup and add to local storage
	            if (settings.oneTimePopup) {
	              COSTCO.util.setInStorage(settings.url, {
	                'url': settings.url
	              });
	            }
	          }
	        }
	      });
	      $('.costcoModalBtn1').unbind().on('click', function () {
	        //modification for ReturnDialogMOdal.jsp
	        if (settings.url == undefined) {
	          $('#select-page').removeClass('hidden');
	          $('#add-edit-page').addClass('hidden');
	        }
	        //end modification for ReturnDialogMOdal.jsp
	
	        if (settings.secondary_event) {
	          settings.secondary_event();
	        } else {
	          $('#costcoModal').modal('hide');
	        }
	      });
	      if (settings.popover) {
	        $('#costcoModal').find('[data-toggle="popover"]').popover();
	      }
	      this.bindEvents(settings);
	      $('#costcoModal').modal({
	        backdrop: settings.preventClose ? 'static' : true,
	        keyboard: settings.preventClose ? false : true,
	        show: true
	      });
	      //Handle page load by opening in new tab
	      $('#costcoModal').show();
	      $('#costcoModal').css('display', 'block');
	    },
	
	    sameAddressValidation: function sameAddressValidation(formSelector, fieldSelector) {
	      var addressEnteredForCheck = $('#addressEnteredForCheck').val();
	      $(fieldSelector).val(addressEnteredForCheck);
	      $(fieldSelector).focus();
	      var forms = $(fieldSelector).parents('FORM');
	      var addressEnteredForCheck2 = $('#addressEnteredForCheck2');
	      if (forms.length && addressEnteredForCheck2.length) {
	        var form = $(forms[0]);
	        var address2 = addressEnteredForCheck2.val();
	        var city = $('#addressEnteredForCheckCity').val();
	        var state = $('#addressEnteredForCheckState').val();
	        var postalCode = $('#addressEnteredForCheckPostalCode').val();
	        var formFields = form.find('INPUT[type="text"]');
	        for (var i = 0; i < formFields.length; i++) {
	          var field = formFields[i];
	          if (/address2/.test(field.name)) {
	            field.value = address2;
	          } else if (/city/.test(field.name)) {
	            field.value = city;
	          } else if (/.*(zip|postal).*/.test(field.name)) {
	            field.value = postalCode;
	          }
	        }
	        formFields = form.find('SELECT');
	        for (var i = 0; i < formFields.length; i++) {
	          var field = formFields[i];
	          if (/.*(province|state).*/.test(field.name)) {
	            field.value = state;
	          }
	        }
	      }
	      $.validator.addMethod("sameAddressValidationRule", function (inputValue) {
	        return addressEnteredForCheck === inputValue ? false : true;
	      }, messages.ERR_SHIP_ADDR_SAME_AS_WHS_ADDR_FIELD_VALIDATION);
	
	      $(formSelector).validate().resetForm();
	      $(formSelector).validate();
	      $(fieldSelector).rules('add', 'sameAddressValidationRule');
	      $(fieldSelector).valid();
	    },
	
	    /**
	     * Updates the modal title, body, buttons, bindings etc without closing the modal
	     * @param  {Object} settings @see COSTCO.dialog.createExtDialogBox()
	     */
	    updateModal: function updateModal(settings) {
	      dialog.showModal(settings);
	    },
	    /**
	     * [description]
	     * @return {void} [description]
	     */
	    close: function close() {
	      $('#costcoModal').modal('hide');
	      dialog.returnFocusOnPreviousElement();
	    },
	    /**
	     * [description]
	     * @return {void} [description]
	     */
	    closeAndUnbind: function closeAndUnbind() {
	      $('#costcoModal').unbind('shown.bs.modal');
	      $('#costcoModal').unbind('hidden.bs.modal');
	      $('#costcoModal').unbind('hide.bs.modal');
	      this.close();
	    },
	    /**
	     * Binds the "hidden/shown" events (ie modal is closed/opened) with some
	     * clear/show actions. Additionally you can pass a function as part
	     * of your settings object to execute custom thangs.
	     * @param  {Object} settings  The settings object that contains
	     *                            the event handlers used for various
	     *                            modal actions.
	     * @return {void}
	     */
	    bindEvents: function bindEvents(settings) {
	      $('#costcoModal').unbind('shown.bs.modal').on('shown.bs.modal', function (e) {
	        // This event is fired when the modal has been made visible to the user
	        // (will wait for CSS transitions to complete). If caused by a click,
	        // the clicked element is available as the relatedTarget property of
	        // the event.
	        if (settings.onshown) settings.onshown(e);
	        if (dialog.modalObserver.elementCausedSecondModalId && !e.target.onclick && !dialog.modalObserver.showingSecondModal) {
	          COSTCO.dialog.removeParentElementForModalObserver();
	        };
	        COSTCO.util.trapFocusInsideModal();
	      });
	      $('#costcoModal').unbind('hidden.bs.modal').on('hidden.bs.modal', function (e) {
	        if (typeof settings.dialogclasses != 'undefined') {
	          $('.modal-dialog').removeClass(settings.dialogclasses);
	        }
	        // clear and show. Execute fn if it exists
	        if (settings.onclose) settings.onclose(e);
	        $('#costcoModalTitle').empty().show();
	        if ($('#react-video-holder').length && $('#videoViewer-popup').length) $('#react-video-holder').append($('#videoViewer-popup'));
	        $('#costcoModalText').empty().show();
	        $('.costcoModalBtn1').empty().show();
	        $('#costcoModalBtn2').empty().show();
	
	        if (settings.afterclose) settings.afterclose(e);
	      });
	      $('#costcoModal').unbind('show.bs.modal').on('show.bs.modal', function (e) {
	        if (settings.onshow) settings.onshow(e);
	      });
	      $('#costcoModal').unbind('hide.bs.modal').on('hide.bs.modal', function (e) {
	        // This event is fired when the modal is going to close.
	        if (settings.onhide) settings.onhide(e);
	      });
	    },
	    /**
	     * [description]
	     * @param  {[type]} hostname [description]
	     * @return {boolean}
	     */
	    isPresentInLocalStorage: function isPresentInLocalStorage(hostname) {
	      if (JSON.stringify(COSTCO.util.getFromStorage(hostname)).indexOf(hostname) > 0) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    /**
	     * Holds previous options object used to instantiate a modal with.
	     * This is the modal stack used by modalStack function.
	     * @type {Array}
	     */
	    modalStackPreviousOptions: [],
	    /**
	     * Create a sequential stack of modals by calling this function
	     * successively.
	     *  ex.
	     *    1. COSTCO.dialog.modalStack({title:'hi', body:'robert'})
	     *      -> Invoke a hi-robert modal, pushes options to stack.
	     *    2. COSTCO.dialog.modalStack({title:'hi', body:'kurt'})
	     *      -> Closes the hi-robert modal and invokes/pushes the hi-kurt
	     *         modal to stack.
	     *    3. (Escape key, Exit Arrow, or blur)
	     *      -> Pops the currently invoked modal from the stack and
	     *         closes it. Invokes the previous modal from the stack
	     *         until the stack b gone or we call this function again.
	     * @param  {Object} options The settings object for the modal.
	     * @return {void}
	     */
	    modalStack: function modalStack(options) {
	      var stack = this.modalStackPreviousOptions;
	      options.index = stack.length + 1;
	      stack.push(options);
	      options.afterclose = function () {
	        var stack = dialog.modalStackPreviousOptions;
	        if (stack.length === this.index && stack.length !== 1) {
	          // we need to go backward
	          dialog.showAndHideModal(stack[this.index - 2]);
	          COSTCO.dialog.modalStackPreviousOptions.pop();
	        } else if (stack.length > this.index) {
	          dialog.showAndHideModal(stack[this.index]);
	        } else {
	          COSTCO.dialog.clearStack();
	        }
	      }.bind(options);
	      if (stack.length === 1) {
	        this.showAndHideModal(options);
	      } else {
	        this.close();
	      }
	    },
	
	    /**
	     * set radio buttons attributes
	     */
	    setRadioButtonsAttributes: function setRadioButtonsAttributes(activeElement, passiveElement) {
	      activeElement.addClass('active').attr('aria-checked', true).find('div').removeClass('hide');
	      passiveElement.removeClass('active').attr('aria-checked', false).find('input').removeAttr('checked');
	      passiveElement.find('div').addClass('hide');
	    },
	
	    /**
	     * Clears the modal stack.
	     * @return {void} [description]
	     */
	    clearStack: function clearStack() {
	      this.modalStackPreviousOptions = [];
	    },
	    /*
	     * Listener for opening/closing modals 
	     * to help with returning focus to original 
	     * element or input 
	     */
	    initializeReturnFocusListener: function initializeReturnFocusListener() {
	      $(document).on('hidden.bs.modal', '#costcoModal', function (e) {
	        dialog.returnFocusOnPreviousElement();
	      });
	      $(document).on('shown.bs.modal', '#costcoModal', function (e) {
	        dialog.returnFocusOnInput();
	      });
	    },
	    /*
	     * This function utilizes the triggerEvent variable
	     * to return focus on elements 
	     */
	    returnFocusOnPreviousElement: function returnFocusOnPreviousElement() {
	      var previousElement = null;
	      if (dialog.triggerEvent != null) {
	        previousElement = dialog.triggerEvent.srcElement;
	      } else if (dialog.triggerEvent == null && COSTCO.timeoutModal != null && COSTCO.timeoutModal.lastActiveElement != null) {
	        previousElement = COSTCO.timeoutModal.lastActiveElement;
	      } else {
	        previousElement = $('body');
	      }
	      $(previousElement).focus();
	    },
	
	    /*
	     * This function's use case is to return 
	     * focus to the element within a modal
	     */
	    returnFocusOnInput: function returnFocusOnInput() {
	      var previousElement = null;
	      if (COSTCO.timeoutModal != null && COSTCO.timeoutModal.lastActiveElement != null && dialog.dialogSettings.title !== messages.TIMEOUT_MODAL_HEADER) {
	        previousElement = COSTCO.timeoutModal.lastActiveElement;
	        COSTCO.timeoutModal.lastActiveElement = null;
	      }
	      $(previousElement).focus();
	    },
	
	    /*
	     * This function captures 
	     */
	    triggerEventUtil: function triggerEventUtil() {
	      if (window.event !== undefined) {
	        if (dialog.getSettings() != null && dialog.getSettings().title === messages.BD_QUESTIONNAIRE_TITLE) {
	          return;
	        } else if (dialog.getSettings() != null && dialog.getSettings().title === messages.TIMEOUT_MODAL_HEADER) {
	          return;
	        } else {
	          dialog.triggerEvent = window.event;
	        }
	      }
	    },
	    /*
	     * returns the current dialog's settings
	     */
	    getSettings: function getSettings() {
	      return dialog.dialogSettings;
	    },
	    /*
	     * Captures data upon opening a modal
	     * to grab the event and copy settings
	     */
	    captureDataBeforeShowingModal: function captureDataBeforeShowingModal(settings) {
	      dialog.triggerEventUtil();
	      dialog.dialogSettings = settings;
	    }
	
	  }; // end costcoDialog object
	  // Expose costcoDialog to the global scope.
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.dialog = dialog;
	  return dialog;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 37:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title ajax-modular.js: Feature level module
	 * @description Utility module associated with ajax modular
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var AjaxModular = {
	    /**
	     * ID of the element that should receive focus after AJAX update.
	     * Cleared after use.
	     * @type {string|null}
	     */
	    pendingFocusId: null,
	
	    /**
	     * A generic function to make ajax requests. The only difference being
	     * that this function sets a default done promise that injects html
	     * into the DOM with the response data. Pass done, fail, and always
	     * functions to the options object to be called in each respective promise.
	     * @param  {Object} options Object containing options to pass to $.ajax
	     *                          and functions to call within $.ajax promises.
	     * @return {void}
	     */
	    ajax_update_state: function ajax_update_state(options) {
	
	      $('.order-ajax').addClass('ajax-busy');
	
	      var checkoutPageName = typeof checkoutPage === 'undefined' ? false : checkoutPage;
	      if (options.page || checkoutPageName) {
	        options.url = COSTCO.util.makeUrl(options.url, {
	          'checkoutPage': options.page || checkoutPageName
	        });
	      }
	      // For appending HTML, caller should override options property by setting
	      // ajax_replace_content: COSTCO.AjaxModular.ajax_append_content
	      // this will be reflected in ajax_update_default_done method (look below)
	      if (!options.done) options.done = COSTCO.AjaxModular.ajax_update_default_done;
	      if (!options.always) options.always = COSTCO.AjaxModular.ajax_update_default_always(options.inputContainer);
	      COSTCO.util.ajax(options);
	    },
	
	    /**
	     * Default implementation of the done promise used by ajax_update_state.
	     * The data structure this function uses is defined in JSONLayout.jsp.
	     * Update the state of each html segment. This assumes that the
	     * property key maps to the id of the html segment to replace. Also,
	     * if there any errors defined on the response_obj.error,
	     * display them.
	     * @param  {String} data       The JSON returned as a string. Contains
	     *                             the encoded html that must be decoded
	     *                             and then is injected into the DOM.
	     * @param  {String} textStatus [description]
	     * @param  {String} jqXHR      [description]
	     * @param  {Object} options    The options object originally passed to
	     *                             ajax_update_state
	     * @return {void}
	     */
	    ajax_update_default_done: function ajax_update_default_done(data, textStatus, jqXHR, options) {
	      try {
	        var response_obj = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : JSON.parse(data);
	        var defaultOptions = {
	          ajax_replace_content: COSTCO.AjaxModular.ajax_replace_content,
	          ajax_handle_errors: COSTCO.AjaxModular.ajax_handle_errors,
	          ajax_update_post_done: function ajax_update_post_done() {},
	          error_container: '',
	          scrollToError: true
	        };
	
	        //trigger start event
	        COSTCO.AjaxModular.triger_event('costco.ajax.content.update.start', response_obj, options.start_event);
	
	        //override any defaults that came from options input parameter
	        var mergedOptions = $.extend(true, {}, defaultOptions, options);
	
	        // Inject New Html
	        mergedOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
	
	        // Post Html Injection
	        mergedOptions.ajax_update_post_done(response_obj, mergedOptions, defaultOptions);
	
	        // Handle any Errors and perform cleanup
	        mergedOptions.ajax_handle_errors(response_obj, mergedOptions, defaultOptions);
	
	        //trigger end event        
	        COSTCO.AjaxModular.triger_event('costco.ajax.content.update.end', response_obj, options.end_event);
	      } catch (e) {
	        console.error(e);
	      }
	      console.log('ajax_update_default_done');
	    },
	
	    ajax_replace_content: function ajax_replace_content(response_obj, mergedOptions, defaultOptions) {
	      Object.keys(response_obj.payload.html).forEach(function (key) {
	        var encoded_html = response_obj.payload.html[key];
	        if (mergedOptions.replaceKey) {
	          if (mergedOptions.replaceKey.original == key) {
	            key = mergedOptions.replaceKey.replace;
	          }
	        }
	        $('#' + key).html(COSTCO.util.get_decoded_html(encoded_html));
	        console.log('ajax_replace_content ' + key);
	      });
	    },
	
	    /**
	    * Append content to the end of already existing div html 
	    */
	    ajax_append_content: function ajax_append_content(response_obj, mergedOptions, defaultOptions) {
	      Object.keys(response_obj.payload.html).forEach(function (key) {
	        var encoded_html = response_obj.payload.html[key];
	        if (mergedOptions.replaceKey) {
	          if (mergedOptions.replaceKey.original == key) {
	            key = mergedOptions.replaceKey.replace;
	          }
	        }
	        $('#' + key).append(COSTCO.util.get_decoded_html(encoded_html));
	      });
	    },
	
	    ajax_handle_errors: function ajax_handle_errors(response_obj, mergedOptions, defaultOptions) {
	
	      if (COSTCO.util.isBusinessDelivery()) {
	        if (COSTCO.CreditCard && COSTCO.CreditCard.isCybersourceEnabled()) {
	          $('.error:not(.error-qty-increment, #cc_cvc, #cc_cvc_err_msg)').empty();
	        } else {
	          $('.error:not(.error-qty-increment)').empty(); // clear any errors that may be on the page
	        }
	      } else {
	        if (COSTCO.CreditCard && COSTCO.CreditCard.isCybersourceEnabled()) {
	          $('.error:not(select, #cc_cvc, #cc_cvc_err_msg)').empty();
	          $('.error:not(select)').removeClass('critical-notification');
	        } else {
	          $('.error:not(select)').empty().removeClass('critical-notification'); // clear any errors that may be on the page
	        }
	      }
	
	      var error_container = mergedOptions.error_container;
	
	      // TODO: This code is not part of ajax modular. Move it to a concrete function implementation
	      // ### Author: START
	
	      // if (typeof Checkout !== 'undefined' && (Checkout.isReviewPage() || Checkout.isPaymentPage())) {
	      //  if(typeof TokenGateway !== 'undefined'){
	      //     TokenGateway.refreshGateway();
	      //   }
	      //  if(response_obj.metadata && response_obj.metadata.quantityUpdatedForCashCardPaymentErr) {
	      //   error_container = '#errquantity_application_';
	      //   	  $('#errquantity_application_').addClass('critical-notification');
	      //   	  $('#errquantity_application_').removeClass('error');
	      //   	  $("#CheckoutPaymentForm input[name=doBillingPaymentCmd]").val('true');
	
	      //   	  if($('#errquantity_application_').html().trim() == ''){
	      //   		  $('#errquantity_application_').html(response_obj.metadata.quantityUpdatedForCashCardPaymentErr);
	      //   	  }
	      //  }
	      //  else{
	      //   if(typeof COSTCO.CreditCard !== 'undefined'){
	      //   		  COSTCO.CreditCard.init();
	      //   	  }
	
	      //   if(typeof COSTCO.wallet !== 'undefined'){
	      // ### Author: END
	
	
	      // ### Author: START
	      // 	  //wallet module is not used in USBD - all other allow 
	      // 	  if (wcs.storeId !='11301') {
	      // 		  COSTCO.wallet.init();    				  
	      // 	  }
	      // ### Author: END
	
	      // ### Author: START
	      //   }
	      //   if(typeof COSTCO.CC !== 'undefined'){
	      // 	  COSTCO.CC.init();
	      //   }  
	      //  }
	      // }
	      // ### Author: END
	
	
	      var input_container = mergedOptions.input_container;
	      var application = response_obj.error.application || [];
	      var exception = response_obj.error.exception || [];
	      var error_html = '';
	      if (exception.length > 0) {
	        error_html += '<p>An unexpected error has occured</p>';
	      }
	      application.forEach(function (error_message) {
	        error_html += '<p>' + error_message.replace(/''/g, '\'') + '</p>';
	      });
	      // if there is a redirect, store the error in sessionStorage and redirect user,
	      // otherwise error will show in error container
	      if (response_obj.error.redirect) {
	        if (typeof sessionStorage != 'undefined') {
	          sessionStorage.setItem('errorMessage', error_html); // store error_html in sessionStorage to show on redirected page
	        }
	        document.location.href = '/' + response_obj.error.redirect;
	        return;
	      }
	      if (typeof error_container === 'string') {
	        error_container = $(error_container);
	      }
	      if (input_container) {
	        if (application.length + exception.length > 0) {
	          $(input_container).addClass('error');
	          $(input_container).attr('aria-invalid', 'true');
	        } else {
	          $(input_container).removeClass('error');
	          $(input_container).attr('aria-invalid', 'false');
	        }
	      }
	
	      // TODO: Rename trigger to more general name
	      if (error_container == '' || error_container.length == 0) {
	        COSTCO.AjaxModular.triger_event('costco.ajax.content.update.sucess', response_obj);
	        return;
	      }
	      error_container.children().remove();
	
	      // TODO: This code is not part of ajax modular. Move it to a concrete function implementation
	      // ### Author: START
	      // if(response_obj.metadata.quantityUpdatedForCashCardPaymentErr && error_html.length > 0){
	      //  $(error_container).html('');
	      // }
	      // ### Author: END
	
	      error_container.append(error_html);
	
	      // TODO: This code is not part of ajax modular. Move it to a concrete function implementation
	      // ### Author: START
	      // if($('#errquantity_application_').length > 0 && $('#errquantity_application_').html().trim() != ''){
	      //  if(!COSTCO.OrderSummary.isAllPaidByCashCard()){
	      //   COSTCO.Checkout.showPaymentEditSection();
	      //  } 
	      //  else{
	      //   $('#errquantity_application_').html('');
	      //   $('#errquantity_application_').removeClass('critical-notification');
	      //   	  $('#errquantity_application_').addClass('error');
	      //  }   	  
	      //  COSTCO.CC.init();
	      // }
	      // else if($('#errquantity_application_').length > 0){
	      //  $('#errquantity_application_').removeClass('critical-notification');
	      //  $('#errquantity_application_').addClass('error');
	      // }
	      // ### Author:  END
	
	
	      // TODO: This code is not part of ajax modular. Move it to a concrete function implementation
	      // ### Author: START
	      //This will do the real work - I have no idea what the above code does.
	      //This will place error messages in-line
	      // if ($('#isBDAppVar').val() == 'BD') {
	      //  COSTCO.OrderItems.placeGlobalCartErrorsInLine(response_obj);
	      // }
	      // ### Author: END
	
	      if (mergedOptions.scrollToError && COSTCO.util.has_errors(response_obj)) {
	
	        // TODO: Rename trigger to more general name
	        $('body').trigger('costco.ajax.content.update.error', response_obj);
	        $('body, html').animate({
	          scrollTop: $(error_container).offset().top - 30
	        }, 800);
	      }
	    },
	
	    /**
	     * Extracting default function out so we can perfom this and something else
	     */
	    ajax_update_default_always: function ajax_update_default_always(inputContainer) {
	      $('.order-ajax').removeClass('ajax-busy');
	      COSTCO.Checkout.validator = undefined;
	      // Create a function to focus back to the original input after
	      // the ajax call is done
	      // This will only be done only if there input is defined in the option payload
	      if (inputContainer) {
	        var focusInput = $(inputContainer);
	        // If we have the id then lets use it
	        if (focusInput[0].id) {
	          console.log(focusInput[0].id);
	          $('#' + focusInput[0].id).focus();
	        } else {
	          console.log('Working for it');
	          // Ok no id so now we have to do work
	          if (focusInput[0].nodeName == 'INPUT') {
	            if (focusInput.attr('type') == 'radio' && focusInput.attr('name')) {
	              $('input:checked[name="' + focusInput.attr('name') + '"]').focus();
	            }
	          }
	        }
	      }
	    },
	
	    /**
	     * Triggers an event
	     *
	     * @param {String}   default_event   Required parameter. It is the default name of the event
	                                         to be triggered in case that 'event' param is not passed
	     * @param {Object}   response_obj    Object to be passed to event listener
	     * @param {String}   event           Custom event name to be triggered. If not specified, 'defaultEvent' will be used
	     *
	     * @return {void}
	     */
	    triger_event: function triger_event(default_event, response_obj, event) {
	      var eName = typeof event === 'undefined' ? default_event : event;
	      $('body').trigger(eName, response_obj);
	    }
	  };
	
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = new Object();
	  }
	  window.COSTCO.AjaxModular = AjaxModular;
	  return AjaxModular;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 77:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title global.base.js: Sub-module of Browse feature
	 * @description This module encapsulates all of the
	 * functionality related to the header component.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16), __webpack_require__(88), __webpack_require__(79), __webpack_require__(80), __webpack_require__(83), __webpack_require__(86), __webpack_require__(87), __webpack_require__(78), __webpack_require__(37), __webpack_require__(89), __webpack_require__(90), __webpack_require__(91), __webpack_require__(92)], __WEBPACK_AMD_DEFINE_RESULT__ = function (dialog, whitelist, myLocation, header, nav_v2, footer, fsamodal, tobacco, ajaxmodular, CanadaGroceryDeliveryChecker, lucidworks, edd, adobeAnalyticsEvents) {
	  /**
	   * Scroll to "this" using elem as the offset and at speed
	   * @param  {Object} elem  Offset element
	   * @param  {number} speed The speed to scroll at in milliseconds
	   * @return {jQuery}       The chainable jQuery object
	   */
	  jQuery.fn.scrollTo = function (elem, speed) {
	    try {
	      $(this).animate({
	        scrollTop: $(this).scrollTop() - $(this).offset().top + $(elem).offset().top
	      }, speed == undefined ? 1000 : speed);
	    } catch (e) {
	      console.warn(e);
	    } finally {
	      return this;
	    }
	  };
	
	  /**
	   * scrollTo alternate that just uses the offset top of the element
	   * @param  {Object} elem  Element to scroll to
	   * @param  {number} speed The speed to scroll at in milliseconds
	   * @return {jQuery}       The chainable jQuery object
	   */
	  jQuery.fn.scrollToElem = function (elem, speed) {
	    try {
	      $(this).animate({
	        scrollTop: $(elem).offset().top
	      }, speed == undefined ? 1000 : speed);
	    } catch (e) {
	      console.warn(e);
	    } finally {
	      return this;
	    }
	  };
	  /**
	   * This method is actually defined in newer versions of jquery.validate
	   * ($.validator.methods.destroy). Literally removes validator for the given form
	   * @param  {$.validator} validator The validator to do the removing from
	   * @return {jQuery}                The chainable jQuery object
	   */
	  jQuery.fn.destroyValidator = function (validator) {
	    validator.resetForm();
	    $(this).off('.validate').removeData('validator').find('.validate-equalTo-blur').off('.validate-equalTo').removeClass('validate-equalTo-blur');
	    return this;
	  };
	  /**
	   * A global ajax complete handler. This should cover common scenarios. For
	   * example, session timeouts are returned as a json response from WAS with
	   * errorCode 2510. In this case we want to redirect the user to the logonForm
	   * so they can re-logon.
	   * 
	   * In case its detected that the user is already at the logon form don't do anything
	   * they are already where they should be
	   * 
	   * @type {[type]}
	   */
	  $(document).ajaxComplete(function globalAjaxComplete(event, request, settings) {
	    // We don't want to redirect if the request was to /navtree.
	    // Changed from a straight == to indexOf to see if the request url starts with /navtree as now we are passing other
	    // parameter in the call such as storeid and langid
	    if (settings.url.indexOf('/navtree') === 0) return;
	
	    var ajaxSessionTimeout = false;
	    //Check to see if the responseJSON contain the 2510 error code associated with session timeout
	    if (request && request.responseJSON && request.responseJSON.errorCode && request.responseJSON.errorCode == 2510) {
	      ajaxSessionTimeout = true;
	      console.warn('Request ' + settings.url + ' Timeout');
	    }
	    // If an ajax call returns session timeout specific html
	    if (request && request.responseText && request.responseText.toLowerCase().indexOf('session-timeout') > -1) {
	      ajaxSessionTimeout = true;
	      console.warn('Request ' + settings.url + ' Timeout');
	    }
	    //If it is a session timeout and we are not already at the LogonForm redirect them to LogonForm 
	    if (ajaxSessionTimeout && document.location.pathname.indexOf('LogonForm') < 0 && document.location.pathname != '/') {
	      var path = document.location.pathname;
	      var url = path + '?_ajax';
	
	      if (document.location.search && document.location.search[0] == '?') {
	        url += "&" + document.location.search.substr(1);
	      }
	
	      document.location.href = COSTCO.util.scrubSpecialChars('/LogonForm?URL=' + (COSTCO.util.isCheckout(path) ? '/CheckoutCartView' : url));
	    }
	    return;
	  });
	  /**
	   * A global ajax error handler. This should cover common scenarios. For
	   * example if any ajax request returns a ReLogonFormView response, we should
	   * direct the user to logon.
	   */
	  $(document).ajaxError(function globalAjaxError(event, jqxhr, settings, thrownError) {
	    if (document.location.hostname != 'www.costco.com' && document.location.hostname != 'www.costco.ca') {
	      console.error(thrownError + ' calling ' + settings.url);
	    }
	  });
	  var GlobalBase = {
	    notify: function notify(eventName) {
	      COSTCO.Global.logger('Firing Event: ' + eventName);
	      var event = document.createEvent('Event');
	      event.initEvent(eventName, true, true);
	      document.dispatchEvent(event);
	    },
	    logger: function logger(message) {
	      if (typeof this.logQueue == 'undefined') {
	        this.logQueue = [];
	      }
	      this.logQueue.push(message);
	      console.log(message);
	    },
	    initPrinting: function initPrinting() {
	      $('.print-link').click(function () {
	        window.print();
	      });
	    },
	    /** Initialize button to perform click when keydown = enter**/
	    initButtonAda: function initButtonAda() {
	      $('input:button').keydown(function (event) {
	        if (event.which == 13) {
	          this.click();
	          event.stopPropagation();
	          event.preventDefault();
	        }
	      });
	      //firefox sometime has issue to resolve enter as an onclick event for a
	      if (typeof InstallTrigger !== 'undefined') {
	        $('a[aria-haspopup!=true], a:not([aria-haspopup])').keydown(function (event) {
	          if (event.which == 13) this.click();
	        });
	      }
	    },
	    setCellCookie: function setCellCookie() {
	      if (window.location.href.indexOf('cell=1') > -1) {
	        $.cookie('cell', 1);
	      }
	      if (window.location.href.indexOf('cell=2') > -1) {
	        $.cookie('cell', 2);
	      }
	      if (window.location.href.indexOf('cell=3') > -1) {
	        $.cookie('cell', 3);
	      }
	      if (window.location.href.indexOf('cell=4') > -1) {
	        $.cookie('cell', 4);
	      }
	    },
	    /**
	     * Bootstrap comes with "Tabs" See:
	     * https://getbootstrap.com/docs/3.3/components/#nav-tabs
	     * Typically, the functionality works natively with ul/li elements. However,
	     * in situations where you may have many "tabs", li's end up wrapping to the
	     * next line. Changing the tabs to a table/cell structure allows them
	     * to remain on a single line. This function supplements the native behavior
	     * of clearing the active state on those cells.
	     * Look for .costco-tabs-alternate for an example
	     * @return {void}
	     */
	    costcoTableTabs: function costcoTableTabs() {
	      $('.costco-tabs-alternate .table-cell a').unbind('click').on('click', function (e) {
	        var $activeCell = $(this).parent();
	        $activeCell.parents('.costco-tabs-alternate').find('.table-cell').removeClass('active');
	        $activeCell.addClass('active');
	      });
	    },
	
	    /**
	     * update selectedMenuItem option in session storage for React My account Nav highlight selected option
	     */
	    updateSelectedMenuItem: function updateSelectedMenuItem(option) {
	      window.sessionStorage.setItem('selectedMenuItem', option);
	    },
	
	    pageSizeCheck: function pageSizeCheck(e) {
	      e.preventDefault();
	      var url = document.getElementById("newAddressLine").getAttribute("href");;
	      if (window.innerWidth > 768 && window.innerWidth < 1025) {
	        pageSize = 8;
	        if (url.indexOf("storeId") !== -1) {
	          url = url + "&pageSize=" + pageSize;
	        } else {
	          url = url + "?pageSize=" + pageSize;
	        }
	      }
	      window.location.href = url;
	    },
	
	    /**
	     * Initialize focus out event for new redesigned (v2) input fields
	     */
	    initInputFieldsV2: function initInputFieldsV2() {
	
	      $(".input-field-v2 .input-outline").each(function (index) {
	        if ($(this).attr('value') !== undefined && $(this).attr('value') !== "") {
	          $('label[for="' + $(this).attr('id') + '"]').addClass("active");
	          if (!$(this).hasClass("error") && !$(this).hasClass("completed")) {
	            $(this).addClass("completed");
	          }
	        }
	      });
	
	      $('body').on("focusout", ".input-field-v2 .input-outline", function (element) {
	        if (!element.target.value && !element.target.placeholder) {
	          $("label[for='" + $(element.target).attr('id') + "']").removeClass("active");
	          if ($(element.target).hasClass("completed")) {
	            $(element.target).removeClass("completed");
	          }
	        } else {
	          $("label[for='" + $(element.target).attr('id') + "']").addClass("active");
	          if (!$(element.target).hasClass("error") && !$(element.target).hasClass("completed")) {
	            $(element.target).addClass("completed");
	          }
	        }
	      });
	    },
	
	    initMultilineDropboxSelectionV2: function initMultilineDropboxSelectionV2() {
	
	      $('body').on("click", ".multiline-dropbox-selection-v2 button", function () {
	
	        var selectedOptionId = $(this).find('a').attr('data-option-id');
	
	        var optionValues = $('.multiline-dropbox-selection-v2 li');
	
	        $.each(optionValues, function (index, optionValue) {
	          if ($(optionValue).find('a').attr('data-option-id') == selectedOptionId) {
	            $(optionValue).hide();
	          } else {
	            $(optionValue).show();
	          }
	        });
	      });
	
	      $('body').on("click", ".multiline-dropbox-selection-v2 li", function () {
	
	        var ul = $(this).parent();
	        var div = $(ul).parent();
	        var button = $(div).find('.dropdown-toggle');
	        var input = $(div).find('.multiline-dropbox-selected-option');
	
	        $(button).html($(this).find('a').clone());
	        $(input).val($(this).find('a').attr('data-option-id'));
	      });
	    },
	
	    /**
	     * Initialize focus out event for new redesigned (v2) input fields
	     */
	    initSelectFieldsV2: function initSelectFieldsV2() {
	
	      $("select.input-outline").each(function (index) {
	        if (this.value !== undefined && this.value !== "") {
	          $('label[for="' + $(this).attr('id') + '"]').addClass("active");
	        }
	      });
	
	      $('body').on("focusout", "select.input-outline", function (element) {
	        if (!element.target.value) {
	          $("label[for='" + $(element.target).attr('id') + "']").removeClass("active");
	        } else {
	          $("label[for='" + $(element.target).attr('id') + "']").addClass("active");
	        }
	      });
	    },
	
	    /**
	     * Register change event for new redesigned (v2) datePicker input
	     */
	    datePickerEventHanler: function datePickerEventHanler() {
	      if ('.preferred-arrival-date-v2') {
	        $(".preferred-arrival-date-v2").each(function () {
	          var selector = $(this).find('input.date-input');
	          selector.change(function () {
	            if ($(this).val() !== '') {
	              $(this).parent().find('.label-outline').addClass('active');
	            } else {
	              $(this).parent().find('.label-outline').removeClass('active');
	            }
	          });
	        });
	      }
	    },
	
	    /**
	     * Register change event for new redesigned (v2) radio button datePicker input
	     */
	    radioButtonDatePickerEventHanler: function radioButtonDatePickerEventHanler() {
	      if ('#deldatepicker-div') {
	        $("#deldatepicker-div").find('input.date-input').each(function () {
	          $(this).change(function () {
	            if ($(this).val() !== '') {
	              $(this).parent().find('.label-outline').addClass('active');
	            } else {
	              $(this).parent().find('.label-outline').removeClass('active');
	            }
	          });
	        });
	      }
	    },
	    /**
	     * Initialize events on back to top links
	     * by finding them by class names that are
	     * used for describing this elements
	     */
	    initBackToTopLinks: function initBackToTopLinks() {
	      if ($('#headerskip').length > 0) {
	        if (window.location.href.indexOf("myaccount/") > -1) {
	          COSTCO.util.setEventOnBackToTopLinkGatsby(".skip-main");
	        }
	        var backToTopClasses = [".back-to-top", ".back-to-top-button", ".back-to-top-refills", ".back_to_top", ".back-to-top-inline", ".drug_detail_back_to_top", ".back-to-top-ada"];
	        backToTopClasses.forEach(function (element) {
	          return COSTCO.util.setEventOnBackToTopLink(element);
	        });
	      }
	    },
	
	    /**
	     * Function called to run things that require the window to be loaded
	     * for it to run. This is introduced as there was a discreprency for chrome
	     * in terms of window on load and document ready
	     */
	    initOnLoad: function initOnLoad() {
	      COSTCO.Header.align_quickbuy_btn();
	      //Call to set zipcode via IP Sniffer
	      if (COSTCO.util.isBusinessDelivery()) {
	        COSTCO.Header.setBDZipCodeFromAkamai();
	      } else {
	        COSTCO.Header.manageGroceryZipCode();
	      }
	      myLocation.init();
	      COSTCO.util.safe(COSTCO.Header.setup_nav_dropdown)();
	      COSTCO.Header.updateSamedayLinks();
	      COSTCO.Global.initInputFieldsV2();
	      COSTCO.Global.initSelectFieldsV2();
	
	      COSTCO.Global.initMultilineDropboxSelectionV2();
	      COSTCO.Global.datePickerEventHanler();
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
	        COSTCO.Global.radioButtonDatePickerEventHanler();
	      }
	      COSTCO.Global.initBackToTopLinks();
	      $('body').on('inserted.bs.popover', COSTCO.Header.updateSamedayLinks);
	
	      // (BD only) If WC_BD_ZIP cookie exists, WC_BD_LOC cookie should also exist in format City|ST|CC - populate it if it doesn't
	      if (COSTCO.util.isBusinessDelivery() && $.cookie('WC_BD_ZIP') && !/^.+\|\w{2}\|\w{2}$/ig.test($.cookie('WC_BD_LOC'))) {
	        if ($('#isGeocodeService').val() != "true") {
	          COSTCO.util.callBingAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP'));
	        } else {
	          COSTCO.util.callGeocodeApiAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP'));
	        }
	      }
	    },
	    init: function init() {
	      COSTCO.Global.logger('Costco Global Object Initialized: ' + window.location);
	      if ($('#isLozadLazyEnabled').val() == "true") {
	        var imgResponsiveEle = document.querySelectorAll('img[data-src].img-responsive');
	        var lozadObserver = lozad(imgResponsiveEle);
	        lozadObserver.observe();
	      } else {
	        $('img').unveil(400);
	      }
	
	      whitelist.init();
	      fsamodal.init();
	      header.init();
	      footer.init();
	      if (COSTCO.util.isBDStore()) {
	        tobacco.init();
	      }
	      COSTCO.Global.initPrinting();
	      COSTCO.Global.initButtonAda();
	      COSTCO.util.iosPositionFix();
	      this.costcoTableTabs();
	      COSTCO.Global.notify('CostcoGlobalLoaded');
	      costcoloadstate.modules = true;
	      if (document.readyState == 'complete') {
	        COSTCO.Global.notify('CostcoSubModulesLoaded');
	        COSTCO.Global.initOnLoad();
	        costcoloadstate.submodules = true;
	      } else {
	        $(window).on('load', function () {
	          COSTCO.Global.notify('CostcoSubModulesLoaded');
	          costcoloadstate.submodules = true;
	          COSTCO.Global.initOnLoad();
	        });
	      }
	      COSTCO.Global.setCellCookie();
	      lucidworks.init();
	      COSTCO.util.addAriaHiddenToHiddenInput();
	    }
	  };
	
	  return GlobalBase;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 78:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	//BEGIN Tobacco Conditions
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
		var TOBACCO = _defineProperty({
			init: function init() {
				$("#ProductForm input[name='tobacco-more']").unbind('click').click(function () {
					TOBACCO.tobaccoModal();
				});
				if ($('#cartbodyBD').val() == 'true') {
					TOBACCO.warningNofication();
				}
				$.each($('.product-tile-set'), function (index, value) {
					TOBACCO.searchDisplayRules(index, value);
				});
			},
			searchDisplayRules: function searchDisplayRules(index, value) {
				var status = COSTCO.TOBACCO.userMemberInfo();
				var hasLicense = status.hasLicense != 'undefined' ? status.hasLicense : false;
				var userInfo = COSTCO.util.getMemberCookie();
				var signedIn = userInfo.signedIn;
				var deptNumber = $(value).find('#deptNumber').val() == "11";
				var tobaccoInState = $(value).find('#tobaccoInState').val() == "true" ? true : false;
				var ebbProduct = tobaccoInState && $(value).find('#ebbProd').val() == "EBB" && deptNumber ? true : false;
				var tobaccoProduct = $(value).find('#tobaccoProd').val() == "Tobacco" ? true : false;
				tobaccoProduct = tobaccoProduct || ebbProduct ? true : false;
				var addtoCart = $(value).find('#add_Button').val();
				var inStock = parseInt($(value).find('#in_Stock').val());
				var signInDetails = $(value).find('#signInDetails').val() == "signin-details" ? true : false;
				if (tobaccoProduct) {
					// tobacco product 
					if (signedIn) {
						$(value).find('#plp-sign-in-for-details').hide();
						if (hasLicense) {
							if (inStock > 0) {
								$(value).find("#plp-more-details").hide();
								$(value).find('#plp-add-to-cart').show();
							} else {
	
								$(value).find('#plp-add-to-cart').remove();
								$(value).find("#plp-more-details").show();
							}
						} else {
							$(value).find('#plp-add-to-cart').remove();
							$(value).find("#plp-more-details").show();
						}
					} else {
						var zipcode = $.cookie('WC_BD_ZIP');
						if (zipcode != null) {
							$(value).find('#plp-add-to-cart').remove();
							$(value).find("#plp-more-details").hide();
							$(value).find('#plp-sign-in-for-details').show();
						} else {
							$(value).find('#plp-add-to-cart').remove();
							$(value).find('#plp-sign-in-for-details').hide();
							$(value).find("#plp-more-details").show();
						}
					}
				} else if (signInDetails && !signedIn) {
					//map Items will come here
					$(value).find('#plp-add-to-cart').hide();
					$(value).find('#plp-sign-in-for-details').show();
					$(value).find("#plp-more-details").hide();
				} else {
					if (addtoCart == "true") {
						$(value).find('#plp-add-to-cart').show();
						$(value).find('#plp-sign-in-for-details').hide();
						$(value).find("#plp-more-details").hide();
						$(value).find('#btnas').removeClass('hide');
					} else if (inStock == 0) {
						$(value).find('#plp-add-to-cart').remove();
						$(value).find('#plp-sign-in-for-details').hide();
						$(value).find("#plp-more-details").show();
					} else {
						$(value).find('#plp-add-to-cart').remove();
						$(value).find('#btnas').removeClass('show');
						return true;
					}
				}
	
				$(value).find('#btnas').removeClass('hide');
			},
			processConditions: function processConditions() {
				var w = COSTCO.util.getBDZipCookie();
				if (w.zipCode.length > 0) {
					var status = TOBACCO.userMemberInfo(),
					    signedIn = status.signedIn,
					    hasLicense = status.hasLicense;
					if (signedIn != 'undefined' && hasLicense != 'undefined') {
						TOBACCO.toggleProductView(signedIn, hasLicense);
					} else if (signedIn == 'undefined' && hasLicense == true) {
						TOBACCO.toggleProductView(false, true);
					} else if (signedIn == false && hasLicense == 'undefined') {
						TOBACCO.toggleProductView(false, false);
					} else {
						TOBACCO.ajaxMemberStatusView(signedIn, hasLicense);
					}
				}
			},
			userMemberInfo: function userMemberInfo() {
	
				var t = getTobCookie();h = $.cookie('hashedUserId'), p = $.cookie('rrDisabledPref'), r = $.cookie('rrStoreFlag');
				if (h != null && h == '""' || h == null && p == null && r == null || h == null && (p != null && p == '""' || r != null && r == '""')) {
					var isSignedIn = false;
				} else if (h != null & h != '""' || h == null && p != null && p != '""' && r != null && r != '""') {
					var isSignedIn = true;
				} else {
					var isSignedIn = 'undefined';
				}
				var hasLicense = t.tobLicense;
				if (hasLicense !== 'undefined') {
					hasLicense = hasLicense == '1' ? true : false;
				}
				//Test Data 
				// hasLicense = false;
				return { signedIn: isSignedIn, hasLicense: hasLicense };
			},
			signInReferrer: function signInReferrer(url) {
				var baseURL = url.split('&URL=')[0],
				    href = baseURL + '&URL=' + encodeURIComponent(window.location.href);
				window.location.href = href;
			},
			openFormWeb: function openFormWeb() {
				window.open("/wcsstore/CostcoUSBDCatalogAssetStore/Tobacco/TobaccoFormWeb.pdf", "_blank");
			},
			navigateToShoppingCart: function navigateToShoppingCart(shoppingCartUrl) {
				var c = getTobCookie();
				var newCookieValue = c.tobLicense + "_1_1";
				$.cookie("wc_tob", newCookieValue);
				window.location.href = shoppingCartUrl;
			},
			ajaxMemberStatusView: function ajaxMemberStatusView(signedInCookie, tobCookie) {
				var tobCookieData = "&cmSignedIn=" + signedInCookie + "&cmStatus=" + tobCookie;
				$.ajax({
					type: 'GET',
					url: '/MemberStatusView',
					data: tobCookieData,
					dataType: 'json',
					success: function success(data) {
						if (data != null) {
							TOBACCO.toggleProductView(data.signedIn, data.hasLicense);
						} else {
							if (signedInCookie == true) {
								TOBACCO.toggleProductView(true, false);
							} else {
								TOBACCO.toggleProductView(false, false);
							}
						}
					},
					error: function error(message) {
						if (signedInCookie == true) {
							TOBACCO.toggleProductView(true, false);
						} else {
							TOBACCO.toggleProductView(false, false);
						}
					}
				});
			},
			toggleProductView: function toggleProductView(isSignIn, hasLicense) {
				if (hasLicense == false) {
					var tobData = $('[data-product="tobacco"]');
					tobData.find('.product').hide();
					tobData.find('#nonAddToCartBtn').hide();
					tobData.find('#addToCartBtn').hide();
					tobData.find('.product-quantity').hide();
					tobData.find('merchandisingText').hide();
					tobData.find('.tobMoreDetails').show();
					tobData.find('.addToCartContainer').attr('style', 'margin-bottom:49px;');
					tobData.find('.promotion').hide();
					if (isSignIn == false) {
						tobData.find('.tobMoreDetails').hide();
						tobData.find('.tobSignIn').show();
					}
				}
			},
			warningNofication: function warningNofication() {
				var t = getTobCookie();inCart = t.tobInCart;tc = t.agreeTobTermCond;
				if (inCart !== 'undefined' && inCart == 1 && tc !== 'undefined' && tc == 0) {
					//data to put in the modal popup
					var modalHtml = $('#tmpl_cart_tob_warning_pop').html();
					var modalText = $(modalHtml).find('.text');
					$('#costcoModal').hide();
					COSTCO.dialog.createExtDialogBox({
						title: messages.TOBACCO_NOTIFICATION_CART,
						body: modalText,
						primary: messages.TOBACCO_NOTIFICATION_ACCEPT,
						primary_event: function primary_event() {
							TOBACCO.navigateToShoppingCart();
						},
						onshown: function onshown(e) {
							$('.close').remove();
							//To avoid closing popup on clicking outside
							$(e.currentTarget).on('hide.bs.modal', function () {
								return false;
							});
						}
					});
				}
			},
			tobaccoModal: function tobaccoModal() {
				COSTCO.dialog.createExtDialogBox({
					title: messages.TOBACCO_CONFIRM_YOUR_ACTION,
					body: COSTCO.util.tmpl('tmpl_tobacco_popups'),
					primary: messages.TOBACCO_CONTINUE_TO_FORM,
					secondary: messages.TOBACCO_CANCEL,
					primary_event: function primary_event() {
						TOBACCO.openFormWeb();
					}
				});
			}
		}, 'navigateToShoppingCart', function navigateToShoppingCart() {
			var c = getTobCookie();
			var newCookieValue = c.tobLicense + "_1_1";
			$.cookie("wc_tob", newCookieValue);
			window.location.href = $("#ShoppingCartUrl").val();
		});
		//END Tobacco Conditions
	
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
		window.COSTCO.TOBACCO = TOBACCO;
	
		return TOBACCO;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	function getTobCookie() {
		var wcTobCookie = $.cookie('wc_tob');
		if (wcTobCookie == null || wcTobCookie == undefined) {
			wcTobCookie = "undefined_undefined_undefined";
		}
		tobArray = wcTobCookie.split("_");
		return { tobLicense: tobArray[0], agreeTobTermCond: tobArray[1], tobInCart: tobArray[2] };
	}

/***/ },

/***/ 79:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	//dependency on dialog.js?
	//console.log?
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
		var myLocation = {
	
			/**
	   * Sets up the country/region/language dropdowns on the header
	   * @return {[void]}
	   */
			init: function init() {
				if (COSTCO.util.getLangId() != -1) {
					//CA specific
					this.initSelectLanguage();
					if ($('#regionLangSelEnabledVal').val() != 'BC') {
						this.initSelectRegion();
					}
				}
			},
	
			/**
	         * Binds a click event to the anchors inside the langugage select
	         * dropdown popover
	         * @return {[void]}
	         */
			initSelectLanguage: function initSelectLanguage() {
				$("#language-select-popover-container").on({
					click: function click() {
						var selectedLangId = $(this).attr("langid");
						COSTCO.util.setInSession('navTree', {});
						COSTCO.myLocation.reloadWithNewLanguage(selectedLangId);
					}
				}, 'a');
			},
	
			/**
	         * Displays the set province abbreviation on the header region select dropdown popover
	         * and binds a click event to the anchors inside the popover
	         * @return {[void]}
	         */
			initSelectRegion: function initSelectRegion() {
				var regionCookieValue = null;
				if (null != COSTCO.util.getRegion()) {
					regionCookieValue = escape(COSTCO.util.getRegion());
				}
				var currentCountry = 'CA';
				var currentRegion = 'AB';
				if (regionCookieValue) {
					currentCountry = regionCookieValue.substring(0, 2);
					currentRegion = regionCookieValue.substring(2);
				}
				COSTCO.myLocation.setElementText('#region-select', currentRegion);
				var currentRegionName = COSTCO.myLocation.getStateDisplayName(currentCountry, currentRegion);
				$('#region-select').attr('aria-label', currentRegionName);
				$("#region-select-popover-container").on({
					click: function click() {
						regionCookieValue = COSTCO.util.getRegion();
						var selectedRegion = $(this).attr("statecode");
						var newCookieValue = "CA" + selectedRegion;
						if (newCookieValue != regionCookieValue) {
							COSTCO.util.setCookie(cookies.SELECTED_REGION_COOKIE, newCookieValue, cookies.SELECTED_REGION_EXPIRES);
							if ($.cookie(cookies.INV_CHECK_POSTAL_CODE_COOKIE) != null) {
								//$.cookie(cookies.INV_CHECK_POSTAL_CODE_COOKIE, '', $.extend({}, { expires: -1 }));
							}
							if ($.cookie(cookies.INV_CHECK_STATE_CODE_COOKIE) != null) {
								$.cookie(cookies.INV_CHECK_STATE_CODE_COOKIE, '', $.extend({}, { expires: -1 }));
							}
							// Initialize cookie to determine grocery delivery 2-day eligible or not 
							COSTCO.myLocation.valid_grocery_region(selectedRegion);
							COSTCO.myLocation.reload_region_change();
						}
					}
				}, 'a');
			},
	
			getStateDisplayName: function getStateDisplayName(currentCountry, currentRegion) {
				if (typeof countries !== 'undefined') {
					var states = countries.find(function (element) {
						return element.code === currentCountry;
					}).states;
					var stateName = currentRegion + " " + states.find(function (e) {
						return e.code === currentRegion;
					}).displayName + " " + messages.HEADER_REGION_OFFSCREEN_TEXT;
					return stateName;
				} else {
					return "";
				}
			},
	
			/**
	         * Displays the language/region select modal if user does not have a province cookie set, otherwise
	         * if the function was triggered from the footer(mobile view), displays the modal regardless of the
	         * province cookie being set. Displays regional pricing for the province set/selected
	         * @param {[boolean]} footerTrigger. Function triggered from footer
	         * @return {[void]}
	         */
			initLocationModal: function initLocationModal(footerTrigger) {
	
				//loads the language and region select modal with the given province pre-selected
				function loadModal() {
	
					//data to put in the modal popup
					var modalHtml = $('#language-region-modal').html();
					var modalTitle = $(modalHtml).find('.title').text();
					var modalText = $(modalHtml).find('.text');
	
					//select the radio button for the current language. Select CA English if button not found
					var langButton = modalText.find('input:radio[name=language][value=' + COSTCO.util.getLangId() + ']');
					if (langButton.length) {
						langButton.prop("checked", true);
					} else {
						modalText.find('input:radio[name=language][value=-24]').prop("checked", true);
					}
	
					//hide sections of modal template that aren't needed
					$('.modal-header > button').hide();
					if ($("#verify-membership") == null) {
						$('.modal-dialog').attr('id', 'language-region-dialog'); //attach id for styling this modal
					}
					COSTCO.dialog.createExtDialogBox({
						title: modalTitle,
						body: modalText
					});
					$('.modal-footer').hide();
					$('#language-region-set').on("click", function () {
						//hide the modal when user submits. hide.bs.modal triggers another event
						$('#costcoModal').modal('hide');
					});
	
					//hotfix : PRB2002994-Canada Ecommerce iPads Not Loading Language and Region options
	
					//add overlay which will be removed in setProvince method
					//$('#navigation-overlay-div-element').show();
					//$('#costcoModal').css('z-index', '20011');
					$("input[name=region][value='AB']").prop('checked', true);
	
					$('#costcoModal').on({
						'hide.bs.modal': function hideBsModal() {
							var selectedLang = $('#language-radio-buttons input:radio:checked').val();
							var selectedRegion = $('#region-radio-buttons input:radio:checked').val();
							if (selectedRegion) {
								COSTCO.util.setCookie(cookies.SELECTED_REGION_COOKIE, 'CA' + selectedRegion, cookies.SELECTED_REGION_EXPIRES);
							}
							if ($.cookie(cookies.INV_CHECK_POSTAL_CODE_COOKIE) != null) {
								//$.cookie(cookies.INV_CHECK_POSTAL_CODE_COOKIE, '', $.extend({}, { expires: -1 }));
							}
							if ($.cookie(cookies.INV_CHECK_STATE_CODE_COOKIE) != null) {
								$.cookie(cookies.INV_CHECK_STATE_CODE_COOKIE, '', $.extend({}, { expires: -1 }));
							}
							COSTCO.myLocation.valid_grocery_region(selectedRegion); // validate the region and sets 'C_2LOC' cookie
							COSTCO.util.addUrlToLangMap(window.location.pathname, selectedLang);
							COSTCO.myLocation.reloadWithNewLanguage(selectedLang); //reload and set lang cookie if user selected different language
						},
						'hidden.bs.modal': function hiddenBsModal() {
							//unhide the hidden modal sections
							$('.modal-footer').show();
							$('.modal-header > button').show();
						}
					});
				}
	
				/**
	    * selects region on region modal based on input province,
	    * if no province is provided, Alberta - AB, will be selected
	    */
				function setProvince(province) {
					//default to Alberta if there is no province given
					if (!province) {
						province = 'AB';
						COSTCO.util.setCookie(cookies.SELECTED_REGION_COOKIE, 'CA' + province, cookies.SELECTED_REGION_EXPIRES);
						COSTCO.util.setCookie(cookies.GROCERY_REGION_COOKIE, false, cookies.SELECTED_REGION_EXPIRES);
					}
	
					var modalText = $('#language-region-dialog').find('.text');
	
					//select the radio button for the given province. Select Alberta if button not found
					var regionButton = modalText.find('input:radio[name=region][value=' + province + ']');
					if (regionButton.length) {
						regionButton.prop("checked", true);
						COSTCO.myLocation.setElementText('#region-select', province); //change the region dropdown text too
					} else {
						modalText.find('input:radio[name=region][value=AB]').prop("checked", true);
						COSTCO.myLocation.setElementText('#region-select', 'ON');
					}
					//hotfix : PRB2002994-Canada Ecommerce iPads Not Loading Language and Region options
					//remove overlay
					//$('#navigation-overlay-div-element').hide();
					$('#costcoModal').css('z-index', '');
				}
				//ALM#30788-Adding the C_LOC preference in client side as well
				var appProvince = COSTCO.util.getParamVal(window.location.href, 'province');
				if (appProvince) {
					COSTCO.util.setCookie(cookies.SELECTED_REGION_COOKIE, 'CA' + appProvince, cookies.SELECTED_REGION_EXPIRES);
					setProvince(appProvince);
				}
				//ALM#11577- show region modal even if C_2LOC grocery cookie null
				if ($.cookie(cookies.SELECTED_REGION_COOKIE) == null || $.cookie(cookies.SELECTED_REGION_COOKIE).length === 2) {
					loadModal();
					this.geoLocator(setProvince);
				} else if (footerTrigger) {
					loadModal();
					setProvince($.cookie(cookies.SELECTED_REGION_COOKIE).substring(2));
				}
				COSTCO.myLocation.initRegionFees(true);
				if ($.cookie(cookies.SELECTED_REGION_COOKIE) != null && $.cookie(cookies.GROCERY_REGION_COOKIE) == null) {
					var isRegionAvl = $.cookie(cookies.SELECTED_REGION_COOKIE).substr(2, 3);
					if (isRegionAvl != null) {
						COSTCO.myLocation.valid_grocery_region(isRegionAvl);
					}
				}
			},
	
			/**
	         * Attempts to get the user's location and runs a callback function after
	         * @param {[function]} callback. The function to execute after getting user's location
	         * @return {[void]}
	         */
			geoLocator: function geoLocator(callback) {
	
				if (!navigator.geolocation) {
					console.log('Geo Location not available');
					callback(null);
					return;
				}
	
				if (typeof geoLocateToken == 'undefined') {
					console.log('BING - Map Token was not defined successfully');
					callback(null);
					return;
				}
	
				//the callback function on error for navigator.geolocation.getCurrentPosition()
				function positionError() {
					console.log('BING - Error Retrieving Coordinates for Geolocation');
					callback(null);
					return;
				};
	
				//the callback function on success for navigator.geolocation.getCurrentPosition()
				function positionCallback(position) {
	
					COSTCO.myLocation.getStateFromBing(position, function (data) {
						console.log('BING - Success retrieving location');
						var province = null;
						try {
							province = data.resourceSets[0].resources[0].address.adminDistrict;
						} catch (err) {
							console.log('BING - Error with Bing Data');
							callback(null);
						}
						callback(province);
					}, function () {
						console.log('BING - Error Retrieving Location Data');
						callback(null);
					});
				}
	
				navigator.geolocation.getCurrentPosition(positionCallback, positionError);
			},
	
			/**
	         * Makes AJAX call to a bing service to get user's location.
	         * @param {[function]} bingsuccess. The function to execute on success
	         * @param {[function]} bingerror. The function to execute on error
	         * @return {[void]}
	         */
			getStateFromBing: function getStateFromBing(position, bingsuccess, bingerror) {
				var lat = position.coords.latitude;
				var longitude = -Math.abs(position.coords.longitude);
	
				var geocodeRequest = "https://dev.virtualearth.net/REST/v1/Locations/" + lat + "," + longitude + "?o=json&key=" + geoLocateToken;
	
				$.ajax({
					url: geocodeRequest,
					dataType: 'jsonp',
					jsonp: 'jsonp',
					error: function error(XMLHttpRequest, textStatus, errorThrown) {
						bingerror(XMLHttpRequest, textStatus, errorThrown);
					},
					success: function success(data, textstatus, XMLHttpRequest) {
						bingsuccess(data, textstatus, XMLHttpRequest);
					}
				});
			},
	
			/**
	         * Reloads the page if the given langId is different than the current one
	         * @param {[int]} langId
	         * @return {[void]}
	         */
			reloadWithNewLanguage: function reloadWithNewLanguage(langId) {
				var appendVariable = null;
				var currentUrl = null;
				var currentLangId = COSTCO.util.getLangId();
				var url = window.location.href;
				var cookieDomain = wcs.domain;
				if (url.indexOf('bd-cmc.vqa') > -1 || url.indexOf('bd-cmc.vuat') > -1 || url.indexOf('bd-cmc.ecom') > -1) {
					url = COSTCO.myLocation.redirectInManagementCenter(url);
					cookieDomain = '.costco.com';
				}
				var langIdFromUrl = COSTCO.util.getParamVal(url, 'langId');
				if (Object.keys(COSTCO.util.parseURL(url).params).length === 0) {
					appendVariable = "?";
				} else {
					appendVariable = "&";
				}
				if (langIdFromUrl == null || langIdFromUrl == undefined || langIdFromUrl == '') {
					url += appendVariable + 'langId=' + langId;
				} else {
					var currentLang = "langId=" + langIdFromUrl;
					var selectedLangId = "langId=" + langId;
					url = url.replace(currentLang, selectedLangId);
				}
				if (url.toLowerCase().includes('currentpage')) {
					url = url.replace('currentPage=' + COSTCO.util.getParamVal(url, 'currentPage') + '&', '');
				}
				var currentUrl = url;
				var paramToStrip = '&refine=';
				COSTCO.util.setCookie(cookies.SELECTED_LANG_COOKIE, langId, cookies.SELECTED_REGION_EXPIRES, cookieDomain);
				if (currentUrl.indexOf(paramToStrip) >= 0) {
					currentUrl = currentUrl.split(paramToStrip)[0];
				}
				if (!window.location.hash) {
					window.location.href = currentUrl;
				} else {
					window.location.reload();
				}
			},
	
			redirectInManagementCenter: function redirectInManagementCenter(url) {
				if (url.indexOf('fromIndex=1') >= 0) {
					return window.location.href.replace('?fromIndex=1', 'webapp/wcs/preview/servlet/StoreView');
				}
				if (window.location.pathname === '/') {
					return window.location.origin + '/webapp/wcs/preview/servlet/StoreView' + '?storeId=' + wcs.storeId;
				}
				if (/(.*).*product*\.[0-9]+.*html+/i.test(window.location.pathname)) {
					var stringElem = window.location.pathname.split(".")[2];
					return window.location.origin + '/webapp/wcs/preview/servlet/ProductDisplay?partNumber=' + stringElem + '&catalogId=' + wcs.catalogId + '&storeId=' + wcs.storeId;
				}
				if (/(.*).*html+/i.test(window.location.pathname) && pageType === 'Category') {
					var categoryName = window.location.pathname.split(".")[0].replace('/', '');
					return window.location.origin + '/webapp/wcs/preview/servlet/CategoryDisplay?identifier=' + categoryName + '&catalogId=' + wcs.catalogId + '&storeId=' + wcs.storeId;
				}
				if (window.location.pathname.indexOf('CatalogSearch') >= 0 && pageType === 'Search') {
					var categoryParams = window.location.href.split("/")[1];
					return window.location.origin + '/webapp/wcs/preview/servlet/' + categoryParams + '?storeId=' + wcs.storeId;
				}
				return url;
			},
	
			reload_region_change: function reload_region_change() {
				if ($('.clear-filter').length > 0) {
					$('.clear-filter').click();
				} else {
					window.location.reload();
				}
			},
	
			/**
	   * Initialize the cookie value to determine whether the selected region is eligible for grocery 2-day delivery or not.
	   * @param {[String]} selectedRegion
	   * @return {[void]}
	   */
			valid_grocery_region: function valid_grocery_region(selectedRegion) {
				var isGroceryRegion = false;
				if (groceryEligRgns) {
					var eligrgn = groceryEligRgns.split(",");
					for (i = 0; i < eligrgn.length; i++) {
						console.log(eligrgn[i]);
						if (selectedRegion == eligrgn[i]) {
							isGroceryRegion = true;
							break;
						}
					}
				}
				COSTCO.util.removeFromSession('isGroceryVisited');
				COSTCO.util.setCookie(cookies.GROCERY_REGION_COOKIE, isGroceryRegion, cookies.SELECTED_REGION_EXPIRES);
			},
	
			//move to Util?
			//gets the element's text node value from the given selector
			getElementText: function getElementText(id) {
				var text = null;
				if ($(id).length) {
					text = $(id).get(0).firstChild.nodeValue;
				}
				return text;
			},
	
			//move to Util?
			//use this for updating the header on the region selectors when user chooses a region
			setElementText: function setElementText(id, text) {
				if ($(id).length) {
					$(id).get(0).firstChild.nodeValue = text;
				}
			},
	
			//pulled from RegionalSelectorMenu_UI.jspf
			saveCatalogSortHeaderDropdownHTML: "",
			saveNavTreeHTML: "",
	
			initRegionFees: function initRegionFees(saveTags) {
	
				function displayCustomTagElments(saveElement, tag, cookieValue) {
					//Loop saved Catalog Sort Header Dropdown elements and display	
					for (var i = 0; i < saveElement.length; i++) {
						saveElement[i].remove();
	
						if (saveElement[i].attr('data-regionnav') == "") {
							$(tag).append(saveElement[i]);
						} else {
							if (saveElement[i].attr('data-regionnav') == cookieValue) {
								$(tag).append(saveElement[i]);
							}
						}
					}
				};
	
				function showRegionalFeePrice(location) {
					$('*[data-region]').hide();
					$('[data-price]').hide();
					$('[data-yourprice]').hide();
					$('[data-wishlist-linkfee="true"]').hide();
					var myDiv = $('[data-region ="' + location + '"]');
					if (myDiv.length == 0) {
						$('[data-price]').attr('style', 'display: inline !important');
						$('[data-yourprice]').attr('style', 'display: inline !important');
						$('[data-wishlist-linkfee="true"]').attr('style', 'display: inline !important');
					} else {
						myDiv.attr('style', 'display: inline !important');
						if ($('#ProductForm .product-option').length == 0 && $('div', myDiv).hasClass('less-price') == false && $('div', myDiv).hasClass('eco-price') == true) {
							$('.your-price', myDiv).css("border-top", "1px solid #333333");
						}
						$('[data-wishlist-linkfee="false"]').attr('style', 'display: inline !important');
					}
				};
	
				function saveCustomTagElements() {
					var dropdownHeaderOptionArray = new Array();
					var dropdownFooterOptionArray = new Array();
					var navTreeDivArray = new Array();
	
					$('#sort_by').find('option[data-regionnav]').each(function () {
						dropdownHeaderOptionArray.push($(this));
					});
	
					COSTCO.myLocation.saveCatalogSortHeaderDropdownHTML = dropdownHeaderOptionArray;
				};
	
				/**
	       * Shows regional price on the search and catalog page
	       * @param {[string]} location. The province to show Regional price for
	       * @return {[void]}
	       */
				function showRegionalPriceInCatalogSearch() {
					var cookieValue = "DEFAULT";
					var feeRegions = ['CAQC', 'CANB', 'CAON', 'CANS']; //the regions with eco-fees
					if (feeRegions.indexOf($.cookie(cookies.SELECTED_REGION_COOKIE)) > -1) {
						cookieValue = $.cookie(cookies.SELECTED_REGION_COOKIE);
						//Display ProductTile currency values
						$('.price-parent').each(function () {
							var regionDiv = $(this).find('[data-regionnav=' + cookieValue + ']');
							if (regionDiv.length > 0 && regionDiv.text()) {
								regionDiv.removeClass('hide').show();
								$(this).find('[data-regionnav=DEFAULT]').hide();
							}
						});
					}
	
					//Display Custom Tags for LeftNav and Catalog Sort Dropdowns
					displayCustomTagElments(COSTCO.myLocation.saveCatalogSortHeaderDropdownHTML, '#sort_by', cookieValue);
				};
	
				/**
	       * Shows regional price on the product page
	       * @param {[string]} location. The province to show Regional price for
	       * @return {[void]}
	       */
				function showRegionalPrice(location) {
					var parentDiv = $('div.product-tile, div.slick-slide');
					var defaultSelector = $('[data-regionNav="DEFAULT"]');
					var regionSelector = $('[data-regionNav="' + location + '"]');
					parentDiv.each(function () {
						if ($(this).find(regionSelector).length > 0) {
							$(this).find(regionSelector).attr('style', 'display: inline !important');
							$(this).find(defaultSelector).hide();
						} else {
							$('.price-with-linkfee', this).hide();
							$(this).find(defaultSelector).attr('style', 'display: inline !important');
						}
					});
				};
	
				var loc = $.cookie(cookies.SELECTED_REGION_COOKIE);
				if (saveTags) {
					saveCustomTagElements();
				}
				if (loc != null) {
					if ($('#ProductForm .product-option').length == 0) showRegionalFeePrice(loc);
					if ($('#search-results').length > 0) {
						showRegionalPriceInCatalogSearch();
					} else {
						showRegionalPrice(loc);
					}
				}
			}
	
		}; //end region object
	
		// Expose region to the global scope.
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.myLocation = myLocation;
	
		return myLocation;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 80:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title header.js: Sub-module of Browse feature
	 * @description This module encapsulates all of the
	 * functionality related to the header component.
	 * @dependency utility.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(81), __webpack_require__(37), __webpack_require__(83), __webpack_require__(84), __webpack_require__(85)], __WEBPACK_AMD_DEFINE_RESULT__ = function (zipCodeModal, ajaxModular, nav_v2, tooltip, retainSearchTerm) {
	  var Header = {
	    miniBannerRefreshAjax: true,
	    itemPartNumberSelcted: '',
	    narvarDCFetchedSku: '',
	    kmsiCount: 0,
	
	    /**
	        * The initializing function modules use
	        * to call.
	        * @return {void}
	        */
	    init: function init() {
	      try {
	        nav_v2.init();
	        if (sessionStorage.getItem("landingPage") === null) {
	          sessionStorage.setItem("landingPage", JSON.stringify({
	            referrer: document.referrer,
	            href: window.location.href,
	            search: window.location.search
	          }));
	        }
	        if (window.location.href.includes("referralId")) {
	          var landingUrl = window.location.href;
	          var pathname = landingUrl.split('?')[1];
	          var referalId = pathname.split('=')[1];
	          sessionStorage.setItem("membershipReferalId", referalId);
	        }
	        COSTCO.util.safe(this.kmsi());
	        COSTCO.util.safe(this.changeLinksForQuickPurchase)();
	        COSTCO.util.safe(this.setup_popovers)();
	        COSTCO.util.safe(this.prevent_drop_dragovers)();
	        COSTCO.util.safe(this.replaceShopMembershipLinksOnAddToCart)();
	        COSTCO.util.safe(this.searchFieldValidation)();
	
	        COSTCO.util.safe(this.signInOutContainerInit)();
	        COSTCO.util.safe(this.miniShopCartRefresh)();
	        COSTCO.util.safe(this.showBanner)();
	        COSTCO.util.safe(this.setupSearchDropdown)();
	        // This is moving to global.js.initOnLoad to prevent the dropdowns
	        // from being invoked before the document.readyState = complete
	        // COSTCO.util.safe(this.setup_nav_dropdown)();
	        COSTCO.util.safe(this.resetSearch)();
	        COSTCO.util.safe(this.closeAlertBanner)();
	        COSTCO.util.safe(this.hideGroceryBannerForInvalidRegion)();
	        //Depot Catalog Online - Required only if grocery flow and if DepotCatalogOnline enabled.
	        if (COSTCO.util.islocationControlledInventoryFlow() && COSTCO.util.isDepotCatalogEnabled()) {
	          COSTCO.util.safe(this.bindRefreshBtn)();
	        }
	
	        // header.js Initialization
	
	        var suggestionEnabled = $('#typeAheadEnabled').val();
	
	        var lwTypeAheadEnabled = COSTCO.LWSearch.isLWTypeAheadEnabled();
	
	        if (suggestionEnabled === 'true' && !lwTypeAheadEnabled) {
	          COSTCO.util.safe(this.typeahead)();
	        }
	
	        COSTCO.util.display_SelectOrSignInButton();
	
	        // Align all add to cart button in same line
	        var waitForFinalEvent = function () {
	          var timers = {};
	          return function (callback, ms, uniqueId) {
	            if (!uniqueId) {
	              uniqueId = '###';
	            }
	            if (timers[uniqueId]) {
	              clearTimeout(timers[uniqueId]);
	            }
	            timers[uniqueId] = setTimeout(callback, ms);
	          };
	        }();
	
	        // this will align quick buy buttons when user switches view.
	        $(window).resize(function () {
	          waitForFinalEvent(function () {
	            Header.align_quickbuy_btn();
	          }, 500, '###');
	        });
	        this.popovers();
	        var appType = $('#applicationType').val();
	        if (appType == 'BD') {
	          COSTCO.zipCodeModal.init();
	        }
	        $('#logoff').click(function () {
	          $.cookie('C_GOP', null, { path: '/' });return false;
	        });
	
	        /**
	         * Below code handles the onclick events on  User Account Menu
	         * React Top Flyout Nav Bar component
	         */
	        var memberCookie = COSTCO.util.getMemberCookie();
	        var c = $.cookie('hashedUserId');
	        if (c != null && c != undefined && c != "") {
	          $('#myaccount-react-m, #myaccount-react-t').attr('href', 'javascript:void(0);');
	
	          $('#myaccount-react-d,#myaccount-react-m,#myaccount-react-t').click(function () {
	
	            var queryToMatch = '(min-width: 1025px)'; // 1024px is a tablet
	
	            // This will return a boolean true for desktop and false for tablets and phones.
	            if (window.matchMedia(queryToMatch).matches) {
	              window.wioEventBus.publish('accountMenu', { accountMenu: true });
	            } else {
	              window.location.href = '/AccountHomeView';
	            }
	          });
	        }
	
	        // populate selectedItem property for nav bar react component lists option highlighting
	        $('#miniBannerList,#miniBannerListBD').click(function () {
	          COSTCO.Global.updateSelectedMenuItem('Lists.label');
	        });
	
	        // populate selectedMenuItem in session storage nav bar react component RenewMembership option to be highlighted
	        if (window.location.href.includes("RenewMembershipView")) {
	          COSTCO.Global.updateSelectedMenuItem("Renew.label");
	        }
	
	        if (this.hasInvPostalCodeCookie() && this.isInvCityStateCookieMissing()) {
	          if ($('#isGeocodeService').val() != "true") {
	            COSTCO.util.callBingAndUpdateCookies($.cookie('invCheckPostalCode'));
	          } else {
	            COSTCO.util.callGeocodeAPIAndUpdateCookies($.cookie('invCheckPostalCode'));
	          }
	        }
	        if (window.location.href.includes("AccountHomeView")) {
	          COSTCO.Global.updateSelectedMenuItem("AccountHome.label");
	        }
	        // populate selectedMenuItem in session storage to display Account Home as page title
	        if (window.location.href.includes("AccountHomeView")) {
	          COSTCO.Global.updateSelectedMenuItem("AccountHome.label");
	        }
	      } catch (e) {
	        console.error("Header Js error" + e);
	      }
	      // COSTCO.util.safe(this.kmsi());
	      COSTCO.util.safe(this.hidePrimaryClause)();
	      retainSearchTerm.init();
	    },
	
	    /**
	     * Checks if inv cookie values for state and zip are missing
	     */
	    isInvCityStateCookieMissing: function isInvCityStateCookieMissing() {
	      return $.cookie('invCheckCity') == null || $.cookie('invCheckStateCode') == null || $.cookie('invCheckCity') == '' || $.cookie('invCheckStateCode') == '';
	    },
	
	    /**
	     * Checks if inv cookie values for state and zip are missing
	     */
	    isInvStateCookieMissing: function isInvStateCookieMissing() {
	      return $.cookie('invCheckStateCode') == null || $.cookie('invCheckStateCode') == '';
	    },
	
	    /**
	     * Checks in inv zipcode cookie is present
	     */
	    hasInvPostalCodeCookie: function hasInvPostalCodeCookie() {
	      return $.cookie('invCheckPostalCode') != null;
	    },
	
	    /**
	     * Function used to link the hidden dropdown for search widget
	     * We need to attach 2 event
	     *    1. Onchange event on the select dropdown which will update the search dropdown facade and the input field
	     *    2. Onfocus event which will then style the facade to be in focus
	     */
	    setupSearchDropdown: function setupSearchDropdown() {
	      $('#search-dropdown-select').change(function (event) {
	        var selectedCat = $("#search-dropdown-select option:selected").first();
	        var catFacadeTxt = selectedCat.data('disp-facade');
	        var catValue = '/' + selectedCat.val();
	
	        //Set facade text to the catFacadeTxt
	        $('#search-label').text(catFacadeTxt);
	        $('#formcatsearch').attr('action', catValue);
	        $('#selected-type').val(catFacadeTxt);
	      });
	      $('#search-dropdown-select').focus(function (event) {
	        $('#search-dropdown-facade').addClass('focus');
	      });
	      $('#search-dropdown-select').blur(function (event) {
	        $('#search-dropdown-facade').removeClass('focus');
	      });
	    },
	    /**
	     * Tool tips.
	     */
	    popovers: function popovers() {
	      $('.minibanner-help').popover({
	        trigger: 'focus',
	        placement: 'bottom'
	      });
	      $('.a11y-tooltip').on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	      $('.help-icon, .a11y-tooltip, .co-help').popover();
	
	      $('.a11y-tooltip').on('click', function (event) {
	        event.preventDefault();
	      });
	    },
	    checkIsGroceryVisited: function checkIsGroceryVisited() {
	      var isGroceryVisited = sessionStorage.getItem('isGroceryVisited');
	      if (null == isGroceryVisited || $.isEmptyObject('isGroceryVisited') || !isGroceryVisited || isGroceryVisited == "false") {
	        return false;
	      } else {
	        return true;
	      }
	    },
	    checkIsRestricted: function checkIsRestricted() {
	      var isRestrictedPostalCode = localStorage.getItem('isRestrictedPostalCode');
	      if (null == isRestrictedPostalCode || $.isEmptyObject('isRestrictedPostalCode') || !isRestrictedPostalCode || isRestrictedPostalCode == 'false') {
	        return false;
	      } else {
	        return true;
	      }
	    },
	    /**
	     * Function that verifies whether the Grocery Modal has been displayed and only allows a
	     * once per session pop-up
	     */
	    checkIsGroceryModalDisplayed: function checkIsGroceryModalDisplayed() {
	      var isGroceryModalDisplayed = sessionStorage.getItem('isGroceryModalDisplayed');
	      if (null == isGroceryModalDisplayed || $.isEmptyObject('isGroceryModalDisplayed') || !isGroceryModalDisplayed || isGroceryModalDisplayed == "false") {
	        return false;
	      } else {
	        return true;
	      }
	    },
	
	    /**
	     * Function that verifies whether the Zip Code Cookie was set by Akamai
	     */
	    checkIsZipSetByAkamai: function checkIsZipSetByAkamai() {
	      var isZipSetByAkamai = sessionStorage.getItem('isZipSetByAkamai');
	      if (null == isZipSetByAkamai || $.isEmptyObject('isZipSetByAkamai') || !isZipSetByAkamai || isZipSetByAkamai == "false") {
	        return false;
	      } else {
	        return true;
	      }
	    },
	
	    /**
	     * Function that verifies whether Zip Code is forced-submitted (the flow should not be disrupted, AddressType modal should not be able to close).
	     */
	    checkIsForcedSubmitZipcode: function checkIsForcedSubmitZipcode() {
	      var isForcedSubmitZipcode = sessionStorage.getItem('isForcedSubmitZipcode');
	      if (null == isForcedSubmitZipcode || $.isEmptyObject('isForcedSubmitZipcode') || !isForcedSubmitZipcode || isForcedSubmitZipcode == "false") {
	        return false;
	      } else {
	        return true;
	      }
	    },
	
	    /**
	     * AJAX call to invoke AjaxDistributionCenterRetrievalCmd() to retrieve the closest distribution center
	     */
	    updateDistributionCenter: function updateDistributionCenter(zipCode, state, item, callBack) {
	      COSTCO.util.ajax({
	        url: '/AjaxDistributionCenterRetrievalCmd',
	        type: 'POST',
	        dataType: 'json',
	        data: {
	          destinationZip: zipCode,
	          destinationState: state,
	          item: item
	        },
	        done: function done(data) {
	          callBack(data);
	        },
	        fail: function fail(data) {
	          console.error('AjaxDistributionCenterRetrievalCmd ajax call fail for zip code: ' + zipCode);
	        }
	      });
	    },
	
	    /**
	     * AJAX call to invoke AjaxShipModeRetrievalCmd() to retrieve the closest distribution center
	     */
	    updateNarvarShipCode: function updateNarvarShipCode(item, callBack) {
	      COSTCO.util.ajax({
	        url: '/AjaxShipModeRetrievalCmd',
	        type: 'POST',
	        dataType: 'json',
	        data: {
	          item: item
	        },
	        done: function done(data) {
	          callBack(data);
	        },
	        fail: function fail(data) {
	          console.error('AjaxShipModeRetrievalCmd ajax call fail for item: ' + item);
	        }
	      });
	    },
	
	    showEDDWidget: function showEDDWidget() {
	      var edd_html = "";
	      var invCheckPostalCode = $.cookie('invCheckPostalCode');
	      var invCheckStateCode = $.cookie('invCheckStateCode');
	      if (typeof invCheckStateCode !== 'undefined' && invCheckStateCode != null && invCheckStateCode.length > 2) {
	        invCheckStateCode = invCheckStateCode.substring(2);
	      }
	      var item = COSTCO.Header.itemPartNumberSelcted;
	      var vendor = $('#vendorName').val();
	      var groceryPdt = $('#groceryIdentifier').val();
	
	      var isPDP = $('#productPage').val();
	      var langId = COSTCO.util.getLangId();
	      var regexPattern = COSTCO.util.POSTAL_CODE_REGEX_US;
	      if (langId == -24 || langId == -25) {
	        regexPattern = COSTCO.util.POSTAL_CODE_REGEX_CA;
	      }
	
	      if (isPDP) {
	        // Show the primary clause by default unless
	        $('.primary-clause').show();
	
	        // Only execute this if the vendor is narvar
	        if (typeof vendor !== 'undefined' && vendor.toLowerCase().includes('narvar')) {
	          // if the zip code isn't set, display the prompt to have customer set it
	          if (!invCheckPostalCode || !regexPattern.test(invCheckPostalCode.replace(/\+/g, ' '))) {
	            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	              edd_html += COSTCO.util.tmpl('templ_edd_widget_fallback_v2', {});
	            } else {
	              edd_html += COSTCO.util.tmpl('templ_edd_widget_fallback', {});
	            }
	            $('.edd-container').html(edd_html);
	            COSTCO.util.hover_click_popover('#edd-postal-code-link-backup', '#edd-postal-code-popover');
	          } else {
	
	            if (typeof groceryPdt === 'undefined' || groceryPdt == "false" || typeof groceryPdt !== 'undefined' && groceryPdt == "true" && typeof costcoStoreFeatures.EDD_GROCERY_ENABLED !== 'undefined' && costcoStoreFeatures.EDD_GROCERY_ENABLED === true) {
	              // if zip code does exist, make sure to get an updated distribution center
	              COSTCO.Header.narvarDCFetchedSku = COSTCO.Header.itemPartNumberSelcted;
	              COSTCO.Header.updateDistributionCenter(invCheckPostalCode, invCheckStateCode, item, function (data) {
	                $('.eddData').attr("data-narvar-dc-id", data.distributionCenterId);
	                var eddDistro = "";
	
	                if (typeof $('.eddData').attr("data-narvar-dc-id") !== 'undefined') {
	                  eddDistro = $('.eddData').attr("data-narvar-dc-id");
	                  // if the distribution center doesn't exist, don't show any prompt
	                  if (typeof eddDistro === 'undefined' || eddDistro === null || eddDistro === '') {
	                    if (typeof groceryPdt !== 'undefined' && groceryPdt == "true") {
	                      edd_html += COSTCO.util.tmpl('templ_edd_widget_grocery_error_v2', {});
	                    } else {
	                      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	                        edd_html += COSTCO.util.tmpl('templ_edd_widget_error_v2', {});
	                      } else {
	                        edd_html += COSTCO.util.tmpl('templ_edd_widget_error', {});
	                      }
	                    }
	                    $('.edd-container').html(edd_html);
	                    COSTCO.util.hover_click_popover('#edd-postal-code-link-backup', '#edd-postal-code-popover');
	                  } else {
	                    // if the distribution center DOES exist, show the EDD widget
	                    if (typeof groceryPdt !== 'undefined' && groceryPdt == "true") {
	                      edd_html += COSTCO.util.tmpl('templ_edd_widget_grocery_v2', {});
	                    } else {
	                      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	                        edd_html += COSTCO.util.tmpl('templ_edd_widget_v2', {});
	                      } else {
	                        edd_html += COSTCO.util.tmpl('templ_edd_widget', {});
	                      }
	                    }
	                    $('.edd-container').html(edd_html);
	                    COSTCO.util.hover_click_popover('#edd-postal-code-link', '#edd-postal-code-popover');
	                    $('.eddData').attr("data-narvar-dest-zip", invCheckPostalCode);
	                    $(".eddData").html("");
	                    $('#edd-postal-code').html(invCheckPostalCode.replace(/\+/g, ' ').toUpperCase());
	                    $('#edd-postal-code-popover').popover('disable');
	                    $('#edd-postal-code-popover-backup').popover('disable');
	                    COSTCO.Header.updateNarvarShipCode(item, function (data) {
	                      $('.eddData').attr("data-narvar-service-code", data.narvarShipCode);
	                      COSTCO.Header.startEDDMutationObserver();
	                    });
	                    $('.primary-clause').hide();
	                  }
	                }
	              });
	            }
	          }
	        }
	      }
	    },
	
	    /**
	     * Function to process location data and verify zip code validity.
	     * @param Object location data from Bing callback.
	     * @return Object of valid zip code, country and province.
	     */
	    extractLocationData: function extractLocationData(data) {
	      var invalidZip = false;
	      var province = null;
	      var country = null;
	      if ($('#isGeocodeService').val() != "true") {
	        try {
	          //Check out if country is Puerto Rico specific
	          country = data.resourceSets[0].resources[0].address.countryRegionIso2;
	          if (country != undefined && country === 'PR') {
	            province = data.resourceSets[0].resources[0].address.countryRegionIso2;
	            country = 'US';
	          } else {
	            province = data.resourceSets[0].resources[0].address.adminDistrict;
	          }
	        } catch (e) {
	          province = null;
	          country = null;
	        }
	
	        if (province == null || country == null) {
	          invalidZip = true;
	        } else if (wcs.storeId == '10301' && country != 'US') {
	          invalidZip = true;
	        } else if (wcs.storeId == '10302' && country != 'CA') {
	          invalidZip = true;
	        }
	        return locationData = {
	          InvalidZip: invalidZip,
	          Province: province,
	          Country: country
	        };
	      }
	      province = data[0].stateProvinceAbbreviation;
	      if (province == null) {
	        province = data[0].stateProvince;
	      }
	      country = data[0].country;
	      if (province == null || country == null) {
	        invalidZip = true;
	      } else if (wcs.storeId == '10301' && country != 'USA') {
	        invalidZip = true;
	      } else if (wcs.storeId == '10302' && country != 'CAN') {
	        invalidZip = true;
	      }
	      return locationData = {
	        InvalidZip: invalidZip,
	        Province: province,
	        Country: country
	      };
	    },
	
	    /**
	     * Function to set delivery/grocery cookies
	     * (70*3600*365 seconds) which equals 1064.5 days
	     */
	    setDeliveryCookies: function setDeliveryCookies(zipCode, province, country) {
	      $.cookie('invCheckStateCode', province, { path: "/", expires: 1064 });
	      $.cookie('invCheckPostalCode', zipCode, { path: "/", expires: 1064 });
	      COSTCO.Header.updateGroceryShipPostalCodeDisplay();
	    },
	
	    isValidZipCode: function isValidZipCode(element) {
	      $.validator.addMethod("countrySpecificZipcode", function (value, element) {
	        if (wcs.storeId === '10301') return COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value));
	        if (wcs.storeId === '10302') return COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value));
	      }, messages.ERR_GROCERY_INVALID_ZIP);
	
	      $(element).validate({
	        debug: true,
	        rules: {
	          deliveryPostalCode: { required: true, countrySpecificZipcode: true }
	        },
	        messages: {
	          deliveryPostalCode: messages.ERR_GROCERY_INVALID_ZIP
	        },
	        errorPlacement: function errorPlacement($error, $element) {
	          var errorContainer = $(element).find('div.error');
	          errorContainer.empty();
	          errorContainer.append($error);
	        },
	        invalidHandler: function invalidHandler(event, validator) {
	          validator.errorList[0].element.focus();
	        },
	        highlight: COSTCO.util.highlightWithErrorLabel,
	        unhighlight: COSTCO.util.unhighlightWithErrorLabel
	      });
	
	      return $(element).valid();
	    },
	
	    validateUpdateZipCode: function validateUpdateZipCode(element) {
	      var errorContainer = $(element).find('div.error');
	      event.preventDefault();
	      $('div.error').empty();
	      var form = event.currentTarget;
	      if (COSTCO.Header.isValidZipCode(element)) {
	        if (typeof document.getElementById("isEDDNarvarFlow") !== "undefined" && document.getElementById("isEDDNarvarFlow") !== null) {
	          document.getElementById("isEDDNarvarFlow").value = true;
	        }
	        var deliveryFormZipCode = null;
	        if (wcs.storeId === '10302') {
	          if ($('#edd-zip-code-field') !== undefined && $('#edd-zip-code-field') !== null) {
	            deliveryFormZipCode = $('#edd-zip-code-field').val();
	          }
	        } else {
	          deliveryFormZipCode = $(form).find("input[name=deliveryPostalCode]").val();
	        }
	
	        window.wioEventBus.publish('changeDeliveryLocation', deliveryFormZipCode);
	      }
	    },
	
	    validateEddZipCode: function validateEddZipCode(element) {
	      if (COSTCO.Header.isValidZipCode(element)) {
	        var updateGroceryCookies = function updateGroceryCookies(data, textstatus, XMLHttpRequest) {
	          var errorContainer = $(element).find('div.error');
	          if (errorContainer) {
	            errorContainer.empty();
	          }
	
	          var locationData = COSTCO.Header.extractLocationData(data);
	          var invalidZip = locationData.InvalidZip;
	          var province = locationData.Province;
	          var country = locationData.Country;
	
	          if (invalidZip) {
	            if (errorContainer) {
	              errorContainer.append(messages.ERR_INVALID_ZIP_EDD);
	            }
	            var inputContainer = $(element).find('.form-control');
	            if (inputContainer) {
	              inputContainer.attr('aria-invalid', 'true');
	              inputContainer.addClass("error");
	            }
	          } else {
	            COSTCO.Header.setDeliveryCookies(newZip, province, country);
	            COSTCO.Header.showEDDWidget();
	          }
	        };
	        var newZip = $('#edd-zip-code-field').val();
	        var isGeocodeService = $('#isGeocodeService').val() == "true";
	        if (newZip !== null && !isGeocodeService) {
	          COSTCO.util.callBing(newZip, updateGroceryCookies, updateGroceryCookies);
	        } else {
	          COSTCO.util.callGeocodeAPI(newZip, updateGroceryCookies, updateGroceryCookies);
	        }
	      }
	    },
	
	    /**
	     * Function to validate delivery zip code
	     * 2 validation will be done
	     * 	 1. Standard form validation postal regex and required
	     *   2. Pass the zipcode to bing to also lookup country and state
	     *   	which we will pass to the command to valid zipcode
	     */
	    validateDeliveryZipCode: function validateDeliveryZipCode(element) {
	      if (COSTCO.Header.isValidZipCode(element)) {
	        var updateDeliveryStateCountry = function updateDeliveryStateCountry(data) {
	          var errorContainer = $(element).find('div.error');
	          if (errorContainer) {
	            errorContainer.empty();
	          }
	
	          var locationData = COSTCO.Header.extractLocationData(data);
	          var invalidZip = locationData.InvalidZip;
	          var province = locationData.Province;
	          var country = locationData.Country;
	
	          if (invalidZip) {
	            if (errorContainer) {
	              errorContainer.append(messages.ERR_GROCERY_INVALID_ZIP);
	            }
	            var inputContainer = $(element).find('.form-control');
	            if (inputContainer) {
	              inputContainer.attr('aria-invalid', 'true');
	              inputContainer.addClass("error");
	            }
	          } else {
	            var stateInput = $(element).find("input[name='deliveryState']");
	            if (stateInput) {
	              stateInput.val(province);
	            }
	            var countryInput = $(element).find("input[name='deliveryCountry']");
	            if (countryInput) {
	              countryInput.val(country);
	            }
	            if (COSTCO.util.isCAStore()) {
	              var postalcode = $(element).find("#postal-code-input").val();
	              $(element).find("#postal-code-input").val(postalcode.toUpperCase());
	            }
	            if ($(element).data('confirm')) {
	              COSTCO.Header.showGroceryChangeModal(element);
	              var id = $('#delivery-postal-change').attr('aria-describedby') || $('#delivery-postal-change').find('.popover').attr('id');
	              if (id) {
	                $('#' + id).popover('destroy');
	                COSTCO.util.hover_click_popover('#delivery-postal-change', '#delivery-postal-code-popover');
	              }
	            } else {
	              COSTCO.Header.updateGroceryShipPostalCode(element);
	            }
	          }
	        };
	        var postalCode = element['deliveryPostalCode'].value;
	        if ($('#isGeocodeService').val() != "true") {
	          COSTCO.util.callBing(postalCode, updateDeliveryStateCountry);
	        } else {
	          COSTCO.util.callGeocodeAPI(postalCode, updateDeliveryStateCountry);
	        }
	      }
	      return false;
	    },
	
	    /**
	     * Function to validate delivery zip code
	     * 2 validation will be done
	     * 	 1. Standard form validation postal regex and required
	     *   2. Pass the zipcode to bing to also lookup country and state
	     *   	which we will pass to the command to valid zipcode
	     */
	    setDeliveryValidateZipCode: function setDeliveryValidateZipCode(element) {
	      if (COSTCO.Header.isValidZipCode(element)) {
	        if (typeof document.getElementById("isSetDeliveryInline") !== "undefined" && document.getElementById("isSetDeliveryInline") !== null) {
	          document.getElementById("isSetDeliveryInline").value = true;
	        }
	        var deliveryFormZipCode = null;
	        if ($('#postal-code-input') !== undefined && $('#postal-code-input') !== null) {
	          deliveryFormZipCode = $('#postal-code-input').val().trim();
	        } else {
	          deliveryFormZipCode = $(element).serialize().split("&")[0].split("=")[1];
	        }
	        window.wioEventBus.publish('changeDeliveryLocation', deliveryFormZipCode);
	      } else {
	        var errorContainer = $(element).find('div.error');
	        if (errorContainer) {
	          errorContainer.empty();
	          errorContainer.append(messages.ERR_GROCERY_INVALID_ZIP);
	        }
	        var inputContainer = $(element).find('.form-control');
	        if (inputContainer) {
	          inputContainer.attr('aria-invalid', 'true');
	          inputContainer.addClass("error");
	        }
	      }
	    },
	
	    /**
	     * Function used to show EDD date from narvar response
	     */
	    updateEDDView: function updateEDDView(eddDataInstance, observer) {
	      var langId = COSTCO.util.getLangId();
	      var groceryPdt = $('#groceryIdentifier').val();
	
	      if ($(eddDataInstance).text() !== "") {
	        try {
	          var data = $.parseJSON($(eddDataInstance).html());
	
	          if ($(eddDataInstance).attr("data-costco-ship-mode-value") !== 'undefined' && $(eddDataInstance).attr("data-costco-ship-mode-value") !== '' && $(eddDataInstance).attr("data-costco-order-item") !== 'undefined' && $(eddDataInstance).attr("data-costco-order-item") !== '') {
	
	            var eddFieldForUpdate = $(".edd-expected-date_" + $(eddDataInstance).attr("data-costco-ship-mode-value") + "_" + $(eddDataInstance).attr("data-costco-order-item"));
	            var eddDateForUpdate = $(".edd-non-formatted-date_" + $(eddDataInstance).attr("data-costco-ship-mode-value") + "_" + $(eddDataInstance).attr("data-costco-order-item"));
	
	            // For warehouse pickup, since the shipmode used is the same as another normal shipmode
	            if ($(eddDataInstance).attr("data-costco-shipping-type") !== undefined && $(eddDataInstance).attr("data-costco-shipping-type") !== '') {
	              eddFieldForUpdate = $(".edd-expected-date_" + $(eddDataInstance).attr("data-costco-ship-mode-value") + "_" + $(eddDataInstance).attr("data-costco-order-item") + "_" + $(eddDataInstance).attr("data-costco-shipping-type"));
	              eddDateForUpdate = $(".edd-non-formatted-date_" + $(eddDataInstance).attr("data-costco-ship-mode-value") + "_" + $(eddDataInstance).attr("data-costco-order-item") + "_" + $(eddDataInstance).attr("data-costco-shipping-type"));
	            }
	
	            $(eddFieldForUpdate).each(function () {
	              var dateToUse = data.formattedDate;
	              // if the language is french, translate to French, otherwise, use the English
	              if (langId === '-25') {
	                dateToUse = new Date(data.rawDate).toLocaleDateString('fr-CA', { weekday: 'long', month: 'long', day: 'numeric' });
	              } else {
	                dateToUse = new Date(data.rawDate).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
	              }
	
	              $(eddFieldForUpdate).text(dateToUse);
	              $(eddDateForUpdate).attr("value", data.rawDate);
	            });
	          }
	          $(".estimated-delivery-output").removeClass("hidden");
	        } catch (err) {
	          var nonJson = $(eddDataInstance).html();
	
	          if ($(eddDataInstance).attr("data-costco-ship-mode-value") !== 'undefined' && $(eddDataInstance).attr("data-costco-ship-mode-value") !== '' && $(eddDataInstance).attr("data-costco-order-item") !== 'undefined' && $(eddDataInstance).attr("data-costco-order-item") !== '') {
	            $(".edd-expected-date_" + $(eddDataInstance).attr("data-costco-ship-mode-value") + "_" + $(eddDataInstance).attr("data-costco-order-item")).each(function () {
	              $(".edd-expected-date_" + $(eddDataInstance).attr("data-costco-ship-mode-value") + "_" + $(eddDataInstance).attr("data-costco-order-item")).text(nonJson);
	            });
	          } else {
	            var edd_html = "";
	            if (typeof groceryPdt !== 'undefined' && groceryPdt == "true") {
	              edd_html += COSTCO.util.tmpl('templ_edd_widget_grocery_error_v2', {});
	            } else {
	              if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	                edd_html += COSTCO.util.tmpl('templ_edd_widget_error_v2', {});
	              } else {
	                edd_html += COSTCO.util.tmpl('templ_edd_widget_error', {});
	              }
	            }
	            $('.edd-container').html(edd_html);
	            COSTCO.util.hover_click_popover('#edd-postal-code-link-backup', '#edd-postal-code-popover');
	          }
	          $(".estimated-delivery-output").removeClass("hidden");
	        }
	
	        var duplicateDate = "";
	        $(".delivery-option-radios[data-orderitem=" + $(eddDataInstance).attr("data-costco-order-item") + "]").find(".individualShipBlock").each(function () {
	
	          var fieldToFind = ".edd-non-formatted-date_" + $(this).attr("data-shipmodeid") + "_" + $(this).attr("data-orderitem");
	
	          if (typeof duplicateDate !== 'undefined' && duplicateDate !== "") {
	            if (duplicateDate === $(this).find(fieldToFind).val() || duplicateDate <= new Date($(this).find(fieldToFind).val())) {
	
	              // mark the previous radio button as "checked"
	              var previous = $(this).prev();
	              var previousCheckBox = $(previous).find("INPUT.shipModeId")[0];
	              // Make sure Checkbox exists before trying call the update shipmode method - this fixes infinite looping on Confirm Page
	              if ($(previousCheckBox).length && $(previousCheckBox).prop("checked") !== true && $($(this).find("INPUT.shipModeId")[0]).prop("checked") === true) {
	                $(previousCheckBox).prop("checked", true);
	                var previousElemOrderItem = costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true ? $(previous).attr("data-orderitem") : $(previous).parent().attr("data-orderitem");
	                COSTCO.OrderItems.update_shipmode.call($(previous), $(previous).attr("data-shipmodeid"), previousElemOrderItem);
	              }
	
	              // remove this second duplicate date from the screen
	              $(this).remove();
	            }
	          }
	          duplicateDate = $(this).find(fieldToFind).val();
	          try {
	            duplicateDate = new Date(duplicateDate);
	          } catch (err) {
	            // this is to catch any conversions that aren't a date - this is OK
	          }
	        });
	
	        if (observer) {
	          observer.disconnect();
	        }
	      }
	    },
	
	    /**
	     * Function used to watch for changes to hidden div
	    */
	    startEDDMutationObserver: function startEDDMutationObserver() {
	      console.log("EDD mutation observer is started");
	      $('.eddData').each(function () {
	        var targetObject = this;
	        var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	          mutationRecordsList.forEach(function (mutation) {
	            if ("attributes" === mutation.type || "childList" === mutation.type || "subtree" === mutation.type) {
	              COSTCO.Header.updateEDDView(targetObject, observerObject);
	            }
	          });
	        });
	        // Register the target node to observe and specify which DOM changes to watch
	        observerObject.observe(targetObject, {
	          attributes: true,
	          attributeOldValue: true,
	          childList: true,
	          subtree: true,
	          characterData: true
	        });
	      });
	    },
	
	    narvarEventAdded: false,
	
	    /**
	     * Function used to attempt to create the grocery zip code cookie and if unsuccessful,
	     * call the Grocery Zip Code Modal function
	     * 1. If cookie already exists, do nothing
	     * 2. If cookie doesn't exist, but user is logged in and has default ship code
	     *    cookie, then use that
	     * 3. If neither of the above are true, try to get the zip code from the Akamai
	     *    Cookie (client-zip-code)
	     * 4. If all three above aren't possible, calls Grocery Zip Code Modal function
	     */
	    manageGroceryZipCode: function manageGroceryZipCode() {
	      var invCheckPostalCode = $.cookie('invCheckPostalCode');
	      var memberPrimaryPostal = $.cookie('memberPrimaryPostal');
	      var akamaiZipEnabled = $('#akamaiZipEnabled').val();
	      var customAkamaiZip = $.cookie('client-zip-short');
	      var finalZipCode = null;
	
	      var updateGroceryCookies = function updateGroceryCookies(data, textstatus, XMLHttpRequest) {
	        var province = null;
	        var country = null;
	
	        try {
	          //Check out if country is Puerto Rico specific
	          country = data.resourceSets[0].resources[0].address.countryRegionIso2;
	          if (country != undefined && country === 'PR') {
	            province = data.resourceSets[0].resources[0].address.countryRegionIso2;
	            country = 'US';
	          } else {
	            province = data.resourceSets[0].resources[0].address.adminDistrict;
	          }
	        } catch (e) {
	          province = null;
	          country = null;
	        }
	
	        if (province != null && (COSTCO.util.isCAStore() && country === 'CA' || !COSTCO.util.isCAStore() && country === 'US')) {
	          // The expiry time is based on the arbitrary calculation in the AjaxUpdateDeliveryPostalCmdImpl class
	          // (70*3600*365 seconds) which equals 1064.5 days
	          $.cookie('invCheckStateCode', province, { path: "/", expires: 1064 });
	          $.cookie('invCheckPostalCode', finalZipCode, { path: "/", expires: 1064 });
	          //invoke OMS API for setting Warehouse Cookie.
	          //COSTCO.Header.invokeOMSLocationApi(finalZipCode, province, "");
	          COSTCO.Header.updateGroceryShipPostalCodeDisplay();
	          var isPDP = $('#productPage').val();
	          if (isPDP) {
	            COSTCO.Header.startEDDMutationObserver();
	            COSTCO.Header.showEDDWidget();
	          }
	        } else {
	          // no cookies were set - remove the session variable
	          COSTCO.util.removeFromSession("isZipSetByAkamai");
	        }
	        // Show ZipCode overlay for CA only
	        if (!COSTCO.util.isDepotCatalogEnabled()) {
	          COSTCO.Header.showGroceryZipCodeInventoryModal();
	        }
	      };
	      // Determine if the cookie already exists
	      if (!invCheckPostalCode || invCheckPostalCode === '') {
	        // Determine whether the default shipping address exists
	        if (!memberPrimaryPostal || memberPrimaryPostal === '') {
	          //if Akamai Zip Enabled in XAPP
	          if (akamaiZipEnabled === '1' && customAkamaiZip) {
	            //Validate that akamai zip is in the country the store is in
	            var postalValidationRegex = null;
	            if (COSTCO.util.isCAStore()) {
	              postalValidationRegex = COSTCO.util.POSTAL_CODE_REGEX_CA;
	            } else if (COSTCO.util.isUSStore()) {
	              postalValidationRegex = COSTCO.util.POSTAL_CODE_REGEX_US;
	            }
	            if (postalValidationRegex.test(customAkamaiZip) || customAkamaiZip.length == 3) {
	              //3 chars for canada FSA
	              finalZipCode = customAkamaiZip;
	            }
	          }
	        } else {
	          // If default shipping address exists, use it
	          finalZipCode = memberPrimaryPostal;
	        }
	      }
	
	      //Avoiding this call in shipping page so that contract items
	      //get merged properly on proceeding from shipping page
	      if (typeof checkoutPage === 'undefined' || checkoutPage !== 'shipping') {
	        if (finalZipCode !== null) {
	          // Calling service to retrieve the Province / State
	          if ($('#isGeocodeService').val() != "true") {
	            COSTCO.util.callBing(finalZipCode, updateGroceryCookies, updateGroceryCookies);
	          } else {
	            COSTCO.util.callGeocodeAPI(finalZipCode, updateGroceryCookies, updateGroceryCookies);
	          }
	        } else {
	          // Show ZipCode overlay for CA only
	          if (!COSTCO.util.isDepotCatalogEnabled()) {
	            COSTCO.Header.showGroceryZipCodeInventoryModal();
	          }
	        }
	      }
	
	      //Populate Warehouse Cookie for BC US
	      //    	if(!COSTCO.util.isBDStore()){
	      //		//Depot Catalog Online Changes-For Populating Warehouse Cookie
	      //    	let zipCode = $.cookie('invCheckPostalCode');
	      //    	let stateCode = $.cookie('invCheckStateCode');
	      //    	let warehouseVal = $.cookie('WAREHOUSEDELIVERY_WHS');
	      //    	/*
	      //		 * If zipCode and state Cookie are there and Warehouse Cookie is not
	      //		 * there,then make AJAX call to populate Warehouse Cookie
	      //		 */
	      //    	if((null !== zipCode && zipCode !== undefined && zipCode.length > 0) && (null !== stateCode && stateCode !== undefined && stateCode.length > 0)
	      //    			&& (typeof warehouseVal === 'undefined' || null === warehouseVal || '' === warehouseVal || warehouseVal.includes('NA'))) {
	      //    		//invoke OMS API for setting Warehouse Cookie.
	      //    		COSTCO.Header.invokeOMSLocationApi(zipCode,stateCode,"");
	      //    	}
	      //     }
	    },
	    /**
	     * Function used to create the required entry pop-up which will prompt
	     * user to enter their grocery delivery zip code
	     * Form input will be validated using the standard regex to check for valid form
	     *
	     */
	    showGroceryZipCodeInventoryModal: function showGroceryZipCodeInventoryModal() {
	      //Check if the delivery postal container in the minibar is visible
	      var invCheckPostalCode = $.cookie('invCheckPostalCode');
	
	      var loadPostalModal = false,
	          loadRegionModal = false;
	      var isRegionValid = $.cookie('C_2LOC');
	      var groceryPdt = $('#groceryIdentifier').val();
	      var isCaGrocery = COSTCO.util.isCAStore() && (COSTCO.util.hasGroceryProducts() || groceryEnabled && typeof groceryPdt !== 'undefined' && groceryPdt == 'true');
	      if ((isCaGrocery && isRegionValid == 'true' || !COSTCO.util.isCAStore()) && $('#delivery-postal-container').is(':visible') && (!invCheckPostalCode || invCheckPostalCode == '') && !COSTCO.Header.checkIsGroceryModalDisplayed()) {
	        loadPostalModal = true;
	      } else if (isCaGrocery && isRegionValid == 'false' && !COSTCO.Header.checkIsGroceryVisited()) {
	        loadRegionModal = true;
	      }
	      if (loadPostalModal) {
	        var modalOptions = {
	          title: '',
	          body: COSTCO.util.tmpl('tmpl_delivery_postal_modal'),
	          keyboard: false,
	          backdrop: 'static',
	          hideHeader: true,
	          hideFooter: true,
	          preventClose: false,
	          onshown: function onshown(e) {
	            if (COSTCO.util.isCAStore()) {
	              COSTCO.Header.maskInput();
	              $('#postal-code-input').unbind('click').on('click', function () {
	                $('#postal-code-input').val('');
	                $('div#postal-code-error').each(function () {
	                  $(this).addClass('hide');
	                }).addClass('hide');
	                $('#postal-code-submit').removeClass('hide');
	              });
	            }
	            $('#postal-code-input').focus();
	          }
	        };
	        COSTCO.dialog.showAndHideModal(modalOptions);
	        COSTCO.util.setInSession("isGroceryModalDisplayed", true);
	
	        window.scrollTo(0, 0);
	      } else if (loadRegionModal) {
	        COSTCO.util.setInSession("isGroceryVisited", true);
	        COSTCO.Header.showGroceryPostalRestrictionModal();
	        window.scrollTo(0, 0);
	      }
	    },
	    submitZipcode: function submitZipcode() {
	      COSTCO.Header.updateGroceryShipPostalCodeDisplay();
	      COSTCO.dialog.close();
	    },
	
	    /**
	     * If Zip Code doesn't exist, pop open the Modal Window
	     */
	    validateZipCodeExists: function validateZipCodeExists(event) {
	      if (groceryEnabled && $('#delivery-postal-container').is(':visible') && (!$.cookie('invCheckPostalCode') || $.cookie('invCheckPostalCode') == '')) {
	        event.preventDefault();
	        event.stopImmediatePropagation();
	        COSTCO.util.removeFromSession("isGroceryModalDisplayed");
	        COSTCO.Header.showGroceryZipCodeInventoryModal();
	        // if we display the Grocery Code Modal, send that information back to the caller
	        return true;
	      } else {
	        // if we don't display the Grocery Code modal, send that information back to the caller
	        return false;
	      }
	    },
	
	    showGroceryPostalRestrictionModal: function showGroceryPostalRestrictionModal() {
	      var modalOptions = {
	        title: '',
	        body: COSTCO.util.tmpl('tmpl_delivery_postal_restriction_modal'),
	        keyboard: false,
	        backdrop: 'static',
	        hideHeader: true,
	        hideFooter: true,
	        preventClose: true,
	        onshown: function onshown(e) {
	          $('#postal-code-continue').focus();
	        }
	      };
	      COSTCO.dialog.showAndHideModal(modalOptions);
	    },
	
	    deliveryPostalContinueShopping: function deliveryPostalContinueShopping(data) {
	      if (data.errorMessage) {
	        if (COSTCO.util.isCAStore()) {
	          $('.alert-notification').removeClass('hide');
	          $('.alert-notification').empty();
	          var error = COSTCO.util.get_decoded_html(data.errorMessage);
	          $('.alert-notification').append(error);
	
	          $("#costcoModalBtn2").off("click").on("click", function () {
	            COSTCO.Header.updateGroceryShipPostalCodeDisplay();
	            if (localStorage) {
	              localStorage.setItem("isRestrictedPostalCode", 'true');
	            }
	            COSTCO.dialog.close();
	          });
	        } else {
	          $('.critical-notification').empty();
	          var _error = COSTCO.util.get_decoded_html(data.errorMessage);
	          $('.critical-notification').append(_error);
	          $('.critical-notification').removeClass('hide');
	          COSTCO.util.announceSRMessage(_error);
	        }
	      } else {
	        if (COSTCO.util.isCAStore()) {
	          if (localStorage) {
	            localStorage.setItem("isRestrictedPostalCode", 'false');
	          }
	        }
	        COSTCO.Header.updateGroceryShipPostalCodeDisplay();
	        COSTCO.dialog.close();
	        if (typeof COSTCO.Lists !== "undefined") {
	          window.removeEventListener("beforeunload", COSTCO.Lists.leavePagePopup);
	        }
	        //STRY0143973-To reload the page when zipcode is changed
	        if (typeof checkoutPage !== 'undefined' && checkoutPage === 'cart') {
	          window.location.href = "/CheckoutCartView";
	        } else {
	          if (!window.location.href.includes('/Logoff')) {
	            window.location.reload();
	          }
	        }
	      }
	    },
	    /**
	     * Function used to show the confirmation dialog when user change
	     * their grocery zip code
	     */
	    showGroceryChangeModal: function showGroceryChangeModal(form) {
	      var oldPostal = null;
	      var oldState = null;
	      var newPostal = null;
	      oldPostal = $.cookie('invCheckPostalCode');
	      oldState = $.cookie('invCheckStateCode');
	      newPostal = form['deliveryPostalCode'].value;
	      if (COSTCO.util.isCAStore()) {
	        if (oldPostal != null) {
	          oldPostal = oldPostal.replace(/\+/g, ' ');
	        }
	      }
	      var callBackFn = COSTCO.Header.deliveryPostalContinueShopping;
	      // If Canada, continue showing the error unless they cancel out of the window
	      if (COSTCO.util.isCAStore()) {
	        callBackFn = "";
	      }
	      var modalOptions = {
	        title: messages.GROCERY_POSTAL_CHANGE_CONFIRM_TITLE,
	        body: COSTCO.util.tmpl('tmpl_delivery_postal_confirm', {
	          old_postal: oldPostal,
	          new_postal: newPostal
	        }),
	        primary: messages.GROCERY_POSTAL_CHANGE_CONFIRM_TITLE,
	        secondary: messages.BUTTON_CANCEL,
	        primary_event: function primary_event() {
	          COSTCO.Header.updateGroceryShipPostalCode(form, callBackFn);
	        },
	        secondary_event: function secondary_event() {
	          if (COSTCO.util.isCAStore()) {
	            // The expiry time is based on the arbitrary calculation in the AjaxUpdateDeliveryPostalCmdImpl class
	            // (70*3600*365 seconds) which equals 1064.5 days
	            $.cookie('invCheckPostalCode', oldPostal, { path: "/", expires: 1064 });
	            $.cookie('invCheckStateCode', oldState, { path: "/", expires: 1064 });
	            COSTCO.Header.updateGroceryShipPostalCodeDisplay();
	          }
	          COSTCO.dialog.close();
	        }
	      };
	      COSTCO.dialog.showAndHideModal(modalOptions);
	    },
	
	    /**
	     * Uses Jquery Mask plugin to format input. Use cleanVal() instead of val() to get unformatted value
	     */
	    maskInput: function maskInput() {
	      var langId = COSTCO.util.getLangId();
	      if (langId == -1) {
	        $('#postal-code-input').mask('00000-0000');
	        $('#edd-zip-code-field').mask('00000-0000');
	        $('#eddZipCodeField').mask('00000-0000');
	      } else if (langId == -24 || langId == -25) {
	        $('#postal-code-input').mask('S0S 0S0');
	        $('#edd-zip-code-field').mask('S0S 0S0');
	        $('#eddZipCodeField').mask('S0S 0S0');
	      }
	    },
	
	    /**
	     *
	     */
	    showBanner: function showBanner() {
	
	      $('#top-bar').show();
	      if (COSTCO.util.hasGroceryProducts() || COSTCO.util.groceryDefaultHomepage()) {
	        setTimeout(function () {
	          $('#banner-list-actions').show();
	        }, 1000);
	      }
	      var bannerCrumbsList = $('#crumbs_ul li');
	      var isGroceryCat = $('#grocerySection').val();
	      var pdtIdentifer = $('#parentIdentifier').val();
	      var isCat = $('#crumbs_ul').data("iscat");
	      var groceryIdentifier = '';
	      var isPDP = $('#productPage').val();
	      var groceryPdt = $('#groceryIdentifier').val();
	
	      if ($('#groceryDefaultHomepage').length != 0) {
	        groceryIdentifier = $('#groceryDefaultHomepage').val().split("/")[1].split(".")[0];
	      }
	      // Showing mini banner on Cart page with grocery item
	      // Showing mini banner on Confirmation page with grocery item added
	      if (typeof checkoutPage != 'undefined' && (checkoutPage == 'cart' || checkoutPage == 'confirmation')) {
	        if ($.cookie('grocSurchargeCookie') != 0) {
	          $('#grocery-amts').hide();
	          $('#frozen-amts').hide();
	          $('#mobile-grocery-frozen-amts').hide();
	          $('#mobile-grocery-amts').hide();
	          $('#mobile-frozen-amts').hide();
	        } else {
	          $('#grocery-amts').show();
	          $('#frozen-amts').show();
	          $('#mobile-grocery-frozen-amts').show();
	          $('#mobile-grocery-amts').show();
	          $('#mobile-frozen-amts').show();
	        }
	      }
	      // Showing mini banner on search result pages
	      else if (bannerCrumbsList.length != 0 && COSTCO.util.isUSStore() && COSTCO.util.hasGroceryProducts()) {
	          $('#grocery-amts').show();
	          $('#frozen-amts').show();
	          $('#mobile-grocery-frozen-amts').show();
	          $('#mobile-grocery-amts').show();
	          $('#mobile-frozen-amts').show();
	          // To make bread crumb hidden in grocery landing page
	          if (isCat && bannerCrumbsList.length > 2) {
	            $('#crumbs_ul').show();
	          } else if (!isCat && bannerCrumbsList.length >= 2) {
	            $('#crumbs_ul').show();
	          }
	        } else if (bannerCrumbsList.length != 0 && COSTCO.util.isCAStore() && COSTCO.util.hasGroceryProducts()) {
	          if (COSTCO.util.is2DayEligbleRegn()) {
	            $('#grocery-amts').show();
	          }
	          // To make bread crumb hidden in grocery landing page
	          if (isCat && bannerCrumbsList.length > 2) {
	            $('#crumbs_ul').show();
	          } else if (!isCat && bannerCrumbsList.length >= 2) {
	            $('#crumbs_ul').show();
	          }
	        } else if (COSTCO.util.isUSStore() && (null != pdtIdentifer && pdtIdentifer != "" && pdtIdentifer == groceryIdentifier || typeof groceryPdt !== 'undefined' && groceryPdt == 'true')) {
	          // for product details page
	          $('#grocery-amts').show();
	          $('#frozen-amts').show();
	          $('#mobile-grocery-frozen-amts').show();
	          $('#mobile-grocery-amts').show();
	          $('#mobile-frozen-amts').show();
	          if (bannerCrumbsList.length >= 2) {
	            $('#crumbs_ul').show();
	          }
	        } else if (COSTCO.util.isCAStore() && isPDP != undefined && isPDP == 'true') {
	          if (groceryEnabled && COSTCO.util.is2DayEligbleRegn() && typeof groceryPdt !== 'undefined' && groceryPdt == 'true') {
	            $('#grocery-amts').show();
	          }
	          if (bannerCrumbsList.length >= 2) {
	            $('#crumbs_ul').show();
	          }
	        } else {
	          $('#crumbs_ul').show();
	          $('#grocery-amts').hide();
	          $('#frozen-amts').hide();
	          $('#mobile-grocery-frozen-amts').hide();
	          $('#mobile-grocery-amts').hide();
	          $('#mobile-frozen-amts').hide();
	        }
	
	      $('#banner-list-actions').hide();
	
	      var minibanner = $('.mini-banner');
	      if (minibanner != null && minibanner.is(":visible")) {
	        $('#banner-list-actions').show();
	      }
	
	      // If grocery mini banner is shown then we need to check if we have
	      // postal code for zip code inventory check only if the flow is enabled.
	      if (validateGroceryDeliveryZip) {
	        if ($.cookie('invCheckPostalCode') != null && $.cookie('invCheckPostalCode') != '' || $.cookie('memberPrimaryPostal') != null && $.cookie('memberPrimaryPostal') != '') {
	          if ($.cookie('invCheckPostalCode') == null || $.cookie('invCheckPostalCode') == '') {
	            var memberPrimaryPostal = $.cookie('memberPrimaryPostal');
	            var memberPrimaryStateCode = $.cookie('memberPrimaryStateCode');
	            if (!COSTCO.util.isCAStore()) {
	              // The expiry time is based on the arbitrary calculation in the AjaxUpdateDeliveryPostalCmdImpl class
	              // (70*3600*365) which equals 1064.5 days
	              $.cookie('invCheckPostalCode', memberPrimaryPostal, { path: "/", expires: 1064 });
	              $.cookie('invCheckStateCode', memberPrimaryStateCode, { path: "/", expires: 1064 });
	            }
	          }
	        }
	        COSTCO.Header.updateGroceryShipPostalCodeDisplay();
	      }
	    },
	    resetSearch: function resetSearch() {
	      var appType = $('#applicationType').val();
	      var isGroceryFilterSelected = $('#is_grocery_Filter_Selected').val();
	      if (!(appType == 'BD')) {
	        var currenturl = window.location.href;
	        searchselected = new RegExp('[\?&]dept=([^&#]*)').exec(currenturl);
	        bannerCrumbsList = $('#crumbs_ul li');
	        type = 'Grocery';
	        reset = false;
	        var groceryIdentifier = '';
	        if ($('#groceryDefaultHomepage').length != 0) {
	          groceryIdentifier = $('#groceryDefaultHomepage').val().split("/")[1].split(".")[0];
	        }
	        var pdtIdentifer = $('#parentIdentifier').val();
	        if (COSTCO.util.hasGroceryProducts()) {
	          reset = true;
	        } else if (groceryEnabled && null != pdtIdentifer && pdtIdentifer != "" && pdtIdentifer == groceryIdentifier) {
	          reset = true;
	        } else if (null != searchselected && searchselected[1] != null && searchselected[1] == type) {
	          reset = true;
	        }
	        if (reset) {
	          var groceryHomepage = COSTCO.util.groceryDefaultHomepage().split('/')[1];
	          $("#search-dropdown-select").val(groceryHomepage).prop('selected', true);
	          $('#search-dropdown-select').change();
	          $('#search-field').value = '';
	        }
	      }
	    },
	    /**
	     * Check if session storage has grocery order params, else fire AJAX call to
	     * fetch values.
	     * If session storage have values update mini banner with the data
	     *
	     * @return {void} [description]
	     */
	    refreshGroceryOrderParams: function refreshGroceryOrderParams() {
	      try {
	        COSTCO.Header.refreshGroceryBanner();
	      } catch (e) {
	        console.log('Error fetching and setting params');
	        //this.fetchGroceryOrderParams();
	      }
	    },
	    /**
	    *
	    * Function call that is used to update the delivery postal code
	    *
	    */
	    updateGroceryShipPostalCode: function updateGroceryShipPostalCode(form, callBack) {
	      try {
	        COSTCO.util.ajax({
	          url: '/AjaxUpdateDeliveryPostal',
	          type: 'POST',
	          data: $(form).serialize(),
	          done: callBack ? function (data) {
	            callBack(data);
	          } : function (data) {
	            if (data.errorMessage) {
	              if (COSTCO.util.isCAStore()) {
	                if (localStorage) {
	                  localStorage.setItem("isRestrictedPostalCode", 'true');
	                }
	                //CA-GRO Implementation
	                $('.alert-notification').empty();
	                $('.alert-notification').append(COSTCO.util.get_decoded_html(data.errorMessage));
	                $('.alert-notification').removeClass('hide');
	                $('#postal-code-continue').removeClass('hide');
	              } else {
	                $('.critical-notification').empty();
	                var error = COSTCO.util.get_decoded_html(data.errorMessage);
	                $('.critical-notification').append(error);
	                $('.critical-notification').removeClass('hide');
	              }
	            } else {
	              if (COSTCO.util.isCAStore()) {
	                if (localStorage) {
	                  localStorage.setItem("isRestrictedPostalCode", 'false');
	                }
	              }
	              COSTCO.Header.updateGroceryShipPostalCodeDisplay();
	              COSTCO.dialog.close();
	              if (typeof COSTCO.Lists !== "undefined") {
	                window.removeEventListener("beforeunload", COSTCO.Lists.leavePagePopup);
	              }
	              window.location.reload();
	            }
	          },
	          fail: function fail(data) {
	            $('.critical-notification').empty();
	            $('.critical-notification').append("<p>Unexpected Error Encountered</p>");
	            $('.critical-notification').removeClass('hide');
	          }
	        });
	      } catch (e) {
	        console.log('Error AjaxRefreshMiniBanner ajaxcall');
	      }
	    },
	
	    /**
	     * Function used to update the delivery zip code display in the minibar with the postalcode
	     * from the cookie
	     */
	    updateGroceryShipPostalCodeDisplay: function updateGroceryShipPostalCodeDisplay() {
	      var postalCode = $.cookie('invCheckPostalCode');
	      var postalCodeContainer = $('#delivery-postal-container');
	      // Only show zip in cart page if globalMiniBanner is enabled
	      var showZip = !(typeof globalMiniBannerFlag !== 'undefined' && globalMiniBannerFlag === '0' && typeof checkoutPage !== 'undefined' && checkoutPage === 'cart');
	      if (showZip) {
	        postalCodeContainer.removeClass('hide');
	      }
	      if (postalCodeContainer.length > 0 && postalCode != null && postalCode != '') {
	        postalCodeContainer.empty();
	        if (COSTCO.util.isCAStore()) {
	          /*This is done to replace the encoded ' + ' sign of Canada postal zipcode with a space character .*/
	          postalCodeContainer.append(COSTCO.util.tmpl('tmpl_delivery_postal_text', { postalCode: postalCode.replace(/\+/g, ' ') }));
	        } else {
	          postalCodeContainer.append(COSTCO.util.tmpl('tmpl_delivery_postal_text', { postalCode: escape(postalCode) }));
	        }
	
	        COSTCO.util.click_popover('#delivery-postal-change', '#delivery-postal-code-popover');
	      }
	      COSTCO.Header.updateSamedayLinks();
	
	      // If global zip changes and we are on the Cart Page, and the Cart
	      // Page is not empty, recalculate the Shipping Costs and update
	      // the estimated shipping zip in the lower right corner
	      if (typeof checkoutPage !== 'undefined' && checkoutPage === 'cart') {
	        if ($.cookie('cartCountCookie') !== null && $.cookie('cartCountCookie') > 0) {
	          if (typeof document.getElementById("order-estimated-zip") !== "undefined" && document.getElementById("order-estimated-zip") !== null) {
	            if (typeof document.getElementById("order-estimated-zip").getElementsByTagName("a")[0] !== "undefined") {
	              var estimatedShippingZip = document.getElementById("order-estimated-zip").getElementsByTagName("a")[0].text;
	              if (estimatedShippingZip !== "" && estimatedShippingZip !== postalCode) {
	                $("#shipping-costs-zip").val(postalCode);
	              }
	            } else {
	              if (typeof document.getElementById("shipping-costs-zip").text === "undefined") {
	                $("#shipping-costs-zip").val(postalCode);
	              }
	            }
	          }
	        }
	      }
	    },
	
	    /**
	     * Dynamically refresh mini banner to shows status of grocery order
	     * after AJAX calls
	     * @param  {[type]} data [description]
	     * @return {void}      [description]
	     */
	    refreshGroceryBanner: function refreshGroceryBanner() {
	      var groceryMiniBannerCookie = $.cookie('C_GOP');
	      if ($('#grocery-amts').length > 0) {
	        //Mini banner displayed
	        //default values displayed on grocery landing pages
	        var grocerythreshold = $('.amount-base').attr('data-amount-base');
	        var frozenthreshold = $('.frozen-amount-base').attr('data-frozen-amount-base');
	        var data = { 'Grocery': { "orderTotal": "0.00", "deliveryFee": "0.00", "threshold": grocerythreshold }, 'Frozen': { "orderTotal": "0.00", "deliveryFee": "0.00", "threshold": frozenthreshold } };
	        if ($('#top-bar').length > 0 && groceryMiniBannerCookie && groceryMiniBannerCookie != '""') {
	          data = JSON.parse(COSTCO.util.decode(groceryMiniBannerCookie));
	        }
	        var currentOrder = data.Grocery.orderTotal || 0.00;
	        var amountBase = data.Grocery.threshold || 0.00;
	        var amountToGoValue = data.Grocery.amountToGo || data.Grocery.threshold;
	        var deliveryFee = data.Grocery.deliveryFee || 0.00;
	
	        var currentFrozenOrder = data.Frozen.orderTotal || 0.00;
	        var frozenAmountBase = data.Frozen.threshold || 0.00;
	        var frozenAmountToGoValue = data.Frozen.amountToGo || data.Frozen.threshold;
	        var frozenDeliveryFee = data.Frozen.deliveryFee || 0.00;
	
	        // The total of grocery products added to order that qualify against
	        // eliminating the delivery fee.
	
	        $('#grocery-order-total').text(COSTCO.util.formatMoney(currentOrder, true));
	
	        // Represents the verbiage that shows right of the "Current Order: $$$"
	        // showing the amount left (if any) the user needs to add to cart to
	        // avoid a delivery fee.
	        $('#grocery-left-to-go').replaceWith(COSTCO.util.tmpl('tmpl_left_to_go', {
	          currentOrder: parseFloat(currentOrder),
	          amountBase: parseFloat(amountBase),
	          amountToGo: parseFloat(amountToGoValue),
	          deliveryFee: deliveryFee
	        }));
	
	        var grocerytogoTooltipText = groceryProgramMessages['MINIBANNER_GROCERY_MSG'];
	        var currentTooltipText = $('#grocery-left-to-go-tooltip button.a11y-tooltip').attr('data-content');
	
	        if (typeof grocerytogoTooltipText !== 'undefined' && grocerytogoTooltipText !== null && grocerytogoTooltipText !== '' && grocerytogoTooltipText !== currentTooltipText) {
	          grocerytogoTooltipText = grocerytogoTooltipText.replace('{0}', grocerythreshold);
	          $('#grocery-left-to-go-tooltip button.a11y-tooltip').attr('data-content', grocerytogoTooltipText);
	        }
	
	        if (wcs.storeId == '10301') {
	          $('#frozen-order-total').text(COSTCO.util.formatMoney(currentFrozenOrder, true));
	          $('#mobile-grocery-order-total').text(COSTCO.util.formatMoney(currentOrder, true));
	          $('#mobile-frozen-order-total').text(COSTCO.util.formatMoney(currentFrozenOrder, true));
	          // Represents the verbiage that shows right of the "Current Order: $$$"
	          // showing the amount left (if any) the user needs to add to cart to
	          // avoid a delivery fee.
	          $('#mobile-grocery-left-to-go').replaceWith(COSTCO.util.tmpl('tmpl_mobile_left_to_go', {
	            currentOrder: parseFloat(currentOrder),
	            amountBase: parseFloat(amountBase),
	            amountToGo: parseFloat(amountToGoValue),
	            deliveryFee: deliveryFee
	          }));
	
	          $('#mobile-frozen-left-to-go').replaceWith(COSTCO.util.tmpl('tmpl_cnf_mobile_left_to_go', {
	            currentOrder: parseFloat(currentFrozenOrder),
	            amountBase: parseFloat(frozenAmountBase),
	            amountToGo: parseFloat(frozenAmountToGoValue),
	            deliveryFee: frozenDeliveryFee
	          }));
	
	          $('#frozen-left-to-go').replaceWith(COSTCO.util.tmpl('tmpl_cnf_left_to_go', {
	            currentOrder: parseFloat(currentFrozenOrder),
	            amountBase: parseFloat(frozenAmountBase),
	            amountToGo: parseFloat(frozenAmountToGoValue),
	            deliveryFee: frozenDeliveryFee
	          }));
	
	          var frozentogoTooltipText = groceryProgramMessages['MINIBANNER_FROZEN_MSG'];
	          var currentFrozenTooltipText = $('#frozen-left-to-go-tooltip button.a11y-tooltip').attr('data-content');
	          if (typeof grocerytogoTooltipText !== 'undefined' && grocerytogoTooltipText !== null && grocerytogoTooltipText !== '' && grocerytogoTooltipText !== currentTooltipText) {
	            grocerytogoTooltipText = grocerytogoTooltipText.replace('{0}', grocerythreshold);
	            $('#mobile-grocery-left-to-go-tooltip button.a11y-tooltip').attr('data-content', grocerytogoTooltipText);
	          }
	          if (typeof frozentogoTooltipText !== 'undefined' && frozentogoTooltipText !== null && frozentogoTooltipText !== '' && frozentogoTooltipText !== currentFrozenTooltipText) {
	            frozentogoTooltipText = frozentogoTooltipText.replace('{0}', frozenthreshold);
	            $('#mobile-frozen-left-to-go-tooltip button.a11y-tooltip').attr('data-content', frozentogoTooltipText);
	          }
	
	          if (typeof frozentogoTooltipText !== 'undefined' && frozentogoTooltipText !== null && frozentogoTooltipText !== '' && frozentogoTooltipText !== currentFrozenTooltipText) {
	            frozentogoTooltipText = frozentogoTooltipText.replace('{0}', frozenthreshold);
	            $('#frozen-left-to-go-tooltip button.a11y-tooltip').attr('data-content', frozentogoTooltipText);
	          }
	        }
	      }
	    },
	
	    getCookie: function getCookie(cookieName) {
	      var name = cookieName + '=';
	      var ca = document.cookie.split(';');
	      for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) == ' ') {
	          c = c.substring(1);
	        }
	        if (c.indexOf(name) == 0) {
	          return c.substring(name.length, c.length);
	        }
	      }
	      return null;
	    },
	    /**
	     * This function relates to STRY0132341 - Modal windows are generating javascript errors when dragging cursor in text boxes.
	     * This fix is for Delivery ZIP Code pop over click mouse cursor in the input field and hold the mouse, drag it do search box - you will see javascript:void(0) copied over.
	     * @return {void} [description]
	     */
	    prevent_drop_dragovers: function prevent_drop_dragovers() {
	      // The fix is for all text boxes appearing not restricted to ZIP code popover
	      $('body').on('dragover', function (e) {
	        e.preventDefault();
	      });
	      $('body').on('drop', function (e) {
	        e.preventDefault();
	      });
	    },
	    /**
	     * This function initializes the popover for
	     * the "Find a Warehouse" feature.
	     * @return {void} [description]
	     */
	    setup_popovers: function setup_popovers() {
	      // Thanks stackoverflow for this - fixes all of the issues with bootstrap popovers
	      $('body').on('hidden.bs.popover', function (e) {
	        $(e.target).data('bs.popover').inState.click = false;
	      });
	
	      var memberCookie = COSTCO.util.getMemberCookie();
	      if (memberCookie.signedIn == true) {
	        $('#myaccount-t, #myaccount-m').attr('href', 'javascript:void(0);'); //set links to void so user can click for my account popover
	        COSTCO.util.hover_click_popover('#myaccount-t', '#my-account-popover');
	        COSTCO.util.hover_click_popover('#myaccount-m', '#my-account-popover');
	      }
	      COSTCO.util.hover_click_popover('#myaccount-d', '#my-account-popover');
	      COSTCO.util.click_popover('#delivery-postal-change', '#delivery-postal-code-popover');
	
	      $('.minibanner-help').popover({
	        trigger: 'focus',
	        placement: 'bottom'
	      });
	    },
	
	    isWcsSessionExpired: function isWcsSessionExpired() {
	
	      try {
	        var kmsi = $.cookie('kmsi');
	        if (typeof kmsi != 'undefined' && kmsi != null && kmsi.indexOf("true") >= 0) {
	
	          var hashedUserId = $.cookie('hashedUserId');
	
	          if (hashedUserId == undefined || typeof hashedUserId == 'undefined' || hashedUserId == null || hashedUserId == '') {
	            return true;
	          }
	
	          var kmsiVal = kmsi.split('_');
	          if (typeof kmsiVal != 'undefined' && kmsiVal != null && kmsiVal.length > 1) {
	            kmsiVal = kmsiVal[1];
	            if (Date.now() - kmsiVal > wcs.loginTimeOut) {
	              return true;
	            } else {
	              return false;
	            }
	          }
	        }
	
	        return false;
	      } catch (e) {
	        return false;
	      }
	    },
	
	    isKmsiEnabled: function isKmsiEnabled() {
	      return costcoStoreFeatures != null && costcoStoreFeatures.SSO_KMSI != null && costcoStoreFeatures.SSO_KMSI != undefined && costcoStoreFeatures.SSO_KMSI;
	    },
	    isTimeOutFixEnabled: function isTimeOutFixEnabled() {
	      return costcoStoreFeatures != null && costcoStoreFeatures.SSO_KMSI_LOGOUTFIX != null && costcoStoreFeatures.SSO_KMSI_LOGOUTFIX != undefined && costcoStoreFeatures.SSO_KMSI_LOGOUTFIX;
	    },
	    isKmsiRedirectEnabled: function isKmsiRedirectEnabled() {
	      return costcoStoreFeatures != null && costcoStoreFeatures.SSO_KMSI_REDIRECT != null && costcoStoreFeatures.SSO_KMSI_REDIRECT != undefined && costcoStoreFeatures.SSO_KMSI_REDIRECT;
	    },
	
	    /**
	     * This function is used to keep the user sign in, if the user opted for it
	     */
	    kmsi: function kmsi() {
	
	      try {
	        if (COSTCO.Header.isKmsiEnabled() && COSTCO.Header.isKmsiSession() && COSTCO.Header.isWcsSessionExpired()) {
	          var e = this;
	          var xhr = new XMLHttpRequest();
	          xhr.open("GET", "/kmsi", false);
	          xhr.onreadystatechange = function () {
	            if (xhr.readyState === 4) {
	              if (xhr.status == 200) {
	                try {
	                  var t = JSON.parse(xhr.responseText);
	                  if ("true" == t.kmsi) {
	                    COSTCO.Header.kmsiCount = 0;
	                    e.signInOutContainerInit();
	                    e.miniShopCartRefresh();
	
	                    if (typeof checkoutPage !== 'undefined' && checkoutPage === 'cart' && !COSTCO.Header.isWcsSessionExpired()) {
	                      window.location.reload();
	                    }
	                  } else if (COSTCO.Header.kmsiCount < 3) {
	                    COSTCO.Header.kmsiCount++;
	                    COSTCO.util.safe(this.kmsi());
	                  }
	                } catch (e) {
	                  console.error(e);
	                }
	              } else {
	                console.error("Request failed with status: /kmsi ", xhr.status);
	
	                if (COSTCO.Header.isKmsiRedirectEnabled() && COSTCO.Header.isWcsSessionExpired()) {
	                  window.location = "/LogonForm?prompt=false&fromPage=/"; // Redirect if conditions are met
	                }
	              }
	            }
	          };
	
	          xhr.send();
	        }
	      } catch (e) {
	        console.log(e);
	      }
	    },
	
	    //Retruns if the user is a KMSI or not
	    isKmsiSession: function isKmsiSession() {
	
	      try {
	
	        var kmsi = $.cookie('kmsi');
	        if (typeof kmsi == 'undefined' || kmsi == null || kmsi == 'false') {
	          return false;
	        }
	      } catch (e) {
	        console.log(e);
	      }
	
	      return true;
	    },
	
	    validateVendor: function validateVendor(urlVal) {
	
	      try {
	        var hashedUserId = $.cookie('hashedUserId');
	        var urlRedirection = urlVal;
	        if ($.trim(urlVal).length !== 0) {
	          if (urlVal.includes('att.com')) {
	            urlRedirection = '/logon-att?URL=' + urlVal;
	          } else if (urlVal.includes('t-mobile.com')) {
	            urlRedirection = '/logon-tmobile?URL=' + urlVal;
	          }
	        }
	
	        if (COSTCO.Header.isKmsiSession() || !(hashedUserId == undefined || typeof hashedUserId == 'undefined' || hashedUserId == null || hashedUserId == '')) {
	          if (COSTCO.util.getMemberCookie().costcoMember && COSTCO.util.getMemberCookie().active) {
	            window.location.href = urlRedirection;
	          } else {
	            window.location.href = '/LinkYourMembershipInterruptView?URL=' + urlVal;
	          }
	        } else {
	          if ($.trim(urlVal).length !== 0 && (urlVal.includes('att.com') || urlVal.includes('t-mobile.com'))) {
	            window.location.href = urlRedirection;
	          } else {
	            window.location.href = '/LogonForm?URL=' + urlVal;
	          }
	        }
	      } catch (e) {
	        window.location.href = urlRedirection;
	      }
	    },
	
	    /**
	     * This function is used to change Membership and Shop Memberships header
	     * links from "/join-costco-quick.html" (used for Quick Purchase flow - when cart is empty)
	     * to "/join-costco.html" in case there is something in the cart
	     */
	    changeLinksForQuickPurchase: function changeLinksForQuickPurchase() {
	      if ($.cookie('cartCountCookie') !== null && $.cookie('cartCountCookie') > 0) {
	        if ($('#Home_Ancillary_7').length > 0) {
	          $('#Home_Ancillary_7').attr('href', $('#Home_Ancillary_7').attr('href').replace("join-costco-quick.html", "join-costco.html"));
	        }
	        if ($('#Home_Ancillary_Popover_7').length > 0) {
	          $('#Home_Ancillary_Popover_7').text($('#Home_Ancillary_Popover_7').text().replace("join-costco-quick.html", "join-costco.html"));
	        }
	      };
	    },
	
	    /**
	     * This function acts as a listener and replaces the Membership and Shop Memberships header
	     * links for quick purchase when Add To Cart is triggered
	     */
	    replaceShopMembershipLinksOnAddToCart: function replaceShopMembershipLinksOnAddToCart() {
	      $('body').bind('costco.cart.item.added', function (event) {
	        COSTCO.Header.changeLinksForQuickPurchase();
	      });
	    },
	
	    //Function used to attach the event listener specific to the header dropdowns
	    //This is done to work make the dropdowns work the same way as previous popover functionality
	    // On Hover/mouseleave the dropdown should toggle
	    // On tabout the dropdown should toggle
	    // When the dropdown is hidden we should reset the underlying form
	    setup_nav_dropdown: function setup_nav_dropdown() {
	
	      $('.header-menu-dropdown').mouseenter(function (event) {
	        //Hover/mouse trigger only for non touch device
	        if (!COSTCO.util.is_touch_device()) {
	          //toggle dropdown if it was not open
	          if (!$(event.target).parents('.dropdown-container').hasClass('open')) {
	            console.log('hover Trigger dropdown');
	            $(this).dropdown('toggle');
	          }
	        }
	      });
	      $('.dropdown-container').on('hide.bs.dropdown', function (e) {
	        //Reset the form inside the dropdown menu on close
	        var dropdownForm = $(e.relatedTarget).siblings('.dropdown-menu').find('form')[0];
	        if (dropdownForm) dropdownForm.reset();
	      }).on('shown.bs.dropdown', function (e) {
	        //On showing the dropdown we need to calculate the offset to center and check if its
	        //within the document width
	        //Current iteration will only handle right overflow
	        var dropdownContainer = $(e.relatedTarget).siblings('.dropdown-menu');
	        var targetPos = $(e.relatedTarget)[0].getBoundingClientRect();
	        var containerWidth = dropdownContainer[0].offsetWidth;
	
	        var dropdownLeft = targetPos.width / 2 - containerWidth / 2;
	
	        dropdownContainer.css({ left: Math.round(dropdownLeft) });
	        //Now that its centered check if new position is over the right edge
	        var windowWidth = $(window).width();
	        var rightEdgeDelta = 0;
	        if (dropdownContainer.offset().left + dropdownContainer.outerWidth() > windowWidth) {
	          rightEdgeDelta = dropdownContainer.offset().left + containerWidth - windowWidth;
	        }
	        dropdownContainer.css({ left: Math.round(dropdownLeft - rightEdgeDelta) });
	      });
	      //Kill event propagation if click within the dropdown menu content
	      //if we don't do this it will close the dropdown
	      $('.header-menu-dropdown-content').click(function (event) {
	        event.stopPropagation();
	      })
	      //if user tab out of the menu content close the dropdown
	      .on('mouseleave focusout', function (event) {
	        //check if the related target is contained within the content
	        //we allow relatedTarget ==  null with an interesting issue when we click the checkbox it will set
	        //related target to null
	        var relatedTargetContained = event.relatedTarget == null || this.contains(event.relatedTarget);
	
	        if (event.type == 'mouseleave' || event.type == 'focusout' && !relatedTargetContained) {
	          //close the dropdown if it was open
	          if ($(event.target).parent('.dropdown-container').hasClass('open')) {
	            $(this).siblings('.header-menu-dropdown').dropdown('toggle');
	          }
	        }
	      });
	    },
	
	    searchFieldValidation: function searchFieldValidation() {
	      $('.CatalogSearchForm').each(function () {
	        $(this).validate({
	          rules: {
	            keyword: 'required'
	          },
	          messages: {
	            keyword: messages.ERR_SEARCHTERM_REQ
	          },
	          errorPlacement: function errorPlacement(error, element) {
	            element.attr('placeholder', error.text());
	          }
	        });
	      });
	    },
	    signInOutContainerInit: function signInOutContainerInit() {
	      try {
	        var c = $.cookie('hashedUserId');
	        var kmsiCookie = $.cookie('kmsi');
	        $('#myaccount-d').hide();
	        if (c && c != '""' || kmsiCookie != undefined && kmsiCookie && kmsiCookie != '""' && kmsiCookie != null && kmsiCookie.indexOf('true') >= 0) {
	          $('#myaccount-react-d').show();
	          $('#header_sign_in').hide();
	        } else {
	          $('#header_sign_in').show();
	          $('#myaccount-react-d').hide();
	        }
	        try {
	          $('#myaccount-react-d,#myaccount-react-m,#myaccount-react-t').click(function () {
	
	            var queryToMatch = '(min-width: 1025px)'; // 1024px is a tablet
	
	            // This will return a boolean true for desktop and false for tablets and phones.
	            if (window.matchMedia(queryToMatch).matches) {
	              window.wioEventBus.publish('accountMenu', { accountMenu: true });
	            } else {
	              window.location.href = '/AccountHomeView';
	            }
	          });
	        } catch (e) {}
	      } catch (e) {}
	    },
	    miniShopCartRefresh: function miniShopCartRefresh() {
	      var c = parseInt($.cookie(cookies.CART_COUNT_COOKIE));
	      if (c && c != '""' || c == '0') {
	        $('.cart-number').html('<div><span>' + c + '</span></div>');
	      }
	
	      var orderTotal = parseFloat($.cookie('wcCartOrder'));
	
	      if (orderTotal && orderTotal != '""') {
	        $('.orderTotal').html(COSTCO.util.isBusinessDelivery() ? COSTCO.util.formatMoney(orderTotal, true) : orderTotal);
	      } else {
	        $('.orderTotal').html(COSTCO.util.formatMoney('0.00', true));
	      }
	      $('.quick-cart-summary').removeClass('hidden');
	      /*display order surcharge for BD */
	      if (COSTCO.util.isBusinessDelivery()) {
	        var total = orderTotal;
	        if (orderTotal == undefined || isNaN(orderTotal) || orderTotal == '""') {
	          total = parseFloat("0.0");
	        }
	        var currentWhsZipCode = $.cookie('WC_BD_WHS');
	        var freeDeliveryOrderAmount = currentWhsZipCode === '729' ? parseFloat($('#minimumOrderAmount').val()) : parseFloat($('#freeDeliveryOrderAmount').val());
	        var deliverySurcharge = parseFloat($('#deliverySurcharge').val());
	        if (typeof checkoutPage != 'undefined' && (checkoutPage == 'shipping' || checkoutPage == 'payment' || checkoutPage == 'review')) {
	          //no need to invoke ajax from checkout pages like payment, shipping, review
	          COSTCO.Header.miniBannerRefreshAjax = false;
	        }
	        if (COSTCO.Header.miniBannerRefreshAjax) {
	          var currentZipCode = $.cookie('WC_BD_ZIP');
	          var cartTotal = $.cookie('wcCartOrder');
	          if (cartTotal == undefined || isNaN(cartTotal) || cartTotal == '""') {
	            cartTotal = parseFloat("0.0");
	          }
	          var options = {
	            url: '/AjaxGetMiniBannerDetails',
	            type: 'POST',
	            dataType: 'json',
	            data: {
	              'orderTotal': total,
	              'zipcode': currentZipCode
	            },
	            success: function success(data, textStatus, xhr) {
	              return data;
	            },
	            error: function error(xhr, textStatus, errorThrown) {
	              console.log('Error in AjaxGetMiniBannerDetailsCmd');
	            }
	          };
	          var miniBannerData = $.ajax(options).done(function (data) {
	            if (data.errorCode) {
	              // session timeout
	              if (data.errorCode == 2510) {
	                document.location.href = 'Logoff?URL=ReLogonFormView&storeId=' + wcs.storeId;
	                return;
	              }
	            } else {
	              COSTCO.Header.refreshMiniBannerDetails(data);
	              COSTCO.Header.saveMiniCartDetSessionStorage(data);
	            }
	          });
	
	          COSTCO.Header.miniBannerRefreshAjax = false;
	        } else {
	          if ($('#deliverySurcharge').val() !== undefined) {
	            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
	              var isStorePickup = $('#isStorePickupSelected').val() === 'true' ? true : false;
	              COSTCO.Header.displayDeliverySurcharge_v2(total, freeDeliveryOrderAmount, deliverySurcharge, isStorePickup);
	            } else {
	              COSTCO.Header.displayDeliverySurcharge(total, freeDeliveryOrderAmount, deliverySurcharge);
	            }
	          }
	        }
	      }
	    },
	    /**
	     * Function to display delivery surcharge for BD.
	     * @param {number} orderTotal
	     * @return {void}
	     */
	    displayDeliverySurcharge: function displayDeliverySurcharge(orderTotal, freeDeliveryOrderAmount, deliverySurcharge, isStorePickup) {
	      if (typeof checkoutPage != 'undefined' && checkoutPage == 'cart' && COSTCO.util.isNdEnabled() && $('input[name="deliveryMethod"]').length > 0) {
	        var shipmodeId = $('input[name="deliveryMethod"]:checked').val();
	        var data = {};
	        if (shipmodeId != undefined) {
	          if (isStorePickup) {
	            shipmodeId = shipmodeId + "_SP";
	          }
	          freeDeliveryOrderAmount = parseFloat($('#freeDeliveeryAmount_' + shipmodeId).val());
	          deliverySurcharge = parseFloat($('#surchargeAmount_' + shipmodeId).val());
	          data.shipmodeId = shipmodeId;
	        }
	        orderTotal = parseFloat($('.orderTotalCart').val());
	        data.freeDeliveryOrderAmount = freeDeliveryOrderAmount;
	        data.deliverySurcharge = deliverySurcharge;
	        data.orderTotal = orderTotal;
	        COSTCO.Header.saveMiniCartDetSessionStorage(data);
	      }
	
	      // Add shipping cost after discount (coming from backend in cookie). (Initially requested for CA only, but then changed for both US and CA STRY0147152)
	      // this was for isCABDStore() only then expanded for US too
	      // let totalPriceNoDiscountAdded = orderStatic.ordertotal - orderStatic.totaldiscount;
	      //  useThisOrderTotal = totalPriceNoDiscountAdded;
	
	      var useThisOrderTotal = orderTotal;
	
	      // Add discount if any to the value coming from cookie to get total value (shipping cost calculated with value before substracting discounts)
	      if (typeof orderTotal == "number" && freeDeliveryOrderAmount && deliverySurcharge) {
	        if (useThisOrderTotal < freeDeliveryOrderAmount) {
	          // Display delivery surcharge
	          if (!$('.zero_surcharge_msg').hasClass('hide')) {
	            $('.zero_surcharge_msg').addClass('hide');
	          }
	          if (!$('.zero_surcharge_msg_cart').hasClass('hide')) {
	            $('.zero_surcharge_msg_cart').addClass('hide');
	          }
	          if ($('.surcharge_msg').hasClass('hide')) {
	            $('.surcharge_msg').removeClass('hide');
	          }
	          if (orderTotal > 0) {
	            $('.surcharge_bypass_amount').html(COSTCO.util.formatMoney((freeDeliveryOrderAmount - orderTotal).toFixed(2)));
	            $('.shipping_charge').html(deliverySurcharge.toFixed(2));
	            $('.current-delivery-amount').html(deliverySurcharge.toFixed(2));
	            // Correct delivery surcharge order summary section in cart for BD
	            if ($('#order-total-estimates') && $('#order-total-estimates').length > 0) {
	              $('#order-total-estimates').find('.delivery-surcharge-in-cart').find('.pull-right').html('$' + deliverySurcharge.toFixed(2));
	            }
	          } else {
	            $('#surcharge_bypass_amount').html(freeDeliveryOrderAmount.toFixed(2));
	            $('#shipping_charge').html(deliverySurcharge.toFixed(2));
	          }
	          if (COSTCO.util.isNdEnabled() && $('#order-estimated-total').length > 0 && checkoutPage === 'cart') {
	            $('#order-estimated-total').text('$' + (orderTotal + deliverySurcharge).toFixed(2));
	            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
	              $('#order-estimated-total-mobile').text('$' + (orderTotal + deliverySurcharge).toFixed(2));
	            }
	          }
	        } else {
	          // Do not display delivery surcharge
	          $('.zero_surcharge_msg').removeClass('hide');
	          $('.zero_surcharge_msg_cart').removeClass('hide');
	          $('.surcharge_msg').addClass('hide');
	          // Correct delivery surcharge order summary section in cart for BD
	          if ($('#order-total-estimates') && $('#order-total-estimates').length > 0) {
	            $('#order-total-estimates').find('.delivery-surcharge-in-cart').find('.pull-right').html('$0.00');
	          }
	        }
	      } else {
	        if (COSTCO.util.isNdEnabled() && deliverySurcharge === 0) {
	          $('.zero_surcharge_msg').removeClass('hide');
	          $('.zero_surcharge_msg_cart').removeClass('hide');
	          $('.surcharge_msg').addClass('hide');
	          // Correct delivery surcharge order summary section in cart for BD
	          if ($('#order-total-estimates') && $('#order-total-estimates').length > 0) {
	            $('#order-total-estimates').find('.delivery-surcharge-in-cart').find('.pull-right').html('$0.00');
	          }
	          if ($('#order-estimated-total') && $('#order-estimated-total').length > 0 && checkoutPage == 'cart') {
	            $('#order-estimated-total').text('$' + (orderTotal + deliverySurcharge).toFixed(2));
	            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
	              $('#order-estimated-total-mobile').text('$' + (orderTotal + deliverySurcharge).toFixed(2));
	            }
	          }
	        } else {
	          console.error('Invalid values for: orderTotal, freeDeliveryOrderAmount, and/or deliverySurcharge.');
	        }
	      }
	    },
	    /**
	     * Function to display delivery surcharge for BD for website redesign.
	     * @param {number} orderTotal
	     * @return {void}
	     */
	    displayDeliverySurcharge_v2: function displayDeliverySurcharge_v2(orderTotal, freeDeliveryOrderAmount, deliverySurcharge, isStorePickup) {
	      if (typeof checkoutPage !== 'undefined' && checkoutPage === 'cart' && COSTCO.util.isNdEnabled() && $('input[name="deliveryMethod"]').length > 0) {
	        var shipmodeId = $('#shipmodeIdBD').val().length > 0 ? $('#shipmodeIdBD').val() : $('input[name="deliveryMethod"]:checked').val();
	        var data = {};
	        if (shipmodeId !== undefined) {
	          if (isStorePickup) {
	            shipmodeId = shipmodeId + "_SP";
	          }
	          freeDeliveryOrderAmount = parseFloat($('#freeDeliveeryAmount_' + shipmodeId).val());
	          deliverySurcharge = parseFloat($('#surchargeAmount_' + shipmodeId).val());
	          data.shipmodeId = shipmodeId;
	        }
	        data.freeDeliveryOrderAmount = freeDeliveryOrderAmount;
	        data.deliverySurcharge = deliverySurcharge;
	        data.orderTotal = orderTotal;
	        COSTCO.Header.saveMiniCartDetSessionStorage(data);
	      }
	      // Add shipping cost after discount (coming from backend in cookie). (Initially requested for CA only, but then changed for both US and CA STRY0147152)
	      // this was for isCABDStore() only then expanded for US too
	      // let totalPriceNoDiscountAdded = orderStatic.ordertotal - orderStatic.totaldiscount;
	      //  useThisOrderTotal = totalPriceNoDiscountAdded;
	
	      var useThisOrderTotal = orderTotal;
	      var cookieDate = $.cookie('deliveryDateCookie');
	      var date_str = COSTCO.OrderItems ? COSTCO.OrderItems.getDisplayDateFormatForReview(cookieDate) : cookieDate;
	      $('#ship-date-nd-off-display').html(date_str);
	      // Add discount if any to the value coming from cookie to get total value (shipping cost calculated with value before substracting discounts)
	      if (typeof orderTotal === "number" && freeDeliveryOrderAmount >= 0 && deliverySurcharge >= 0) {
	
	        if (useThisOrderTotal < freeDeliveryOrderAmount) {
	          // Display delivery surcharge
	          if (!$('.zero_surcharge_msg').hasClass('hide')) {
	            $('.zero_surcharge_msg').addClass('hide');
	          }
	          if (!$('.zero_surcharge_msg_cart').hasClass('hide')) {
	            $('.zero_surcharge_msg_cart').addClass('hide');
	          }
	          if ($('.surcharge_msg').hasClass('hide')) {
	            $('.surcharge_msg').removeClass('hide');
	          }
	          if (orderTotal > 0) {
	            $('.surcharge_bypass_amount').html(COSTCO.util.formatMoney((freeDeliveryOrderAmount - orderTotal).toFixed(2)));
	            $('.shipping_charge').html(deliverySurcharge.toFixed(2));
	            if ($('.delivery-surcharge-nd-off') && $('.delivery-surcharge-nd-off').is(':visible')) {
	              if (deliverySurcharge.toFixed(0) === "0") {
	                $('.delivery-surcharge-nd-off').hide();
	                $('.delivery-surcharge-nd-off-waived').show();
	              } else {
	                $('.delivery-surcharge-nd-off-waived').hide();
	                $('.delivery-surcharge-nd-off').show();
	              }
	            }
	            $('.current-delivery-amount').html(deliverySurcharge.toFixed(2));
	            // Correct delivery surcharge order summary section in cart for BD
	            if ($('#order-summary-total-prices').length > 0) {
	              $('#order-summary-total-prices').find('.cart-delivery-surcharge').find('.summary-right').html(COSTCO.util.formatMoney(deliverySurcharge.toFixed(2), true));
	            }
	          } else {
	            $('#surcharge_bypass_amount').html(freeDeliveryOrderAmount.toFixed(2));
	            $('#shipping_charge').html(deliverySurcharge.toFixed(2));
	            if ($('.delivery-surcharge-nd-off') && $('.delivery-surcharge-nd-off').is(':visible')) {
	              if (deliverySurcharge.toFixed(0) === "0") {
	                $('.delivery-surcharge-nd-off').hide();
	                $('.delivery-surcharge-nd-off-waived').show();
	              } else {
	                $('.delivery-surcharge-nd-off-waived').hide();
	                $('.delivery-surcharge-nd-off').show();
	              }
	            }
	          }
	
	          var discount = 0;
	          if ($('#totalDiscountOutput').attr('discount') != null) {
	            discount = parseFloat($('#totalDiscountOutput').attr('discount'));
	          }
	
	          if (COSTCO.util.isNdEnabled() && $('#order-estimated-total').length > 0 && checkoutPage === 'cart') {
	            $('#order-estimated-total').text(COSTCO.util.formatMoney((orderTotal + deliverySurcharge).toFixed(2), true));
	            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
	              $('#order-estimated-total-mobile').text(COSTCO.util.formatMoney((orderTotal + deliverySurcharge).toFixed(2), true));
	            }
	          }
	        } else {
	          // Do not display delivery surcharge
	          $('.zero_surcharge_msg').removeClass('hide');
	          if ($('.delivery-surcharge-nd-off') && $('.delivery-surcharge-nd-off').is(':visible')) {
	            $('.delivery-surcharge-nd-off').hide();
	            $('.delivery-surcharge-nd-off-waived').show();
	          }
	          $('.zero_surcharge_msg_cart').removeClass('hide');
	          $('.surcharge_msg').addClass('hide');
	          // Correct delivery surcharge order summary section in cart for BD
	          if ($('#order-summary-total-prices').length > 0) {
	            $('#order-summary-total-prices').find('.cart-delivery-surcharge').find('.summary-right').html(COSTCO.util.formatMoney(0, true));
	          }
	        }
	      } else {
	        if (COSTCO.util.isNdEnabled() && deliverySurcharge === 0) {
	          $('.zero_surcharge_msg').removeClass('hide');
	          $('.zero_surcharge_msg_cart').removeClass('hide');
	          $('.surcharge_msg').addClass('hide');
	          // Correct delivery surcharge order summary section in cart for BD
	          if ($('#order-summary-total-prices').length > 0) {
	            $('#order-summary-total-prices').find('.cart-delivery-surcharge').find('.summary-right').html(COSTCO.util.formatMoney(0, true));
	          }
	          if ($('#order-estimated-total').length > 0 && checkoutPage === 'cart') {
	            $('#order-estimated-total').text(COSTCO.util.formatMoney((orderTotal + deliverySurcharge).toFixed(2), true));
	            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
	              $('#order-estimated-total-mobile').text(COSTCO.util.formatMoney((orderTotal + deliverySurcharge).toFixed(2), true));
	            }
	          }
	        } else {
	          console.error('Invalid values for: orderTotal, freeDeliveryOrderAmount, and/or deliverySurcharge.');
	        }
	      }
	    },
	    displayTooltip: function displayTooltip(shipmodeId, addrType) {
	      if (typeof addrType !== 'undefined') {
	        var currentWhsZipCode = $.cookie('WC_BD_WHS');
	        if (addrType === 'S' || currentWhsZipCode === '729') {
	          var minimumOrderAmount = parseInt($('#minimumOrderAmount').val());
	          $(".a11y-tooltip").attr("data-content", messages.MINIMUM_ORDER_AMOUNT_TOOLTIP.replace('{0}', minimumOrderAmount));
	        }
	      } else if (typeof shipmodeId !== 'undefined') {
	        if (shipmodeId == 10101) {
	          var surchargeAmount = parseInt($('#freeDeliveryOrderAmount').val());
	          var shippingCharge = parseInt($('#toolTipDeliverySurcharge').val());
	          $('#delivery-fee .a11y-tooltip').attr("data-content", messages.HEADER_BANNER_TOOLTIP.replace('{0}', surchargeAmount).replace('{1}', shippingCharge));
	        } else {
	          $('#delivery-fee .a11y-tooltip').attr("data-content", messages.HEADER_BANNER_TOOLTIP_GND);
	        }
	      }
	    },
	    /**
	     *
	     */
	    typeahead: function typeahead() {
	      var search = new Bloodhound({
	        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
	        queryTokenizer: Bloodhound.tokenizers.whitespace,
	        remote: {
	          url: '/TypeAhead?searchTerm=%QUERY&dept=',
	          replace: function replace(url, query) {
	            var serviceURL = '/TypeAhead?searchTerm=%QUERY&dept=';
	            if ($('#grocery-dropdown').text()) {
	              serviceURL += encodeURIComponent($.trim($('#grocery-dropdown').text()));
	            } else {
	              serviceURL += "All";
	            }
	            serviceURL += "&storeId=" + wcs.storeId + "&catalogId=" + wcs.catalogId + "&langId=" + wcs.langId;
	            //this param is used by BD to determine whether or not product suggestion should be turned off
	            var isMobile = COSTCO.util.is_touch_device();
	            serviceURL += "&isMobile=" + isMobile;
	            var newURL = serviceURL;
	            query = encodeURIComponent(query);
	            newURL = newURL.replace('%QUERY', query);
	            return newURL;
	          },
	          wildcard: '%QUERY',
	          rateLimitWait: 0,
	          filter: function filter(data) {
	            var terms = '';
	
	            terms = data.costcoAutoSuggestionView;
	            var display = [];
	            data = terms || [];
	            var count = 0;
	            var curObjType = '';
	            $.each(data, function (i, obj) {
	              if (obj.type != curObjType && count > 0) {
	                obj.border = 'border';
	              }
	              curObjType = obj.type;
	              count++;
	              display.push(obj);
	            });
	            return display;
	          }
	        }
	      });
	      $('#search-widget .typeahead').typeahead({
	        hint: true,
	        highlight: true,
	        minLength: parseInt($('#typeAheadMinCharacters').val())
	      }, {
	        name: 'search',
	        display: 'term',
	        source: search,
	        limit: 999,
	        templates: {
	          suggestion: function suggestion(data) {
	            var _in = '<span class="hidden-xs">&nbsp;in&nbsp;</span>';
	            var category = data.category ? _in + '<span class="category hidden-xs">' + data.category + '</span>' : '';
	            var appType = $('#applicationType').val();
	            if (appType == 'BC') {
	              if (data.type == 'Warehouse') {
	                var warehouse = '';
	                warehouse = ' Warehouse ' + data.properties.WarehouseAddress;
	                return '<div class=' + (data.border ? 'border' : '') + '>' + data.value + warehouse + '</div>';
	              }
	            }
	            if (data.type == 'Product') {
	              var productImage = '<img class="product-image" src=' + data.properties.FullImage + '>';
	              return '<h6 class=' + (data.border ? 'border' : '') + '>' + productImage + data.value + '</h6>';
	            }
	            return '<div>' + data.term + category + '</div>';
	          }
	        }
	      }).on('typeahead:render', function () {
	        // hr element between categories and brands
	        if (!$('.tt-dataset :first-child.tt-suggestion').hasClass('border')) {
	          $('<hr>').insertBefore($('.tt-dataset .border'));
	        }
	      }).on('typeahead:selected', function (event, suggestion) {
	        var appType = $('#applicationType').val();
	        if (suggestion.refinementId) {
	          if (suggestion.type == 'Category') {
	            var searchString = suggestion.identifierId + '.html?' + 'autosugg=true';
	            if ($.trim(suggestion.deptId) != '') {
	              searchString = searchString + '&dept=' + encodeURIComponent(suggestion.deptId);
	            }
	            if (window.location.href.includes('warehouse-locations')) {
	              searchString = '/' + searchString;
	            }
	            window.location.href = searchString;
	          } else if (suggestion.type == 'ShadowDimension') {
	            var searchString = suggestion.identifierId + '.html?' + 'refine=' + suggestion.refinementId + '|';
	            if ($.trim(suggestion.deptId) != '') {
	              searchString = searchString + '&dept=' + encodeURIComponent(suggestion.deptId);
	            }
	            if (window.location.href.includes('warehouse-locations')) {
	              searchString = '/' + searchString;
	            }
	            window.location.href = searchString;
	          } else if (suggestion.type == 'Warehouse') {
	            window.location.href = suggestion.baseUrl;
	          } else if (suggestion.type == 'Product') {
	            window.location.href = '/' + suggestion.baseUrl.toLowerCase();
	          } else {
	            $('.CatalogSearchForm').append('<input type="hidden" name="refine" value=' + suggestion.refinementId + '>');
	            if ($.trim(suggestion.deptId) != '' && suggestion.type != 'Brand') {
	              $('.CatalogSearchForm').append('<input type="hidden" name="dept" value=' + suggestion.deptId + '>');
	            }
	            $(this).closest('.CatalogSearchForm').submit();
	          }
	        } else {
	          $(this).closest('.CatalogSearchForm').submit();
	        }
	        //if(appType == 'BD' || (appType == 'BC' && suggestion.type != 'Warehouse' && suggestion.type != 'ShadowDimension' && suggestion.type != 'Product'
	        //&& suggestion.type != 'Category')) {
	        //$(this).closest('.CatalogSearchForm').submit();
	        //}
	      });
	    },
	    /**
	     * page_size is attached to the onsubmit event handler of the search form.
	     * It uses the viewport width to determine the "batch" size of returned results.
	     * Where we return 24 for phone resolutions otherwise we return 96.
	     * @return {void}
	     */
	    page_size: function page_size() {
	      if (typeof this.pageSize === 'undefined') {
	        var pageSize = 96;
	        var input = document.createElement('input');
	        input.type = 'hidden';
	        input.name = 'pageSize';
	        if (window.innerWidth < 668) {
	          pageSize = 24;
	        }
	        input.value = pageSize;
	        this.appendChild(input);
	      }
	    },
	    /**
	     *Align quick buy buttons in same line.
	     * It sets margin-top for button group dynamically.
	     * @return {void}
	     */
	    align_quickbuy_btn: function align_quickbuy_btn() {
	      var products = $('[data-set-same-height]');
	
	      // Clear margin-top
	      products.find('.addbutton').css({
	        'padding-top': '0'
	      });
	
	      var featureProducts = products.closest('.featured-product');
	      var plp = products.closest('.product-list.grid');
	      var compare = products.closest('#product-tile-box');
	
	      if (plp && plp.length > 0) {
	        var slickSplits = products.closest('.slick-list').find('.product-tile-set.slick-slide');
	        if (slickSplits && slickSplits.length > 0) {
	          COSTCO.Header.alignItems(slickSplits);
	        }
	        var splits = products.closest('.product-list').find('[data-row-split]:visible');
	
	        if (splits && splits.length > 0) {
	          // let rows = []; <- not used
	          splits.each(function (index, split) {
	            split = $(split);
	            var tempProducts = split.prevUntil('[data-row-split]:visible', '.product');
	            if (tempProducts && tempProducts.length > 0) {
	              COSTCO.Header.alignItems(tempProducts);
	            }
	          });
	        } else {
	          COSTCO.Header.alignItems(products);
	        }
	      } else if ($('#isBDAppVar').val() == 'BD' && featureProducts && featureProducts.length > 0) {
	        COSTCO.Header.alignItems(featureProducts);
	      } else if ($('#isBDAppVar').val() == 'BC' && featureProducts && featureProducts.length > 0 || compare && compare.length > 0) {
	        COSTCO.Header.alignItems(products);
	      }
	    },
	
	    /**
	     * [alignItems description]
	     * @param  {[type]} items [description]
	     * @return {void}       [description]
	     */
	    alignItems: function alignItems(items) {
	      var maxHeight = COSTCO.util.getMaxOutherHeight(items.find('.product-tile-set'));
	
	      items.each(function (index, item) {
	        item = $(item);
	        var height = item.find('.product-tile-set').height();
	
	        var paddingCorrection = maxHeight - height;
	        if (item.find('div.column-stock-status').length > 0) {
	          var pdbottom = item.find('div.column-stock-status').last().css('padding-bottom');
	          var paddingCorrection_status = (parseInt(pdbottom, 10) || 0) + paddingCorrection;
	          item.find('div.column-stock-status').last().css({ 'padding-bottom': paddingCorrection_status + 'px' });
	        } else {
	
	          if (item.find('.addbutton').length > 1 && $('#isBDAppVar').val() == 'BD') {
	            var addbuttonH = item.find('.addbutton').last();
	            var plpSignInForDetails = addbuttonH.find('#plp-sign-in-for-details').css('display');
	            var plpMoreDetails = addbuttonH.find('#plp-more-details').css('display');
	            if (plpSignInForDetails === "none" && plpMoreDetails === "none") {
	              paddingCorrection = paddingCorrection + addbuttonH.height();
	            }
	          }
	
	          var pdtop = item.find('div.addbutton').css('padding-top');
	          var paddingCorrection_btn = (parseInt(pdtop, 10) || 0) + paddingCorrection;
	          if (item.find('.criteo-sponsored').length > 0) {
	            item.find('div.addbutton').css({ 'padding-top': paddingCorrection_btn + 'px' });
	          } else {
	            item.find('div.addbutton').css({ 'padding-top': paddingCorrection_btn + 'px' });
	          }
	        }
	      });
	    },
	    /**
	     * Assign value to alert-box cookie used to determine whether
	     * or not user has closed the alert box before for current warehouse
	     * @return {void}
	     */
	    closeAlertBanner: function closeAlertBanner() {
	      $('#header-promo .alert').on('closed.bs.alert', function () {
	        var whsNum = void 0;
	        if (!!$.cookie('WC_BD_WHS')) {
	          var whsCookie = $.cookie('WC_BD_WHS').split('-');
	          whsNum = whsCookie[0];
	        }
	        if (!!$.cookie('alert-box')) {
	          var whsList = $.cookie('alert-box');
	          whsList = whsList + '|' + whsNum;
	          $.cookie('alert-box', whsList, { path: '/' });
	        } else {
	          $.cookie('alert-box', whsNum, { path: '/' });
	        }
	      });
	    },
	
	    /**
	     * Following function updates all links pointing to the Instacart site
	     * zipcode should be appended to any sameday link if the postalcode cookie is present
	     * This will prevent the zip code box from opening for new users.
	     */
	    previousZip: null,
	    updateSamedayLinks: function updateSamedayLinks() {
	
	      var postalCode = $.cookie('invCheckPostalCode');
	
	      // Exit method if postalCode is not set
	      if (typeof postalCode === 'undefined' || postalCode == null || postalCode == '') {
	        return;
	      }
	      //STRY0154556, STRY0154557 - Instacart-canada-phase-2 - Zip code validation for CA site
	      if (COSTCO.util.isCAStore()) {
	        var isValidzipCode = /^\w\d\w.\d\w\d/.test(postalCode);
	        if (!isValidzipCode) {
	          return;
	        }
	      }
	      if (COSTCO.util.isUSStore()) {
	        var isNumeric = /^\d+$/.test(postalCode);
	        // XSS check
	        if (!isNumeric) {
	          return;
	        }
	      }
	      var samedayLinks = $(samedayLink);
	      for (var i = 0; i < samedayLinks.length; i++) {
	        var link = samedayLinks[i];
	        var href = $(link).attr('href');
	
	        // Do not append if zipcode is already in the url
	        if (href.indexOf('zipcode=') == -1) {
	          if (href.indexOf('?') > -1) {
	            href = href.concat('&zipcode=' + postalCode);
	          } else {
	            href = href.concat('?zipcode=' + postalCode);
	          }
	        } else {
	          href = href.replace('zipcode=' + COSTCO.Header.previousZip, 'zipcode=' + postalCode);
	        }
	        COSTCO.Header.previousZip = postalCode;
	        $(link).attr('href', href);
	      }
	    },
	
	    /**
	     * Hide Grocery tile on Banner , when user is on a non-eligible CA grocery region
	     * @return {void}
	     */
	    hideGroceryBannerForInvalidRegion: function hideGroceryBannerForInvalidRegion() {
	      var isRegionValid = $.cookie('C_2LOC');
	      if (isRegionValid != null && COSTCO.util.isCAStore() && isRegionValid == 'false') {
	        //STRY0160243-Flag to disable CA instacart
	        //If instacart CA is enabled , then home ancilalry cannot be hidden based on the 2 day regions alone.
	        //Handled in the espot through branching
	        if (instaCartCAEnabled == 'false') {
	          //hiding grocery tile for non eligible 2 day regions
	          $("#Home_Ancillary_0").hide();
	        }
	        //hiding grocery espot "How Costco Grocery Program works" for non eligible 2 day regions
	        $("a[href$='all-costco-grocery.html']").parent().hide();
	      }
	    },
	    /**
	     * Hide Primary Clause when EDD on PDP
	     * If the EDD Block exists on the page, then hide the primary clause
	     * @return {void}
	     */
	    hidePrimaryClause: function hidePrimaryClause() {
	
	      if ($('#edd-form-block').length) {
	        if ($('.primary-clause').length) {
	          $('.primary-clause').hide();
	        }
	      }
	    },
	
	    /**
	     * bind the refresh button in PDP page
	     */
	    bindRefreshBtn: function bindRefreshBtn() {
	      if ($("#RefreshBtn").length > 0) {
	        $("#RefreshBtn").click(function () {
	          $("#RefreshBtn").attr("disabled", true);
	          $('#product-page').addClass('ajax-busy');
	          COSTCO.CMath.handleContractSpecificRules();
	        });
	      }
	    },
	    /**
	    Function used to attempt set the akamai zipcode,
	    * 1. If cookie already exists, remove 'isZipSetByAkamai' from session
	    * 2. If cookie doesn't exist try to get the zip code from the Akamai Cookie (client-zip-code)
	    */
	    setBDZipCodeFromAkamai: function setBDZipCodeFromAkamai() {
	      var currentZipCode = $.cookie('WC_BD_ZIP');
	      var akamaiZipEnabled = $('#akamaiZipEnabled').val();
	      var customAkamaiZip = $.cookie('client-zip-short');
	      var finalZipCode = null;
	      var submitZip = function submitZip() {
	        if (finalZipCode != null) {
	          zipCodeModal.setAkamaiBDZipCode(finalZipCode);
	        }
	        if (COSTCO.Header.checkIsForcedSubmitZipcode()) {
	          COSTCO.util.removeFromSession('isForcedSubmitZipcode');
	        }
	      };
	      // Determine if the cookie already exists
	      if (!currentZipCode || currentZipCode == '') {
	        //if Akamai Zip Enabled in XAPP
	        if (akamaiZipEnabled == "1" && customAkamaiZip != null && customAkamaiZip != '') {
	          //Validate that akamai zip is in the country the store is in
	          var postalValidationRegex = null;
	          if (COSTCO.util.isCABDStore()) {
	            postalValidationRegex = /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}$/;
	          } else if (COSTCO.util.isUSBDStore()) {
	            postalValidationRegex = /^(\d{5}(-\d{4})?$)$/;
	          }
	          if (postalValidationRegex.test(customAkamaiZip)) {
	            finalZipCode = customAkamaiZip;
	            if (COSTCO.util.isCABDStore()) {
	              COSTCO.util.callGeocodeApiAndUpdateBDLocationCookie(customAkamaiZip).then(function () {
	                finalZipCode = sessionStorage.getItem('finalZipcode');
	                COSTCO.util.removeFromSession('finalZipcode');
	                COSTCO.util.setInSession("isGeoApiCalled", true);
	                submitZip();
	              });
	            } else if (COSTCO.util.isUSBDStore()) {
	              finalZipCode = customAkamaiZip;
	            }
	            COSTCO.util.setInSession("isZipSetByAkamai", true);
	          }
	        }
	      } else {
	        if (COSTCO.Header.checkIsZipSetByAkamai()) {
	          //$('#set-zip-code-parent a[open-flyout]').click();
	          COSTCO.util.removeFromSession('isZipSetByAkamai');
	        }
	      }
	      if (COSTCO.util.isUSBDStore()) {
	        submitZip();
	      }
	    },
	
	    refreshMiniBannerDetails: function refreshMiniBannerDetails(data) {
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
	        COSTCO.Header.displayDeliverySurcharge_v2(parseFloat(data.orderTotal), parseFloat(data.freeDeliveryOrderAmount), parseFloat(data.deliverySurcharge), data.isStorePickup);
	      } else {
	        COSTCO.Header.displayDeliverySurcharge(parseFloat(data.orderTotal), parseFloat(data.freeDeliveryOrderAmount), parseFloat(data.deliverySurcharge), data.isStorePickup);
	      }
	      COSTCO.Header.displayTooltip(data.shipmodeId, data.addrType);
	
	      if ($('#set-addr-type-parent').hasClass('hidden')) {
	        $('#set-addr-type-parent').removeClass('hidden');
	        $('#set-addr-type-parent').addClass('visible-xs-block visible-sm-block visible-md-block visible-lg-block visible-xl-block');
	      }
	
	      if (data.addrType == 'R') {
	        $('#delivery-option-' + data.shipmodeId).prop("checked", true);
	      } else if (data.addrType == 'S') {
	        $('#delivery-option-SP').prop("checked", true);
	      } else if (data.addrType == 'C') {
	        $('#delivery-option-10101').prop("checked", true);
	      }
	
	      if (data.addrType == 'R') {
	        $('#bdaddrtype').html('Delivery Method: <span class="bold">Nationwide Delivery</span>');
	      } else if (data.addrType == 'S') {
	        $('#bdaddrtype').html('Delivery Method: <span class="bold">Pick-Up</span>');
	      } else if (data.addrType == 'C') {
	        $('#bdaddrtype').html('Delivery Method: <span class="bold">Local Business Delivery</span>');
	      }
	
	      if (!data.showAddrTypeChangeLink) {
	        $('#set-addr-type-change').removeClass('visible-xs-block visible-sm-block visible-md-block visible-lg-block visible-xl-block');
	        $('#set-addr-type-change').addClass('hidden');
	      }
	    },
	    saveMiniCartDetSessionStorage: function saveMiniCartDetSessionStorage(data) {
	      if (!data.zipDetails) {
	        var bdaddrType = $('#bdaddrtype').text();
	        var addrType = bdaddrType != '' ? bdaddrType == 'Commercial Address' ? 'C' : 'R' : '';
	        var currentZipDet = $.cookie('WC_BD_ZIP');
	        if (addrType) {
	          currentZipDet = currentZipDet + "-" + addrType;
	        }
	        data.zipDetails = currentZipDet;
	        data.addrType = addrType;
	      }
	      sessionStorage.setItem('miniBannerDetails', COSTCO.util.encode(JSON.stringify(data)));
	    },
	    showCommentBox: function showCommentBox() {
	      var commentSection = $(COSTCO.util.tmpl('tmpl_return_order_reason_comment'));
	      commentSection.find('textarea').focus(function (event) {
	        COSTCO.Checkout.character_count('#chars_' + 0, '#comments_' + 0);
	      });
	      $("#return_edit_form_" + 0).find(".return-comment").remove();
	      var actionsContainer = $("#return_actions_" + 0).empty();
	      actionsContainer.before(commentSection);
	    }
	  };
	
	  /*
	   *  A11Y STRY0166460
	   */
	  COSTCO.util.closeDropdownWhenOutOfFocus();
	
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.Header = Header;
	  return Header;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 81:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/* js function used in set delivery zip code */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(82), __webpack_require__(15)], __WEBPACK_AMD_DEFINE_RESULT__ = function (ziphelper, preauthchargesmodal) {
		var zipCodeModal = {
			validateSuccess: undefined,
			setSuccess: undefined,
			digit5Zip: undefined,
			init: function init() {
				var zipcode = COSTCO.util.getBDZipCookie().zipCode;
				if (zipcode != null && zipcode != "undefined" && zipcode != "") {
					$('#signin_zip').remove();
					$("#set-zip-code-parent").find(".zipcode-toggle").each(function () {
						$(this).hasClass("hidden") ? $(this).removeClass("hidden") : $(this).addClass("hidden");
					});
					$("#set-delivery-zipcode").find(".zipcode-toggle").each(function () {
						if ($(this).hasClass("hidden")) {
							$("#set-delivery-zipcode").attr('aria-label', messages.CHANGE_ZIP_CODE);
						} else {
							$("#set-delivery-zipcode").attr('aria-label', messages.SET_ZIP_CODE);
						}
					});
	
					var originalZipCode = COSTCO.util.getBDZipCookie().originalZipCode;
	
					if (originalZipCode != "") {
						$("#bdzip").text(originalZipCode);
					} else {
						$("#bdzip").text(zipcode);
					}
				}
	
				$.validator.addMethod("countryspecificpostalcode", function (value, element, params) {
					var zip_pattern = new RegExp(document.getElementById("zipcode_patterns").getAttribute("value"));
					return this.optional(element) || zip_pattern.test($.trim(value));
				}, messages.ERR_ENTER_ZIPCODE);
	
				//Added for BD set zipcode
				//ALM40905 Avoid calling these functions for CrossSiteRequestForgeryErrorView and ProhibitedCharacterErrorView 
				if (!$('#isErrorPage').val() || $('#isErrorPage').length == 0) {
					zipCodeModal.generatePopovers();
				}
	
				//Added for BD SetDeliveryLocationView page
				// If div with id exist on page, show its belonging template content (ZIP code input)
				if (zipCodeModal.isDeliveryLocationPage()) {
					zipCodeModal.generateDeliveryLocationPage();
				}
				if ($('#delivery-zipcode-form') && $('#delivery-zipcode-form').length == 1) {
					$('#delivery-zipcode-form').append(COSTCO.util.tmpl('template_ProductDetails'));
				}
				if ($('#orderByItm-zipcode-form') && $('#orderByItm-zipcode-form').length == 1) {
					$('#orderByItm-zipcode-form').append(COSTCO.util.tmpl('template_OrderByItemNo'));
				}
			},
	
			generatePopovers: function generatePopovers() {
				if (typeof checkoutPage == "undefined" || typeof checkoutPage != "undefined" && (checkoutPage == 'cart' || checkoutPage == 'confirmation' || !checkoutPage)) {
					var c = $.cookie('hashedUserId');
					var t = document.getElementById("template_SetDeliveryZip");
					var div = document.createElement("div");
					div.innerHTML = t.innerHTML;
	
					if (c && c != '""') {
						$(div).find('.invite-sign-up').addClass('hidden');
					} else {
						$(div).find('.invite-sign-up').removeClass('hidden');
					}
					t.innerHTML = div.innerHTML;
				}
	
				zipCodeModal.addMaskToZipInput($(t).find('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode'));
	
				var selector = "#set-zip-code-parent a[open-flyout]";
				var content = "#template_SetDeliveryZip";
				COSTCO.util.click_popover(selector, content);
			},
	
			generateDeliveryLocationPage: function generateDeliveryLocationPage() {
				$('#delivery-location-zip').html(COSTCO.util.tmpl('template_deliveryLocation', {}));
			},
	
			// Add mask to zip input in case US (global var shippingCountries[0] used to determine country)
			addMaskToZipInput: function addMaskToZipInput(zipInput) {
				if (zipInput) {
					// Add mask to zip input in case US (global var shippingCountries[0] used to determine country)
					if (shippingCountries != null && shippingCountries.length > 0 && shippingCountries[0] == "US") {
						zipInput.unmask().mask('00000-0000');
					}
				}
			},
	
			getZipByAddressModal: function getZipByAddressModal(tmpZip) {
				COSTCO.dialog.createExtDialogBox({
					title: messages.JS_DIALOG_CHK_DELIVERY_ADDRESS,
					body: $('#tmpl_get_zip_by_address').html(),
					primary: messages.JS_DIALOG_CHK_ADDRESS,
					primary_event: function primary_event() {
						var formElement = $("#zip_by_address-modal-modal");
						zipCodeModal.ajaxGetZipByAddress(formElement, "processValidateZipCodeSuccess");
					},
					secondary: messages.JS_DIALOG_CANCEL
				});
				// prepop. zip inut text		      
				$('#postalId').val(tmpZip);
				//$('#formId').val(formid);
				//deliveryZipCode
			},
			isDeliveryLocationPage: function isDeliveryLocationPage() {
				if ($('#delivery-location-zip').length !== 0) {
					return true;
				} else {
					return false;
				}
			},
			redirectToSignIn: function redirectToSignIn(url) {
				window.location = url;
				return false;
			},
			changeZip_buttonClickChange: function changeZip_buttonClickChange(data, params, form, verifiedAddress) {
				if (!window.location.href.includes('SinglePageCheckoutView')) {
					$.cookie('deliveryDateCookie', null, { expires: -1, path: '/' });
					$('[name="selDeliveryDate"]').val('');
				}
				COSTCO.ziphelper.setZipCookie(data.SetDeliveryZip);
				COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
				$('#header-delivery-zip').find('#bdzip').text(data.SetDeliveryZip);
				if (verifiedAddress != undefined) {
					COSTCO.CAddress.submitAddress(data, params, form, verifiedAddress);
				}
				var submitUrl = "/AjaxBusinessDeliveryBrowse";
				var redirectUrl = window.location.href;
				var submitParams = [submitUrl, form, redirectUrl];
				zipCodeModal.ajaxCallFormSubmit(form, params ? submitParams.concat(params) : submitParams, zipCodeModal.saveDetailsBeforePlaceOrder);
			},
			/**
	   * saveDetailsBeforePlaceOrder - to save the shipmode derived based on the 
	   * address change in review page 
	   * National-Delivery
	   */
			saveDetailsBeforePlaceOrder: function saveDetailsBeforePlaceOrder() {
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
					if ($('#shipping #address-modal-inline').length === 0) {
						if (COSTCO.util.isNdEnabled()) {
							COSTCO.OrderSummary.updateSelectedShipDetails(parseFloat($.cookie('wcCartOrder')), undefined);
						} else {
							window.location.reload();
						}
					}
					if ($('#shipping #address-modal-inline').length > 0) {
						window.location.href = window.location.href + '&forceFirstStep=true';
					}
				} else {
					if (typeof checkoutPage != "undefined" && checkoutPage == 'review' && COSTCO.util.isNdEnabled()) {
						COSTCO.OrderSummary.updateSelectedShipDetails(parseFloat($.cookie('wcCartOrder')), undefined);
					} else {
						window.location.reload();
					}
				}
			},
			buttonClickChange: function buttonClickChange(zipCode, form, optParams, data, verifiedAddress) {
				//$.cookie('WC_BD_ZIP', zipCode);
				var submitUrl = "/AjaxBusinessDeliveryBrowse";
				var redirectUrl = window.location.href;
				if ($('#WC_CachedHeaderDisplay_Link_2').attr('href') != '' && $('#WC_CachedHeaderDisplay_Link_2').attr('href') != null) {
					redirectUrl = $('#WC_CachedHeaderDisplay_Link_2').attr('href');
				}
				if (window.location.href.includes('CheckoutCartDisplayView')) {
					var tmpUrl = window.location.href.replace('CheckoutCartDisplayView', 'CheckoutCartView');
					redirectUrl = tmpUrl;
				}
				if (typeof data != 'undefined' && data != null && typeof verifiedAddress != 'undefined' && verifiedAddress != null) {
					COSTCO.CAddress.submitAddress(data, optParams, form, verifiedAddress);
				}
				var submitParams = [submitUrl, form, redirectUrl];
				if (!window.location.href.includes('SinglePageCheckoutView')) {
					$.cookie('deliveryDateCookie', null, { expires: -1, path: '/' });
				}
				zipCodeModal.ajaxCallFormSubmit(form, optParams ? submitParams.concat(optParams) : submitParams, zipCodeModal.setSuccess);
			},
			changeZipDel_buttonClickChange: function changeZipDel_buttonClickChange(zipCode, submitParams) {
				zipCodeModal.ajaxCallFormSubmit(submitParams[1], submitParams, zipCodeModal.setSuccess);
			},
	
			buttonClickViewCart: function buttonClickViewCart() {
				if (typeof checkoutPage !== "undefined" && (checkoutPage === 'shipping' || checkoutPage === 'review')) {
					COSTCO.CAddress.closeModal();
					window.location.href = $('#return-to-cart').attr('href');
				} else {
					window.location.href = $('#set-zip-code-parent').data().cartlink;
				}
			},
			dialogAlert: function dialogAlert(popupMsg, form) {
				COSTCO.dialog.createExtDialogBox({
					title: messages.ZIPCODE_DELIVERY_ALERT_HEADER,
					body: COSTCO.util.tmpl('tmpl_delivery_zipcode_alert', {
						messageTxt: popupMsg }),
					primary: messages.ZIPCODE_SELECTOR_CANCEL_BUTTON,
					secondary: messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_VIEW_CART_BUTTON,
					secondary_event: function secondary_event() {
						zipCodeModal.buttonClickViewCart();
					}
				});
			},
			dialog: function dialog(zipCode, optParams, popupMsg, form, data, verifiedAddress, userDeliveryMethod) {
				var primaryButton = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_ZIP_CODE_BUTTON;
				var titleMsg = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_HEADER;
				var messageQues = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_QUESTION1;
				COSTCO.dialog.createExtDialogBox({
					title: titleMsg,
					body: COSTCO.util.tmpl('tmpl_change_delivery_zipcode', {
						messageTxt: popupMsg,
						msgQuestion: messageQues }),
					primary: primaryButton,
					secondary: messages.ZIPCODE_SELECTOR_CANCEL_BUTTON,
					primary_event: function primary_event() {
						var isCheckoutFlow = false;
						if (typeof checkoutPage !== 'undefined') {
							if (checkoutPage == 'review' || checkoutPage == 'shipping') {
								isCheckoutFlow = true;
							}
						}
						if (COSTCO.util.isNdEnabled() && !isCheckoutFlow && (data == null || !data.ShowAddressTypePopup)) {
							if (data != null && data.isNDOnly) {
								$(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val("Nationwide");
							}
							zipCodeModal.buttonClickChange(zipCode, form, optParams, data);
						} else if (COSTCO.util.isNdEnabled() && isCheckoutFlow && COSTCO.zipCodeModal.isUserDeliveryMethodExists(data, userDeliveryMethod) && !verifiedAddress) {
							$(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val(userDeliveryMethod);
							zipCodeModal.buttonClickChange(zipCode, form, optParams, data);
						} else if (COSTCO.util.isNdEnabled() && isCheckoutFlow && !COSTCO.zipCodeModal.isUserDeliveryMethodExists(data, userDeliveryMethod) && !verifiedAddress) {
							COSTCO.zipCodeModal.viewDeliveryMethodModal(form, data, optParams, verifiedAddress);
						} else if (COSTCO.util.isNdEnabled() && isCheckoutFlow && verifiedAddress) {
							COSTCO.zipCodeModal.viewDeliveryMethodModal(form, data, optParams, verifiedAddress);
						} else if (!COSTCO.util.isNdEnabled() && (data == null || !data.ShowAddressTypePopup || isCheckoutFlow)) {
							zipCodeModal.buttonClickChange(zipCode, form, optParams, data, verifiedAddress);
						} else {
							if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE") {
								$(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val("Local");
								COSTCO.zipCodeModal.submitZipCode(form);
							} else {
								COSTCO.zipCodeModal.viewDeliveryMethodModal(form, data, optParams);
							}
						}
					}
				});
			},
			isUserDeliveryMethodExists: function isUserDeliveryMethodExists(data, userDeliveryMethod) {
				if (userDeliveryMethod === 'Local') {
					return data.isBDTruckZoneEnabledForWareHouse;
				}
				if (userDeliveryMethod === 'Nationwide') {
					return data.isNationalDeliveryEnabledForWareHouse;
				}
				return true;
			},
			changeZipDialog: function changeZipDialog(data, params, popupMsg, form, verifiedAddress) {
				var primaryButton = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_ZIP_CODE_BUTTON;
				var titleMsg = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_HEADER;
				var messageQues = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_QUESTION1;
				COSTCO.dialog.createExtDialogBox({
					title: titleMsg,
					body: COSTCO.util.tmpl('tmpl_change_delivery_zipcode', {
						messageTxt: popupMsg,
						msgQuestion: messageQues }),
					primary: primaryButton,
					secondary: messages.ZIPCODE_SELECTOR_CANCEL_BUTTON,
					primary_event: function primary_event() {
						if (typeof checkoutPage !== 'undefined') {
							if (checkoutPage == 'review' || checkoutPage == 'shipping') {
								isCheckoutFlow = true;
							}
						}
						if (data != null && data.ShowAddressTypePopup && data.redirectURL[0] == "SetDeliveryZip") {
							if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE") {
								$(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val("Local");
								COSTCO.zipCodeModal.submitZipCode(form);
							} else {
								COSTCO.zipCodeModal.viewDeliveryMethodModal(form, data, params, verifiedAddress);
							}
						} else {
							if (COSTCO.util.isNdEnabled()) {
								if (isCheckoutFlow && verifiedAddress && !data.ShowDeliveryMethodPopup && (data.ExternalCarrierChange || data.WarehouseChange)) {
									if (data.IsInBDTruckZoneOnly) {
										$(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val("Local");
										COSTCO.CAddressForm.showNationalDeliveryQuestionnaireModal_v2(form, data, params, verifiedAddress);
									} else if (data.isNDOnly) {
										$(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val("Nationwide");
										zipCodeModal.changeZip_buttonClickChange(data, params, form, verifiedAddress);
									} else {
										zipCodeModal.changeZip_buttonClickChange(data, params, form, verifiedAddress);
									}
								} else {
									COSTCO.zipCodeModal.viewDeliveryMethodModal(form, data, params, verifiedAddress);
								}
							} else {
								zipCodeModal.changeZip_buttonClickChange(data, params, form, verifiedAddress);
							}
						}
					}
				});
			},
			changeZipDelDialog: function changeZipDelDialog(zipCode, submitParams, popupMsg) {
	
				COSTCO.dialog.createExtDialogBox({
					title: messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_HEADER,
					body: COSTCO.util.tmpl('tmpl_change_delivery_zipcode', {
						messageTxt: popupMsg,
						msgQuestion: messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_QUESTION1 }),
					primary: messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_ZIP_CODE_BUTTON,
					secondary: messages.ZIPCODE_SELECTOR_CANCEL_BUTTON,
					primary_event: function primary_event() {
						zipCodeModal.changeZipDel_buttonClickChange(zipCode, submitParams);
					}
				});
			},
			submitZipCodeFromPopover: function submitZipCodeFromPopover(event) {
				if (COSTCO.Header.checkIsZipSetByAkamai()) {
					// If user is on the page where Akamai tries to set ZIP code, enter forced submit flow
					COSTCO.util.setInSession('isForcedSubmitZipcode', true);
				}
				COSTCO.zipCodeModal.submitZipCode(event);
			},
			submitZipCode: function submitZipCode(event, validateSuccess, setSuccess, optParams, digit5Zip) {
				//('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode').val();
				// in case event has no currentTarget attribute, it means html form attribute is passed. Usually event attribute is passed
				var formElement = event;
	
				if (event.currentTarget) {
					formElement = $(event.currentTarget);
				};
	
				var formElementZip = $(formElement).find('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode');
				var errorHolder = $(formElement).find("[critical-notification-holder]");
				errorHolder.addClass("hidden").removeClass("warning").addClass("critical-notification");
				// This style of validation allows for no error to be displayed until the User moves forward with request
				var deliveryMethodFlow = false;
				var selectedDeliveryMethod = $(formElement).find('#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod').val();
				if (selectedDeliveryMethod && selectedDeliveryMethod != "") {
					deliveryMethodFlow = true;
				}
				// Setting the currentZipCode hidden variable value because of intermittent cache issue in JSP 
				var zipcode = COSTCO.util.getBDZipCookie().zipCode;
				$(formElement).find('#BusinessDeliveryBrowseForm_FormInput_currentZipCode').val(zipcode);
	
				var validator = $(formElement).validate();
	
				$(formElementZip).rules("remove");
	
				$(formElementZip).rules('add', {
					required: true,
					'countryspecificpostalcode': true,
					messages: {
						required: messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER,
						countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER
					}
				});
	
				validator.form();
				var valid = validator.valid();
	
				if (valid) {
					validateSuccess ? zipCodeModal.validateSuccess = validateSuccess : zipCodeModal.validateSuccess = zipCodeModal.processValidateZipCodeSuccess;
					setSuccess ? zipCodeModal.setSuccess = setSuccess : zipCodeModal.setSuccess = zipCodeModal.processSetZipCodeSuccess;
					var submitUrl = "/AjaxBusinessDeliveryBrowse";
					var validateUrl = "/AjaxDeliveryZipValidation";
					var redirectUrl = window.location.protocol + '//' + window.location.host;
					if (window.location.href.includes('CheckoutCartDisplayView')) {
						var tmpUrl = window.location.href.replace('CheckoutCartDisplayView', 'CheckoutCartView');
						redirectUrl = tmpUrl;
					}
					var submitParams = [submitUrl, formElement, redirectUrl];
					var validateParams = [validateUrl, formElement];
					var zipCookie = COSTCO.util.getBDZipCookie();
					var trimmedZip = $(formElementZip).val().trim();
					$(formElementZip).val(trimmedZip);
					digit5Zip ? zipCodeModal.digit5Zip = digit5Zip : zipCodeModal.digit5Zip = trimmedZip;
	
					if (zipCookie.zipCode.length > 0 && !deliveryMethodFlow) {
						zipCodeModal.ajaxCallFormSubmit(formElement, optParams ? validateParams.concat(optParams) : validateParams, zipCodeModal.validateSuccess);
					} else {
						if ($(formElement).find("#WC_BusinessDeliveryBrowseForm_FormInput_url").val() != '' && $(formElement).find("#WC_BusinessDeliveryBrowseForm_FormInput_url").val() != null) {
							submitParams[2] = $(formElement).find("#WC_BusinessDeliveryBrowseForm_FormInput_url").val();
						} else if ($(formElement).find("#WC_BusinessDeliveryBrowseForm_FormInput_redirectUrl").val() == 'ProductDetails') {
							submitParams[2] = document.URL;
						} else if ($(formElement).find("#WC_BusinessDeliveryBrowseForm_FormInput_redirectUrl").val() == 'OrderByItemsDisplayViewBD') {
							submitParams[2] = 'OrderByItemsDisplayViewBD?storeId=' + wcs.storeId + '&catalogId=' + wcs.catalogId + '&langId=' + wcs.langId + '&fromPage=OrderByItemsDisplayView';
						} else if (document.URL.indexOf('CashCardBalanceInquiry') != -1) {
							submitParams[2] = 'costco-shop-card';
						} else {
							submitParams[2] = document.URL;
						}
						zipCodeModal.ajaxCallFormSubmit(formElement, optParams ? submitParams.concat(optParams) : submitParams, zipCodeModal.setSuccess);
					}
				}
			},
	
			submitZipCodeForValidation: function submitZipCodeForValidation(form, validateSuccess, setSuccess, optParams, oldAddy, newAddy) {
				validateSuccess ? zipCodeModal.validateSuccess = validateSuccess : zipCodeModal.validateSuccess = zipCodeModal.processValidateZipCodeSuccess;
				setSuccess ? zipCodeModal.setSuccess = setSuccess : zipCodeModal.setSuccess = zipCodeModal.processSetZipCodeSuccess;
				var submitUrl = "/AjaxBusinessDeliveryBrowse";
				var validateUrl = "/AjaxDeliveryZipValidation";
				var redirectUrl = window.location.protocol + '//' + window.location.host;
				var submitParams = [submitUrl, form, redirectUrl];
				var validateParams = [validateUrl, form];
				var zipCookie = COSTCO.util.getBDZipCookie();
				if (zipCookie.zipCode.length > 0) {
					zipCodeModal.ajaxCallFormSubmit(form, optParams ? validateParams.concat(optParams) : validateParams, zipCodeModal.validateSuccess, oldAddy, newAddy);
				}
			},
			/**
	   * Function to change content of IP Sniffer popover if Akamai set zip code in client-zip-short cookie
	   * @param  $popover - popover element used by jQuery
	   */
			transformToIPSnifferPopover: function transformToIPSnifferPopover($popover) {
				$popover.find('.invite-sign-up').addClass('hidden');
				$popover.find('.text-shoot').addClass('hidden');
				$popover.find('.get-zip-code-form').addClass('hidden');
				$popover.find('.ip-sniffer-close-link').removeClass('hidden');
				$popover.find('.text-shoot-ip-sniffer').removeClass('hidden');
				var zipcode = COSTCO.util.getBDZipCookie().zipCode;
				var baseAlert = messages.ZIPCODE_POPUP_SR_ALERT_MESSAGE;
				COSTCO.util.announceSRMessage(baseAlert.replace("{0}", zipcode));
			},
			/**
	     * Function to handle the successful zip code change
	     * @param  {[json]}  data - json response of the ajax call AjaxBusinessDeliveryBrowse
	     * @param  {[array]} params - parameters for page redirection
	     * @param  {String}  form - submitted form
	     * @return 
	     */
			processSetZipCodeSuccess: function processSetZipCodeSuccess(data, params, form) {
				var errorHolder = $(form).find("[critical-notification-holder]");
				errorHolder.addClass("hidden").removeClass("warning").addClass("critical-notification");
				// If zip code entered is an error or left blank, display either business selected message or generic error message.
				// Otherwise redirect to previous page.
				var redirecturl = data.redirecturl;
				if ((data.errorMessage != null || data.errorMessage != "") && data.errorMessage != undefined) {
					//Opens the tool tip window for IP sniffer
					if (COSTCO.Header.checkIsZipSetByAkamai()) {
						$('#set-zip-code-parent a[open-flyout]').find("div").css('display', 'block');
						//COSTCO.util.removeFromSession("isZipSetByAkamai");
					}
					var zipUserEntered = $(params[1]).find("input[name='zipCodeFormDeliveryZipCode']").val();
					var originForm = $(params[1]).attr('id');
					if (data.errorMessage.indexOf("InactiveMessage") >= 0) {
						errorHolder.removeClass("hidden").find("div").html(data.errorMessage.replace("InactiveMessage: ", "")).slideDown("fast");
					} else if (zipUserEntered != "") {
						if (data.errorMessageKey != undefined && (data.errorMessageKey != null || data.errorMessageKey != "") && data.errorMessageKey == "ERR_INCOMPLETE_SEGMENTED_ZIP_CODE") {
							errorHolder.removeClass("hidden").removeClass("critical-notification").addClass("warning").find("div").html(zipCodeModal.refactorSegmentedZipNeededMsg(zipUserEntered, messages.ERR_INCOMPLETE_SEGMENTED_ZIP_CODE)).slideDown("fast");
						} else {
							errorHolder.removeClass("hidden").find("div").html(messages.ERR_INVALID_DELIVERY_ZIP_CODE_MSG).slideDown("fast");
							COSTCO.zipCodeModal.showZipByAddressInlineError();
						}
					} else {
						// From storeErrorMessages__.properties
						errorHolder.removeClass("hidden").find("div").html(zipCodeModal.decodeHTMLText(data.errorMessage)).slideDown("fast");
					}
				} else {
					if (typeof data.newLocation != 'undefined' && data.newLocation == true && redirecturl.length > 0) {
						if (window.location.href != redirecturl) {
							window.location.href = redirecturl;
						} else {
							$('#set-zip-code-parent a[open-flyout]').find("div").css('display', 'block');
						}
					} else if (params[2] != "") {
						// replace "Logon" with "LogonForm?URL=%2f" or "UserRegistrationAdd" with "RegisterView?URL=%2f&isPharmacy=false" if needed					
						var tmpUrl = zipCodeModal.replaceForwardURL(params[2], "Logon", "LogonForm", "LogonForm?URL=%2f");
						tmpUrl = zipCodeModal.replaceForwardURL(tmpUrl, "UserRegistrationAdd", "RegisterView", "RegisterView?URL=%2f&isPharmacy=false");
						// Set IP-sniffed ZIP to header, and open IP-sniffer popover
						if (COSTCO.Header.checkIsZipSetByAkamai() && !COSTCO.Header.checkIsForcedSubmitZipcode()) {
							// STRY0169326 - Added check for Safari to reposition popover 
							if (COSTCO.util.isSafari()) {
								$('#set-zip-code-parent a[open-flyout]').find("div").css('display', 'block');
								$('#set-zip-code-parent a[open-flyout]').popover('show');
							}
							$('div#set-zip-code-parent #bdzip').text(data.SetDeliveryZip);
							$('div#set-zip-code-parent .zip-exists').removeClass('hidden');
							$('div#set-zip-code-parent .zip-not-exists').addClass('hidden');
							COSTCO.zipCodeModal.transformToIPSnifferPopover($('#set-zip-code-parent a[open-flyout]'));
							$('#set-zip-code-parent a[open-flyout]').find("div").css('display', 'block');
							if (!$('#set-zip-code-parent .popover').is(':visible')) {
								$('#set-zip-code-parent a[open-flyout]').popover('show');
							}
							// Show address type modal if the zipcode is in BD Truck zone
						} else if (data.ShowAddressTypePopup) {
							if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE") {
								$(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val("Local");
								COSTCO.zipCodeModal.submitZipCode(form);
							} else {
								COSTCO.zipCodeModal.viewDeliveryMethodModal(form, data, params);
							}
						} else {
							COSTCO.util.removeFromSession('isForcedSubmitZipcode');
							COSTCO.util.removeFromSession('isZipSetByAkamai');
							if (typeof COSTCO.Lists !== "undefined") {
								window.removeEventListener("beforeunload", COSTCO.Lists.leavePagePopup);
							}
							if (COSTCO.util.isBusinessDelivery() && typeof COSTCO.Checkout != 'undefined' && COSTCO.Checkout.isCartPage()) {
								tmpUrl = '/CheckoutCartView';
							}
							if (!window.location.hash) {
								window.location.href = tmpUrl;
							} else {
								window.location.reload();
							}
						}
					}
					if (data.currentZipCode != '' && data.currentZipCode != data.zipCodeFormDeliveryZipCode) {
						$.cookie('deliveryDateCookie', null, { expires: -1, path: '/' });
					}
					var whsCookie = $.cookie('WC_BD_WHS');
					if (whsCookie != null && whsCookie != '') {
						$('#bd-in-location-from-cookie').html('Location: ' + whsCookie);
					}
				}
			},
	
			/*
	   * utility function to decode html messages comming from .properties files such as StoreErrorMessages
	   */
			decodeHTMLText: function decodeHTMLText(encodedVal) {
				var textArea = document.createElement('textarea');
				textArea.innerHTML = encodedVal;
				return textArea.value;
			},
	
			/*
	   * utility function to replace one string value with another
	   * "Logon" with "LogonForm?URL=%2f" in URL string
	   */
			replaceForwardURL: function replaceForwardURL(urlvalue, replaceme, controlString, replacewith) {
				var returnValue = urlvalue;
				if (returnValue.indexOf(controlString) == -1) {
					returnValue = urlvalue.replace(replaceme, replacewith);
				}
				return returnValue;
			},
	
			launchZipModal: function launchZipModal(data, submitParams) {
				var zipcodeDeliveryMsg = COSTCO.util.isUSBDStore() ? messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT_ND_OFF_USBD : messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT_ND_OFF;
				var errorMessage = COSTCO.util.isNdEnabled() ? messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT5 : zipcodeDeliveryMsg;
				errorMessage = errorMessage.replace(/\{0\}/g, data.CurrentDeliveryZip);
				errorMessage = errorMessage.replace(/\{1\}/g, data.SetDeliveryZip);
				var popupMsg = errorMessage;
	
				zipCodeModal.changeZipDelDialog(data.SetDeliveryZip, submitParams, popupMsg);
			},
			launchModal: function launchModal(data, params, form, verifiedAddress, userDeliveryMethod) {
	
				var fromZipCodeToDisplay = data.bdZipCookieOriginal;
				if (fromZipCodeToDisplay == null || fromZipCodeToDisplay == "undefined" || fromZipCodeToDisplay == "") {
					fromZipCodeToDisplay = data.CurrentDeliveryZip;
				}
	
				var popupMsg = "";
				var isCheckoutFlow = false;
				var isDeliveryMethodChange = false;
				if (typeof checkoutPage !== 'undefined') {
					if (checkoutPage == 'review' || checkoutPage == 'shipping') {
						isCheckoutFlow = true;
					}
				}
				if (!COSTCO.util.isNdEnabled()) {
					// ND disabled flow
					popupMsg = COSTCO.util.isUSBDStore() ? messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT_ND_OFF_USBD : messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT_ND_OFF;
					popupMsg = popupMsg.replace(/\{0\}/g, fromZipCodeToDisplay);
					popupMsg = popupMsg.replace(/\{1\}/g, data.SetDeliveryZip);
				} else if (data.RegisteredUser) {
					// ND enabled flow
					if (data.InactiveZipMessage.length > 0) {
						popupMsg = data.InactiveZipMessage;
					} else if (data.NewWarehouseAlert.length > 0) {
						popupMsg = data.NewWarehouseAlert;
					} else if (!isCheckoutFlow && (data.ExternalCarrierChange || data.WarehouseChange)) {
						var errorMessage2;
						if (data.SetDeliveryZip == data.CurrentDeliveryZip) {
							errorMessage2 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT9;
							isDeliveryMethodChange = true;
						} else {
							errorMessage2 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT8;
						}
						errorMessage2 = errorMessage2.replace(/\{0\}/g, fromZipCodeToDisplay);
						errorMessage2 = errorMessage2.replace(/\{1\}/g, data.SetDeliveryZip);
						popupMsg = errorMessage2;
					} else {
						var errorMessage3;
						if (data.SetDeliveryZip == data.CurrentDeliveryZip) {
							errorMessage3 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT9;
							isDeliveryMethodChange = true;
						} else {
							errorMessage3 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT8;
						}
						errorMessage3 = errorMessage3.replace(/\{0\}/g, fromZipCodeToDisplay);
						errorMessage3 = errorMessage3.replace(/\{1\}/g, data.SetDeliveryZip);
						popupMsg = errorMessage3;
					}
				} else {
					var errorMessage1;
					if (data.SetDeliveryZip == data.CurrentDeliveryZip) {
						errorMessage1 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT9;
						isDeliveryMethodChange = true;
					} else {
						errorMessage1 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT8;
					}
					errorMessage1 = errorMessage1.replace(/\{0\}/g, fromZipCodeToDisplay);
					errorMessage1 = errorMessage1.replace(/\{1\}/g, data.SetDeliveryZip);
					popupMsg = errorMessage1;
				}
				if (data.StatusMessage == data.ZipStatusMessageList[5]) {
					zipCodeModal.dialogAlert(popupMsg, form);
				} else if (verifiedAddress && (data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7])) {
					zipCodeModal.changeZipDialog(data, params, popupMsg, form, verifiedAddress);
				} else {
	
					if (!isCheckoutFlow && isDeliveryMethodChange) {
						zipCodeModal.viewDeliveryMethodModal(form, data, params);
					} else {
						zipCodeModal.dialog(data.SetDeliveryZip, params, popupMsg, form, data, verifiedAddress, userDeliveryMethod);
					}
				}
			},
			/**
	      * Function to validate the zip code entered by the user
	      * @param  {json}    data - json response of the ajax call AjaxDeliveryZipValidation
	      * @param  {[array]} params - parameters for page redirection
	      * @param  {String}  form - submitted form
	      * @return 
	      */
			processValidateZipCodeSuccess: function processValidateZipCodeSuccess(data, params, form) {
				var forcedSubmitFlow = COSTCO.Header.checkIsForcedSubmitZipcode();
				// Temporarily proclaim this flow as non-forced, re-proclaim it as forced only if it doesn't uninterrupt
				COSTCO.util.removeFromSession('isForcedSubmitZipcode');
				var errorHolder = $(form).find("[critical-notification-holder]");
				//To read the address type to show the warning modal
				errorHolder.addClass("hidden").removeClass("warning").addClass("critical-notification");
				if (data.InactiveZipMessage && data.InactiveZipMessage.length > 0) {
					errorHolder.removeClass("hidden").find("div").html(data.InactiveZipMessage).slideDown("fast");
				} else if (data.ZipStatusMessageList != undefined) {
					switch (data.StatusMessage) {
						//Warehouse Not Active - contract inactive
						case data.ZipStatusMessageList[5]:
							// contract inactive
							if (data.NewWarehouseSplashPageURL.length > 0) {
								window.location.href = data.NewWarehouseSplashPageURL;
							} else {
								errorHolder.removeClass("hidden").find("div").html(messages.ERR_INVALID_DELIVERY_ZIP_CODE_MSG).slideDown("fast");
								COSTCO.zipCodeModal.showZipByAddressInlineError();
							}
							break;
						//Delivery Zip Empty
						case data.ZipStatusMessageList[1]:
							errorHolder.removeClass("hidden").find("div").html(data.StatusMessage).slideDown("fast");
							break;
						//Delivery Zip Not Found  
						case data.ZipStatusMessageList[3]:
							errorHolder.removeClass("hidden").find("div").html(messages.ERR_INVALID_DELIVERY_ZIP_CODE_MSG).slideDown("fast");
							COSTCO.zipCodeModal.showZipByAddressInlineError();
							break;
						//Delivery Zip Address Type Change
						case data.ZipStatusMessageList[7]:
							if (data.ExternalCarrierChange || data.WarehouseChange || data.ShowChangeDeliveryZipModal) {
								if (forcedSubmitFlow) {
									COSTCO.util.setInSession('isForcedSubmitZipcode', true);
								}
								data.ShowChangeDeliveryZipModal = false;
								zipCodeModal.launchModal(data, params, form);
							} else if (data.ShowAddressTypePopup) {
								if (forcedSubmitFlow) {
									COSTCO.util.setInSession('isForcedSubmitZipcode', true);
								}
								if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE") {
									$(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val("Local");
									COSTCO.zipCodeModal.submitZipCode(form);
								} else {
									COSTCO.zipCodeModal.viewDeliveryMethodModal(form, data, params);
								}
							}
							break;
						//Delivery Zip Found
						case data.ZipStatusMessageList[0]:
							var referrerUrl = window.location.href;
							if (data.URL != null && data.URL != '' && data.URL.includes(window.location.host) && data.URL.includes(".html")) {
								referrerUrl = data.URL;
							}
							var submitUrl = "/AjaxBusinessDeliveryBrowse";
							var submitParams = [submitUrl, params[1], referrerUrl];
							if (zipCodeModal.isDelDatePresent() && data.ShowAddressTypePopup != null) {
								zipCodeModal.launchZipModal(data, submitParams);
							} else {
								if (forcedSubmitFlow) {
									COSTCO.util.setInSession('isForcedSubmitZipcode', true);
								}
								zipCodeModal.ajaxCallFormSubmit(submitParams[1], submitParams, zipCodeModal.setSuccess);
							}
							break;
	
						//Delivery Zip Same
						case data.ZipStatusMessageList[2]:
							var referrer = window.location.href;
							//URL validation
							if (data.URL != null && data.URL != '' && data.URL.includes(window.location.host) && data.URL.includes(".html")) {
								referrer = data.URL;
							} else if (referrer == '') {
								referrer = window.location.protocol + '//' + window.location.host;
							}
							var costcoHostName = zipCodeModal.extractHostname(wcs.productBaseURL);
							var redirecHostName = zipCodeModal.extractHostname(params[2]);
							var referrerHostName = zipCodeModal.extractHostname(referrer);
							//This code will keep User on website if they arrive at zip-in page via external link
							if (redirecHostName.includes(costcoHostName)) {
								window.location.href = referrer;
							} else if (referrerHostName.includes(costcoHostName)) {
								window.location.href = referrer;
							} else {
								window.location.href = 'https://' + costcoHostName;
							}
							break;
	
						case data.ZipStatusMessageList[4]:
							/// different zipcode, same warehouse						
							var referrerUrl = document.URL;
							if (data.URL != null && data.URL != '' && data.URL.includes(window.location.host) && data.URL.includes(".html")) {
								referrerUrl = data.URL;
							}
							var submitUrl = "/AjaxBusinessDeliveryBrowse";
							var submitParams = [submitUrl, params[1], referrerUrl];
	
							if (zipCodeModal.isDelDatePresent() && data.ShowAddressTypePopup != null) {
								zipCodeModal.launchZipModal(data, submitParams);
							} else {
								zipCodeModal.ajaxCallFormSubmit(submitParams[1], submitParams, zipCodeModal.setSuccess);
							}
							break;
	
						case data.ZipStatusMessageList[6]:
							// segmented zip needed (Yellow)
							{
								errorHolder.removeClass("hidden").removeClass("critical-notification").addClass("warning").find("div").html(zipCodeModal.refactorSegmentedZipNeededMsg(data.SetDeliveryZip, messages.ERR_INCOMPLETE_SEGMENTED_ZIP_CODE)).slideDown("fast");
							}
							break;
						default:
							errorHolder.removeClass("hidden").find("div").html(messages.ERR_INVALID_DELIVERY_ZIP_CODE_MSG).slideDown("fast");
							COSTCO.zipCodeModal.showZipByAddressInlineError();
					}
				}
			},
			refactorSegmentedZipNeededMsg: function refactorSegmentedZipNeededMsg(deliveryZip, msg) {
				var newZip = deliveryZip == null ? "" : deliveryZip;
				var onClickEvent = "onclick=\"javascript: COSTCO.zipCodeModal.getZipByAddressModal(" + newZip + ");\""; //(not used)
				// Replace first {0} with newly entered zip code	
				var wReplacedParam = msg.replace('{0}', newZip);
				// Replace second {0} with newly entered zip code
				wReplacedParam = wReplacedParam.replace('{0}', newZip);
				// Next replace {1} with js function to open correct modal (not used)
				wReplacedParam = wReplacedParam.replace('{1}', onClickEvent);
				return wReplacedParam;
			},
			extractHostname: function extractHostname(url) {
				var hostname = "";
				try {
					if (url.indexOf("://") > -1) {
						hostname = url.split('/')[2];
					} else {
						hostname = url.split('/')[0];
					}
					hostname = hostname.split(':')[0];
				} catch (e) {
					// TODO: handle exception
				}
				return hostname;
			},
			getBDDelDateCookie: function getBDDelDateCookie() {
				var z = $.cookie('deliveryDateCookie');
				if (z == null || z == '""') {
					z = '';
				}
				return { delDate: z };
			},
			isDelDatePresent: function isDelDatePresent() {
				var bdDeliveryDate = zipCodeModal.getBDDelDateCookie().delDate;
				return bdDeliveryDate != null && bdDeliveryDate != '' && bdDeliveryDate != undefined;
			},
	
			ajaxGetZipByAddress: function ajaxGetZipByAddress(form) {
				//clean error holders
				var errorHolder = $(form).find("[critical-notification-holder]");
				errorHolder.addClass("hidden").removeClass("warning").addClass("critical-notification");
				$('.inline_error').remove();
				//
	
				var addressArray = zipCodeModal.buildShortAddress(form);
				var _dataType = 'json';
				var _data = {};
				var _event = event;
				_data['formdata'] = encodeURIComponent(JSON.stringify(addressArray));
				$('.modal-content').addClass('btn-disabled');
	
				$.ajax({
					url: '/AjaxGetZipByAddress',
					type: 'POST',
					dataType: _dataType,
					data: _data,
					timeout: 30000
				}).done(function (data) {
					// TODO - am refactor!
					var oldZip = $(form).find('#postalId').val(); // REFACTOR tmp solution to keep value placeholder when modal window is closed
					var tmpZip = JSON.parse(data.jsonValidatedAddress).returnedZip;
					var tmpAddress = JSON.parse(data.jsonValidatedAddress).returnedAddress;
					var tmpErrorCode = JSON.parse(data.jsonValidatedAddress).errorCode;
					console.log('Returned data ' + tmpAddress);
					console.log('Returned ZIP ' + tmpZip);
					//if ((tmpErrorCode!=null) && (tmpErrorCode == 'ERR_GROUP1_INVALID_ADDRESS')) { // invalid address error from AjaxGetZipByAddress (empty zip returned)
					if (tmpZip == null || tmpZip == '') {
						errorHolder.removeClass("hidden").find("div").html(messages.ERR_GROUP1_INVALID_ADDRESS).slideDown("fast");
					} else {
						// if non empty zip returned
						$(form).find('#postalId').val(tmpZip);
						$(form).find('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode').val(tmpZip);
						zipCodeModal.setSuccess = zipCodeModal.processSetZipCodeSuccess;
	
						zipCodeModal.submitZipCode(form);
					}
				}).fail(function () {
					// Timeout or error sets verifiedAddress to inputted array
					console.log('Error Calling Verification Service');
					console.log('Verification Address : ' + JSON.stringify(addressArray));
				}).always(function () {
					$('.modal-content').removeClass('btn-disabled');
				});
			},
	
			/*
	     * Returns previously entered zip code depending on the form where zip entry originates from
	     */
			getTypedZipCode: function getTypedZipCode() {
				var tmpZipValue = "";
				var loginZipInput = $('#LogonFormBD #deliveryZipCode');
				// if login page
				if (loginZipInput.length > 0) {
					tmpZipValue = $(loginZipInput).val();
				} else if (zipCodeModal.digit5Zip != null && zipCodeModal.digit5Zip != "") {
					tmpZipValue = zipCodeModal.digit5Zip;
				}
				return tmpZipValue;
			},
	
			/*
	     * Build Address Array from a query selector
	     * Short Address consists of minimal ammount of mandatory attributes for the address verification service call
	     */
			buildShortAddress: function buildShortAddress(form) {
				var addressObject = {};
				var addressArray = [];
				var formID = form.attr("id") == undefined ? '#zip_by_address-modal-modal' : form.attr("id");
				var _addrForm = zipCodeModal.getForm('#' + formID);
	
				// init (prepopulate) zip code value if empty
				if (_addrForm.find('[name=postal]').val() == null || _addrForm.find('[name=postal]').val() == "") {
					if (zipCodeModal.digit5Zip != undefined && zipCodeModal.digit5Zip != null) {
						_addrForm.find('[name=postal]').val(zipCodeModal.digit5Zip);
					}
				}
	
				// Init default country value in case global var (shippingCountries) is ommited
				var countryValue = "";
				if (_addrForm.find('[name=storeId]').val() == "11301") {
					countryValue = "US";
				}
				if (_addrForm.find('[name=storeId]').val() == "11303") {
					countryValue = "CA";
				}
	
				addressObject['line1'] = _addrForm.find('[name=address1]').val();
				addressObject['line2'] = _addrForm.find('[name=address2]').val();
				addressObject['zip'] = _addrForm.find('[name=postal]').val();
				addressObject['country'] = shippingCountries[0] ? shippingCountries[0] : countryValue;
	
				addressArray.push(addressObject);
				return addressArray;
			},
	
			getForm: function getForm(formID) {
				return $(formID);
			},
	
			/**
	  * Invokes the ajax call by submitting the form
	  * @param  {String}    form - submitted form element
	  * @param  {[array]}   params - parameters required for form submission
	  * @param  {[function]} callbackSuccess - the function to be called upon success
	  * @param  {[String]} oldAddy - this is used in delivery page for edit scenario, stores the old addressId
	  * @param  {[String]} newAddy - this is used in delivery page for edit scenario, stores the new addressId
	  * @return {Boolean}
	  */
			ajaxCallFormSubmit: function ajaxCallFormSubmit(form, params, callbackSuccess, oldAddy, newAddy) {
				var postData = form.serializeArray();
				if (sessionStorage.getItem('isGeoApiCalled') !== null) {
					var obj = { name: "deleteBDLocationCookie", value: false };
					postData.push(obj);
				}
	
				if ($('input[name="removeOriginalZipCookie"]').val() && $.cookie('WC_BD_ZIP_ORIGINAL')) {
					var _obj = { name: "removeOriginalZipCookie", value: false };
					postData.push(_obj);
				}
	
				var formURL = form.attr("action") == "javascript:void(0)" ? params[0] : form.attr("action");
				if (params != null && $.type(params[0]) == 'object') {
					$(params[0]).addClass('disabled');
				}
				$.ajax({
					url: formURL,
					type: 'POST',
					data: postData,
					dataType: 'json',
					success: function success(data, textStatus, xhr) {
						if (data.errorCode) {
							if (data.errorCode == 2510) {
								// session timeout
								document.location.href = 'Logoff?URL=ReLogonFormView&storeId=' + wcs.storeId;
								return;
							}
						} else {
	
							if (data.ResidentialStatusMessage === 'Delivery Zip Not Found') {
								var errorHolder = $(form).find("[critical-notification-holder]");
								errorHolder.removeClass("hidden").find("div").html(messages.ERR_INVALID_DELIVERY_ZIP_CODE_MSG).slideDown("fast");
								COSTCO.zipCodeModal.showZipByAddressInlineError();
							} else {
	
								// BD only: Update WC_BD_LOC cookie if ZIP is set/changed
								if (COSTCO.util.isBusinessDelivery() && data.zipCodeBDCookieSet && !sessionStorage.getItem('isGeoApiCalled')) {
									if ($('#isGeocodeService').val() != "true") {
										COSTCO.util.callBingAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP')).then(function () {
											callbackSuccess(data, params, form, newAddy, oldAddy);
										});
									} else {
										COSTCO.util.callGeocodeApiAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP')).then(function () {
											callbackSuccess(data, params, form, newAddy, oldAddy);
										});
									}
								} else {
									COSTCO.util.removeFromSession('isGeoApiCalled');
									callbackSuccess(data, params, form, newAddy, oldAddy);
								}
							}
						}
					},
					error: function error(xhr, textStatus, errorThrown) {
						zipCodeModal.ajaxCallErrorLog(xhr, textStatus, errorThrown, true);
					},
					complete: function complete() {
						if (params != null && $.type(params[0]) == 'object') {
							$(params[0]).removeClass('disabled');
						}
						if (COSTCO.OrderItems !== undefined) {
							COSTCO.OrderItems.init();
							COSTCO.preauthchargesmodal.init();
						}
					}
				});
			},
	
			//Displey alternate inline error messages on getzipbyaddress modal
			showZipByAddressInlineError: function showZipByAddressInlineError() {
				var parentNode = $(".has_inline_error");
				if (parentNode != null) {
					var newDiv = document.createElement("div");
					newDiv.innerHTML = messages.ADDRESS_NOT_IN_DELIVERY_AREA;
					newDiv.className = 'error inline_error';
					parentNode.append(newDiv);
				}
				newDiv.textContent;
			},
	
			//logs error on console
			ajaxCallErrorLog: function ajaxCallErrorLog(xhr, textStatus, errorThrown, printErrorThrown) {
				console.log("Status :: " + xhr.status);
				switch (textStatus) {
					case 'timeout':
						console.log(" timeout with server - ");
						break;
					case 'parsererror':
						console.log(" Parse Error - ");
						break;
					case 'error':
						console.log(" Error - ");
						break;
					case 'abort':
						console.log(" Aborted - ");
						break;
					default:
						console.log(" Unknown error - ");
				}
				if (printErrorThrown == true) {
					console.log(errorThrown);
				}
			},
			/**
	    * Function called to submit the akamai zip code
	    * @param  {String}    finalZipCode - akamai zip code
	   */
			setAkamaiBDZipCode: function setAkamaiBDZipCode(finalZipCode) {
				COSTCO.zipCodeModal.submitSetDeliveryZipcodeForm(finalZipCode, COSTCO.Header.checkIsZipSetByAkamai());
			},
			submitSetDeliveryZipcodeForm: function submitSetDeliveryZipcodeForm(zipCode, insertSetDeliveryZipcodeForm, isCalledFromChangeAddressType) {
				if (insertSetDeliveryZipcodeForm) {
					$('#set-zip-code-parent a[open-flyout]').popover("show");
					if (COSTCO.Header.checkIsZipSetByAkamai()) {
						$('#set-zip-code-parent a[open-flyout]').find("div").css('display', 'none');
					}
				}
				$('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode').val(zipCode);
	
				if (isCalledFromChangeAddressType === true) {
					$('#WC_BusinessDeliveryBrowseForm_FormInput_isInitiatedFromChangeAddressType').val(true);
				}
	
				COSTCO.zipCodeModal.submitZipCode($('#formSetDeliveryZip'));
				if (!COSTCO.Header.checkIsZipSetByAkamai()) {
					$('#set-zip-code-parent a[open-flyout]').popover("hide");
				}
			},
			/**
	    * Function called to show the form to set the zipcode when zipcode set by IP Sniffer
	   */
			showSetZipcode: function showSetZipcode() {
				$('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode').val('');
				$('.get-zip-code-form').removeClass('hidden');
				// Trigger click event to prevent automatic popover closing on mouse out/leave and set focus to input field
				// (jQuery fails here, use vanilla Javascript)
				if (document.querySelectorAll('#set-zip-code-parent a[open-flyout]')[0]) {
					document.querySelectorAll('#set-zip-code-parent a[open-flyout]')[0].click();
				}
				if (document.querySelectorAll('input[name=zipCodeFormDeliveryZipCode]')[0]) {
					document.querySelectorAll('input[name=zipCodeFormDeliveryZipCode]')[0].focus();
				}
				window.digitalDataEvents = window.digitalDataEvents || [];
				digitalDataEvents.push({ ui: "Delivery Location tooltip | change your Delivery Postal Code" });
			},
			/**
	   * Function called to close the tool tip window for IP Sniffer.
	   */
			closeSetZipForm: function closeSetZipForm() {
				//$('.zip_flyout_block').addClass('hidden');
				$('#set-zip-code-parent .popover').addClass('hidden');
				if (COSTCO.Header.checkIsZipSetByAkamai()) {
					// STRY0158461: Force-submit the sniffed ZIP code
					COSTCO.zipCodeModal.forceSubmitZipCode();
				}
				window.digitalDataEvents = window.digitalDataEvents || [];
				digitalDataEvents.push({ ui: "Delivery Location tooltip | Close", defer: true });
			},
			/**
	   * STRY0158461: Function to force-submit the ZIP sniffed by Akamai.
	   */
			forceSubmitZipCode: function forceSubmitZipCode() {
				var zipCode = $('div#set-zip-code-parent #bdzip').text().trim();
				if (zipCode && !COSTCO.Header.checkIsForcedSubmitZipcode()) {
					console.log('Trying to force-submit ZIP code [zipCode=' + zipCode + ']');
					COSTCO.util.setInSession('isForcedSubmitZipcode', true);
					COSTCO.zipCodeModal.submitSetDeliveryZipcodeForm(zipCode);
				}
			},
	
			/**
	   * Displays the new Adress Type modal so that the user sets the address type (if in BD Truck zone)
	   * @param  {String}    form - submitted form element
	   */
			viewAddressTypeModal: function viewAddressTypeModal(form, data, params) {
				var preventClose = COSTCO.Header.checkIsForcedSubmitZipcode();
				COSTCO.dialog.createExtDialogBox({
					title: messages.DELIVERY_OPTIONS,
					body: COSTCO.util.tmpl('tmpl_delivery_address_modal'),
					primary: messages.SET_DELIVERY_METHOD,
					popover: true,
					preventClose: preventClose,
					dialogclasses: 'nd-delivery-method-dialog',
					onshow: function onshow() {
						$('#delivery_address_modal_form').append($('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset'));
						$('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset').remove();
						$('.nd-delivery-method-dialog #costcoModalBtn2').attr("data-bi-tc", "ui:Browse | Choose Delivery Method | Set Delivery Method");
					},
					onshown: function onshown() {
						if (preventClose) {
							$(document).bind('click', COSTCO.zipCodeModal.showErrorOnClickOutsideModal);
						}
					},
					onclose: function onclose() {
						$(document).unbind('click', COSTCO.zipCodeModal.showErrorOnClickOutsideModal);
						$('#nd-zipcode-method-modal-body').append($('#delivery_address_modal_form #nd-zipcode-method-fieldset'));
						$('#delivery_address_modal_form #nd-zipcode-method-fieldset').remove();
					},
					primary_event: function primary_event() {
						if (document.querySelector('input[name="nd-radio-group-input"]:checked') == null) {
							$('.addresstype-setup-notification').removeClass("hidden");
							$('.addresstype-setup-notification').find("div").html(messages.ERR_DELIVERY_METHOD_NOT_SELECTED);
						} else {
							var addresstype = "C";
							if (document.querySelector('input[name="nd-radio-group-input"]:checked') != null) {
								addresstype = document.querySelector('input[name="nd-radio-group-input"]:checked').value;
								$(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedAddressType").val(addresstype);
							}
							window.digitalDataEvents = window.digitalDataEvents || [];
							if (addresstype == 'C') {
								digitalDataEvents.push({
									browseDeliveryMethod: "Local Business Delivery"
								});
							} else if (addresstype == 'R') {
								digitalDataEvents.push({
									browseDeliveryMethod: "National Delivery Method"
								});
							} else if (addresstype == 'P') {
								digitalDataEvents.push({
									browseDeliveryMethod: "Store Delivery Method"
								});
							}
	
							if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE" && addresstype == 'R') {
								COSTCO.zipCodeModal.showModalForResidentialError(data.SetDeliveryZip, form);
							} else if (data.ExternalCarrierChange || data.WarehouseChange) {
								zipCodeModal.buttonClickChange(data.SetDeliveryZip, form, params);
							} else {
								data.ShowAddressTypePopup = null;
								if (data.ZipStatusMessageList != undefined) {
									COSTCO.zipCodeModal.processValidateZipCodeSuccess(data, params, form);
								} else {
									COSTCO.zipCodeModal.submitZipCode(form);
								}
							}
						}
					}
				});
				$('.close').addClass("hidden");
			},
			/**
	  * Displays the new Delivery Method modal so that the user sets the delivery method
	  * @param  {String}    form - submitted form element, data, params, verifiedAddress
	  */
			viewDeliveryMethodModal: function viewDeliveryMethodModal(form, data, params, verifiedAddress) {
				var showQuestionnaireModal = false;
				var isCheckoutFlow = false;
				COSTCO.dialog.createExtDialogBox({
					title: messages.DELIVERY_OPTIONS,
					body: COSTCO.util.tmpl('tmpl_delivery_address_modal'),
					primary: messages.SET_DELIVERY_METHOD,
					popover: true,
					dialogclasses: 'nd-delivery-method-dialog',
					onshow: function onshow() {
						$('#delivery_address_modal_form').append($('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset'));
						$('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset').remove();
						$('.nd-delivery-method-dialog #costcoModalBtn2').attr("data-bi-tc", "ui:Browse | Choose Delivery Method | Set Delivery Method");
						$('.addresstype-setup-notification').addClass("hidden");
						$('.addresstype-setup-notification').find("div").html('');
	
						if (data.isBDTruckZoneEnabledForWareHouse === true) {
							$("#nd-local-delivery-modal-section").removeClass("hidden");
						} else {
							$("#nd-local-delivery-modal-section").addClass("hidden");
						}
	
						if (data.isNationalDeliveryEnabledForWareHouse === true) {
							$("#nd-nationwide-delivery-modal-section").removeClass("hidden");
						} else {
							$("#nd-nationwide-delivery-modal-section").addClass("hidden");
						}
	
						if (data.isStorePickupEnabledForWareHouse === true) {
							$("#store-pickup-modal-section").removeClass("hidden");
						} else {
							$("#store-pickup-modal-section").addClass("hidden");
						}
	
						$('#nd-local-delivery-radio-button').focus();
					},
					onclose: function onclose() {
						$(document).unbind('click', COSTCO.zipCodeModal.showErrorOnClickOutsideModal);
						$('#nd-zipcode-method-modal-body').append($('#delivery_address_modal_form #nd-zipcode-method-fieldset'));
						$('#delivery_address_modal_form #nd-zipcode-method-fieldset').remove();
					},
					primary_event: function primary_event() {
						if (typeof checkoutPage !== 'undefined') {
							if (checkoutPage == 'review' || checkoutPage == 'shipping') {
								isCheckoutFlow = true;
							}
						}
						if (document.querySelector('input[name="nd-radio-group-input"]:checked') == null) {
							$('.addresstype-setup-notification').removeClass("hidden");
							$('.addresstype-setup-notification').find("div").html(messages.ERR_DELIVERY_METHOD_NOT_SELECTED);
	
							var isFocusSet = false;
							if (data.isBDTruckZoneEnabledForWareHouse === true) {
								$('#nd-local-delivery-radio-button').focus();
								isFocusSet = true;
							}
	
							if (data.isNationalDeliveryEnabledForWareHouse === true && isFocusSet == false) {
								$('#nd-nationwide-delivery-radio-button').focus();
								isFocusSet = true;
							}
	
							if (data.isStorePickupEnabledForWareHouse === true && isFocusSet == false) {
								$('#store-pickup-radio-button').focus();
							}
						} else {
							var deliveryMehod;
							if ($('input[name="deliveryMethod"]').length > 0) {
								deliveryMethod = $("input[name='deliveryMethod']:checked").val();
							}
							var selectedDeliveryMethod = 'Local';
							if (document.querySelector('input[name="nd-radio-group-input"]:checked') != null) {
	
								var uiSelectedDeliveryMethod = document.querySelector('input[name="nd-radio-group-input"]:checked').value;
	
								switch (uiSelectedDeliveryMethod) {
									case "C":
										selectedDeliveryMethod = "Local";
										break;
									case "R":
										selectedDeliveryMethod = "Nationwide";
										break;
									case "P":
										selectedDeliveryMethod = "Store-Pick-Up";
										break;
								}
								$(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val(selectedDeliveryMethod);
							}
							window.digitalDataEvents = window.digitalDataEvents || [];
							if (selectedDeliveryMethod === 'Local') {
								digitalDataEvents.push({
									ui: "Delivery Method Modal | Set Delivery Method | Local Business Delivery"
								});
							} else if (selectedDeliveryMethod === 'Nationwide') {
								digitalDataEvents.push({
									ui: "Delivery Method Modal | Set Delivery Method | Nationwide Delivery"
								});
							} else if (selectedDeliveryMethod === 'Store-Pick-up') {
								digitalDataEvents.push({
									ui: "Delivery Method Modal | Set Delivery Method | Pick-Up"
								});
							}
							data.userSelectionDeliveryMethod = selectedDeliveryMethod;
							showQuestionnaireModal = COSTCO.util.isNdEnabled() && selectedDeliveryMethod === 'Local';
							if (showQuestionnaireModal && isCheckoutFlow) {
								COSTCO.CAddressForm.showNationalDeliveryQuestionnaireModal_v2(form, data, params, verifiedAddress);
							} else {
								if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE") {
									COSTCO.zipCodeModal.showModalForResidentialError(data.SetDeliveryZip, form);
								} else if (!isCheckoutFlow && (data.ExternalCarrierChange || data.WarehouseChange)) {
									COSTCO.zipCodeModal.buttonClickChange(data.SetDeliveryZip, form, params, data);
								} else if (isCheckoutFlow && !verifiedAddress) {
									COSTCO.zipCodeModal.buttonClickChange(data.SetDeliveryZip, form, params, data);
								} else if (isCheckoutFlow && (data.ExternalCarrierChange || data.WarehouseChange || data.ShowDeliveryMethodPopup)) {
									COSTCO.zipCodeModal.changeZip_buttonClickChange(data, params, form, verifiedAddress);
								} else {
									data.ShowAddressTypePopup = null;
									if (data.ZipStatusMessageList != undefined) {
										data.StatusMessage = data.ZipStatusMessageList[0];
										COSTCO.zipCodeModal.processValidateZipCodeSuccess(data, params, form);
									} else {
										COSTCO.zipCodeModal.submitZipCode(form);
									}
								}
							}
						}
					}
				});
			},
			validateShowDeliveryMethodModal: function validateShowDeliveryMethodModal(verifiedAddress) {
				return verifiedAddress.showDeliveryModal;
			},
			/**
	   * Displays inline error message in the new Adress Type modal if user try to close it by clicking outside the modal
	   * @param  event - Mouse click or keyboard press event
	   */
			showErrorOnClickOutsideModal: function showErrorOnClickOutsideModal(event) {
				if ($(event.target).parents('.modal-content').length == 0) {
					$('.addresstype-setup-notification').removeClass("hidden");
					$('.addresstype-setup-notification').find("div").html(messages.ERR_DELIVERY_METHOD_NOT_SELECTED);
				}
			},
			showModalForResidentialError: function showModalForResidentialError(zipCode, form) {
				COSTCO.dialog.close();
				$(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val("");
				if (COSTCO.Header.checkIsZipSetByAkamai() && COSTCO.Header.checkIsForcedSubmitZipcode()) {
					// This part of code is entered during forced-submit, when Akamai sniffed the ZIP where BDTRUCKZONE=1 and NDFFMWHS=null,
					// and the user chose Residential Address
					COSTCO.util.removeFromSession("isZipSetByAkamai");
					COSTCO.util.removeFromSession('isForcedSubmitZipcode');
					$('div#set-zip-code-parent #bdzip').text('');
					$('div#set-zip-code-parent .zip-exists').addClass('hidden');
					$('div#set-zip-code-parent .zip-not-exists').removeClass('hidden');
					$('#set-zip-code-parent .popover').removeClass('hidden');
					$('#set-zip-code-parent a[open-flyout]').popover('show');
				} else if (COSTCO.Header.checkIsZipSetByAkamai()) {
					$('#set-zip-code-parent a[open-flyout]').find("div").css('display', 'block');
					COSTCO.util.removeFromSession("isZipSetByAkamai");
				} else {
					if ($(form).attr('id') != "formProductDetails") {
						$('#set-zip-code-parent a[open-flyout]').popover("show");
					}
				}
				$('.get-zip-code-form').removeClass('hidden');
				$('.zip-setup-notification').removeClass("hidden");
				$('.zip-setup-notification').find("div").html(messages.ERR_RESIDENTIAL_NOT_SERVICED_MSG);
				$('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode').val(zipCode);
			},
			handleRadioButtonClick: function handleRadioButtonClick(element) {
				$('#costcoModalBtn2').removeClass('btn-disabled');
			},
			changeAddressType: function changeAddressType() {
				var zipcode = COSTCO.util.getBDZipCookie().zipCode;
	
				COSTCO.zipCodeModal.submitSetDeliveryZipcodeForm(zipcode, true, true);
			}
		};
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.zipCodeModal = zipCodeModal;
		return zipCodeModal;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 82:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title ziphelper.js: helper methods
	 * @description This module contains helper methods 
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
		var ziphelper = {
	
			setLocationCookie: function setLocationCookie(locationVal) {
				$.cookie('C_LOC', locationVal);
			},
	
			setZipCookie: function setZipCookie(zipVal) {
				$.cookie('WC_BD_ZIP', zipVal);
			},
	
			fmtZipOnEnter: function fmtZipOnEnter(element, event) {
				var charCode;
				if (event && event.which) {
					charCode = event.which;
				} else if (window.event) {
					event = window.event;
					charCode = event.keyCode;
				}
				if (charCode == 13) {
					// Do your thing here with element
					zipCode = ziphelper.formatZipCode(element.value);
					document.getElementById(element.id).value = zipCode;
				}
			},
	
			fmtZipKeyUp: function fmtZipKeyUp(element, event) {
				var form = $(event.target).closest('form');
				var isValid = form.valid();
				if (isValid == false) {
					var errorHolder = form.find("[critical-notification-holder]");
					errorHolder.addClass("hidden");
				}
			},
	
			formatZipCode: function formatZipCode(zipCode) {
				var fomatedZipcode = zipCode;
				if ($('#zipFormatterFlag')) {
					var formatFlag = document.getElementById("zipFormatterFlag").getAttribute("value");
					if (formatFlag == 'true') {
						fomatedZipcode = zipCode.split(' ').join('');
						fomatedZipcode = fomatedZipcode.toUpperCase();
						fomatedZipcode = fomatedZipcode.replace(/^(.{3})(.*)$/, "$1 $2");
					}
				}
				return fomatedZipcode.length > 10 ? zipCode : fomatedZipcode;
			}
	
		};
		// Expose ziphelper to the global scope.
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.ziphelper = ziphelper;
	
		return ziphelper;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 83:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title navigation_v2.js: Feature level module
	 * @description The module used for redesigned 'navigation'
	 * feature which encapsulates 'navigation'.
	 * 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	  var Navigation_v2 = {
	
	    maxLevel: 4,
	    maxPhoneLevel: 3,
	    navigationData: '#navigation_v2_data',
	    navigationUI: '#navigation-v2-category-container',
	    navigationPhoneUI: '#navigation-v2-category-container-phone',
	    navigationCategoryLevel: '.navigation-category-level',
	    level: '#level',
	    level1_AllDepartments: '#level1-all-departments',
	    level1_AncillaryDepartments: '#level1-ancillary-departments',
	    level2_AllDepartments: '#level2-all-departments',
	    level2_AncillaryDepartments: '#level2-ancillary-departments',
	    navigationContainerPhone: '#navigation-v2-category-container-phone',
	    menuIconDesktop: '#navigation-dropdown',
	    nextFocusElementClosedMenu: '#Home_Ancillary_0',
	    menuIconMobile: '#shop-mt-mobile',
	    firstSubcategoryElement: '',
	    lastSubcategoryElement: '',
	    lastAllDepartmentsElementTablet: '',
	    allDepartmentsParentId: '',
	    closeMenuButtonHTML: '<li class="cds-u-space-pb-md"><a id="close-menu-button" href="#"><input type="button" class="btn btn-primary" value="' + messages.CLOSE_MENU + '"/></a></li>',
	    KEYCODES: {
	      TAB_KEY: 9,
	      ESC_KEY: 27,
	      ENTER_KEY: 13,
	      RIGHT_ARROW_KEY: 39,
	      KEYDOWN_EVENT: 1
	    },
	    tempFragment: document.createDocumentFragment(),
	
	    init: function init() {
	      Navigation_v2.$navigationWidgetEle = $('#navigation-widget');
	      var $navigationDataEle = $('#navigation_v2_data');
	      Navigation_v2.$navigationDataUL = $($navigationDataEle.prop('nodeName') === 'NOSCRIPT' ? $navigationDataEle.text() : $navigationDataEle.html());
	
	      if (Navigation_v2.$navigationWidgetEle.length > 0) {
	        Navigation_v2.initializeMegaMenuForDesktopView();
	        Navigation_v2.initializeMegaMenuForMobileView();
	        Navigation_v2.setMegaMenuOverlay();
	        Navigation_v2.bindMegaMenuFocusEvents();
	
	        //populate navigation data with category-level-2 and category level-3 links from corresponding espots
	        Navigation_v2.$navigationDataUL.find('[data-parent="0"]').each(function () {
	          var topCategoryId = $(this).attr('data-id');
	          var $espotParentEle = Navigation_v2.$navigationDataUL.find('[data-espot-parent="' + topCategoryId + '"]');
	          if ($espotParentEle.find('.category-level-2').length !== 0) {
	            Navigation_v2.populateNavigationDataWithEspotSubcategoryLinks(topCategoryId);
	          }
	        });
	
	        //extracting ancillary subcategory links from espots for phone view
	        if (Navigation_v2.isPhoneView()) {
	          $('#level2-phone').empty();
	          $('#level3-phone').empty();
	          Navigation_v2.$navigationDataUL.find('[data-parent="ancillary_0"]').each(function () {
	            var topCategoryId = $(this).attr('data-id');
	            Navigation_v2.populateAncillaryNavigationDataWithEspotSubcategoryLinks(topCategoryId);
	          });
	        }
	
	        // append extracted all subcategory links from espots at once to the parent <ul></ul>
	        if (Navigation_v2.tempFragment.childNodes.length) {
	          Navigation_v2.$navigationDataUL.append(Navigation_v2.tempFragment);
	          $('#navigation_v2_data').empty().append(Navigation_v2.$navigationDataUL);
	        }
	
	        if ($('#isBDAppVar').val() == 'BD') {
	          Navigation_v2.nextFocusElementClosedMenu = '#Home_Ancillary_1';
	        }
	
	        // Nav popovers are required for Ancillary links that are part #navigation-widget which is shown only when VW is greater than 1024px
	        // Hence we do not need to initialize nav popovers for phone and tablet view
	        if (!Navigation_v2.isPhoneView() && !Navigation_v2.isTabletView()) {
	          Navigation_v2.initNavPopovers();
	        }
	
	        console.log("navigation_v2.js module loaded.");
	      }
	    },
	
	    /**
	     *  This method is called on each tab key and (shift + tab) key press when menu icon is focused or
	     *  when focus is on navigation panel. Method switch focus by defined rules for Desktop
	     *  and Tablet view.
	     *
	     *  @param event
	     *
	     * */
	    navigationFocusControl: function navigationFocusControl(event) {
	      var level = Navigation_v2.checkAndSetLevelFirstAndLastElement();
	      var firstSubcategoryElement = Navigation_v2.firstSubcategoryElement;
	      var lastSubcategoryElement = Navigation_v2.lastSubcategoryElement;
	      var menuIconDesktop = Navigation_v2.menuIconDesktop;
	      var nextFocusElementClosedMenu = Navigation_v2.nextFocusElementClosedMenu;
	
	      // Shift + tab combination returns focus and check if first category link is selected
	      // if it is first level it focus the 'shop all departments' button on other return focus parent category
	      // and closes the higher level.
	      if (event.shiftKey) {
	        if (event.keyCode === Navigation_v2.KEYCODES.TAB_KEY) {
	          if ($(document.activeElement).is(firstSubcategoryElement)) {
	            event.preventDefault();
	            if (level === 1) {
	              //This is needed because we dont want to trigger extra shift + tab event which is already getting fired from react Mui component
	              isEventFromReact = Array.from(event.target.classList).some(function (className) {
	                return className.startsWith('Mui');
	              });
	              if (!isEventFromReact) {
	                if (Navigation_v2.isTabletView()) {
	                  $(Navigation_v2.menuIconMobile).focus();
	                  Navigation_v2.hideOverlayAndCloseMenu(false);
	                } else {
	                  $(menuIconDesktop).focus();
	                }
	              }
	            } else if (level === 2 || level === 3) {
	              Navigation_v2.selectSubcategoryParentLink(Navigation_v2.returnParentCategoryId(firstSubcategoryElement, "firstElement"));
	            }
	          }
	        }
	      } else if (event.keyCode === Navigation_v2.KEYCODES.TAB_KEY) {
	        // Tab key set focus on next element. If it is last element on first level it closes the menu and shift focus to
	        // grocery link. On higher levels when focus reach last element next tab will shift focus to the next element
	        // below parent category and will close the higher level.
	
	        if ($(document.activeElement).is(lastSubcategoryElement)) {
	          //prevent default doesnt let it focus correctly on espots when Mega menu react component is used
	          // but we also want to prevent default if we are are on level 1
	          if (!isGRSMegaMenuEnabled || level === 1) {
	            event.preventDefault();
	          }
	          if (level === 1) {
	            Navigation_v2.hideOverlayAndCloseMenu(false);
	            $(nextFocusElementClosedMenu).focus();
	          } else if (level === 2 || level === 3) {
	            $($('#' + Navigation_v2.returnParentCategoryId(lastSubcategoryElement, "lastElement"))).next().find('a').focus();
	          }
	        }
	      }
	    },
	
	    /**
	     *  This method check what level is currently active and set first and last element
	     *  appropriately. Used for desktop and tabled view.
	     *
	     *  Sets Navigation_v2 variables firstSubcategoryElement and lastSubcategoryElement.
	     *
	     *  @return number of level currently active
	     * 
	     * */
	    checkAndSetLevelFirstAndLastElement: function checkAndSetLevelFirstAndLastElement() {
	      var level = 0;
	      var levelSelector = '';
	      // We check what level is current focus on so we can select proper first and last elements
	      // that are used as starting and ending point for focus switching.
	      if ($('#level1-all-departments').is(':visible') && $('#level2').is(':hidden') && $('#level3').is(':hidden')) {
	        // For first level there are ancillary elements too so we need to use level1-phone and not
	        // level1-all-departments-phone since it holds only category elements.
	        if (Navigation_v2.isTabletView()) {
	          levelSelector = '#level1';
	        } else {
	          levelSelector = '#level1-all-departments';
	        }
	
	        level = 1;
	      } else if ($('#level2').is(':visible') && $('#level3').is(':hidden')) {
	        levelSelector = '#level2';
	        level = 2;
	      } else if ($('#level3').is(':visible')) {
	        levelSelector = '#level3';
	        level = 3;
	      }
	
	      Navigation_v2.firstSubcategoryElement = $(levelSelector).find('li a').first();
	      Navigation_v2.lastSubcategoryElement = $(levelSelector).find('li').last();
	
	      if (Navigation_v2.categoryHasChildData(Navigation_v2.lastSubcategoryElement.attr('id'))) {
	        Navigation_v2.lastSubcategoryElement = $('#arrow-' + Navigation_v2.lastSubcategoryElement.attr('id'));
	      } else {
	        Navigation_v2.lastSubcategoryElement = $(Navigation_v2.lastSubcategoryElement.find('a'));
	      }
	
	      return level;
	    },
	
	    returnParentCategoryId: function returnParentCategoryId(element, elementPosition) {
	      return elementPosition === "firstElement" ? $(element).parent().parent().attr('data-parent') : $(element).parent().attr('data-parent');
	    },
	
	    /**
	     *  This method is called on each tab and (shift + tab) key press when menu icon is focused or
	     *  when focus is on navigation panel. Method switch focus by defined rules for Phone view.
	     *
	     *  @param event
	     * 
	     * */
	    navigationFocusControlPhone: function navigationFocusControlPhone(event) {
	      var level = Navigation_v2.checkAndSetLevelFirstAndLastElementPhone();
	      var firstSubcategoryElement = Navigation_v2.firstSubcategoryElement;
	      var lastSubcategoryElement = Navigation_v2.lastSubcategoryElement;
	      var backToParentCategoryButton = $('#level1-phone').children('li').eq(1);
	      var backToAllCategoriesButton = $('#level1-phone').find('li').first();
	      var nextFocusElementClosedMenu = Navigation_v2.nextFocusElementClosedMenu;
	      var navigationContainerPhone = $(Navigation_v2.navigationContainerPhone).is(':visible');
	
	      $(Navigation_v2.menuIconMobile).attr('aria-expanded', 'true');
	      if (event.shiftKey) {
	        if (event.keyCode === Navigation_v2.KEYCODES.TAB_KEY) {
	          // This is executes when shift + tab combination is pressed.
	          // First should check if it is first element in subcategory is selected.
	          if ($(document.activeElement).is(firstSubcategoryElement)) {
	            // On first level there is no back buttons(links) so focus should go to menu icon.
	            if (level === 1) {
	              event.preventDefault();
	              Navigation_v2.hideOverlayAndCloseMenu(true);
	              Navigation_v2.setFocusOnMenuIcon();
	            } else if (level === 2) {
	              // On second level there is only back to all categories button(link) so focus should go
	              //to 'back to all categories button'
	              event.preventDefault();
	              backToAllCategoriesButton.focus();
	            } else if (level === 3) {
	              // On third level there are 'back to all categories button' and 'back to parent category button'
	              // so focus should go to first of those two which is 'back to parent category button'.
	              event.preventDefault();
	              backToParentCategoryButton.focus();
	            }
	          } else if ($(document.activeElement).is(backToAllCategoriesButton)) {
	            // If focus is not on first category element then we check if it is on
	            // 'back to all categories button' or 'back to parent category button' if it is level 3.
	            event.preventDefault();
	            Navigation_v2.setFocusOnMenuIcon();
	          } else if (level === 3) {
	            if ($(document.activeElement).is(backToParentCategoryButton)) {
	              event.preventDefault();
	              backToAllCategoriesButton.focus();
	            }
	          }
	        }
	      } else if (event.keyCode === Navigation_v2.KEYCODES.TAB_KEY) {
	        // This executes on Tab keypress
	        if ($(document.activeElement).is(lastSubcategoryElement) || $(document.activeElement).is($(Navigation_v2.menuIconMobile)) && navigationContainerPhone == true) {
	          // Condition cover case scenario where menu is already open but focus is on last element or on menu icon in both cases
	          event.preventDefault();
	          // If level is first then we select first link since on first level there is no back to all categories button
	          if (level === 1) {
	            Navigation_v2.hideOverlayAndCloseMenu(false);
	            $(nextFocusElementClosedMenu).focus();
	          } else {
	            backToAllCategoriesButton.focus();
	          }
	        } else if (level === 3) {
	          // If level is third one and none of the above cases is met focus is
	          // set manually from 'back to all categories button' to 'back to parent category button'
	          // Also if 'back to parent category button' is focused then we need to move focus to 'first subcategory element'.
	          if ($(document.activeElement).is(backToAllCategoriesButton)) {
	            event.preventDefault();
	            backToParentCategoryButton.focus();
	          } else if ($(document.activeElement).is(backToParentCategoryButton)) {
	            event.preventDefault();
	            $(firstSubcategoryElement).focus();
	          }
	        }
	      }
	    },
	
	    setFocusOnMenuIcon: function setFocusOnMenuIcon() {
	      $(Navigation_v2.menuIconMobile).focus();
	    },
	
	    /**
	     *  This method check what level is currently active and set first and last element
	     *  appropriately. Used for phone view.
	     *
	     *  Sets Navigation_v2 variables firstSubcategoryElement and lastSubcategoryElement.
	     *
	     *  @return number of level currently active
	     *
	     * */
	    checkAndSetLevelFirstAndLastElementPhone: function checkAndSetLevelFirstAndLastElementPhone() {
	      var level = 0;
	      var levelSelector = '';
	      // We check what level is current focus on so we can select proper first and last elements
	      // that are used as starting and ending point for focus switching.
	      if ($('#level1-all-departments-phone').is(':visible')) {
	        // For first level there are ancillary elements too so we need to use level1-phone and not
	        // level1-all-departments-phone since it holds only category elements.
	        levelSelector = '#level1-phone';
	        level = 1;
	      } else if ($('#level2-phone').is(':visible')) {
	        levelSelector = '#level2-phone';
	        level = 2;
	      } else if ($('#level3-phone').is(':visible')) {
	        levelSelector = '#level3-phone';
	        level = 3;
	      }
	
	      if (levelSelector == '#level1-phone') {
	        Navigation_v2.firstSubcategoryElement = $('#level1-all-departments-phone').find('li a').first();
	      } else {
	        Navigation_v2.firstSubcategoryElement = $(levelSelector).find('a').first();
	      }
	
	      Navigation_v2.lastSubcategoryElement = $(levelSelector).find('li a').last();
	
	      return level;
	    },
	
	    bindMegaMenuFocusEvents: function bindMegaMenuFocusEvents() {
	
	      if (Navigation_v2.isTabletView() || Navigation_v2.isPhoneView()) {
	        Navigation_v2.nextFocusElementClosedMenu = '#search-field';
	      }
	
	      $('#navigation-v2-category-container,' + Navigation_v2.menuIconDesktop + ', ' + Navigation_v2.menuIconMobile).keydown(function (event) {
	        // If we don't check if navigation container is visible then focus
	        // will stop on menu icon when container is closed.
	        if (event.which === Navigation_v2.KEYCODES.TAB_KEY && $('#navigation-v2-category-container').is(':visible')) {
	          COSTCO.Navigation_v2.navigationFocusControl(event);
	        }
	      });
	
	      $('#navigation-v2-category-container-phone,' + Navigation_v2.menuIconMobile).keydown(function (event) {
	        // If we don't check if navigation container is visible then focus
	        // will stop on menu icon when container is closed.
	        if (event.which === Navigation_v2.KEYCODES.TAB_KEY && $('#navigation-v2-category-container-phone').is(':visible')) {
	          if (COSTCO.Navigation_v2.isPhoneView()) {
	            COSTCO.Navigation_v2.navigationFocusControlPhone(event);
	          }
	        }
	      });
	
	      $("#level1-ancillary-departments-phone").click(function () {
	        window.scrollTo({ top: 0, behavior: "smooth" });
	      });
	    },
	
	    initializeMegaMenuForDesktopView: function initializeMegaMenuForDesktopView() {
	      $(Navigation_v2.menuIconDesktop).on('keydown click', function (event) {
	        // Key down event for Enter key
	        if (event.which === Navigation_v2.KEYCODES.ENTER_KEY) {
	          event.preventDefault();
	        }
	        if ((event.which === Navigation_v2.KEYCODES.ENTER_KEY || event.which === Navigation_v2.KEYCODES.KEYDOWN_EVENT) && event.which !== Navigation_v2.KEYCODES.TAB_KEY) {
	          Navigation_v2.toggleNavigation(false, event);
	          $(Navigation_v2.menuIconDesktop).attr('aria-expanded', 'true');
	        }
	      });
	      $(Navigation_v2.menuIconDesktop).on('focus', function (event) {
	        Navigation_v2.hideOverlayAndCloseMenu(false);
	      });
	      $(Navigation_v2.menuIconDesktop).on('mouseenter', function (event) {
	        if (typeof isJQueryUpgraded != 'undefined' && isJQueryUpgraded) {
	          if (event.target.id.length > 0) {
	            Navigation_v2.menuIconDesktopMouseEnterDef(event);
	          }
	        } else {
	          Navigation_v2.menuIconDesktopMouseEnterDef(event);
	        }
	      }).on('mouseleave', function (event) {
	        if (typeof isJQueryUpgraded != 'undefined' && isJQueryUpgraded) {
	          if (event.target.id.length > 0) {
	            Navigation_v2.menuIconDesktopMouseLeaveDef(event);
	          }
	        } else {
	          Navigation_v2.menuIconDesktopMouseLeaveDef(event);
	        }
	      });
	    },
	
	    menuIconDesktopMouseLeaveDef: function menuIconDesktopMouseLeaveDef(event) {
	      var timerId = $('#' + event.target.id).data('timerId');
	      if (timerId != null) {
	        clearTimeout(timerId);
	      }
	    },
	
	    menuIconDesktopMouseEnterDef: function menuIconDesktopMouseEnterDef(event) {
	      var hoveredElement = $('#' + event.target.id);
	      var timer = setTimeout(function () {
	        hoveredElement.data('timerId', null);
	        if (hoveredElement.attr('id') !== undefined && hoveredElement.attr('id') !== false) {
	          Navigation_v2.toggleNavigation(false, event);
	          $(Navigation_v2.menuIconDesktop).attr('aria-expanded', 'true');
	        }
	        Navigation_v2.toggleSubCategoryElements(false);
	      }, 300);
	      hoveredElement.data('timerId', timer);
	    },
	
	    initializeMegaMenuForMobileView: function initializeMegaMenuForMobileView() {
	      $(Navigation_v2.menuIconMobile).attr('aria-expanded', 'false');
	      $(Navigation_v2.menuIconMobile).on('click', function (event) {
	        if (Navigation_v2.isPhoneView()) {
	          Navigation_v2.toggleNavigation(true, event);
	        } else {
	          Navigation_v2.toggleNavigation(false, event);
	        }
	      });
	    },
	
	    setMegaMenuOverlay: function setMegaMenuOverlay() {
	      if (Navigation_v2.isPhoneView()) {
	        $(document.documentElement).on('touchstart mousedown', function (e) {
	          var userDropdownArea = $(Navigation_v2.menuIconMobile + ", " + Navigation_v2.navigationPhoneUI);
	          var target = $(e.target);
	          if (!userDropdownArea.is(target) && userDropdownArea.has(target).length === 0) {
	            Navigation_v2.hideOverlayAndCloseMenu(true);
	          }
	        });
	      } else {
	        $(document.documentElement).on('mousedown', function (e) {
	          var userDropdownArea = $("#navigation-dropdown, .navigation-category-level, .navigation");
	          var target = $(e.target);
	          if (!userDropdownArea.is(target) && userDropdownArea.has(target).length === 0) {
	            Navigation_v2.hideOverlayAndCloseMenu(false);
	          }
	        });
	
	        $('.nav-item:not(#navigation-dropdown), .top-links', Navigation_v2.$navigationWidgetEle.add('#header-widget')).on('mouseenter', function (event) {
	          var hoveredElement = $(event.target);
	          var timer = setTimeout(function () {
	            hoveredElement.data('timerId', null);
	            if (hoveredElement !== undefined && hoveredElement !== false) {
	              Navigation_v2.hideOverlayAndCloseMenu(false);
	            }
	          }, 500);
	          hoveredElement.data('timerId', timer);
	        }).on('mouseleave', function (event) {
	          var timerId = $(event.target).data('timerId');
	          if (timerId != null) {
	            clearTimeout(timerId);
	          }
	        });
	      }
	    },
	
	    isPhoneView: function isPhoneView() {
	      return $(window).width() <= 667;
	    },
	
	    isTabletView: function isTabletView() {
	      return $(window).width() <= 1024 && !Navigation_v2.isPhoneView();
	    },
	
	    toggleNavigation: function toggleNavigation(isPhone, event) {
	
	      event.preventDefault();
	      var elementPanel = isPhone ? Navigation_v2.navigationPhoneUI : Navigation_v2.navigationUI;
	      if (isGRSMegaMenuEnabled) {
	        $(elementPanel).children().first().children().css('display', '');
	      }
	      if ($(elementPanel).is(':visible')) {
	        Navigation_v2.hideOverlayAndCloseMenu(isPhone);
	      } else {
	        Navigation_v2.fillTopCategoryData(isPhone);
	        if (isPhone) {
	          Navigation_v2.bindPhoneChildCategories(1);
	        } else {
	          Navigation_v2.bindChildCategories(1);
	        }
	        Navigation_v2.showOverlayWhenMenuDisplayed();
	        Navigation_v2.toggleSubCategoryElements(isPhone);
	        $(elementPanel).show();
	        if (event.which === Navigation_v2.KEYCODES.ENTER_KEY || event.which === Navigation_v2.KEYCODES.KEYDOWN_EVENT) {
	          if ($(event.target).is('#navigation-dropdown')) {
	            Navigation_v2.selectFirstElementInCategory(1, false);
	          } else if ($(event.target).is('#shop-mt-mobile')) {
	            $(Navigation_v2.menuIconMobile).attr('aria-expanded', 'true');
	            if (Navigation_v2.isPhoneView()) {
	              Navigation_v2.selectFirstElementInCategory(1, true);
	            } else {
	              Navigation_v2.selectFirstElementInCategory(1, false);
	            }
	          }
	        }
	      }
	    },
	
	    selectFirstElementInCategory: function selectFirstElementInCategory(level, isPhone) {
	      var phoneSufix = isPhone ? '-phone' : '';
	      if (isPhone) {
	        $(Navigation_v2.level + level + phoneSufix).find('li a').first().focus();
	      } else {
	        $(Navigation_v2.level + level).find('li a').first().focus();
	      }
	    },
	
	    selectSubcategoryParentLink: function selectSubcategoryParentLink(parentId) {
	      $('#' + parentId + ' a').focus();
	    },
	
	    fillTopCategoryData: function fillTopCategoryData(isPhone) {
	      var phoneSufix = isPhone ? '-phone' : '';
	      var allDepartmentsParentData = Navigation_v2.$navigationDataUL.find('[data-parent="0"]').clone();
	      Navigation_v2.addIdAttributeToElements(allDepartmentsParentData);
	
	      var ancillaryDepartmentsData = wcs.isPharmacy === "true" ? Navigation_v2.$navigationDataUL.find('[data-parent="ancillary_0"][data-id^="RX_Home_Ancillary"]').clone() : Navigation_v2.$navigationDataUL.find('[data-parent="ancillary_0"][data-id^="Home_Ancillary"]').clone();
	
	      Navigation_v2.addIdAttributeToElements(ancillaryDepartmentsData);
	
	      $(Navigation_v2.level1_AllDepartments + phoneSufix).find('ul').append(allDepartmentsParentData);
	      $(Navigation_v2.level1_AncillaryDepartments + phoneSufix).append(ancillaryDepartmentsData);
	
	      if (isPhone) {
	        $(Navigation_v2.level1_AllDepartments + phoneSufix).each(function () {
	          $(Navigation_v2.level1_AllDepartments + phoneSufix + ' a').removeAttr('href');
	        });
	        $(Navigation_v2.level1_AncillaryDepartments + phoneSufix + ' li').each(function () {
	          var parentLiElementId = $(this).attr('data-id') !== undefined && $(this).attr('data-id') !== false ? $(this).attr('data-id') : $(this).attr('id');
	          if (Navigation_v2.categoryHasChildData(parentLiElementId)) {
	            $(this).find('a').each(function () {
	              $(this).removeAttr('href');
	            });
	          }
	        });
	      }
	    },
	
	    addIdAttributeToElements: function addIdAttributeToElements(elements) {
	      elements.each(function () {
	        var dataIdAttribute = $(this).attr('data-id');
	        $(this).attr('id', dataIdAttribute);
	        $(this).removeAttr('data-id');
	      });
	    },
	
	    bindChildCategories: function bindChildCategories(level) {
	
	      if (Navigation_v2.isTabletView()) {
	        if ($('#level1-ancillary-departments').find('#close-menu-button').length === 0) {
	          $('#level1-ancillary-departments').append(Navigation_v2.closeMenuButtonHTML);
	        }
	        Navigation_v2.bindCloseMenuEvent(false);
	      }
	
	      $(Navigation_v2.level + level + ' li').hover(function (event) {
	        return Navigation_v2.bindChildElementOnHover(event, level);
	      }, function (event) {
	        return Navigation_v2.unbindChildElementOnHover(event);
	      });
	
	      $(Navigation_v2.level + level + ' li a').on('focus', function (event) {
	        if ($(event.target.parentElement).attr('id') !== undefined && $(event.target.parentElement).attr('id') !== false) {
	          Navigation_v2.emptySubCategoryElements(level + 1, false);
	          Navigation_v2.bindChildElementOnKeyboardNavigation(event, level);
	          Navigation_v2.toggleSubCategoryElements(false);
	        } else if ($(event.target.parentElement).attr('data-id') !== undefined && $(event.target.parentElement).attr('data-id') !== false) {
	          var dataParentId = $(event.target.parentElement).attr('data-id');
	          $(Navigation_v2.level + level).find('li[data-parent="' + dataParentId + '"]').each(function () {
	            $(this).removeClass('selectedLinkBold');
	          });
	        }
	      });
	    },
	
	    bindChildElementOnHover: function bindChildElementOnHover(event, level) {
	      if (typeof isJQueryUpgraded != 'undefined' && isJQueryUpgraded) {
	        if (event.target.id.length > 0) {
	          Navigation_v2.bindChildElementOnHoverDef(event, level);
	        }
	      } else {
	        Navigation_v2.bindChildElementOnHoverDef(event, level);
	      }
	    },
	
	    bindChildElementOnHoverDef: function bindChildElementOnHoverDef(event, level) {
	      var hoveredElement = $('#' + event.target.id);
	      var hoveredElementId = event.target.id;
	      var parentId = hoveredElement.attr('data-parent');
	      var isAncillary = Navigation_v2.isAncillaryElementSelected(hoveredElementId);
	
	      Navigation_v2.keepParentLinksHighlighted(level, hoveredElement.attr('id'));
	      Navigation_v2.removeChevronFromAllLinks();
	
	      if (level < Navigation_v2.maxLevel - 1) {
	        if (isGRSMegaMenuEnabled && level == 2) {
	          //skip the execution of below block if this condition is met
	          //we dont want to fill empty subcategories because they are now coming from react component.
	        } else {
	          var timer = setTimeout(function () {
	            hoveredElement.data('timerId', null);
	            if (hoveredElement.attr('id') !== undefined && hoveredElement.attr('id') !== false) {
	              Navigation_v2.fillChildData(level + 1, hoveredElement.attr('id'), isAncillary);
	            }
	            Navigation_v2.toggleSubCategoryElements(false);
	          }, 300);
	          hoveredElement.data('timerId', timer);
	        }
	      }
	    },
	
	    unbindChildElementOnHover: function unbindChildElementOnHover(event) {
	      if (typeof isJQueryUpgraded != 'undefined' && isJQueryUpgraded) {
	        if (event.target.id.length > 0) {
	          Navigation_v2.unbindChildElementOnHoverDef(event);
	        }
	      } else {
	        Navigation_v2.unbindChildElementOnHoverDef(event);
	      }
	    },
	
	    unbindChildElementOnHoverDef: function unbindChildElementOnHoverDef(event) {
	      var timerId = $('#' + event.target.id).data('timerId');
	      if (timerId != null) {
	        clearTimeout(timerId);
	      }
	    },
	
	    bindChildElementOnClick: function bindChildElementOnClick(event, level) {
	      if (event.which === Navigation_v2.KEYCODES.ENTER_KEY || event.type == 'click') {
	        if (typeof isJQueryUpgraded != 'undefined' && isJQueryUpgraded) {
	          if (event.target.id.length > 0) {
	            Navigation_v2.bindChildElementOnClickDef(event, level);
	          }
	        } else {
	          Navigation_v2.bindChildElementOnClickDef(event, level);
	        }
	      }
	    },
	
	    bindChildElementOnClickDef: function bindChildElementOnClickDef(event, level) {
	      var clickedElement = $('#' + event.target.id);
	      var clickedElementId = event.target.id;
	      var parentId = clickedElement.attr('data-parent');
	      var isAncillary = Navigation_v2.isAncillaryElementSelected(clickedElementId);
	
	      Navigation_v2.keepParentLinksHighlighted(level, clickedElement.attr('id'));
	      Navigation_v2.removeChevronFromAllLinks();
	
	      if (level < Navigation_v2.maxLevel - 1) {
	        if (clickedElement.attr('id') !== undefined && clickedElement.attr('id') !== false) {
	          Navigation_v2.fillChildData(level + 1, clickedElement.attr('id'), isAncillary);
	        }
	
	        clickedElement.find('a').attr('aria-expanded', 'true');
	
	        Navigation_v2.toggleSubCategoryElements(false);
	      }
	    },
	
	    bindChildElementOnKeyboardNavigation: function bindChildElementOnKeyboardNavigation(event, level) {
	      var parentLiElement = $(event.target.parentElement);
	      var parentLiElementId = parentLiElement.attr('data-id') !== undefined && parentLiElement.attr('data-id') !== false ? parentLiElement.attr('data-id') : parentLiElement.attr('id');
	      var parentId = parentLiElement.attr('data-parent');
	      var isAncillary = Navigation_v2.isAncillaryElementSelected(parentLiElementId);
	
	      Navigation_v2.keepParentLinksHighlighted(level, parentLiElementId);
	      Navigation_v2.removeChevronFromAllLinks();
	
	      if (isGRSMegaMenuEnabled || Navigation_v2.categoryHasChildData(parentLiElementId)) {
	        Navigation_v2.addChevronForSelectedLink(parentLiElement);
	      }
	
	      $(Navigation_v2.level + level + ' li  a, li  i').on('click keydown', function (event) {
	        var parentLiElementId = $(event.target).is('a') || $(event.target).is('i') ? $(event.target.parentElement).attr('id') : $(event.target.parentElement.parentElement).attr('id');
	        var categoryParentId = $('#' + parentLiElementId).attr('data-parent');
	        if (event.which === Navigation_v2.KEYCODES.ESC_KEY) {
	          Navigation_v2.closeMenuLevelPanelOnEcs(categoryParentId, level);
	        } else if ($(event.target).is('a') && event.which === Navigation_v2.KEYCODES.RIGHT_ARROW_KEY) {
	          Navigation_v2.openSubcategoryOnRightArrow(parentLiElementId, level, isAncillary);
	          $('#' + parentLiElementId).find('a').attr('aria-expanded', 'true');
	          if (isGRSMegaMenuEnabled) {
	            // Accessibility feature - fetch subcategories for the selected top category from the react component.
	            var topLevelCategory = void 0;
	            if (event.target.nextElementSibling) {
	              topLevelCategory = event.target.nextElementSibling.parentElement;
	            }
	            if (topLevelCategory && window.openSubCategoriesFromElement) {
	              window.openSubCategoriesFromElement(topLevelCategory, true);
	            }
	          }
	          // when screen reader is active target is set to child span element
	        } else if (($(event.target).is('button') || $(event.target).is('i')) && (event.which === Navigation_v2.KEYCODES.ENTER_KEY || event.which === Navigation_v2.KEYCODES.KEYDOWN_EVENT)) {
	          event.preventDefault();
	          Navigation_v2.toggleSubCategoryElements(false);
	          Navigation_v2.openSubcategoryOnEnter(parentLiElementId, level, isAncillary);
	          $('#' + parentLiElementId).find('a').attr('aria-expanded', 'true');
	
	          if (isGRSMegaMenuEnabled) {
	            // Accessibility feature - fetch subcategories for the selected top category from react component
	            var _topLevelCategory = void 0;
	            if ($(event.target).is('i')) {
	              _topLevelCategory = event.target.parentElement;
	            } else if ($(event.target).is('button')) {
	              _topLevelCategory = event.target.parentElement.parentElement;
	            }
	            if (_topLevelCategory && window.openSubCategoriesFromElement) {
	              window.openSubCategoriesFromElement(_topLevelCategory, true);
	            }
	          }
	        }
	      });
	    },
	
	    closeMenuLevelPanelOnEcs: function closeMenuLevelPanelOnEcs(parentId, level) {
	      if (level == 1) {
	        Navigation_v2.hideOverlayAndCloseMenu(false);
	        $('#navigation-dropdown').focus();
	      } else {
	        Navigation_v2.emptySubCategoryElements(level, false);
	        Navigation_v2.selectSubcategoryParentLink(parentId);
	      }
	      //change aria-expanded attribute to false
	      if ($('#arrow-' + parentId) !== undefined) {
	        $('#arrow-' + parentId).attr('aria-expanded', 'false');
	      }
	      if ($('#span-' + parentId) !== undefined) {
	        $('#span-' + parentId).attr('aria-expanded', 'false');
	      }
	      if ($('#' + parentId).find('a') !== undefined) {
	        $('#' + parentId).find('a').attr('aria-expanded', 'false');
	      }
	    },
	
	    openSubcategoryOnEnter: function openSubcategoryOnEnter(parentLiElementId, level, isAncillary) {
	      if (level < Navigation_v2.maxLevel - 1) {
	        Navigation_v2.openSubcategoryOnKeyup(level, parentLiElementId, isAncillary);
	      }
	    },
	
	    openSubcategoryOnRightArrow: function openSubcategoryOnRightArrow(parentLiElementId, level, isAncillary) {
	      if (level < Navigation_v2.maxLevel - 1) {
	        Navigation_v2.openSubcategoryOnKeyup(level, parentLiElementId, isAncillary);
	      }
	    },
	
	    openSubcategoryOnKeyup: function openSubcategoryOnKeyup(level, elementId, isAncillary) {
	      Navigation_v2.fillChildData(level + 1, elementId, isAncillary);
	      Navigation_v2.toggleSubCategoryElements(false);
	      Navigation_v2.selectFirstElementInCategory(level + 1);
	    },
	
	    bindPhoneChildCategories: function bindPhoneChildCategories(level) {
	      var phoneSufix = '-phone';
	      var parentElementId = Navigation_v2.level + level + phoneSufix;
	
	      $(Navigation_v2.level + level + phoneSufix).find('li').each(function () {
	        if (level == 1 && $(this).text().trim() != messages.NAV_LOCATIONS) {
	          $(this).find('a').attr("href", "#");
	        }
	        if (!Navigation_v2.categoryHasChildData($(this).attr('id'))) {
	          $(this).find('a').addClass('clickable-link');
	        }
	      });
	
	      $(parentElementId + ' li').on('click keydown', function (e) {
	        if (e.which === Navigation_v2.KEYCODES.ENTER_KEY || e.type == 'click') {
	          if (isGRSMegaMenuEnabled) {
	            var topLevelCategory = void 0;
	            if ($(e.target).is('a')) {
	              topLevelCategory = e.target.parentElement;
	              if (topLevelCategory && window.openSubCategoriesFromElement) {
	                window.openSubCategoriesFromElement(topLevelCategory, true);
	              }
	            }
	          } else {
	            var id = this.id;
	            var parentId = $(this).attr('data-parent');
	            if (Navigation_v2.categoryHasChildData(id)) {
	              Navigation_v2.emptySubCategoryElements(1);
	              Navigation_v2.addSubcategoryTitle(this.innerText);
	              if (level > 1) {
	                Navigation_v2.addParentSubcategoryLink(parentId);
	                Navigation_v2.addAllDepartmentsLink(parentId);
	              } else {
	                Navigation_v2.addAllDepartmentsLink(id);
	              }
	
	              if (e.which === Navigation_v2.KEYCODES.ENTER_KEY) {
	                $('#all-departments-link').focus();
	              }
	              Navigation_v2.fillPhoneChildData(level + 1, id);
	            }
	          }
	        }
	      });
	
	      var selector = '';
	      if (level === 1) {
	        selector = '#level1-ancillary-departments-phone';
	      } else {
	        selector = parentElementId;
	      }
	      $(selector).append(Navigation_v2.closeMenuButtonHTML);
	      Navigation_v2.bindCloseMenuEvent(true);
	    },
	
	    /**
	     * Due to screenreader focus issue for mobile users new close menu button 
	     * is added. This bind event is added to that button to close the menu on mobile devices. 
	     * @param isPhone parameter to check is device actually phone screen size. 
	     * @return {void}
	     * 
	     * */
	    bindCloseMenuEvent: function bindCloseMenuEvent(isPhone) {
	      var closeMenuSelector = '#close-menu-button';
	      $(closeMenuSelector).on('keydown click', function (e) {
	        e.preventDefault();
	        COSTCO.Navigation_v2.hideOverlayAndCloseMenu(isPhone);
	        //Move the focus back to shop menu button
	        Navigation_v2.setFocusOnMenuIcon();
	      });
	    },
	
	    categoryHasChildData: function categoryHasChildData(parentId) {
	      return Navigation_v2.$navigationDataUL.find('[data-parent=' + parentId + ']').length !== 0 || Navigation_v2.$navigationDataUL.find('[data-espot-parent=' + parentId + ']').length !== 0;
	    },
	
	    fillChildData: function fillChildData(level, parentId, isAncillary) {
	      for (i = level; i <= Navigation_v2.maxLevel; i++) {
	        if (i == 2) {
	          $(Navigation_v2.level2_AllDepartments).find('ul').empty();
	          $(Navigation_v2.level2_AncillaryDepartments).empty();
	        } else {
	          $(Navigation_v2.level + i).find('ul').empty();
	        }
	      }
	      if (isAncillary) {
	        Navigation_v2.showTopCatEspot(parentId, isAncillary);
	      } else {
	        var childElements = Navigation_v2.$navigationDataUL.find('[data-parent=' + parentId + ']').clone();
	        Navigation_v2.addIdAttributeToElements(childElements);
	        var subcategoryTitle = Navigation_v2.$navigationDataUL.find('[data-id=' + parentId + ']').first().clone();
	        subcategoryTitle.attr('data-parent', parentId);
	        subcategoryTitle.removeAttr('data-id');
	        subcategoryTitle.attr('id', 'title-' + parentId);
	        subcategoryTitle.addClass('subcategoryTitle');
	
	        Navigation_v2.wrapSubcategoryTitleAnchor(subcategoryTitle);
	
	        if (level == 2) {
	          if ($(childElements).length != 0) {
	            $(Navigation_v2.level2_AllDepartments).find('ul').append(subcategoryTitle);
	            $(Navigation_v2.level2_AllDepartments).find('ul').append(childElements);
	          }
	        } else if ($(childElements).length != 0) {
	          $(Navigation_v2.level + level).find('ul').append(subcategoryTitle);
	          $(Navigation_v2.level + level).find('ul').append(childElements);
	        }
	
	        var topCategoryId = $(Navigation_v2.navigationUI).find('li[id=' + parentId + ']').attr('data-parent') !== undefined ? $(Navigation_v2.navigationUI).find('li[id=' + parentId + ']').attr('data-parent') : 0;
	        if (topCategoryId == "0") {
	          topCategoryId = parentId;
	        }
	        Navigation_v2.showTopCatEspot(topCategoryId, isAncillary);
	        if (level < Navigation_v2.maxLevel) {
	          Navigation_v2.bindChildCategories(level, parentId);
	        }
	      }
	    },
	
	    wrapSubcategoryTitleAnchor: function wrapSubcategoryTitleAnchor(subcategoryTitle) {
	      var subcategoryTitleAnchor = $(subcategoryTitle).find('a').clone();
	      var subcategoryTitleAnchorWrapper = document.createElement('span');
	      $(subcategoryTitleAnchorWrapper).attr('role', 'heading');
	      $(subcategoryTitleAnchorWrapper).attr('aria-level', '2');
	      $(subcategoryTitle).find('a').remove();
	      $(subcategoryTitle).append($(subcategoryTitleAnchorWrapper).append($(subcategoryTitleAnchor)));
	    },
	
	    fillPhoneChildData: function fillPhoneChildData(level, parentId) {
	      var phoneSufix = '-phone';
	      var subCategories = Navigation_v2.$navigationDataUL.find('[data-parent=' + parentId + ']');
	      if (subCategories.length == 0) {
	        subCategories = $('[data-parent="' + parentId + '"]');
	      }
	      var childElements = parentId % 1 === 0 ? subCategories.clone() : Navigation_v2.$navigationDataUL.find('[data-parent^=' + parentId + ']').clone();
	      Navigation_v2.addIdAttributeToElements(childElements);
	      var parentElementId = Navigation_v2.level + (level - 1) + phoneSufix;
	      var isAncillary = Navigation_v2.isAncillaryElementSelected(parentId);
	
	      if ($(Navigation_v2.level + level + phoneSufix).length == 0) {
	        Navigation_v2.recreatePhoneLevelHTMLStructure(level, parentElementId);
	      }
	
	      $(Navigation_v2.level + level + phoneSufix).prepend(childElements);
	      Navigation_v2.addAllSubcategoryLink(level, parentId);
	
	      var topCategoryId = Navigation_v2.$navigationDataUL.find('li[data-id=' + parentId + ']').attr('data-parent') !== undefined ? Navigation_v2.$navigationDataUL.find('li[data-id=' + parentId + ']').attr('data-parent') : 0;
	      if (topCategoryId == "0" || topCategoryId == "ancillary_0") {
	        topCategoryId = parentId;
	      }
	
	      Navigation_v2.showTopCatEspotForPhone(level, topCategoryId, isAncillary);
	
	      Navigation_v2.toggleSubCategoryElements(true);
	
	      if (level < Navigation_v2.maxPhoneLevel) {
	        Navigation_v2.bindPhoneChildCategories(level);
	      }
	    },
	
	    showTopCatEspot: function showTopCatEspot(parent, isAncillary) {
	      var parentEspot = Navigation_v2.$navigationDataUL.find('[data-espot-parent=' + parent + ']').clone();
	      // replacing data-img-src for all the li image nodes 
	      var imgSrcRegExp = new RegExp('data-img-src', 'g');
	      parentEspot.each(function () {
	        $(this).html($(this).html().replace(imgSrcRegExp, 'src'));
	
	        if (isGRSMegaMenuEnabled) {
	          $(this).find('a').attr('tabindex', '0');
	          $(this).find('a').first().on('keydown', function (event) {
	            if (event.shiftKey && event.keyCode === Navigation_v2.KEYCODES.TAB_KEY) {
	              event.preventDefault();
	              if ($("#subcategory-level3").length) {
	                $("#subcategory-level3").find('a').last().focus();
	              } else if ($("#subcategory-level2").length) {
	                $("#subcategory-level2").find('a').last().focus();
	              }
	            }
	            if (event.keyCode === Navigation_v2.KEYCODES.ESC_KEY) {
	              event.preventDefault();
	              var _parentElement = document.getElementById(parent);
	              Navigation_v2.handleEspotFocus(_parentElement);
	            }
	          });
	
	          $(this).find('a').last().on('keydown', function (event) {
	            if (!event.shiftKey && event.keyCode === Navigation_v2.KEYCODES.TAB_KEY) {
	              event.preventDefault();
	              if (document.getElementById("subcategory-level3")) {
	                var allLevel3Categories = document.getElementById("subcategory-level3").querySelectorAll('li');
	                if (allLevel3Categories.length > 1) {
	                  var firstLevel3Element = allLevel3Categories[1];
	                  var firstLevel3ElementId = firstLevel3Element.getAttribute('data-parent');
	                  var nextLevel2ElementToFocus = document.getElementById("subcategory-level2").querySelector('#l2_' + firstLevel3ElementId);
	                  if (nextLevel2ElementToFocus) {
	                    nextLevel2ElementToFocus.focus();
	                    window.wioEventBus.publish('clearLevel3Categories');
	                  } else {
	                    var _parentElement2 = document.getElementById(Number(parent) + 1);
	                    if (!_parentElement2) {
	                      //This is the last element of top category so keep it focused
	                      _parentElement2 = document.getElementById(parent);
	                    }
	                    Navigation_v2.handleEspotFocus(_parentElement2);
	                  }
	                }
	              } else {
	                var _parentElement3 = document.getElementById(Number(parent) + 1);
	                if (!_parentElement3) {
	                  //This is the last element of top category so keep it focused
	                  _parentElement3 = document.getElementById(parent);
	                }
	                Navigation_v2.handleEspotFocus(_parentElement3);
	              }
	            }
	            if (event.keyCode === Navigation_v2.KEYCODES.ESC_KEY) {
	              event.preventDefault();
	              parentElement = document.getElementById(parent);
	              Navigation_v2.handleEspotFocus(parentElement);
	            }
	          });
	        }
	      });
	      if (isAncillary) {
	        $(Navigation_v2.level2_AncillaryDepartments).append(parentEspot);
	      } else {
	        for (i = 2; i <= Navigation_v2.maxLevel; i++) {
	          if (i == 2) {
	            if ($(Navigation_v2.level2_AllDepartments).find('ul').is(':empty')) {
	              $(Navigation_v2.level2_AllDepartments).find('ul').append(parentEspot);
	            }
	          } else {
	            if ($(Navigation_v2.level + i).find('ul').is(':empty')) {
	              $(Navigation_v2.level + i).find('ul').append(parentEspot);
	              break;
	            }
	          }
	        }
	      }
	    },
	
	    handleEspotFocus: function handleEspotFocus(parentElement) {
	      if (parentElement) {
	        var childElement = parentElement.querySelector('a');
	        if (childElement) {
	          childElement.focus();
	          window.wioEventBus.publish('clearSubcategory');
	        }
	      }
	    },
	
	    showTopCatEspotForPhone: function showTopCatEspotForPhone(level, parent, isAncillary) {
	      var parentEspot = Navigation_v2.$navigationDataUL.find('[data-espot-parent=' + parent + ']').clone();
	      // replacing data-img-src for all the li image nodes 
	      var imgSrcRegExp = new RegExp('data-img-src', 'g');
	      parentEspot.each(function () {
	        $(this).html($(this).html().replace(imgSrcRegExp, 'src'));
	      });
	      for (i = 2; i <= Navigation_v2.maxPhoneLevel; i++) {
	        $(Navigation_v2.level + i + '-phone').find('li[data-espot-parent]').each(function () {
	          $(this).remove();
	        });
	      }
	
	      $(Navigation_v2.level + level + '-phone').append(parentEspot);
	    },
	
	    // espotContainsSubcategoryLinks: function(espotTopCategoryId) {
	    //   return $('[data-espot-parent="' + espotTopCategoryId +'"]').find('.category-level-2').length !== 0;
	    // },
	
	    populateNavigationDataWithEspotSubcategoryLinks: function populateNavigationDataWithEspotSubcategoryLinks(espotTopCategoryId) {
	      Navigation_v2.$navigationDataUL.find('[data-espot-parent="' + espotTopCategoryId + '"]').each(function () {
	        if ($(this).find('.category-level-2').length !== 0) {
	          $(this).find('.category-level-2').each(function (cat2Index) {
	            if ($(this).find('.category-level-3').length !== 0) {
	              //creating category-level-2 navigation data li elements from espot content
	              var categoryLevel2Title = $(this).find('li').first().contents();
	              var cat2ElementIdAttr = espotTopCategoryId + '-cat2-' + cat2Index;
	              Navigation_v2.createLiElementInNavigationData(espotTopCategoryId, cat2ElementIdAttr, categoryLevel2Title);
	
	              //creating category-level-3 navigation data li elements from espot content
	              $(this).find('.category-level-3').find('li').each(function (cat3Index) {
	                var categoryLevel3Link = $(this).contents();
	                var cat3ElementIdAttr = espotTopCategoryId + '-cat3-' + cat3Index;
	                Navigation_v2.createLiElementInNavigationData(cat2ElementIdAttr, cat3ElementIdAttr, categoryLevel3Link);
	                $(this).remove();
	              });
	            }
	          });
	        }
	        if ($(this).text().trim().length === 0) {
	          $(this).remove();
	        }
	      });
	    },
	
	    populateAncillaryNavigationDataWithEspotSubcategoryLinks: function populateAncillaryNavigationDataWithEspotSubcategoryLinks(espotTopCategoryId) {
	      Navigation_v2.$navigationDataUL.find('[data-espot-parent="' + espotTopCategoryId + '"]').each(function () {
	        var $olEle = $(this).find('ol');
	        if ($olEle.length !== 0) {
	          $olEle.each(function (levelIndex) {
	            var $liSubItemEle = $(this).find('li.sub-item');
	            var $liNotSubItemEle = $(this).find('li:not(.sub-item)');
	
	            //level-2 navigation data li elements from espot content
	            if ($liNotSubItemEle.length !== 0) {
	              var categoryLevel2Title = $liNotSubItemEle.contents();
	              var cat2ElementIdAttr = espotTopCategoryId + '-level2-' + levelIndex;
	              Navigation_v2.createLiElementInNavigationData(espotTopCategoryId, cat2ElementIdAttr, categoryLevel2Title);
	
	              //level-3 navigation data li elements from espot content
	              if ($liSubItemEle.length !== 0) {
	                $liSubItemEle.each(function (level3Index) {
	                  var categoryLevel3Link = $(this).contents();
	                  var cat3ElementIdAttr = espotTopCategoryId + '-level3-' + levelIndex + '-' + level3Index;
	                  Navigation_v2.createLiElementInNavigationData(cat2ElementIdAttr, cat3ElementIdAttr, categoryLevel3Link);
	                  $(this).remove();
	                });
	              }
	            } else {
	              if ($liSubItemEle.length !== 0) {
	                $liSubItemEle.each(function (level2Index) {
	                  var categoryLevel2Link = $(this).contents();
	                  var cat2ElementIdAttr = espotTopCategoryId + '-level2-' + levelIndex + '-' + level2Index;
	                  Navigation_v2.createLiElementInNavigationData(espotTopCategoryId, cat2ElementIdAttr, categoryLevel2Link);
	                  $(this).remove();
	                });
	              }
	            }
	            $(this).remove();
	          });
	        }
	        if ($(this).text().trim().length === 0) {
	          $(this).remove();
	        }
	      });
	    },
	
	    addParentSubcategoryLink: function addParentSubcategoryLink(elementId) {
	
	      var parentSubcategoryElement = Navigation_v2.$navigationDataUL.find('[data-id=' + elementId + ']').clone();
	      Navigation_v2.addIdAttributeToElements(parentSubcategoryElement);
	      parentSubcategoryElement.attr('data-parent-subcategory', 'parent-subcategory-link');
	      parentSubcategoryElement.attr('tabindex', '-1');
	      parentSubcategoryElement.on('keydown click', function (e) {
	        if (e.type == 'click' || e.which === Navigation_v2.KEYCODES.ENTER_KEY) {
	          var id = this.id;
	          Navigation_v2.emptySubCategoryElements(1);
	          Navigation_v2.addSubcategoryTitle(this.innerText);
	          Navigation_v2.addAllDepartmentsLink(id);
	          if (e.which === Navigation_v2.KEYCODES.ENTER_KEY) {
	            $('#all-departments-link').focus();
	          }
	          Navigation_v2.fillPhoneChildData(2, id);
	        }
	      });
	      $('#level1-phone').prepend(parentSubcategoryElement);
	    },
	
	    addSubcategoryTitle: function addSubcategoryTitle(subcategoryTitle) {
	      jQuery('<li/>', {
	        id: 'all-subcategory-title',
	        class: 'selectedSubcategoryTitle',
	        text: subcategoryTitle
	      }).prependTo('#level1-phone');
	    },
	
	    addAllSubcategoryLink: function addAllSubcategoryLink(level, elementId) {
	      var allSubcategoryElement = Navigation_v2.$navigationDataUL.find('[data-id=' + elementId + '] a').clone();
	      allSubcategoryElement.attr('all-subcategory-link', 'true');
	      allSubcategoryElement.addClass('clickable-link');
	      var subcategoryTitle = allSubcategoryElement.text();
	      allSubcategoryElement.text('All ' + subcategoryTitle);
	
	      $(Navigation_v2.level + level + '-phone').prepend(allSubcategoryElement);
	    },
	
	    addAllDepartmentsLink: function addAllDepartmentsLink(parentId) {
	      Navigation_v2.allDepartmentsParentId = parentId;
	      jQuery('<li/>', {
	        id: 'all-departments-link',
	        text: "All Departments",
	        tabindex: -1
	      }).prependTo('#level1-phone');
	      $('#all-departments-link').on('click keydown', function (event) {
	        if (event.type == 'click' || event.which === Navigation_v2.KEYCODES.ENTER_KEY) {
	          Navigation_v2.emptySubCategoryElements(1, true);
	          $(Navigation_v2.navigationPhoneUI).hide();
	          Navigation_v2.toggleNavigation(true, event);
	          if (event.which === Navigation_v2.KEYCODES.ENTER_KEY) {
	            $('#level1-all-departments-phone').find('#' + Navigation_v2.allDepartmentsParentId + ' a').focus();
	          }
	        }
	      });
	    },
	
	    addChevronForSelectedLink: function addChevronForSelectedLink(element) {
	      var elementName = $(element).text();
	      var spanElement = jQuery('<button/>', {
	        id: 'span-' + $(element).attr('id'),
	        class: 'offscreen',
	        tabindex: '0',
	        'aria-haspopup': 'true',
	        'aria-expanded': 'false',
	        text: elementName + ' ' + messages.MENU
	      });
	      var iElement = jQuery('<i/>', {
	        id: 'arrow-' + $(element).attr('id'),
	        class: 'co-arrow-right navigation-v2-arrow pull-right',
	        tabindex: '0',
	        'aria-haspopup': 'true',
	        'aria-expanded': 'false'
	      });
	
	      spanElement.appendTo(iElement);
	      iElement.appendTo(element);
	    },
	
	    createLiElementInNavigationData: function createLiElementInNavigationData(dataParentAttr, idAttr, content) {
	      var newListItem = document.createElement("li");
	      newListItem.setAttribute('data-parent', dataParentAttr);
	      newListItem.setAttribute('data-id', idAttr);
	      newListItem.appendChild(content[0]);
	      Navigation_v2.tempFragment.appendChild(newListItem);
	    },
	
	    removeChevronFromAllLinks: function removeChevronFromAllLinks() {
	      $(Navigation_v2.navigationUI + ' i').each(function () {
	        $('.navigation-v2-arrow').remove();
	      });
	    },
	
	    recreatePhoneLevelHTMLStructure: function recreatePhoneLevelHTMLStructure(level, parentElementId) {
	      jQuery('<div/>', {
	        id: 'level' + level + '-phone',
	        class: 'col-xs-12 navigation-category-level panelPaddingLeft30'
	      }).appendTo(parentElementId);
	    },
	
	    alignSubMenus: function alignSubMenus() {
	
	      var maxLev = Navigation_v2.maxLevel;
	
	      for (j = 1; j <= maxLev; j++) {
	        $(Navigation_v2.level + j).removeAttr("style");
	      }
	
	      for (j = 2; j <= maxLev; j++) {
	        if ($(Navigation_v2.level + j).height() > 0) {
	          var h1 = $(Navigation_v2.level + (j - 1)).outerHeight();
	          if ($(Navigation_v2.level + j).height() < h1) $(Navigation_v2.level + j).attr("style", "height: " + h1 + "px !important");
	          if ($(Navigation_v2.level + j).height() > h1) {
	            var h2 = $(Navigation_v2.level + j).outerHeight();
	            for (k = j; k > 0; k--) {
	              $(Navigation_v2.level + k).attr("style", "height: " + h2 + "px !important");
	            }
	          }
	        }
	      }
	    },
	
	    /**
	     * this function enables/disables <a> tag default behaviour depending on the value of aria-expanded attribute
	     * @param  level - panel level
	      */
	    toggleAnchorTagForTablet: function toggleAnchorTagForTablet(level) {
	      $(Navigation_v2.level + level).find('a').each(function () {
	        var parentLiElementId = $(this).parent().attr('id');
	        if (parentLiElementId !== undefined && parentLiElementId !== false) {
	          if (Navigation_v2.categoryHasChildData(parentLiElementId)) {
	            if ($(this).attr('aria-expanded') === 'true') {
	              $(this).removeClass('disabled');
	            } else {
	              $(this).addClass('disabled');
	            }
	          }
	        }
	      });
	    },
	
	    toggleSubCategoryElements: function toggleSubCategoryElements(isPhone) {
	      var maxLev = isPhone ? Navigation_v2.maxPhoneLevel : Navigation_v2.maxLevel;
	      var phoneSufix = isPhone ? '-phone' : '';
	      for (i = 1; i <= maxLev; i++) {
	        if (i == 1) {
	          if ($(Navigation_v2.level1_AllDepartments + phoneSufix).find('li').length == 0) {
	            $(Navigation_v2.level1_AllDepartments + phoneSufix).hide();
	          } else {
	            $(Navigation_v2.level1_AllDepartments + phoneSufix).show();
	            $('#phone-divider').show();
	          }
	          if ($(Navigation_v2.level1_AncillaryDepartments + phoneSufix).html().length == 0) {
	            $(Navigation_v2.level_AncillaryDepartments + phoneSufix).hide();
	          } else {
	            $(Navigation_v2.level1_AncillaryDepartments + phoneSufix).show();
	          }
	        } else if (i == 2) {
	          if (isPhone) {
	            var level2Element = Navigation_v2.level + i + phoneSufix;
	            var level3Element = Navigation_v2.level + (i + 1) + phoneSufix;
	            if ($(level3Element).length == 0 || $(level3Element).html().length == 0) {
	              if ($(':not([id^="level3-phone"])', level2Element).length == 0) {
	                $(Navigation_v2.level + i + phoneSufix).hide();
	              } else {
	                $(Navigation_v2.level + i + phoneSufix).show();
	              }
	            }
	          } else {
	            if ($(Navigation_v2.level2_AllDepartments).find('li').length == 0) {
	              $(Navigation_v2.level2_AllDepartments).hide();
	              $(Navigation_v2.level + i).hide();
	            } else {
	              $(Navigation_v2.level2_AllDepartments).show();
	              $(Navigation_v2.level + i).show();
	
	              if (!Navigation_v2.isTabletView()) {
	                Navigation_v2.alignSubMenus();
	              }
	            }
	            if ($(Navigation_v2.level2_AncillaryDepartments).html().length == 0) {
	              $(Navigation_v2.level2_AncillaryDepartments).hide();
	            } else {
	              $(Navigation_v2.level2_AncillaryDepartments).show();
	              $(Navigation_v2.level + i).hide();
	            }
	          }
	        } else {
	          if ($(Navigation_v2.level + i + phoneSufix).find('li').length == 0) {
	            $(Navigation_v2.level + i + phoneSufix).hide();
	          } else {
	            $(Navigation_v2.level + i + phoneSufix).show();
	          }
	        }
	        if (Navigation_v2.isTabletView() && i < maxLev - 1) {
	          Navigation_v2.toggleAnchorTagForTablet(i);
	        }
	      }
	    },
	
	    emptySubCategoryElements: function emptySubCategoryElements(level, isPhone) {
	      var isPhoneDevice = isPhone || Navigation_v2.isPhoneView();
	      var maxLev = isPhoneDevice ? Navigation_v2.maxPhoneLevel : Navigation_v2.maxLevel;
	      var phoneSufix = isPhoneDevice ? '-phone' : '';
	      for (i = level; i <= maxLev; i++) {
	        if (i == 1) {
	          $(Navigation_v2.level1_AllDepartments + phoneSufix).find('ul').empty();
	          $(Navigation_v2.level1_AllDepartments + phoneSufix).hide();
	          $(Navigation_v2.level1_AncillaryDepartments + phoneSufix).empty();
	          $(Navigation_v2.level1_AncillaryDepartments + phoneSufix).hide();
	          if (isPhoneDevice) {
	            $('[data-parent-subcategory="parent-subcategory-link"]').remove();
	            $('#all-departments-link').remove();
	            $('.selectedSubcategoryTitle').remove();
	          }
	        } else if (i == 2) {
	          if (isPhoneDevice) {
	            $('#phone-divider').hide();
	            $('#level3-phone').empty();
	            $(':not([id^="level3-phone"])', '#level2-phone').remove();
	            $('#level2-phone').hide();
	          } else {
	            $(Navigation_v2.level2_AllDepartments).find('ul').empty();
	            $(Navigation_v2.level2_AllDepartments).hide();
	            $(Navigation_v2.level2_AncillaryDepartments).empty();
	            $(Navigation_v2.level2_AncillaryDepartments).hide();
	          }
	        } else {
	          if ($(Navigation_v2.level + i + phoneSufix).find('ul').length != 0) {
	            $(Navigation_v2.level + i + phoneSufix).find('ul').empty();
	          }
	          $(Navigation_v2.level + i).hide();
	        }
	      }
	    },
	
	    showOverlayWhenMenuDisplayed: function showOverlayWhenMenuDisplayed() {
	      $('#tiles-body-attribute').addClass('navigation-v2-disable-links');
	      $('#navigation-overlay-div-element').show();
	    },
	
	    hideOverlayAndCloseMenu: function hideOverlayAndCloseMenu(isPhone) {
	      var elementPanel = isPhone ? Navigation_v2.navigationPhoneUI : Navigation_v2.navigationUI;
	      $('#navigation-overlay-div-element').hide();
	      $('#tiles-body-attribute').removeClass('navigation-v2-disable-links');
	
	      Navigation_v2.emptySubCategoryElements(1, isPhone);
	      $(elementPanel).hide();
	      $('#navigation-dropdown').attr('aria-expanded', 'false');
	      $(Navigation_v2.menuIconMobile).attr('aria-expanded', 'false');
	      window.wioEventBus.publish('clearSubcategory');
	    },
	
	    isAncillaryElementSelected: function isAncillaryElementSelected(elementId) {
	      return elementId !== undefined && elementId.includes("Ancillary") ? true : false;
	    },
	
	    keepParentLinksHighlighted: function keepParentLinksHighlighted(level, elementId) {
	      var currentElement = $(Navigation_v2.navigationUI + ' #' + elementId);
	      var currentElementId = elementId;
	      var currentLevel = level;
	      while (currentElement.length != 0) {
	        $(Navigation_v2.level + currentLevel).find('li:not(#' + currentElementId + ')').each(function () {
	          $(this).removeClass('selectedLinkBold');
	        });
	        if (!Navigation_v2.isAncillaryElementSelected(elementId) && currentLevel < 3) {
	          currentElement.addClass('selectedLinkBold');
	        }
	        currentLevel = --currentLevel;
	        currentElementId = currentElement.attr('data-parent');
	        currentElement = $(Navigation_v2.navigationUI + ' #' + currentElementId);
	      }
	    },
	
	    initNavPopovers: function initNavPopovers() {
	      //removal of nav-flyout class and Home_Ancillary ids from navigation_v2_data elements
	      //in order to skip them in the next loop
	      Navigation_v2.$navigationDataUL.find('[data-parent="ancillary_0"] [id^="Home_Ancillary"]').each(function () {
	        var newId = 'data_' + $(this).attr('id');
	        $(this).removeClass('nav-flyout');
	        $(this).attr('id', newId);
	      });
	
	      Navigation_v2.$navigationWidgetEle.find('.nav-flyout').each(function () {
	        var _this = $(this);
	        var flyoutId = _this.data('flyout');
	        console.log('Init Nav Flyout' + flyoutId);
	        flyoutId = flyoutId ? '#' + flyoutId : '';
	
	        if (flyoutId != null && flyoutId != '') {
	          var containerId = flyoutId + '-container';
	          Navigation_v2.hover_click_popover_link_and_button(_this, flyoutId, false);
	          var rule = "{width:" + _this.data('width') + "px}";
	          COSTCO.util.setStyleRule(containerId, rule);
	        }
	      });
	
	      Navigation_v2.$navigationWidgetEle.find('[id^="button_Home_Ancillary"]').each(function (i) {
	        var _this = $('#popover_for_' + this.id);
	        var ancillaryLinkElement = $('#' + _this.attr('data-emsName'));
	        var flyoutId = ancillaryLinkElement.data('flyout') ? '#' + ancillaryLinkElement.data('flyout') : '';
	        var buttonSpanText = $('#Home_Ancillary_' + i).text();
	        $('#' + this.id + ' span').text(buttonSpanText);
	        if (flyoutId != null && flyoutId != '') {
	          var containerId = 'button_' + flyoutId + '-container';
	          Navigation_v2.hover_click_popover_link_and_button(_this, flyoutId, true);
	          var rule = "{width:" + _this.data('width') + "px}";
	          COSTCO.util.setStyleRule(containerId, rule);
	        }
	
	        $('#' + this.id).on('keydown click', function (event) {
	          if (event.which === Navigation_v2.KEYCODES.ENTER_KEY || event.type === "click") {
	            event.preventDefault();
	            if ($('#popover_for_' + this.id).has('.popover').length == 1) {
	              $('#popover_for_' + this.id).popover('hide');
	            } else {
	              $('#popover_for_' + this.id).popover("show");
	            }
	          }
	        });
	      });
	
	      //added logic here to check if url is an external site per
	      //same logic as in whiteList. Whitelist init does not apply to
	      //any of the dropdown since they are not part of the dom on page init
	      Navigation_v2.$navigationWidgetEle.find('.nav-flyout').on('click', 'a', function (e) {
	        if (this.hostname && this.hostname != location.hostname && !this.href.match(/^(mailto|javascript)\:/) && this.href != '' && !COSTCO.whiteList.isOnWhiteList(this.hostname)) {
	          COSTCO.whiteList.createDialogBox(this.href);
	          e.preventDefault();
	        }
	        //user want to click on the url inside the flyout not the parent link
	        e.stopPropagation();
	      });
	
	      Navigation_v2.setKeyboardNavigationForAncillaryLinks();
	    },
	
	    hover_click_popover_link_and_button: function hover_click_popover_link_and_button(selector, _content, isArrowButton) {
	      var hoverClickElement = $(selector);
	      var triggerEvent = 'hover';
	      if (isArrowButton) {
	        triggerEvent = 'manual';
	      }
	      hoverClickElement.popover({
	        html: true,
	        sanitize: false,
	        animation: false,
	        delay: {
	          show: 200,
	          hide: 200
	        },
	        content: function content() {
	          return $(_content).html();
	        },
	        container: selector,
	        placement: 'bottom',
	        trigger: triggerEvent
	      }).on('focus', function (e) {
	        Navigation_v2.hideAllNavigationPopovers();
	        Navigation_v2.hideOverlayAndCloseMenu(false);
	      })
	      // Adding listener to toggle the aria tags when popover shown/hidden
	      .on('shown.bs.popover', function () {
	        if ($(this).prop("tagName") == "BUTTON" || this.id.startsWith("popover_for_button")) {
	          $(this).attr('aria-expanded', 'true');
	        }
	
	        $(this).find('.popover').addClass('top50pixels');
	        // used to create ada attributes on popover
	        var identifierString = this.id + '_id';
	        $(this).find('.popover-content').attr('id', identifierString);
	
	        $(this).removeAttr('aria-describedby');
	        $(this).find('.popover').removeAttr('role');
	
	        $('#' + identifierString).find('li:first a').focus();
	      }).on('hidden.bs.popover', function () {
	        if ($(this).prop("tagName") == "BUTTON" || this.id.startsWith("popover_for_button")) {
	          $(this).attr('aria-expanded', 'false');
	        }
	      });
	    },
	
	    setKeyboardNavigationForAncillaryLinks: function setKeyboardNavigationForAncillaryLinks() {
	      Navigation_v2.$navigationWidgetEle.find('[id^="Home_Ancillary"]').on('focus', function (event) {
	        Navigation_v2.$navigationWidgetEle.find('[id^="button_Home_Ancillary"]').addClass('hidden');
	        $('#button_' + this.id).removeClass('hidden');
	      });
	    },
	
	    hideAllNavigationPopovers: function hideAllNavigationPopovers() {
	      Navigation_v2.$navigationWidgetEle.find('a[id^="Home_Ancillary"], button[id^="button_Home_Ancillary"]').popover('hide');
	    }
	  };
	
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = new Object();
	  }
	
	  window.COSTCO.Navigation_v2 = Navigation_v2;
	  return Navigation_v2;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 84:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title tooltip.js: Feature level module
	 * @description Function used application wide.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		var Tooltip = {
	
			//a11ybutton onclick handler
			clickHandler: function clickHandler(a11yButton, event) {
				this.ariaHandler(a11yButton);
			},
	
			//a11ybutton onkeyup handler
			keyupHandler: function keyupHandler(a11yButton, event) {
				this.eventHandler(a11yButton, event);
			},
	
			//Handles keyboard events when onkeyup is fired, flips aria and shows/hides popover
			eventHandler: function eventHandler(a11yButton, event) {
				switch (event.which) {
					//Spacebar handler
					case 32:
						event.preventDefault();
						this.ariaHandler(a11yButton);
						break;
					//enter handler - simply preventDefault
					case 13:
						event.preventDefault();
						this.ariaHandler(a11yButton);
						break;
					//exit handler - simply close
					case 27:
						event.preventDefault();
						$(a11yButton).attr('aria-expanded', 'false').popover('hide');
						break;
					default:
						break;
				}
				return;
			},
	
			//Handles click event and flips aria + shows/hides popover
			ariaHandler: function ariaHandler(a11yButton) {
				if ($(a11yButton).attr('aria-expanded') === 'true') {
					$(a11yButton).attr('aria-expanded', 'false').popover('hide');
				} else {
					$(a11yButton).attr('aria-expanded', 'true').popover('show');
				}
			}
		};
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
		/*
	  * exposing the file to global
	  * use COSTCO.Tooltip.xxx to check
	  * any constants defined at the top
	  */
		window.COSTCO.Tooltip = Tooltip;
		return Tooltip;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 85:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title retainSearchTerm.js: Feature level module
	 * @description This module is a helper for storing the users' search terms 
	 * @EnablerStory STRY0163174
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		var retainSearchTerm = {
	
			KEYWORD: 'keyword',
	
			init: function init() {
				var searchTerm = COSTCO.util.getParameterByName(retainSearchTerm.KEYWORD);
	
				if (searchTerm != null) {
					retainSearchTerm.loadTerm(searchTerm);
				}
				retainSearchTerm.closeButton();
				retainSearchTerm.setListenerOnDeleteButton();
			},
			/**
	   * This function loads the previously saved term 
	   * (if available)into the search field 
	   * @param(String) 
	   *  
	   */
			loadTerm: function loadTerm(searchTerm) {
				$('#search-field').val(searchTerm);
			},
			/**
	   * This function is a listener to close and 
	   * delete the search term upon the users request
	   */
			setListenerOnDeleteButton: function setListenerOnDeleteButton() {
				$('#retain-search-close').on('click', function () {
					retainSearchTerm.deleteSearchFieldText();
					$(this).css('display', 'none');
				});
				$('#retain-search-close').on('keydown', function (e) {
					retainSearchTerm.keyboardFunctionality(e);
				});
			},
			/**
	   * This function selects the text and deletes it 
	   * This simulates a user deleting text so that typeahead 
	   * gets a new value of empty and does not retain past search history 
	   */
			deleteSearchFieldText: function deleteSearchFieldText() {
				var searchField = $('#search-field');
	
				searchField.select();
				document.execCommand('delete');
	
				if (searchField.val() !== '') {
					searchField.val('');
					searchField.select();
					document.execCommand('delete');
				}
			},
			/**
	   * This function is a listener on the search form 
	   * when focused in, it will display the close button
	   * with a condition: searchfield value = search term previously searched
	   * if the user manipulates the text we remove the close button as well
	   */
			closeButton: function closeButton() {
				$('#formcatsearch').on('focusin', function () {
					if ($('#search-field').val() !== '') {
						$('#retain-search-close').css('display', 'flex');
					}
					$('#search-field').on('keyup', function () {
						if ($('#search-field').val() !== '') {
							$('#retain-search-close').css('display', 'flex');
						} else {
							$('#retain-search-close').css('display', 'none');
						}
					});
				});
			},
			/**
	   * on enter (13) or space (32)
	   * the search term will be deleted
	   */
			keyboardFunctionality: function keyboardFunctionality(e) {
				switch (e.keyCode) {
					case 13:
						e.preventDefault();
						retainSearchTerm.deleteSearchFieldText();
						break;
					case 32:
						e.preventDefault();
						retainSearchTerm.deleteSearchFieldText();
						break;
					default:
						break;
				}
			}
	
		};
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
		window.COSTCO.retainSearchTerm = retainSearchTerm;
		return retainSearchTerm;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 86:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title header.js: Sub-module of Browse feature
	 * @description This module encapsulates all of the
	 * functionality related to the header component.
	 * @dependency utility.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var Footer = {
	    /**
	     * The initializing function modules use
	     * to call.
	     * @return {[type]} [description]
	     */
	    init: function init() {
	      COSTCO.util.safe(this.copyright)();
	      COSTCO.util.safe(this.copy_content_to_accordion)();
	
	      //ALM40905 Avoid calling these functions for CrossSiteRequestForgeryErrorView and ProhibitedCharacterErrorView 
	      if (!$('#isErrorPage').val() || $('#isErrorPage').length == 0) {
	        COSTCO.util.safe(this.country_select_addon)();
	        // STRY0170011 - Removed the Language Drop Down for BD if accessing from Mobile App
	        if (COSTCO.util.getLangId() != -1 && !(COSTCO.util.isRunningOnMobileApp() && COSTCO.util.isBusinessDelivery())) {
	          COSTCO.util.safe(this.language_region_select_addon)();
	        }
	      }
	
	      COSTCO.util.safe(this.loadImages)();
	    },
	    copyright: function copyright() {
	      $('#copyright-year').text(new Date().getFullYear());
	    },
	    /**
	     * This copies the espot links from the footer into
	     * their corresponding accordion panels. This eliminates
	     * the need for the business to maintain duplicated content
	     * @return {[type]}
	     */
	    copy_content_to_accordion: function copy_content_to_accordion() {
	      if ($(".footer-list").length === 5) {
	        $('.footer-list').each(function (index, el) {
	          $('#accordion-footer #collapse-' + (index + 1) + ' .panel-body').append(el.outerHTML);
	        });
	      } else {
	        setTimeout(Footer.copy_content_to_accordion, 200);
	      }
	    },
	    /**
	     * Copies the country-select dropdown from the header to the footer
	     * @return {[void]}
	     */
	    country_select_addon: function country_select_addon() {
	      if ($('#country-select-popover-container').length > 0) {
	        var handler = 'id="footer-country-select"',
	            header = $('#country-select-popover-container').find('[data-selected=true] a').html(),
	            body = '<div class="footer-flags">' + $('#country-select-popover-container').html() + '</div>',
	            instructionText = $('.country-select-instruction').text();
	        COSTCO.util.accordion_addon('accordion-footer', header, body, handler);
	        //when clicking the accordion header, change the header text.
	        $('#footer-country-select').find('.panel-heading').unbind('click').on('click', function () {
	          if ($(this).hasClass('collapsed')) {
	            $(this).find('a').text(instructionText);
	          } else {
	            $(this).find('a').text(header);
	          }
	        });
	      }
	    },
	    /**
	     * Copies the language/region-select dropdown from the header to the footer
	     * @return {[void]}
	     */
	    language_region_select_addon: function language_region_select_addon() {
	      var langSelect = $('#language-select');
	
	      if (langSelect.length == 0) {
	        return true;
	      }
	      if (!COSTCO.util.isBusinessDelivery()) {
	        var handler = 'id="footer-language-select"',
	            _header = $('#header-selected-language').text(),
	            body = '<div class="footer-language-flags">' + $('#language-select-popover-container').html() + '</div>';
	        COSTCO.util.accordion_addon('accordion-footer', _header, body, handler);
	        $(".footer-language-flags").on('click', 'a', function () {
	          var selectedLangId = $(this).attr("langid");
	          COSTCO.util.addUrlToLangMap(window.location.pathname, selectedLangId);
	          COSTCO.myLocation.reloadWithNewLanguage(selectedLangId);
	        });
	      } else {
	        if ($('#region-select').length > 0) {
	          var header = $('#header-selected-language').text() + ' - ' + $.cookie('C_LOC').substring($.cookie('C_LOC').length - 2);
	        } else {
	          var header = $('#header-selected-language').text();
	        }
	
	        var clickHandler = "onclick='if(event.stopPropagation){event.stopPropagation();event.preventDefault();}event.cancelBubble=true;COSTCO.Footer.language_region_handler();'";
	        COSTCO.util.accordion_addon('accordion-footer', header, null, clickHandler);
	      }
	    },
	    /**
	     * Handler function for the language/region-select accordion in the footer
	     * @return {[void]}
	     */
	    language_region_handler: function language_region_handler() {
	      if (COSTCO.util.isBusinessDelivery()) {
	        COSTCO.myLocation.initLocationModal(true);
	        $('#costcoModal').one('hidden.bs.modal', function () {
	          if ($('#region-select').length > 0) {
	            var newHeader = $('#language-select').get(0).firstChild.nodeValue + ' - ' + $('#region-select').get(0).firstChild.nodeValue;
	          } else {
	            var newHeader = $('#language-select').get(0).firstChild.nodeValue;
	          }
	          $('.panel[onclick] .panel-title a').get(0).firstChild.nodeValue = newHeader;
	        });
	      }
	    },
	    /**
	     * This function loads the image based on the device width.
	     * Espot will be configured with the suitable data attributes,
	     * and its values will be loaded based on the screen size.
	     * @return {[void]}
	     */
	    loadImages: function loadImages() {
	      $(window).on("load resize", function (e) {
	        var imageSource;
	        $('.dynamic-image-load').each(function () {
	          var screenType = COSTCO.util.getScreenType();
	          var mobileDefaultLazyAttr = 'data-lazy-mobile';
	          if (screenType === 'PHONE-PORTRAIT') {
	            imageSource = $(this).is('[data-lazy-xs]') ? $(this).attr('data-lazy-xs') : $(this).attr(mobileDefaultLazyAttr);
	          } else if (screenType === 'PHONE-LANDSCAPE') {
	            imageSource = $(this).is('[data-lazy-sm]') ? $(this).attr('data-lazy-sm') : $(this).attr(mobileDefaultLazyAttr);
	          } else if (screenType === 'TABLET-PORTRAIT') {
	            imageSource = $(this).is('[data-lazy-md]') ? $(this).attr('data-lazy-md') : $(this).attr(mobileDefaultLazyAttr);
	          } else if (screenType === 'TABLET-LANDSCAPE') {
	            imageSource = $(this).is('[data-lazy-lg]') ? $(this).attr('data-lazy-lg') : $(this).attr('data-lazy-desktop');
	          } else {
	            imageSource = $(this).attr('data-lazy-desktop');
	          }
	          //identified the screentype and setting the image source
	          $(this).attr('src', imageSource);
	        });
	      });
	    }
	  };
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = new Object();
	  }
	  window.COSTCO.Footer = Footer;
	  return Footer;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 87:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title fsamodal.js: Sub-module for Global pages
	 * @description This module is used to display the fsa modal
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16)], __WEBPACK_AMD_DEFINE_RESULT__ = function (dialog) {
	
		var fsamodal = {
	
			init: function init() {
				this.attachExternalClass();
			},
	
			attachExternalClass: function attachExternalClass() {
				//$('.fsa-text').unbind().on('click' ,this.bind_external);
				$('body').on('click', '.fsa-text', this.bind_external);
			},
	
			bind_external: function bind_external(event) {
				fsamodal.createDialogBox(this.href);
				event.preventDefault();
			},
	
			createDialogBox: function createDialogBox(url) {
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
					dialog.createExtDialogBox({
						title: messages.PDETAIL_FSA,
						body: COSTCO.util.tmpl('tmpl_fsa_modal_v2', {}),
						replaceFooter: COSTCO.util.tmpl('tmpl_fsa_footer_modal_v2', {}),
						primary: messages.CLOSE,
						primary_event: function primary_event() {
							//COSTCO.dialog.close();
						},
						primary_button_style: "rounded"
					});
				} else {
					dialog.createExtDialogBox({
						title: messages.PDETAIL_FSA,
						body: COSTCO.util.tmpl('tmpl_fsa_modal', {}),
						primary: messages.CLOSE
					});
				}
			}
	
		}; //end fsamodal object
	
		// Expose fsamodal to the global scope.
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.fsamodal = fsamodal;
	
		return fsamodal;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 88:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title whitelist.js: Sub-module for Global pages
	 * @description This module is used to check whitelist links 
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16)], __WEBPACK_AMD_DEFINE_RESULT__ = function (dialog) {
	
		var whitelist = {
	
			// initialization	
			init: function init() {
				this.attachExternalClass();
			},
	
			attachExternalClass: function attachExternalClass() {
				var locHost = location.hostname;
				$('a').filter(function () {
					return this.hostname && this.hostname != locHost && !this.href.match(/^(mailto|javascript)\:/) && this.href != '' && !whitelist.isOnWhiteList(this.hostname);
				}).addClass("external").unbind().on('click', this.bind_external);
			},
	
			//if hostname found in whitelist return true
			isOnWhiteList: function isOnWhiteList(hostname) {
				var retVal = false;
				if (urlWhitelist && urlWhitelist.findIndex(function (x) {
					return hostname.includes(x);
				}) > -1 && domainWhiteListWithExternalPopup && domainWhiteListWithExternalPopup.findIndex(function (x) {
					return hostname.includes(x);
				}) < 0) {
					retVal = true;
				}
	
				return retVal;
			},
	
			bind_external: function bind_external(event) {
				whitelist.createDialogBox(this.href);
				event.preventDefault();
			},
	
			createDialogBox: function createDialogBox(url) {
				dialog.createExtDialogBox({
					url: url,
					title: messages.JS_DIALOG_EXTERNAL_LINK,
					body: isBDApplication === "BD" ? messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG_BD : messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
					secondary: messages.JS_DIALOG_CANCEL,
					primary: messages.JS_DIALOG_EXTERNAL_LINK,
					oneTimePopup: whitelist.oneTimePopup(url)
				});
			},
	
			oneTimePopup: function oneTimePopup(url) {
				if (urlWarnOncePerSessionList && urlWarnOncePerSessionList.findIndex(function (x) {
					return url.includes(x);
				}) > -1) {
					return true;
				} else {
					return false;
				}
			}
	
		}; //end whitelist object
	
		// Expose whiteList to the global scope.
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.whiteList = whitelist;
	
		return whitelist;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 89:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	/**
	 * @title grocery-delivery-checker.js: Sub-module
	 * @description 
	 * This JS file binds the apply  button 
	 * and  functionalities to 
	 * respective event listeners
	 *  
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		var CanadaGroceryDeliveryChecker = {
			init: function init() {
				if (window.location.href.indexOf("CanadaGroceryDeliveryRedirect") > -1 && wcs.storeId === "10302") {
					CanadaGroceryDeliveryChecker.initialize();
				}
			},
			/**
	   * The method initializes the binding for different 
	   * JSP elements and is the starting point for most of 
	   * the actions.
	   */
			initialize: function initialize() {
				var zipCode = $.cookie('invCheckPostalCode');
				if (zipCode !== null) {
					var zipCodeDisplay = zipCode.replace(/[^a-zA-Z 0-9]+/g, ' ');
	
					//handles case of zipcode looking like: M1R+0E9
					zipCode = zipCode.replace(/[^a-zA-Z 0-9]+/g, '');
					//handles case of zipcode looking like: M1R 0E9
					zipCode = zipCode.replace(/\s/g, '');
					$('.user-entered-zip').text(zipCodeDisplay);
	
					if (COSTCO.Header.hasInvPostalCodeCookie() && COSTCO.Header.isInvStateCookieMissing()) {
						var updateZipCodeStateCookies = function updateZipCodeStateCookies(data, textstatus, XMLHttpRequest) {
	
							var locationData = COSTCO.Header.extractLocationData(data);
							var invalidZip = locationData.InvalidZip;
							var province = locationData.Province;
							var country = locationData.Country;
	
							if (!invalidZip) {
								COSTCO.Header.setDeliveryCookies(zipCode, province, country);
	
								var stateCode = $.cookie('invCheckStateCode');
								if (typeof stateCode !== 'undefined' && stateCode != null && stateCode.length > 2) {
									stateCode = stateCode.substring(2);
								}
								CanadaGroceryDeliveryChecker.checkTwoDayEligible(stateCode, zipCode);
							}
						};
						if ($('#isGeocodeService').val() != "true") {
							COSTCO.util.callBing(zipCode, updateZipCodeStateCookies, updateZipCodeStateCookies);
						} else {
							COSTCO.util.callGeocodeAPI(zipCode, updateZipCodeStateCookies, updateZipCodeStateCookies);
						}
					} else {
						var stateCode = $.cookie('invCheckStateCode');
						if (typeof stateCode !== 'undefined' && stateCode != null && stateCode.length > 2) {
							stateCode = stateCode.substring(2);
						}
						CanadaGroceryDeliveryChecker.checkTwoDayEligible(stateCode, zipCode);
					}
				}
				$(window).on('load', function () {
					COSTCO.util.click_popover('#two-day-postal-code-changer', '#ca-grocery-delivery-postal-code-popover');
					COSTCO.util.click_popover('#same-day-postal-code-changer', '#ca-grocery-delivery-postal-code-popover');
				});
			},
			/**
	   * Calls AjaxDeliveryWarehouseLocatorCmd to validate and save Aeroplan Account Number
	   * @param
	   * @return void
	   */
			checkTwoDayEligible: function checkTwoDayEligible(stateCode, zipCode, groceryDeliveryCategory) {
				//let stateCode = "AB";
	
				// test no two day delivery
				//let zipCode = "Y0B1M0";
	
				// test two day delivery
				// let zipCode = "M1R0E9";
	
				COSTCO.util.ajax({
					type: 'GET',
					url: 'AjaxDeliveryWarehouseLocatorCmd?stateCode=' + stateCode + "&zipCode=" + zipCode + "&storeId=" + wcs.storeId,
					done: function done(data) {
						var responseJson = JSON.parse(data);
						var status = responseJson.omsResponse;
						if (status === true) {
							if (responseJson.SameDay === true) {
								$('#same-day-delivery-row-success').removeClass('hidden');
								$('#same-day-delivery-row-failure').addClass('hidden');
								COSTCO.util.announceSRMessage(messages.SAMEDAY_AVAILABLE);
							} else {
								$('#same-day-delivery-row-success').addClass('hidden');
								$('#same-day-delivery-row-failure').removeClass('hidden');
								COSTCO.util.announceSRMessage(messages.SAMEDAY_NOT_AVAILABLE);
							}
							if (responseJson.Regional === true) {
								$('#two-day-delivery-row-success').removeClass('hidden');
								$('#two-day-delivery-row-failure').addClass('hidden');
								if (groceryDeliveryCategory == 'two-day-postal-code-changer') {
									COSTCO.util.announceSRMessage(messages.GROCERY_AVAILABLE);
								}
							} else {
								$('#two-day-delivery-row-success').addClass('hidden');
								$('#two-day-delivery-row-failure').removeClass('hidden');
								if (groceryDeliveryCategory == 'two-day-postal-code-changer') {
									COSTCO.util.announceSRMessage(messages.GROCERY_NOT_AVAILABLE);
								}
							}
						}
					},
					timeout: wcs.ajaxTimeout,
					fail: function fail(x, t, m) {
						if (t === 'timeout') {
							console.error('Error AJAX timeout.');
						} else {
							console.error('Unexpected AJAX error.');
						}
					}
				});
			},
			useZipcodeSubmitPopover: function useZipcodeSubmitPopover(element) {
				var userEnteredZip = $('#postal-code-input-grocery').val().toUpperCase();
				var userEnteredZipSubmit = userEnteredZip.replace(/ /g, '');
				userEnteredZip = userEnteredZip.replace(/ /g, ' ');
				var groceryDeliveryCategory = $('input[name="category-grocery-delivery"]').val();
	
				if (userEnteredZip.length === 0) {
					var errorContainer = $(element).find('div.error');
					if (errorContainer) {
						errorContainer.empty();
					}
	
					if (errorContainer) {
						errorContainer.append(messages.ERR_GROCERY_INVALID_ZIP);
					}
					var inputContainer = $(element).find('.form-control');
					if (inputContainer) {
						inputContainer.attr('aria-invalid', 'true');
						inputContainer.addClass("error");
					}
				} else {
					$('.user-entered-zip').text(" " + userEnteredZip + " ");
					var userSavedProvince = $.cookie('invCheckStateCode');
					if (!userSavedProvince) {
						userSavedProvince = $.cookie('C_LOC');
					}
					if (userSavedProvince.length > 2) {
						userSavedProvince = userSavedProvince.substring(2);
					}
					CanadaGroceryDeliveryChecker.checkTwoDayEligible(userSavedProvince, userEnteredZipSubmit, groceryDeliveryCategory);
				}
			}
		};
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
	
		if (typeof window.COSTCO.Global == 'undefined') {
			document.addEventListener("CostcoGlobalLoaded", CanadaGroceryDeliveryChecker.init, false);
		} else {
			CanadaGroceryDeliveryChecker.init();
		}
	
		window.COSTCO.CanadaGroceryDeliveryChecker = CanadaGroceryDeliveryChecker;
		return CanadaGroceryDeliveryChecker;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 90:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title lucidworks.js: Sub-module of LucidWorks feature
	 * @description This module encapsulates all of the
	 * functionality related to the lucidworks search component.
	 * @dependency
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var numCounter = 0;
	  var prevSuggestionType = '';
	  var LWSearch = {
	    fusionQueryId: null,
	    origSrchTerm: null,
	    /**
	     * The initializing function modules use
	     * to call.
	     * @return {void}
	     */
	    init: function init() {
	      var lwTypeAheadEnabled = this.isLWTypeAheadEnabled();
	
	      if (lwTypeAheadEnabled) {
	        COSTCO.util.safe(this.lwTypeAhead)();
	      }
	    },
	    /**
	     * Set Up Bootstrap TypeAhead with Bloodhound as remote data source
	     * @return {void}
	     */
	    lwTypeAhead: function (_lwTypeAhead) {
	      function lwTypeAhead() {
	        return _lwTypeAhead.apply(this, arguments);
	      }
	
	      lwTypeAhead.toString = function () {
	        return _lwTypeAhead.toString();
	      };
	
	      return lwTypeAhead;
	    }(function () {
	
	      LWSearch.loadTypeaheadConfig();
	
	      var search = new Bloodhound({
	        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
	        queryTokenizer: Bloodhound.tokenizers.whitespace,
	
	        remote: {
	          url: lwTypeAhead.endpoint,
	          prepare: function prepare(query, settings) {
	            var serviceURL = settings.url + '?q=' + encodeURIComponent(query);
	            serviceURL += '&locale=' + wcs.locale.replace('_', '-') + '&loc=' + LWSearch.getWarehouseLocations() + '&rowsPerGroup=' + lwTypeAhead.maxPerType;
	
	            if (typeof lwTypeAhead.enableZipRestriction != 'undefined' && lwTypeAhead.enableZipRestriction != 'undefined' && lwTypeAhead.enableZipRestriction.length > 0 && lwTypeAhead.enableZipRestriction == 'true') {
	
	              var userStateCode = $.cookie('invCheckStateCode');
	              var userPostalCode = $.cookie('invCheckPostalCode');
	
	              if (typeof userStateCode == 'undefined' || userStateCode == 'undefined' || userStateCode.length == 0 || typeof userPostalCode == 'undefined' || userPostalCode == 'undefined' || userPostalCode.length == 0) {
	                userStateCode = lwTypeAhead.defaultStateCode;
	                userPostalCode = lwTypeAhead.defaultZipCode;
	              }
	
	              if (typeof userStateCode != 'undefined' && userStateCode != 'undefined' && userStateCode.length > 0 && typeof userPostalCode != 'undefined' && userPostalCode != 'undefined' && userPostalCode.length > 0) {
	                if (userPostalCode.indexOf("-") != -1) {
	                  userPostalCode = userPostalCode.split('-')[0];
	                }
	
	                if (userPostalCode.indexOf(" ") != -1) {
	                  userPostalCode = userPostalCode.replace(/ /g, '%20');
	                }
	
	                serviceURL = serviceURL + '&userLocation=' + userStateCode;
	                serviceURL = serviceURL + '&userPostal=' + userPostalCode;
	              }
	            }
	
	            if (lwTypeAhead.enableTravel) {
	              serviceURL = serviceURL + '&includeTravelInSearch=' + lwTypeAhead.enableTravel;
	            }
	            //Check for National Delivery Flow
	            var bdZipCookie = COSTCO.util.getBDZipCookie();
	            if (bdZipCookie != null && bdZipCookie.externalCarrier == 'ND') {
	              serviceURL += '&nationalDelivery=true';
	            }
	            settings.headers = {
	              Authorization: 'Basic ' + lwTypeAhead.basicAuth
	            };
	            settings.url = serviceURL;
	            return settings;
	          },
	          rateLimitBy: 'throttle',
	          rateLimitWait: lwTypeAhead.rateLimitWait,
	          filter: function filter(data) {
	            var firstSection = [];
	            var lastSection = [];
	            var allSuggestions = [];
	            LWSearch.fusionQueryId = data.fusion.fusionQueryId;
	            LWSearch.origSrchTerm = $('#search-field').val();
	            $.each(data.response.docs, function (i, suggestion) {
	              switch (suggestion.type.toLowerCase()) {
	                case 'popularsearch':
	                  suggestion.displayOrder = 1;
	                  firstSection.push(suggestion);
	                  break;
	                case 'shadowdimension':
	                  suggestion.displayOrder = 2;
	                  firstSection.push(suggestion);
	                  break;
	                case 'category':
	                  suggestion.displayOrder = 3;
	                  firstSection.push(suggestion);
	                  break;
	                case 'brand':
	                  suggestion.displayOrder = 4;
	                  firstSection.push(suggestion);
	                  break;
	                case 'product':
	                  suggestion.displayOrder = 5;
	                  if (suggestion.pharmacy_drug_id) {
	                    suggestion.FullImage = lwTypeAhead.cmppProductImage;
	                  }
	                  lastSection.push(suggestion);
	                  break;
	                case 'warehouse':
	                  suggestion.displayOrder = 6;
	                  suggestion.WarehouseAddress = LWSearch.normalizeWarehouseText(suggestion.WarehouseAddress);
	                  lastSection.push(suggestion);
	                  break;
	              }
	            });
	
	            search.sorter(firstSection);
	            search.sorter(lastSection);
	
	            var firstSectionLength = firstSection.length;
	            var lastSectionLength = lastSection.length;
	
	            var defaultSize = lwTypeAhead.maxSuggestions - lwTypeAhead.maxFirstSection;
	            lastSectionLength = defaultSize;
	
	            if (firstSectionLength < lwTypeAhead.maxFirstSection) {
	              lastSectionLength = lwTypeAhead.maxSuggestions - firstSectionLength;
	            } else {
	              firstSectionLength = lwTypeAhead.maxFirstSection;
	            }
	
	            firstSection = firstSection.slice(0, firstSectionLength);
	            lastSection = lastSection.slice(0, lastSectionLength);
	            allSuggestions = firstSection.concat(lastSection);
	
	            // Adding Border
	            var display = [];
	            data = allSuggestions || [];
	            var count = 0;
	            var curObjType = '';
	            $.each(data, function (i, suggestion) {
	              if (suggestion.type != curObjType && count > 0) {
	                suggestion.border = 'border';
	              }
	              curObjType = suggestion.type;
	              count++;
	              display.push(suggestion);
	            });
	
	            return display;
	          }
	        },
	        sorter: function sorter(suggestionA, suggestionB) {
	          if (suggestionA.displayOrder < suggestionB.displayOrder) {
	            return -1;
	          } else if (suggestionA.displayOrder > suggestionB.displayOrder) {
	            return 1;
	          } else return 0;
	        }
	      });
	
	      $('#search-widget .typeahead').typeahead({
	        hint: true,
	        highlight: true,
	        minLength: parseInt(lwTypeAhead.minChar)
	      }, {
	        name: 'search',
	        display: 'term',
	        source: search,
	        limit: 999,
	        templates: {
	          suggestion: function suggestion(data) {
	            numCounter = data.type == prevSuggestionType ? numCounter + 1 : 0;
	            prevSuggestionType = data.type;
	            var numId = numCounter == 0 ? '' : numCounter;
	            var travelTile = false;
	            if (data.travel_destination) {
	              travelTile = true;
	            }
	            var _in = '<span class="hidden-xs">&nbsp;in&nbsp;</span>';
	            var category = data.category ? _in + '<span class="category hidden-xs">' + data.category + '</span>' : '';
	            var privateTag = data.leads_to_fsa_chdi ? 'data-bi-private ="true" data-private ' : '';
	            if (data.type == 'Warehouse') {
	              var warehouse = '';
	              warehouse = ' Warehouse ' + data.WarehouseAddress;
	              return '<div ' + privateTag + ' automation-id=sugguestion-' + data.type + '-' + data.refinementId + ' class=' + (data.border ? 'border' : '') + '>' + data.value + warehouse + '</div>';
	            }
	            if (data.type == 'Product' && !travelTile) {
	              privateTag = data.item_fsa_eligible || data.item_chdi_eligible ? 'data-bi-private ="true" data-private ="true"' : '';
	              var productImage = '<img class="product-image" src=' + data.FullImage + '>';
	              return '<h6 ' + privateTag + 'automation-id=sugguestion-' + data.type + numId + ' class=' + (data.border ? 'border' : '') + '>' + productImage + data.label + '</h6>';
	            }
	            if (travelTile) {
	              var _productImage = '<img class="product-image" src=' + data.travel_imageURL + '>';
	              return '<h6 automation-id=sugguestionTravel-' + data.type + numId + ' class=' + (data.border ? 'border' : '') + '>' + _productImage + data.travel_description + '</h6>';
	            }
	            return '<div ' + privateTag + 'automation-id=sugguestion-' + data.type + numId + '>' + data.term + category + '</div>';
	          }
	        }
	      }).on('typeahead:render', function () {
	        if (!$('.tt-dataset :first-child.tt-suggestion').hasClass('border')) {
	          $('<hr>').insertBefore($('.tt-dataset .border'));
	        }
	      }).on('typeahead:selected', function (event, suggestion) {
	        var currEvent = 'search';
	        var srchType = null;
	        var brandFacet = 'Brand_attr-';
	        //const searchProviderParam = 'searchProvider';
	        //const searchProviderFlag = 'lucidworks';
	        switch (suggestion.type.toLowerCase()) {
	          case 'popularsearch':
	            $(this).closest('.CatalogSearchForm').submit();
	            srchType = 'type ahead:popular';
	            LWSearch.pushAdobeAnalyticsData(currEvent, srchType, suggestion.label, LWSearch.origSrchTerm, LWSearch.fusionQueryId);
	            break;
	          case 'shadowdimension':
	            var searchString = suggestion.baseUrl + '?refine=||' + brandFacet + LWSearch.cleanSDRefine(suggestion.Brand_attr);
	            srchType = 'type ahead:shadow dimension';
	            LWSearch.pushAdobeAnalyticsData(currEvent, srchType, suggestion.label, LWSearch.origSrchTerm, LWSearch.fusionQueryId);
	            window.location.href = searchString;
	            break;
	          case 'category':
	            var categoryUrl = suggestion.baseUrl;
	            srchType = 'type ahead:category';
	            LWSearch.pushAdobeAnalyticsData(currEvent, srchType, suggestion.label, LWSearch.origSrchTerm, LWSearch.fusionQueryId);
	            window.location.href = categoryUrl;
	            break;
	          case 'brand':
	            $('.CatalogSearchForm').append('<input type="hidden" name="refine" value="||' + brandFacet + LWSearch.cleanBrandRefine(suggestion.Brand_attr) + '">');
	            //$('.CatalogSearchForm').append('<input type="hidden" name="' + searchProviderParam + '" value="' + searchProviderFlag + '">');
	            srchType = 'type ahead:brand';
	            LWSearch.pushAdobeAnalyticsData(currEvent, srchType, suggestion.label, LWSearch.origSrchTerm, LWSearch.fusionQueryId);
	            $(this).closest('.CatalogSearchForm').submit();
	            break;
	          case 'product':
	            srchType = 'type ahead:product';
	
	            var pdpUrl = '';
	            if (suggestion.travel_pageURL) {
	              pdpUrl = suggestion.travel_pageURL;
	              srchType = 'type ahead:travel';
	            } else {
	              var suggestionTerm = suggestion.term.replaceAll('(', '').replaceAll(")", "");
	              pdpUrl = '/' + LWSearch.getSEOFriendlyURL(suggestionTerm) + '.product.' + suggestion.group_id + '.html';
	            }
	            if (suggestion.pharmacy_drug_id) {
	              pdpUrl = '/cmpps?drugIdentifierParam=' + suggestion.pharmacy_drug_id + '&drugNameParam=' + suggestion.term;
	            }
	            LWSearch.pushAdobeAnalyticsData(currEvent, srchType, suggestion.label, LWSearch.origSrchTerm, LWSearch.fusionQueryId);
	            window.location.href = pdpUrl;
	            break;
	          case 'warehouse':
	            srchType = 'type ahead:warehouse';
	            var displayLabel = suggestion.label + ' ' + suggestion.type + ' ' + suggestion.WarehouseAddress;
	            LWSearch.pushAdobeAnalyticsData(currEvent, srchType, displayLabel, LWSearch.origSrchTerm, LWSearch.fusionQueryId);
	            window.location.href = suggestion.baseUrl;
	            break;
	        }
	      });
	    }),
	    /**
	     * Feature Toggle for LW Typeahead
	     */
	    isLWTypeAheadEnabled: function isLWTypeAheadEnabled() {
	      if (typeof lwTypeAhead !== 'undefined') {
	        //let lwTypeAheadEnabled = lwTypeAhead.searchProvider.toLowerCase() === 'lucidworks';
	        //let queryParams = window.location.search.toLowerCase();
	        //if (queryParams.includes('searchprovider=lucidworks')) {
	        lwTypeAheadEnabled = true;
	        //} else if (queryParams.includes('searchprovider=solr') || queryParams.includes('searchprovider=solr>lucidworks')) {
	        //  lwTypeAheadEnabled = false;
	        //}
	        // Added for A/B testing
	        //if (!lwTypeAheadEnabled && $('#typeAheadSearchProvider').val() === this.searchProviderLW) {
	        //lwTypeAheadEnabled = true;
	        //}
	        return lwTypeAheadEnabled;
	      }
	      return false;
	    },
	    /**
	     * Performs string manipulations to extract warehouse number from warehouse cookie
	     * based on catalog type.
	     */
	    fetchWarehouseCookieVal: function fetchWarehouseCookieVal(catalogType) {
	      var result = void 0;
	      var warehouseCookie = $.cookie('WAREHOUSEDELIVERY_WHS');
	      if (warehouseCookie != null && warehouseCookie != '') {
	        warehouseCookie = JSON.parse(warehouseCookie);
	        if (warehouseCookie[catalogType] != null && warehouseCookie[catalogType] != '') {
	          if (catalogType.toLowerCase() === 'nearestwarehouse') {
	            result = warehouseCookie[catalogType]['catalog'];
	          } else {
	            result = warehouseCookie[catalogType];
	          }
	        }
	      }
	      return result;
	    },
	
	    /**
	     * Performs string manipulations to extract warehouse number from warehouse cookie
	     * based on catalog type.
	     */
	    getCookie: function getCookie(cookieName) {
	      var cookieValue = $.cookie(cookieName);
	      return cookieValue;
	    },
	
	    /**
	    * Get grocery and distribution location data
	    */
	    getRegionalLocations: function getRegionalLocations() {
	      var whLocation = '';
	      var regionalWH = this.fetchWarehouseCookieVal('distributionCenters');
	      var groceryWH = this.fetchWarehouseCookieVal('groceryCenters');
	      if (regionalWH) {
	        whLocation = whLocation + regionalWH;
	      }
	      if (groceryWH) {
	        if (whLocation != '') {
	          whLocation = whLocation + ',' + groceryWH;
	        } else {
	          whLocation = whLocation + groceryWH;
	        }
	      }
	      return whLocation;
	    },
	    /**
	     * Get location data for LW
	     */
	    getWarehouseLocations: function getWarehouseLocations() {
	      var whLocation = '';
	      if (COSTCO.util.isBusinessDelivery()) {
	        whLocation = COSTCO.util.getBDZipCookie().warehouseNumber;
	        whLocation = whLocation.replace('-ND', '');
	        if (!whLocation) {
	          if (wcs.langId < -1) {
	            whLocation = 889;
	          } else {
	            whLocation = 888;
	          }
	        }
	      } else {
	        var regionalWH = this.fetchWarehouseCookieVal('distributionCenters');
	        var groceryWH = this.fetchWarehouseCookieVal('groceryCenters');
	        var nearestWH = this.fetchWarehouseCookieVal('nearestWarehouse');
	        if (regionalWH) {
	          whLocation = whLocation + regionalWH;
	        }
	        if (groceryWH) {
	          whLocation = whLocation != '' ? whLocation + ',' + groceryWH : whLocation + groceryWH;
	        }
	        if (nearestWH) {
	          whLocation = whLocation != '' ? whLocation + ',' + nearestWH : whLocation + nearestWH;
	        }
	      }
	      return whLocation;
	    },
	    /**
	     * Push Digital for Adobe analytics
	     */
	    pushAdobeAnalyticsData: function pushAdobeAnalyticsData(currEvent, srchType, srchTerm, actualSrchTerm, fusionQueryId) {
	      window.digitalDataEvents = window.digitalDataEvents || [];
	      digitalDataEvents.push({
	        event: currEvent,
	        searchType: srchType,
	        searchTerm: srchTerm,
	        actualSearchTerm: actualSrchTerm,
	        fusionQueryId: fusionQueryId
	      });
	    },
	    /**
	     * Create SEO friendly url from product name
	     */
	    getSEOFriendlyURL: function getSEOFriendlyURL(productName) {
	      return productName.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
	      .replace(/#/g, '') // Replace # with empty string
	      .replace(/%/g, '') // Replace % with empty string
	      .replace(/"/g, '') // Replace " with empty string
	      .replace(/'/g, '') // Replace ' with empty string
	      .replace(/\?/g, '') // Replace ? with empty string
	      .replace(/\-\-+/g, '-') // Replace multiple - with single -
	      .replace(/^-+/, '') // Trim - from start of text
	      .replace(/-+$/, ''); // Trim - from end of text
	    },
	    encodeUrl: function encodeUrl(url) {
	      return encodeURIComponent(url).replace(/'/g, '%27').replace(/"/g, '%22');
	    },
	    /**
	     * Clean Brand facet value
	     */
	    cleanBrandRefine: function cleanBrandRefine(brandFacet) {
	      // Single encode brand facet value
	      var brandEncoded = this.encodeUrl(brandFacet);
	      // Replace encoded spaces with + to match Java URLEncoder
	      return brandEncoded.toString().replace(/%20/g, '+');
	    },
	    /**
	     * Clean Shadow Dimension facet value
	     */
	    cleanSDRefine: function cleanSDRefine(brandFacet) {
	      // Double encode brand facet value
	      var brandEncoded = escape(this.encodeUrl(brandFacet));
	
	      // Replace encoded spaces with %2B to match Java URLEncoder
	      return brandEncoded.toString().replace(/%2520/g, '%2B');
	    },
	    /**
	     * Utility function to fix warehouse character casing
	     */
	    normalizeWarehouseText: function normalizeWarehouseText(whText) {
	      var firstLetterRx = /(^|\s)[a-z]/g;
	
	      function upperCase(str) {
	        return str.toUpperCase();
	      }
	      whText = whText.toLowerCase();
	      return whText.replace(firstLetterRx, upperCase);
	    },
	    /*
	     * Function to specify behavior of lw typeahead a/b config
	     */
	    loadTypeaheadConfig: function loadTypeaheadConfig() {
	      // Following lines of code allow minChars and maxSuggestions 
	      // for lw typeahead to be configured from adobe target.
	      var sessionParams = sessionStorage.getItem("lw-typeahead-ab-parms");
	      var adobeLwConfig = void 0;
	      if (COSTCO.util.objectExistsAndNonEmpty(sessionParams)) {
	        adobeLwConfig = JSON.parse(sessionParams);
	      }
	
	      if (COSTCO.util.objectExistsAndNonEmpty(adobeLwConfig)) {
	        var minCharConfig = adobeLwConfig.minchars;
	        var limitConfig = adobeLwConfig.maxchars;
	        lwTypeAhead.minChar = COSTCO.util.objectExistsAndNonEmpty(minCharConfig) ? minCharConfig : lwTypeAhead.minChar;
	        lwTypeAhead.maxSuggestions = COSTCO.util.objectExistsAndNonEmpty(limitConfig) ? limitConfig : lwTypeAhead.maxSuggestions;
	      }
	      return;
	    },
	    /**
	     * Function to reload page on ZSR for edge case
	     */
	    ZSR_reloader: function ZSR_reloader() {
	      var lw_whsName = $('#whsName').val();
	      var isCategoryPage = $('#isCategoryPage').val();
	      var isReloaded = COSTCO.util.getParameterByName('reloaded') == null ? false : true;
	      var whsRegionalCookieValue = LWSearch.fetchWarehouseCookieVal('Regional');
	      if (!isReloaded && isCategoryPage != null && whsRegionalCookieValue && lw_whsName !== whsRegionalCookieValue) {
	        document.location.search = COSTCO.util.insertParamInUrl('reloaded', 'true');
	      }
	    }
	  };
	
	  // If user is on android or iOS mobile device, disable keyboard autocorrect for searches
	  $('#search-field').focusin(function () {
	    if (/Android|iPhone|iPad/i.test(navigator.userAgent) && $(this).attr('autocorrect') !== 'off') {
	      $(this).attr('autocorrect', 'off');
	    }
	  });
	
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = {};
	  }
	
	  window.COSTCO.LWSearch = LWSearch;
	
	  return LWSearch;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 91:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	/**
	 * @title edd.js: Feature level module
	 * @description A collection of edd functions used
	 * application wide. This module should contain
	 * edd utility code.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		var EDD = {
	
			/**
	      * Message Types for Delivery Services
	      */
			INCLUDED_MESSAGE_TYPE: "Included",
			EXCLUDED_MESSAGE_TYPE: "Excluded",
			WARNING_MESSAGE_TYPE: "Warning",
			INFORMATIONAL_MESSAGE_TYPE: "Informational",
	
			/**
	          * Method to invoke delivery API service
	        **/
			invokeDeliveryServices: function invokeDeliveryServices(deliveryServicesRequestMap, jsonDataForDBSave) {
				var clientIdentifier = $('#apigeeClientIdentifierHeader').val();
				var deliveryServicesConnectionTime = $('#connectionTimeOutForEDD').val();
				var costcoEnv = COSTCO.Product.validateCostcoEnv();
				var deliveryServicesResponseMap = new Map();
				var responseCount = 0;
	
				var timeOutController = COSTCO.util.getTimeoutController();
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = deliveryServicesRequestMap.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var orderItem = _step.value;
	
	
						installationUri = deliveryServicesRequestMap.get(orderItem);
	
						timeOutController(deliveryServicesConnectionTime, fetch(installationUri, {
							method: 'GET',
							headers: {
								"costco.env": costcoEnv,
								"client-identifier": clientIdentifier
							}
						})).then(function (response) {
							return response.json();
						}).then(function (jsonResponse) {
	
							responseCount++;
							if (jsonResponse.services !== undefined && jsonResponse.services.length > 0) {
	
								if (undefined !== jsonResponse.orderItemId) {
									deliveryServicesResponseMap.set(jsonResponse.orderItemId, jsonResponse.services);
								}
							}
	
							if (deliveryServicesRequestMap.size == responseCount) {
								if (deliveryServicesResponseMap.size > 0) {
									eddInstallationServicesJSON = jsonResponse.services;
								}
							}
						}).catch(function (err) {
							responseCount++;
	
							if (deliveryServicesRequestMap.size == responseCount) {
								if (deliveryServicesResponseMap.size > 0) {
									eddInstallationServicesJSON = jsonResponse.services;
								}
							}
						});
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			},
	
			/**
	       * Method populate installation services in cart and checkout review pages
	       */
			populateDeliveryServices: function populateDeliveryServices(deliveryServicesResponseMap) {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
	
					for (var _iterator2 = deliveryServicesResponseMap.keys()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var orderItemId = _step2.value;
	
						var eddInstallationServicesContainer = '';
	
						eddInstallationServicesContainer = COSTCO.EDD.buildHTMLforDeliveryServices(deliveryServicesResponseMap.get(orderItemId));
	
						if (null !== document.getElementById('cart_installation_services_' + orderItemId)) {
							document.getElementById('cart_installation_services_' + orderItemId).innerHTML = "";
							$('#cart_installation_services_' + orderItemId).removeClass('hidden');
							$('#cart_installation_services_' + orderItemId).append(eddInstallationServicesContainer.replace('parts-icon-margin', ""));
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
			},
	
			buildHTMLforDeliveryServices: function buildHTMLforDeliveryServices(eddInstallationServicesJSON) {
				var eddDeliveryServicesHTML = '';
	
				var eddDeliveryWarningServices = '';
				var eddDeliveryIncludedServices = '';
				var eddDeliveryExcludedServices = '';
				var eddDeliveryInformationServices = '';
				var eddDeliveryServicesContainerHTML = '';
	
				$.each(eddInstallationServicesJSON, function (index, serviceJson) {
					var descriptionText = [serviceJson.message];
					if (typeof descriptionText !== 'undefined' && descriptionText !== null && descriptionText !== '') {
						if (serviceJson.messageType === COSTCO.EDD.WARNING_MESSAGE_TYPE) {
							eddDeliveryWarningServices += COSTCO.util.tmpl('templ_edd_delivery_services_row_warning', { 'description': descriptionText });
						}
						if (serviceJson.messageType === COSTCO.EDD.INCLUDED_MESSAGE_TYPE) {
							eddDeliveryIncludedServices += COSTCO.util.tmpl('templ_edd_installation_services_row', { 'description': descriptionText });
						}
						if (serviceJson.messageType === COSTCO.EDD.EXCLUDED_MESSAGE_TYPE) {
							eddDeliveryExcludedServices += COSTCO.util.tmpl('templ_edd_installation_services_row_not_included', { 'description': descriptionText });
						}
						if (serviceJson.messageType === COSTCO.EDD.INFORMATIONAL_MESSAGE_TYPE) {
							eddDeliveryInformationServices += COSTCO.util.tmpl('templ_edd_delivery_services_row_informational', { 'description': descriptionText });
						}
					}
				});
	
				if (eddDeliveryWarningServices !== '') {
					eddDeliveryServicesHTML += eddDeliveryWarningServices;
				}
	
				if (eddDeliveryIncludedServices !== '') {
					eddDeliveryServicesHTML += COSTCO.util.tmpl('templ_edd_delivery_services_section', {
						sectionTitle: messages.DELIVERY_SERVICES_INCLUDED_TITLE,
						services: eddDeliveryIncludedServices
					});
				}
	
				if (eddDeliveryExcludedServices !== '') {
					eddDeliveryServicesHTML += COSTCO.util.tmpl('templ_edd_delivery_services_section', {
						sectionTitle: messages.DELIVERY_SERVICES_EXCLUDED_TITLE,
						services: eddDeliveryExcludedServices
					});
				}
				if (eddDeliveryInformationServices !== '') {
					eddDeliveryServicesHTML += COSTCO.util.tmpl('templ_edd_delivery_services_section', {
						sectionTitle: messages.DELIVERY_SERVICES_INFORMATIONAL_TITLE,
						services: eddDeliveryInformationServices
					});
				}
	
				if (eddDeliveryServicesHTML.length) {
					eddDeliveryServicesContainerHTML = COSTCO.util.tmpl('templ_edd_delivery_services', {
						title: messages.EDD_DELIVERY_SERVICES_CHECKOUT_SUBTITLE,
						sections: eddDeliveryServicesHTML
					});
				}
	
				return eddDeliveryServicesContainerHTML;
			}
	
		};
	
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
		window.COSTCO.EDD = EDD;
		return EDD;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 92:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		var AdobeEvents = {
	
			// fields definition
			eventName: '',
			productItems: [],
			contextVars: '',
			adobeAnalyticsData: {},
			event: {
				name: {
					VIEWPDP: 'commerce.productViews',
					ADDTOCART: 'commerce.productListAdds',
					VIEWCART: 'commerce.productListViews',
					ORDER: 'commerce.purchases',
					EMAILSIGNUP: 'Email SignUp'
				}
			},
			language: {
				FRENCH: '-25'
			},
	
			/**
	   * Initialization of the module.
	   */
			init: function init(eventName, productItems, adobeAnalyticsData, contextVars) {
				AdobeEvents.eventName = eventName;
				AdobeEvents.productItems = productItems;
				AdobeEvents.adobeAnalyticsData = adobeAnalyticsData;
				AdobeEvents.contextVars = contextVars;
				$(document).ready(function () {
					var adobeURL = AdobeEvents.adobeAnalyticsData.serviceURL;
					if (typeof adobeURL !== 'undefined' && adobeURL.trim().length !== 0) {
						var adobeObject = AdobeEvents.getAdobeAnalyticsEventObject();
						COSTCO.util.sha256(AdobeEvents.getAdobeUUID(), function (hash) {
							if (hash) {
								adobeObject.body.xdmEntity._id = hash;
							}
							AdobeEvents.sendAdobeEvent(adobeURL, JSON.stringify(adobeObject));
						});
					}
				});
			},
	
			/**
	   * Init call only if user is logged in
	   */
			initEventIfLoggedIn: function initEventIfLoggedIn(eventName, productItems, adobeAnalyticsData, contextVars) {
				if (COSTCO.util.isUserLoggedIn()) {
					AdobeEvents.init(eventName, productItems, adobeAnalyticsData, contextVars);
				}
			},
	
			sendAdobeEvent: function sendAdobeEvent(url, payload) {
				var noConsentRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
				if (typeof url === 'undefined' || url.trim().length === 0) {
					//skip if url is not set
					return;
				}
				var saleOfInfoCode = "C0004";
				var personalizedAdvConsent = costcoConsentManager.checkConsent(saleOfInfoCode);
				//send adobe events only when the personalized advertising is active on cookie settings or if no consent required when the consent is implicit
				if (personalizedAdvConsent || noConsentRequired) {
					COSTCO.util.ajax({
						url: window.location.protocol + '//' + window.location.host + '/' + 'CostcoAdobeAuthCmd?storeId=' + AdobeEvents.contextVars.storeId + '&catalogId=' + AdobeEvents.contextVars.catalogId,
						method: 'GET',
						done: function done(data, textStatus, jqXHR, options) {
							data = JSON.parse(data);
							if (data.accessToken != null || data.status != '') {
								return AdobeEvents.sendEvent(url, payload, data.accessToken);
							} else {
								console.log('Error bearer token is missing or empty');
							}
						}, fail: function fail(data) {
							console.log('Unexpected Error Occured while retrieving bearer token');
						}
					});
				}
			},
	
			sendEvent: function sendEvent(url, payload, bearerToken) {
				if (typeof url === 'undefined' || url.trim().length === 0) {
					//skip if url is not set
					return;
				}
				var adobeFlowId = $("input[name='adobeFlowId']").val();
				var adobeSandBoxName = $("input[name='adobeParamSandBox']").val();
				COSTCO.util.ajax({
					url: url,
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + bearerToken,
						'x-adobe-flow-id': adobeFlowId,
						'x-sandbox-name': adobeSandBoxName
					},
					data: payload,
					done: function done(data, textStatus, jqXHR, options) {
						if (data.status != null || data.status != '') {
							if (AdobeEvents.contextVars.eventName === 'Connections Email SignUp') {
								window.location.replace(window.location.protocol + '//' + window.location.host + '/' + 'costco-connection-confirmation.html');
							}
							if (typeof AdobeEvents.event.name.EMAILSIGNUP != 'undefined' && AdobeEvents.event.name.EMAILSIGNUP != '') {
								if (AdobeEvents.event.name.EMAILSIGNUP == AdobeEvents.contextVars.eventName) {
									if (COSTCO.util.isUSStore()) {
										window.location.replace(window.location.protocol + '//' + window.location.host + '/' + 'email-sign-up-confirmation.html');
									}
									if (COSTCO.util.isCAStore()) {
										window.location.replace(window.location.protocol + '//' + window.location.host + '/' + 'email-sign-up-confirmation.html?email=' + $("input[name='email']").val());
									}
								}
							}
						} else {
							console.log('Error sending Adobe event');
						}
					}, fail: function fail(data) {
						console.log('Unexpected Error Occured while sending Adobe event');
					}
				});
			},
	
			sendEmailSubscriptionEvent: function sendEmailSubscriptionEvent(emailPopUpUrl, contextVars, data) {
				AdobeEvents.contextVars = contextVars;
				emailPopUpUrl = emailPopUpUrl.replace('http://', 'https://');
				var emailPopUpPayload = AdobeEvents.returnEmailSubscriptionAdobeAnalyticsObject(data);
				if (COSTCO.util.isCABDStore() || COSTCO.util.isUSBDStore()) {
					delete emailPopUpPayload.consents.marketing.email.subscriptions;
				} else {
					if (COSTCO.util.isUSStore()) {
						emailPopUpPayload.consents.marketing.email.subscriptions.Costco_US_Daily = {};
						emailPopUpPayload.consents.marketing.email.subscriptions.Costco_US_Daily.val = AdobeEvents.getDaily(data);
					} else {
						emailPopUpPayload.consents.marketing.email.subscriptions.Costco_CA_Daily = {};
						emailPopUpPayload.consents.marketing.email.subscriptions.Costco_CA_Daily.val = AdobeEvents.getDaily(data);
					}
				}
				AdobeEvents.sendAdobeEvent(emailPopUpUrl, JSON.stringify(emailPopUpPayload), true);
			},
	
			getAdobeAnalyticsEventObject: function getAdobeAnalyticsEventObject() {
				var adobeAnalyticsEventObject = {
					header: AdobeEvents.getEventHeader(),
					body: AdobeEvents.getEventBody()
				};
				return adobeAnalyticsEventObject;
			},
	
			returnEmailSubscriptionAdobeAnalyticsObject: function returnEmailSubscriptionAdobeAnalyticsObject(data) {
				return {
					memberNumber: data.memberNumber,
					webMembershipType: data.webMembershipType,
					source: COSTCO.util.getSource(),
					listSource: data.listSource,
					sourceRegion: COSTCO.util.getLocale().slice(-2),
					emailAddress: data.emailAddress,
					activeInd: "A",
					languagePref: AdobeEvents.getLanguagePreference(data.listSource),
					homeLocationNum: "",
					homeLocationRegionCode: "",
					warehouse: data.warehouse,
					zip: AdobeEvents.getZipCode(data),
					consents: {
						marketing: {
							email: {
								reason: "subscribe",
								Time: new Date().toISOString(),
								subscriptions: {
									Costco_Digital_Connections: {
										val: AdobeEvents.getConnections(data)
									}
								},
								val: "y"
							}
						}
					}
				};
			},
	
			getEventHeader: function getEventHeader() {
				return {
					schemaRef: {
						id: AdobeEvents.adobeAnalyticsData.schemaRefId,
						contentType: AdobeEvents.adobeAnalyticsData.schemaRefContenType
					},
					imsOrgId: AdobeEvents.adobeAnalyticsData.imsOrgId,
					datasetId: AdobeEvents.adobeAnalyticsData.datasetId,
					flowId: AdobeEvents.adobeAnalyticsData.flowId,
					source: {
						name: AdobeEvents.adobeAnalyticsData.sourceName
					}
				};
			},
	
			getEventBody: function getEventBody() {
				return {
					xdmMeta: AdobeEvents.getXdmMeta(),
					xdmEntity: AdobeEvents.getXdmEntity()
				};
			},
	
			getLanguagePreference: function getLanguagePreference(source) {
				if ((source === 'EmailPopUp' || source === 'Email SignUp') && !(COSTCO.util.isUSStore() || COSTCO.util.isUSBDStore()) && document.getElementsByName('slid_1').length === 2) {
					var isFirstOptionChecked = document.getElementsByName('slid_1')[0].checked;
					if (!isFirstOptionChecked) {
						return COSTCO.util.getLocale() == 'en-CA' ? 'FR' : 'EN';
					}
				}
				return COSTCO.util.getLocale().slice(0, 2).toUpperCase();
			},
	
			getXdmMeta: function getXdmMeta() {
				return {
					schemaRef: {
						id: AdobeEvents.adobeAnalyticsData.schemaRefId,
						contentType: AdobeEvents.adobeAnalyticsData.schemaRefContenType
					}
				};
			},
	
			getXdmEntity: function getXdmEntity() {
				return {
					_costco: {
						costcoIdentity: {
							hashedCostcoID: $.cookie("costcoHashId"),
							sourceRegion: AdobeEvents.adobeAnalyticsData.sourceRegion
						}
					},
					commerce: AdobeEvents.getCommerce(),
					eventType: AdobeEvents.eventName,
					extSourceSystemAudit: {
						lastActivityDate: new Date().toISOString(),
						lastUpdatedBy: AdobeEvents.adobeAnalyticsData.lastUpdatedBy
					},
					identityMap: AdobeEvents.getCostcoHashedId(),
					productListItems: AdobeEvents.getProductItemsDetails(),
					timestamp: new Date().toISOString(),
					web: {
						webInteraction: {
							region: AdobeEvents.contextVars.language == AdobeEvents.language.FRENCH ? 'FR' : 'EN'
						},
						webPageDetails: {
							URL: document.getElementsByTagName("title")[0].baseURI.split('?')[0],
							name: document.getElementsByTagName("title")[0].innerText.replace(/\r?\n|\r/g, "")
						}
					}
				};
			},
	
			getCostcoHashedId: function getCostcoHashedId() {
				return {
					costcoHashedID: [{
						authenticatedState: 'authenticated',
						id: $.cookie("costcoHashId"),
						primary: true
					}]
				};
			},
	
			/**
	   * Adobe require UUID to mark particular event with the suffix of the event.
	   */
			getAdobeUUID: function getAdobeUUID() {
				var dt = new Date().getTime();
				var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
					var r = (dt + Math.random() * 16) % 16 | 0;
					dt = Math.floor(dt / 16);
					return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
				});
				var id = uuid + '-' + COSTCO.util.getCookieByName('costcoHashId');
				return id;
			},
	
			getCommerce: function getCommerce() {
				if (AdobeEvents.eventName == AdobeEvents.event.name.VIEWPDP) {
					return {
						cart: {
							cartSource: AdobeEvents.getCartSource()
						},
						productViews: {
							value: AdobeEvents.productItems[0].priceTotal
						}
					};
				} else if (AdobeEvents.eventName == AdobeEvents.event.name.ADDTOCART) {
					return {
						cart: {
							cartID: AdobeEvents.contextVars.orderId,
							cartSource: AdobeEvents.getCartSource()
						},
						productListAdds: {
							value: AdobeEvents.productItems[0].priceTotal
						}
					};
				} else if (AdobeEvents.eventName == AdobeEvents.event.name.VIEWCART) {
					if (typeof AdobeEvents.contextVars.orderId != 'undefined' && AdobeEvents.contextVars.orderId != '') {
						localStorage.setItem("adobeOrderId", AdobeEvents.contextVars.orderId);
					}
					return {
						cart: {
							cartID: AdobeEvents.getCartOrderId(),
							cartSource: AdobeEvents.getCartSource()
						},
						productListViews: {
							value: AdobeEvents.contextVars.priceTotal
						}
					};
				} else if (AdobeEvents.eventName == AdobeEvents.event.name.ORDER) {
					localStorage.removeItem("adobeOrderId", AdobeEvents.contextVars.orderId);
					return {
						order: {
							currencyCode: AdobeEvents.contextVars.currencyCode,
							discountAmount: AdobeEvents.contextVars.discountAmount,
							priceTotal: AdobeEvents.contextVars.priceTotal,
							purchaseOrderNumber: AdobeEvents.contextVars.purchaseOrderNumber
						},
						cart: {
							cartID: AdobeEvents.contextVars.orderId,
							cartSource: AdobeEvents.getCartSource()
						},
						purchases: {
							value: AdobeEvents.contextVars.priceTotal
						}
					};
				}
			},
	
			getCartOrderId: function getCartOrderId() {
				if (localStorage.getItem("adobeOrderId") === null) {
					return;
				} else {
					return localStorage.getItem("adobeOrderId");
				}
			},
	
			getProductItemsDetails: function getProductItemsDetails() {
				if (AdobeEvents.eventName == AdobeEvents.event.name.VIEWCART) {
					return AdobeEvents.getCartItemsDetails();
				} else if (AdobeEvents.eventName == AdobeEvents.event.name.VIEWPDP) {
					if ($("#product-page").attr('data-bi-private')) {
						AdobeEvents.productItems[0].productImageUrl = window.location.hostname;
						AdobeEvents.productItems[0].product = window.location.hostname;
					}
					AdobeEvents.productItems[0].quantity = $('#add-to-cart-btn').length > 0 && $('#add-to-cart-btn').hasClass('out-of-stock') != true ? 1 : -1;
				}
				return AdobeEvents.productItems;
			},
	
			getCartItemsDetails: function getCartItemsDetails() {
				if (typeof AdobeEvents.productItems != 'undefined' && AdobeEvents.productItems.length > 0) {
					for (var i = 0; i < AdobeEvents.productItems.length; i++) {
						var orderItemNumberInArray = i + 1;
						if ($("#order-item_" + orderItemNumberInArray).attr('data-bi-private')) {
							AdobeEvents.productItems[i].productImageUrl = window.location.hostname;
							AdobeEvents.productItems[i].product = window.location.hostname;
						} else {
							AdobeEvents.productItems[i].productImageUrl = $('#order-item_' + orderItemNumberInArray + ' .item-thumbnail img').attr('src');
							AdobeEvents.productItems[i].product = $('#order-item_' + orderItemNumberInArray + ' .product-title a').attr('href');
						}
						if (AdobeEvents.contextVars && AdobeEvents.contextVars.outOfStock && AdobeEvents.contextVars.outOfStock.length > 0) {
							AdobeEvents.productItems[i].quantity = AdobeEvents.getOutOfStockQuantity(AdobeEvents.productItems[i].SKU, AdobeEvents.productItems[i].quantity);
						}
					}
				}
				return AdobeEvents.productItems;
			},
	
			getOutOfStockQuantity: function getOutOfStockQuantity(partnumber, quantity) {
				for (var i = 0; i < AdobeEvents.contextVars.outOfStock.length; i++) {
					if (AdobeEvents.contextVars.outOfStock[i] == partnumber) {
						return quantity != -1 ? -1 * quantity : quantity;
					}
				}
				return quantity;
			},
	
			getCartSource: function getCartSource() {
				if (COSTCO.util.isBusinessDelivery()) {
					return AdobeEvents.adobeAnalyticsData.sourceRegion + 'BD';
				} else {
					return AdobeEvents.adobeAnalyticsData.sourceRegion + 'BC';
				}
			},
	
			getZipCode: function getZipCode(data) {
				if (COSTCO.util.isUSStore() || COSTCO.util.isUSBDStore()) {
					return data.zip;
				} else if (COSTCO.util.isCAStore() || COSTCO.util.isCABDStore()) {
					return data.postalCode;
				}
			},
	
			getConnections: function getConnections(data) {
				if (data.listSource === 'Connections_EmailSignUp') {
					return 'y';
				} else {
					return 'n';
				}
			},
	
			getDaily: function getDaily(data) {
				if (data.listSource === 'Connections_EmailSignUp') {
					return 'n';
				} else {
					return 'y';
				}
			}
		};
		if (typeof window.COSTCO === 'undefined') {
			window.COSTCO = {};
		}
		window.COSTCO.AdobeEvents = AdobeEvents;
		return AdobeEvents;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }

/******/ });


// WEBPACK FOOTER //
// global.module.min.js